import React, { useState } from 'react';
import style from './../../Css/Courses.module.css'

function JavaScriptdata() {
    // State to keep track of the selected chapter
    const [selectedChapter, setSelectedChapter] = useState('chapter1')

    // Function to handle chapter selection
    const handleChapterClick = (chapter) => {
        setSelectedChapter(chapter)
    }

    // State to track the active chapter
    const [activeChapter, setActiveChapter] = useState('chapter1');

    // Function to handle chapter click
    const handleChapterActive = (chapter) => {
        setActiveChapter(chapter);
    };
    const handleClick = (chapter) => {
        handleChapterActive(chapter);
        handleChapterClick(chapter);
        window.scrollTo(0,0);
    };


    return (
        <div className={`${style.firstcontainer} container-fluid`}>

            <div className={`${style.therow} row`}>

                <div className={`${style.droupdownbtnbar} dropdown`}>
                    <button className={`${style.droupdownbtn} btn dropdown-toggle`} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                     JavaScript
                    </button>
                    
                    <ul className={`${style.dropdownmenu} dropdown-menu`}>
                    
                        <li onClick={() => handleClick('chapter1')}
                            className={`${style.chapter1} ${activeChapter === 'chapter1' ? style.active : ''} text-decoration-none dropdown-item`} >
                          Introduction
                        </li>


                        <li
                            onClick={() => handleClick('chapter2')}
                            className={`${style.chapter2} ${activeChapter === 'chapter2' ? style.active : ''} dropdown-item `}>
                              History and Evolution
                        </li>


                        <li onClick={() => handleClick('chapter3')}
                             className={`${style.chapter3} ${activeChapter === 'chapter3' ? style.active : ''} dropdown-item `}>
                            Role of JavaScript in Web Development
                     </li>
            
                        <li onClick={() => handleClick('chapter4')} 
                          className={`${style.chapter4} ${activeChapter === 'chapter4' ? style.active : ''} dropdown-item `}>
                      How JavaScript Works 
                        </li>


<h5>Setting Up the Environment</h5>
                        <li onClick={() => handleClick('chapter5')} 
                        className={`${style.chapter5} ${activeChapter === 'chapter5' ? style.active : ''} dropdown-item `}>
                        Installing and Setting Up IDE 
                        </li>

                        <li onClick={() => handleClick('chapter6')}
                        className={`${style.chapter6} ${activeChapter === 'chapter6' ? style.active : ''} dropdown-item `}>
                        Using Browsers Developer Tools
                        </li>

                        <li onClick={() => handleClick('chapter7')} 
                        className={`${style.chapter7} ${activeChapter === 'chapter7' ? style.active : ''} dropdown-item `}>
                        Including JavaScript in HTML 
                        </li>


<h5>JavaScript Basics</h5>
                        <li onClick={() => handleClick('chapter8')}
                        className={`${style.chapter8} ${activeChapter === 'chapter8' ? style.active : ''} dropdown-item `}>
                        Varibles 
                        </li>

                        <li onClick={() => handleClick('chapter9')}
                          className={`${style.chapter9} ${activeChapter === 'chapter9' ? style.active : ''} dropdown-item `}>
                        Data Types
                        </li>

                        <li onClick={() => handleClick('chapter10')}
                        className={`${style.chapter10} ${activeChapter === 'chapter10' ? style.active : ''} dropdown-item `}>
                        Operators 
                        </li>

                        <li onClick={() => handleClick('chapter11')} 
                        className={`${style.chapter11} ${activeChapter === 'chapter11' ? style.active : ''} dropdown-item `}>
                        Comments and Whitespace
                            </li>


<h5>Control Structure</h5>
                        <li onClick={() => handleClick('chapter12')}
                        className={`${style.chapter12} ${activeChapter === 'chapter12' ? style.active : ''} dropdown-item `}>
                          Conitional Statement 
                        </li>

                        <li onClick={() => handleClick('chapter13')} 
                        className={`${style.chapter13} ${activeChapter === 'chapter13' ? style.active : ''} dropdown-item `}>
                            Loops 
                        </li>
                        <li onClick={() => handleClick('chapter14')} 
                        className={`${style.chapter14} ${activeChapter === 'chapter14' ? style.active : ''} dropdown-item `}>
                            Break and Continue Statement
                        </li>


<h5>Function</h5>
                        <li onClick={() => handleClick('chapter15')} 
                          className={`${style.chapter15} ${activeChapter === 'chapter15' ? style.active : ''} dropdown-item `}>
                          Function Declaration vs. Expression
                        </li>

                        <li onClick={() => handleClick('chapter16')} 
                        className={`${style.chapter16} ${activeChapter === 'chapter16' ? style.active : ''} dropdown-item `}>
                          Arrow Functions
                        </li>

                        <li onClick={() => handleClick('chapter17')}
                          className={`${style.chapter17} ${activeChapter === 'chapter17' ? style.active : ''} dropdown-item `}>
                          Parameters, Arguments, and Return Values
                        </li>

                        <li onClick={() => handleClick('chapter18')} 
                        className={`${style.chapter18} ${activeChapter === 'chapter18' ? style.active : ''} dropdown-item `}>
                          Function Scope 
                        </li>

                        <li onClick={() => handleClick('chapter19')}
                        className={`${style.chapter19} ${activeChapter === 'chapter19' ? style.active : ''} dropdown-item `}>
                           IIFE 
                        </li>

                        <li onClick={() => handleClick('chapter20')} 
                        className={`${style.chapter20} ${activeChapter === 'chapter20' ? style.active : ''} dropdown-item `}>
                          Closures and Higher-Order Functions 
                        </li>

                        <li onClick={() => handleClick('chapter21')}
                        className={`${style.chapter21} ${activeChapter === 'chapter21' ? style.active : ''} dropdown-item `}>
                              Callbacks
                        </li>


<h5>Data Structure in JavaScript</h5>
                        <li onClick={() => handleClick('chapter22')} 
                        className={`${style.chapter22} ${activeChapter === 'chapter22' ? style.active : ''} dropdown-item `}>
                           Arrays
                        </li>

                        <li onClick={() => handleClick('chapter23')} 
                        className={`${style.chapter23} ${activeChapter === 'chapter23' ? style.active : ''} dropdown-item `}>
                          Methods 
                        </li>


                        <li onClick={() => handleClick('chapter24')} 
                        className={`${style.chapter24} ${activeChapter === 'chapter24' ? style.active : ''} dropdown-item `}>
                         Iterating Over Arrays
                        </li>
                        
                        <li onClick={() => handleClick('chapter25')} 
                        className={`${style.chapter25} ${activeChapter === 'chapter25' ? style.active : ''} dropdown-item `}>
                       Multi-dimentional Arrays
                        </li>

                        <li onClick={() => handleClick('chapter26')} 
                        className={`${style.chapter26} ${activeChapter === 'chapter26' ? style.active : ''} dropdown-item `}>
                        Objects
                        </li>

                        <li onClick={() => handleClick('chapter27')} 
                        className={`${style.chapter27} ${activeChapter === 'chapter27' ? style.active : ''} dropdown-item `}>
                         Creating Objects 
                        </li>

                        <li onClick={() => handleClick('chapter28')} 
                        className={`${style.chapter28} ${activeChapter === 'chapter28' ? style.active : ''} dropdown-item `}>
                       Accessing Properties and Methods
                        </li>

                        <li onClick={() => handleClick('chapter29')} 
                        className={`${style.chapter29} ${activeChapter === 'chapter29' ? style.active : ''} dropdown-item `}>
                       this Keyword in Objects 
                        </li>

                        <li onClick={() => handleClick('chapter30')} 
                        className={`${style.chapter30} ${activeChapter === 'chapter30' ? style.active : ''} dropdown-item `}>
                      ES6 Maps and Sets
                        </li>



<h5>JavaScript Events</h5>
                        <li onClick={() => handleClick('chapter31')} 
                        className={`${style.chapter31} ${activeChapter === 'chapter31' ? style.active : ''} dropdown-item `}>
                             Understanding Events 
                        </li>

                        <li onClick={() => handleClick('chapter32')} 
                        className={`${style.chapter32} ${activeChapter === 'chapter32' ? style.active : ''} dropdown-item `}>
                           Event Listeners and Event Handlers
                        </li>

                        <li onClick={() => handleClick('chapter33')} 
                        className={`${style.chapter33} ${activeChapter === 'chapter33' ? style.active : ''} dropdown-item `}>
                               Event Bubbling and Capturing
                        </li>

                        <li onClick={() => handleClick('chapter34')} 
                        className={`${style.chapter34} ${activeChapter === 'chapter34' ? style.active : ''} dropdown-item `}>
                             Preventing Default Behavior
                        </li>


<h5>DOM Manipulation</h5>
                        <li onClick={() => handleClick('chapter35')} 
                        className={`${style.chapter35} ${activeChapter === 'chapter35' ? style.active : ''} dropdown-item `}>
                         Selecting Elements 
                        </li>

                        <li onClick={() => handleClick('chapter36')} 
                        className={`${style.chapter36} ${activeChapter === 'chapter36' ? style.active : ''} dropdown-item `}>
                         Modifying HTML and Text Content
                        </li>

                        <li onClick={() => handleClick('chapter37')} 
                        className={`${style.chapter37} ${activeChapter === 'chapter37' ? style.active : ''} dropdown-item `}>
                         Changing Attributes, Classes, and Styles
                        </li>

                        <li onClick={() => handleClick('chapter38')} 
                        className={`${style.chapter38} ${activeChapter === 'chapter38' ? style.active : ''} dropdown-item `}>
                       Creating and Removing Elements
                        </li>

                        <li onClick={() => handleClick('chapter39')} 
                        className={`${style.chapter39} ${activeChapter === 'chapter39' ? style.active : ''} dropdown-item `}>
                          Traversing the DOM
                        </li>

                        <li onClick={() => handleClick('chapter40')} 
                        className={`${style.chapter40} ${activeChapter === 'chapter40' ? style.active : ''} dropdown-item `}>
                          DOM Events
                        </li>


<h5>JavaScript Object-Oriented Programming (OOP)</h5>
                        <li onClick={() => handleClick('chapter41')} 
                        className={`${style.chapter41} ${activeChapter === 'chapter41' ? style.active : ''} dropdown-item `}>
                         Introduction of OOP Concept 
                        </li>

                        <li onClick={() => handleClick('chapter42')} 
                        className={`${style.chapter42} ${activeChapter === 'chapter42' ? style.active : ''} dropdown-item `}>
                         Constructors and Prototypes
                        </li>

                        <li onClick={() => handleClick('chapter43')} 
                        className={`${style.chapter43} ${activeChapter === 'chapter43' ? style.active : ''} dropdown-item `}>
                          Encapsulation and Polymorphism
                        </li>

                        <li onClick={() => handleClick('chapter44')} 
                        className={`${style.chapter44} ${activeChapter === 'chapter44' ? style.active : ''} dropdown-item `}>
                        ES6 Classes and Methods
                        </li>

                        <li onClick={() => handleClick('chapter45')} 
                        className={`${style.chapter45} ${activeChapter === 'chapter45' ? style.active : ''} dropdown-item `}>
                        Inheritance 
                        </li>

                        <li onClick={() => handleClick('chapter46')} 
                        className={`${style.chapter46} ${activeChapter === 'chapter46' ? style.active : ''} dropdown-item `}>
                        Static Methods and Properties
                        </li>


<h5>Asynchronous JavaScript</h5>
                        <li onClick={() => handleClick('chapter47')} 
                        className={`${style.chapter47} ${activeChapter === 'chapter47' ? style.active : ''} dropdown-item `}>
                             Callback
                        </li>

                        <li onClick={() => handleClick('chapter48')} 
                        className={`${style.chapter48} ${activeChapter === 'chapter48' ? style.active : ''} dropdown-item `}>
                              Promises 
                        </li>

                        <li onClick={() => handleClick('chapter49')} 
                        className={`${style.chapter49} ${activeChapter === 'chapter49' ? style.active : ''} dropdown-item `}>
                              Async/Await
                        </li>

                        <li onClick={() => handleClick('chapter50')} 
                        className={`${style.chapter50} ${activeChapter === 'chapter50' ? style.active : ''} dropdown-item `}>
                              Error Handling in Asynchronous Code
                        </li>

                        <li onClick={() => handleClick('chapter51')} 
                        className={`${style.chapter51} ${activeChapter === 'chapter51' ? style.active : ''} dropdown-item `}>
                           Fetch API for HTTP Requests
                        </li>

                        <li onClick={() => handleClick('chapter52')} 
                        className={`${style.chapter52} ${activeChapter === 'chapter52' ? style.active : ''} dropdown-item `}>
                           Working with APIs 
                        </li>


<h5> Error Handling  </h5>
                        <li onClick={() => handleClick('chapter53')} 
                        className={`${style.chapter53} ${activeChapter === 'chapter53' ? style.active : ''} dropdown-item `}>
                        try, catch, finally
                        </li>

                        <li onClick={() => handleClick('chapter54')} 
                        className={`${style.chapter54} ${activeChapter === 'chapter54' ? style.active : ''} dropdown-item `}>
                        Custom Errors
                        </li>

                        <li onClick={() => handleClick('chapter55')} 
                        className={`${style.chapter55} ${activeChapter === 'chapter55' ? style.active : ''} dropdown-item `}>
                         Debugging with console.log, Breakpoints, and Developer Tools
                        </li>



<h5>ES6+ Features</h5>
                        <li onClick={() => handleClick('chapter56')} 
                        className={`${style.chapter56} ${activeChapter === 'chapter56' ? style.active : ''} dropdown-item `}>
                             Template Literals
                        </li>

                        <li onClick={() => handleClick('chapter57')} 
                        className={`${style.chapter57} ${activeChapter === 'chapter57' ? style.active : ''} dropdown-item `}>
                             Destructing Assignment 
                        </li>

                        <li onClick={() => handleClick('chapter58')} 
                        className={`${style.chapter58} ${activeChapter === 'chapter58' ? style.active : ''} dropdown-item `}>
                             Default Functions Parameters
                        </li>

                        <li onClick={() => handleClick('chapter59')} 
                        className={`${style.chapter59} ${activeChapter === 'chapter59' ? style.active : ''} dropdown-item `}>
                             Spread and Rest Operators
                        </li>

                        <li onClick={() => handleClick('chapter60')} 
                        className={`${style.chapter60} ${activeChapter === 'chapter60' ? style.active : ''} dropdown-item `}>
                             Modules 
                        </li>

                        <li onClick={() => handleClick('chapter61')} 
                        className={`${style.chapter61} ${activeChapter === 'chapter61' ? style.active : ''} dropdown-item `}>
                             Promises and Async/Await
                        </li>

                        <li onClick={() => handleClick('chapter62')} 
                        className={`${style.chapter62} ${activeChapter === 'chapter62' ? style.active : ''} dropdown-item `}>
                         Arrow Functions
                        </li>

                        <li onClick={() => handleClick('chapter63')} 
                        className={`${style.chapter63} ${activeChapter === 'chapter63' ? style.active : ''} dropdown-item `}>
                           Symbol, Map, and Set 
                        </li>


<h5>JavaScript Modules</h5>
                        <li onClick={() => handleClick('chapter64')} 
                        className={`${style.chapter64} ${activeChapter === 'chapter64' ? style.active : ''} dropdown-item `}>
                           Understanding Modules and their Importance
                        </li>

                        <li onClick={() => handleClick('chapter65')} 
                        className={`${style.chapter65} ${activeChapter === 'chapter65' ? style.active : ''} dropdown-item `}>
                           export and import
                        </li>

                        <li onClick={() => handleClick('chapter66')} 
                        className={`${style.chapter66} ${activeChapter === 'chapter66' ? style.active : ''} dropdown-item `}>
                           Default and Named Exports
                        </li>

                        <li onClick={() => handleClick('chapter67')} 
                        className={`${style.chapter67} ${activeChapter === 'chapter67' ? style.active : ''} dropdown-item `}>
                           Modularization Best Practice
                        </li>



<h5>JSON and Data Storage</h5>
                        <li onClick={() => handleClick('chapter68')} 
                        className={`${style.chapter68} ${activeChapter === 'chapter68' ? style.active : ''} dropdown-item `}>
                       Work with JSON 
                        </li>

                        <li onClick={() => handleClick('chapter69')} 
                        className={`${style.chapter69} ${activeChapter === 'chapter69' ? style.active : ''} dropdown-item `}>
                        Parsing and Stringifying JSON
                        </li>

                        <li onClick={() => handleClick('chapter70')} 
                        className={`${style.chapter70} ${activeChapter === 'chapter70' ? style.active : ''} dropdown-item `}>
                         Local Storage and Session Storage
                        </li>

                        <li onClick={() => handleClick('chapter71')} 
                        className={`${style.chapter71} ${activeChapter === 'chapter71' ? style.active : ''} dropdown-item `}>
                         Cookies in JavaScript
                        </li>



<h5>JavaScript and Web APIs</h5>
                        <li onClick={() => handleClick('chapter72')} 
                        className={`${style.chapter72} ${activeChapter === 'chapter72' ? style.active : ''} dropdown-item `}>
                          Inroduction of Web APIs
                        </li>


                        <li onClick={() => handleClick('chapter73')} 
                        className={`${style.chapter73} ${activeChapter === 'chapter73' ? style.active : ''} dropdown-item `}>
                         Fetch API for Ajax Calls
                        </li>

                        <li onClick={() => handleClick('chapter74')} 
                        className={`${style.chapter74} ${activeChapter === 'chapter74' ? style.active : ''} dropdown-item `}>
                         Working with APIs 
                        </li>

                        <li onClick={() => handleClick('chapter75')} 
                        className={`${style.chapter75} ${activeChapter === 'chapter75' ? style.active : ''} dropdown-item `}>
                        Geolocation API
                        </li>

            
                        <li onClick={() => handleClick('chapter76')} 
                        className={`${style.chapter76} ${activeChapter === 'chapter76' ? style.active : ''} dropdown-item `}>
                          File API 
                        </li>


            
 <h5>Error Handling and Debugging</h5>           
                        <li onClick={() => handleClick('chapter77')} 
                        className={`${style.chapter77} ${activeChapter === 'chapter77' ? style.active : ''} dropdown-item `}>
                         JavaScript Error Types 
                        </li>

            
                        <li onClick={() => handleClick('chapter78')} 
                        className={`${style.chapter78} ${activeChapter === 'chapter78' ? style.active : ''} dropdown-item `}>
                          try/ catch Blocks
                        </li>


                        <li onClick={() => handleClick('chapter79')} 
                        className={`${style.chapter79} ${activeChapter === 'chapter79' ? style.active : ''} dropdown-item `}>
                          Using throw for Custom Errors
                        </li>

            
                        <li onClick={() => handleClick('chapter80')} 
                        className={`${style.chapter80} ${activeChapter === 'chapter80' ? style.active : ''} dropdown-item `}>
                          Debugging Technique and Tools
                        </li>


  <h5> JavaScript Best Practices</h5>          
                        <li onClick={() => handleClick('chapter81')} 
                        className={`${style.chapter81} ${activeChapter === 'chapter81' ? style.active : ''} dropdown-item `}>
                         Clean Code Practrice
                        </li>

            
                        <li onClick={() => handleClick('chapter82')} 
                        className={`${style.chapter82} ${activeChapter === 'chapter82' ? style.active : ''} dropdown-item `}>
                         Code Optimization
                        </li>

            
                        <li onClick={() => handleClick('chapter83')} 
                        className={`${style.chapter83} ${activeChapter === 'chapter83' ? style.active : ''} dropdown-item `}>
                          Avoiding Common Mistakes
                        </li>

            
                        <li onClick={() => handleClick('chapter84')} 
                        className={`${style.chapter84} ${activeChapter === 'chapter84' ? style.active : ''} dropdown-item `}>
                          Memory Management
                        </li>

            
<h5>Version Control and Collaboration</h5>
                        <li onClick={() => handleClick('chapter85')} 
                        className={`${style.chapter85} ${activeChapter === 'chapter85' ? style.active : ''} dropdown-item `}>
                           Integrating JavaScript Projects with Git/GitHub
                        </li>

            
                        <li onClick={() => handleClick('chapter86')} 
                        className={`${style.chapter86} ${activeChapter === 'chapter86' ? style.active : ''} dropdown-item `}>
                          Best Practices for Code Versioning
                        </li>

            

<h5>JavaScript in Modern Web Development</h5>
                        <li onClick={() => handleClick('chapter87')} 
                        className={`${style.chapter87} ${activeChapter === 'chapter87' ? style.active : ''} dropdown-item `}>
                          Single Page Application
                        </li>

            
                        <li onClick={() => handleClick('chapter88')} 
                        className={`${style.chapter88} ${activeChapter === 'chapter88' ? style.active : ''} dropdown-item `}>
                           JavaScript Framworks and Libraries Overview 
                        </li>

            
                        <li onClick={() => handleClick('chapter89')} 
                        className={`${style.chapter89} ${activeChapter === 'chapter89' ? style.active : ''} dropdown-item `}>
                            Frontend Tooling 
                        </li>

            
                        <li onClick={() => handleClick('chapter90')} 
                        className={`${style.chapter90} ${activeChapter === 'chapter90' ? style.active : ''} dropdown-item `}>
                          TypeScript
                        </li>


 <h5>Testing in JavaScript</h5>
                        <li onClick={() => handleClick('chapter91')} 
                        className={`${style.chapter91} ${activeChapter === 'chapter91' ? style.active : ''} dropdown-item `}>
                         Unit Testing with Jasmine or Mocha
                        </li>

            
                        <li onClick={() => handleClick('chapter92')} 
                        className={`${style.chapter92} ${activeChapter === 'chapter92' ? style.active : ''} dropdown-item `}>
                             Integration Testing
                        </li>

            
                        <li onClick={() => handleClick('chapter93')} 
                        className={`${style.chapter93} ${activeChapter === 'chapter93' ? style.active : ''} dropdown-item `}>
                           Test-Driven Development Concepts
                        </li>

            

 <h5>Advanced JavaScript Concepts</h5> 

                        <li onClick={() => handleClick('chapter94')} 
                        className={`${style.chapter94} ${activeChapter === 'chapter94' ? style.active : ''} dropdown-item `}>
                     Currying and Partial Application
                        </li>

            
                        <li onClick={() => handleClick('chapter95')} 
                        className={`${style.chapter95} ${activeChapter === 'chapter95' ? style.active : ''} dropdown-item `}>
                          Memoization
                        </li>

            
                        <li onClick={() => handleClick('chapter96')} 
                        className={`${style.chapter96} ${activeChapter === 'chapter96' ? style.active : ''} dropdown-item `}>
                          Event Loop and Concurrency Model
                        </li>

            
                        <li onClick={() => handleClick('chapter97')} 
                        className={`${style.chapter97} ${activeChapter === 'chapter97' ? style.active : ''} dropdown-item `}>
                         JavaScript Engines
                        </li>

            
                        <li onClick={() => handleClick('chapter98')} 
                        className={`${style.chapter98} ${activeChapter === 'chapter98' ? style.active : ''} dropdown-item `}>
                           Web Workers
                        </li>

            
                        <li onClick={() => handleClick('chapter99')} 
                        className={`${style.chapter99} ${activeChapter === 'chapter99' ? style.active : ''} dropdown-item `}>
                        Proxy and Reflect
                        </li>

<h5>JavaScript Security</h5>
                        <li onClick={() => handleClick('chapter100')} 
                        className={`${style.chapter100} ${activeChapter === 'chapter100' ? style.active : ''} dropdown-item `}>
                           Common JavaScript Security Issues
                        </li>

                        <li onClick={() => handleClick('chapter101')} 
                        className={`${style.chapter101} ${activeChapter === 'chapter101' ? style.active : ''} dropdown-item `}>
                           Avoiding Cross-Site Scripting 
                        </li>

                        <li onClick={() => handleClick('chapter102')} 
                        className={`${style.chapter102} ${activeChapter === 'chapter102' ? style.active : ''} dropdown-item `}>
                           Content Security Policy 
                        </li>


              </ul>
                </div>





                <div className={`${style.leftcolumn} col-2`}>

                    <ul className={`${style.chapters} `}>
                    <h5 className={style.stickyheading} >JavaScript</h5>
                
                        <li
                            onClick={() => handleClick('chapter1')}

                            className={`${style.chapter1} ${activeChapter === 'chapter1' ? style.active : ''} text-decoration-none`}>
                              Introduction
                            </li>


                            <li
                            onClick={() => handleClick('chapter2')}
                            className={`${style.chapter2} ${activeChapter === 'chapter2' ? style.active : ''} `}>
                              History and Evolution
                        </li>


                        <li onClick={() => handleClick('chapter3')}
                             className={`${style.chapter3} ${activeChapter === 'chapter3' ? style.active : ''}`}>
                            Role of JavaScript in Web Development
                     </li>
            
                        <li onClick={() => handleClick('chapter4')} 
                          className={`${style.chapter4} ${activeChapter === 'chapter4' ? style.active : ''}`}>
                      How JavaScript Works 
                        </li>

<h5>Setting Up the Environment</h5>
                        <li onClick={() => handleClick('chapter5')} 
                        className={`${style.chapter5} ${activeChapter === 'chapter5' ? style.active : ''}`}>
                        Installing and Setting Up IDE 
                        </li>

                        <li onClick={() => handleClick('chapter6')}
                        className={`${style.chapter6} ${activeChapter === 'chapter6' ? style.active : ''}`}>
                        Using Browsers Developer Tools
                        </li>

                        <li onClick={() => handleClick('chapter7')} 
                        className={`${style.chapter7} ${activeChapter === 'chapter7' ? style.active : ''}`}>
                        Including JavaScript in HTML 
                        </li>
<h5>JavaScript Basics</h5>
                        <li onClick={() => handleClick('chapter8')}
                        className={`${style.chapter8} ${activeChapter === 'chapter8' ? style.active : ''}`}>
                        Varibles 
                        </li>

                        <li onClick={() => handleClick('chapter9')}
                          className={`${style.chapter9} ${activeChapter === 'chapter9' ? style.active : ''}`}>
                        Data Types
                        </li>

                        <li onClick={() => handleClick('chapter10')}
                        className={`${style.chapter10} ${activeChapter === 'chapter10' ? style.active : ''}`}>
                        Operators 
                        </li>

                        <li onClick={() => handleClick('chapter11')} 
                        className={`${style.chapter11} ${activeChapter === 'chapter11' ? style.active : ''}`}>
                        Comments and Whitespace
                            </li>


<h5>Control Structure</h5>
                        <li onClick={() => handleClick('chapter12')}
                        className={`${style.chapter12} ${activeChapter === 'chapter12' ? style.active : ''}`}>
                          Conitional Statement 
                        </li>

                        <li onClick={() => handleClick('chapter13')} 
                        className={`${style.chapter13} ${activeChapter === 'chapter13' ? style.active : ''}`}>
                            Loops 
                        </li>
                        <li onClick={() => handleClick('chapter14')} 
                        className={`${style.chapter14} ${activeChapter === 'chapter14' ? style.active : ''}`}>
                            Break and Continue Statement
                        </li>
<h5>Function</h5>
                        <li onClick={() => handleClick('chapter15')} 
                          className={`${style.chapter15} ${activeChapter === 'chapter15' ? style.active : ''}`}>
                          Function Declaration vs. Expression
                        </li>

                        <li onClick={() => handleClick('chapter16')} 
                        className={`${style.chapter16} ${activeChapter === 'chapter16' ? style.active : ''}`}>
                          Arrow Functions
                        </li>

                        <li onClick={() => handleClick('chapter17')}
                          className={`${style.chapter17} ${activeChapter === 'chapter17' ? style.active : ''}`}>
                          Parameters, Arguments, and Return Values
                        </li>


                        <li onClick={() => handleClick('chapter18')} 
                        className={`${style.chapter18} ${activeChapter === 'chapter18' ? style.active : ''}`}>
                          Function Scope 
                        </li>



                        <li onClick={() => handleClick('chapter19')}
                        className={`${style.chapter19} ${activeChapter === 'chapter19' ? style.active : ''} `}>
                         IIFE 
                        </li>

                        <li onClick={() => handleClick('chapter20')} 
                        className={`${style.chapter20} ${activeChapter === 'chapter20' ? style.active : ''}`}>
                         Closures and Higher-Order Functions 
                        </li>

                        <li onClick={() => handleClick('chapter21')}
                        className={`${style.chapter21} ${activeChapter === 'chapter21' ? style.active : ''}`}>
                        Callbacks
                        </li>

<h5>Data Structure in JavaScript</h5>
                        <li onClick={() => handleClick('chapter22')} 
                        className={`${style.chapter22} ${activeChapter === 'chapter22' ? style.active : ''}`}>
                       Arrays
                        </li>

                        <li onClick={() => handleClick('chapter23')} 
                        className={`${style.chapter23} ${activeChapter === 'chapter23' ? style.active : ''}  `}>
                    Methods 
                        </li>


                        <li onClick={() => handleClick('chapter24')} 
                        className={`${style.chapter24} ${activeChapter === 'chapter24' ? style.active : ''}  `}>
                     Iterating Over Arrays
                        </li>
                        
                        <li onClick={() => handleClick('chapter25')} 
                        className={`${style.chapter25} ${activeChapter === 'chapter25' ? style.active : ''}  `}>
                       Multi-dimentional Arrays
                        </li>

                        <li onClick={() => handleClick('chapter26')} 
                        className={`${style.chapter26} ${activeChapter === 'chapter26' ? style.active : ''}  `}>
                        Objects
                        </li>

                        <li onClick={() => handleClick('chapter27')} 
                        className={`${style.chapter27} ${activeChapter === 'chapter27' ? style.active : ''}  `}>
                      Creating Objects 
                        </li>

                        <li onClick={() => handleClick('chapter28')} 
                        className={`${style.chapter28} ${activeChapter === 'chapter28' ? style.active : ''}  `}>
                         Accessing Properties and Methods
                        </li>

                        <li onClick={() => handleClick('chapter29')} 
                        className={`${style.chapter29} ${activeChapter === 'chapter29' ? style.active : ''}  `}>
                       this Keyword in Objects 
                        </li>

                        <li onClick={() => handleClick('chapter30')} 
                        className={`${style.chapter30} ${activeChapter === 'chapter30' ? style.active : ''}  `}>
                      ES6 Maps and Sets
                        </li>

<h5>JavaScript Events</h5>
                        <li onClick={() => handleClick('chapter31')} 
                        className={`${style.chapter31} ${activeChapter === 'chapter31' ? style.active : ''}  `}>
                        Understanding Events 
                        </li>

                        <li onClick={() => handleClick('chapter32')} 
                        className={`${style.chapter32} ${activeChapter === 'chapter32' ? style.active : ''}  `}>
                        Event Listeners and Event Handlers
                          </li>

                        <li onClick={() => handleClick('chapter33')} 
                        className={`${style.chapter33} ${activeChapter === 'chapter33' ? style.active : ''}  `}>
                       Event Bubbling and Capturing
                        </li>

                        <li onClick={() => handleClick('chapter34')} 
                        className={`${style.chapter34} ${activeChapter === 'chapter34' ? style.active : ''}  `}>
                         Preventing Default Behavior
                        </li>

<h5>DOM Manipulation</h5>
                        <li onClick={() => handleClick('chapter35')} 
                        className={`${style.chapter35} ${activeChapter === 'chapter35' ? style.active : ''}  `}>
                         Selecting Elements 
                        </li>

                        <li onClick={() => handleClick('chapter36')} 
                        className={`${style.chapter36} ${activeChapter === 'chapter36' ? style.active : ''}  `}>
                        Modifying HTML and Text Content
                        </li>

                        <li onClick={() => handleClick('chapter37')} 
                        className={`${style.chapter37} ${activeChapter === 'chapter37' ? style.active : ''}  `}>
                        Changing Attributes, Classes, and Styles
                        </li>

                        <li onClick={() => handleClick('chapter38')} 
                        className={`${style.chapter38} ${activeChapter === 'chapter38' ? style.active : ''}  `}>
                         Creating and Removing Elements
                        </li>

                        <li onClick={() => handleClick('chapter39')} 
                        className={`${style.chapter39} ${activeChapter === 'chapter39' ? style.active : ''}  `}>
                        Traversing the DOM
                        </li>

                        <li onClick={() => handleClick('chapter40')} 
                        className={`${style.chapter40} ${activeChapter === 'chapter40' ? style.active : ''}  `}>
                         DOM Events
                        </li>

<h5>JavaScript Object-Oriented Programming (OOP)</h5>
                        <li onClick={() => handleClick('chapter41')} 
                        className={`${style.chapter41} ${activeChapter === 'chapter41' ? style.active : ''}  `}>
                       Introduction of OOP Concept 
                        </li>

                        <li onClick={() => handleClick('chapter42')} 
                        className={`${style.chapter42} ${activeChapter === 'chapter42' ? style.active : ''}  `}>
                       Constructors and Prototypes
                        </li>

                        <li onClick={() => handleClick('chapter43')} 
                        className={`${style.chapter43} ${activeChapter === 'chapter43' ? style.active : ''}  `}>
                        Encapsulation and Polymorphism
                        </li>

                        <li onClick={() => handleClick('chapter44')} 
                        className={`${style.chapter44} ${activeChapter === 'chapter44' ? style.active : ''}  `}>
                         ES6 Classes and Methods
                        </li>

                        <li onClick={() => handleClick('chapter45')} 
                        className={`${style.chapter45} ${activeChapter === 'chapter45' ? style.active : ''}  `}>
                        Inheritance 
                        </li>

                        <li onClick={() => handleClick('chapter46')} 
                        className={`${style.chapter46} ${activeChapter === 'chapter46' ? style.active : ''}  `}>
                      Static Methods and Properties
                        </li>

<h5>Asynchronous JavaScript</h5>
                        <li onClick={() => handleClick('chapter47')} 
                        className={`${style.chapter47} ${activeChapter === 'chapter47' ? style.active : ''}  `}>
                       Callback
                        </li>

                        <li onClick={() => handleClick('chapter48')} 
                        className={`${style.chapter48} ${activeChapter === 'chapter48' ? style.active : ''}  `}>
                       Promises 
                        </li>

                        <li onClick={() => handleClick('chapter49')} 
                        className={`${style.chapter49} ${activeChapter === 'chapter49' ? style.active : ''}  `}>
                        Async/Await
                        </li>

                        <li onClick={() => handleClick('chapter50')} 
                        className={`${style.chapter50} ${activeChapter === 'chapter50' ? style.active : ''}  `}>
                        Error Handling in Asynchronous Code
                        </li>

                        <li onClick={() => handleClick('chapter51')} 
                        className={`${style.chapter51} ${activeChapter === 'chapter51' ? style.active : ''}  `}>
                         Fetch API for HTTP Requests
                        </li>

                        <li onClick={() => handleClick('chapter52')} 
                        className={`${style.chapter52} ${activeChapter === 'chapter52' ? style.active : ''}  `}>
                         Working with APIs 
                        </li>


<h5> Error Handling  </h5>
                        <li onClick={() => handleClick('chapter53')} 
                        className={`${style.chapter53} ${activeChapter === 'chapter53' ? style.active : ''}  `}>
                        try, catch, finally
                        </li>

                        <li onClick={() => handleClick('chapter54')} 
                        className={`${style.chapter54} ${activeChapter === 'chapter54' ? style.active : ''}  `}>
                        Custom Errors
                        </li>

                        <li onClick={() => handleClick('chapter55')} 
                        className={`${style.chapter55} ${activeChapter === 'chapter55' ? style.active : ''}  `}>
                         Debugging with console.log, Breakpoints, and Developer Tools
                        </li>


<h5>ES6+ Features</h5>
                        <li onClick={() => handleClick('chapter56')} 
                        className={`${style.chapter56} ${activeChapter === 'chapter56' ? style.active : ''}  `}>
                              Template Literals
                        </li>

                        <li onClick={() => handleClick('chapter57')} 
                        className={`${style.chapter57} ${activeChapter === 'chapter57' ? style.active : ''}  `}>
                            Destructing Assignment 
                        </li>

                        <li onClick={() => handleClick('chapter58')} 
                        className={`${style.chapter58} ${activeChapter === 'chapter58' ? style.active : ''}  `}>
                             Default Functions Parameters
                        </li>

                        <li onClick={() => handleClick('chapter59')} 
                        className={`${style.chapter59} ${activeChapter === 'chapter59' ? style.active : ''}  `}>
                            Spread and Rest Operators
                        </li>

                        <li onClick={() => handleClick('chapter60')} 
                        className={`${style.chapter60} ${activeChapter === 'chapter60' ? style.active : ''}  `}>
                              Modules 
                        </li>

                        <li onClick={() => handleClick('chapter61')} 
                        className={`${style.chapter61} ${activeChapter === 'chapter61' ? style.active : ''}  `}>
                              Promises and Async/Await
                        </li>

                        <li onClick={() => handleClick('chapter62')} 
                        className={`${style.chapter62} ${activeChapter === 'chapter62' ? style.active : ''}  `}>
                         Arrow Functions
                        </li>

                        <li onClick={() => handleClick('chapter63')} 
                        className={`${style.chapter63} ${activeChapter === 'chapter63' ? style.active : ''}  `}>
                           Symbol, Map, and Set 
                        </li>

<h5>JavaScript Modules</h5>
                        <li onClick={() => handleClick('chapter64')} 
                        className={`${style.chapter64} ${activeChapter === 'chapter64' ? style.active : ''}  `}>
                         Understanding Modules and their Importance
                        </li>

                        <li onClick={() => handleClick('chapter65')} 
                        className={`${style.chapter65} ${activeChapter === 'chapter65' ? style.active : ''}  `}>
                         export and import
                        </li>

                        <li onClick={() => handleClick('chapter66')} 
                        className={`${style.chapter66} ${activeChapter === 'chapter66' ? style.active : ''}  `}>
                          Default and Named Exports
                        </li>

                        <li onClick={() => handleClick('chapter67')} 
                        className={`${style.chapter67} ${activeChapter === 'chapter67' ? style.active : ''}  `}>
                         Modularization Best Practice
                        </li>

<h5>JSON and Data Storage</h5>
                        <li onClick={() => handleClick('chapter68')} 
                        className={`${style.chapter68} ${activeChapter === 'chapter68' ? style.active : ''}  `}>
                       Work with JSON 
                        </li>

                        <li onClick={() => handleClick('chapter69')} 
                        className={`${style.chapter69} ${activeChapter === 'chapter69' ? style.active : ''}  `}>
                        Parsing and Stringifying JSON
                        </li>

                        <li onClick={() => handleClick('chapter70')} 
                        className={`${style.chapter70} ${activeChapter === 'chapter70' ? style.active : ''}  `}>
                        Local Storage and Session Storage
                        </li>

                        <li onClick={() => handleClick('chapter71')} 
                        className={`${style.chapter71} ${activeChapter === 'chapter71' ? style.active : ''}  `}>
                        Cookies in JavaScript
                        </li>

<h5>JavaScript and Web APIs</h5>
                        <li onClick={() => handleClick('chapter72')} 
                        className={`${style.chapter72} ${activeChapter === 'chapter72' ? style.active : ''}  `}>
                      Inroduction of Web APIs
                        </li>


                        <li onClick={() => handleClick('chapter73')} 
                        className={`${style.chapter73} ${activeChapter === 'chapter73' ? style.active : ''}  `}>
                        Fetch API for Ajax Calls
                        </li>

                        <li onClick={() => handleClick('chapter74')} 
                        className={`${style.chapter74} ${activeChapter === 'chapter74' ? style.active : ''}  `}>
              Working with APIs 
                        </li>

                        <li onClick={() => handleClick('chapter75')} 
                        className={`${style.chapter75} ${activeChapter === 'chapter75' ? style.active : ''}  `}>
                        Geolocation API
                        </li>

            
                        <li onClick={() => handleClick('chapter76')} 
                        className={`${style.chapter76} ${activeChapter === 'chapter76' ? style.active : ''}  `}>
                        File API 
                        </li>

            
 <h5>Error Handling and Debugging</h5>           
                        <li onClick={() => handleClick('chapter77')} 
                        className={`${style.chapter77} ${activeChapter === 'chapter77' ? style.active : ''}  `}>
                          JavaScript Error Types 
                        </li>

            
                        <li onClick={() => handleClick('chapter78')} 
                        className={`${style.chapter78} ${activeChapter === 'chapter78' ? style.active : ''}  `}>
                         try/ catch Blocks
                        </li>

            
                        <li onClick={() => handleClick('chapter79')} 
                        className={`${style.chapter79} ${activeChapter === 'chapter79' ? style.active : ''}  `}>
                         Using throw for Custom Errors
                        </li>

            
                        <li onClick={() => handleClick('chapter80')} 
                        className={`${style.chapter80} ${activeChapter === 'chapter80' ? style.active : ''}  `}>
                         Debugging Technique and Tools
                        </li>

  <h5> JavaScript Best Practices</h5>          
                        <li onClick={() => handleClick('chapter81')} 
                        className={`${style.chapter81} ${activeChapter === 'chapter81' ? style.active : ''}  `}>
                         Clean Code Practrice
                        </li>

            
                        <li onClick={() => handleClick('chapter82')} 
                        className={`${style.chapter82} ${activeChapter === 'chapter82' ? style.active : ''}  `}>
                          Code Optimization
                        </li>

            
                        <li onClick={() => handleClick('chapter83')} 
                        className={`${style.chapter83} ${activeChapter === 'chapter83' ? style.active : ''}  `}>
                        Avoiding Common Mistakes
                        </li>

            
                        <li onClick={() => handleClick('chapter84')} 
                        className={`${style.chapter84} ${activeChapter === 'chapter84' ? style.active : ''}  `}>
                          Memory Management
                        </li>

            
<h5>Version Control and Collaboration</h5>
                        <li onClick={() => handleClick('chapter85')} 
                        className={`${style.chapter85} ${activeChapter === 'chapter85' ? style.active : ''}  `}>
                         Integrating JavaScript Projects with Git/GitHub
                        </li>

            
                        <li onClick={() => handleClick('chapter86')} 
                        className={`${style.chapter86} ${activeChapter === 'chapter86' ? style.active : ''}  `}>
                          Best Practices for Code Versioning
                        </li>

            

<h5>JavaScript in Modern Web Development</h5>
                        <li onClick={() => handleClick('chapter87')} 
                        className={`${style.chapter87} ${activeChapter === 'chapter87' ? style.active : ''}  `}>
                         Single Page Application
                        </li>

            
                        <li onClick={() => handleClick('chapter88')} 
                        className={`${style.chapter88} ${activeChapter === 'chapter88' ? style.active : ''}  `}>
                          JavaScript Framworks and Libraries Overview 
                        </li>

            
                        <li onClick={() => handleClick('chapter89')} 
                        className={`${style.chapter89} ${activeChapter === 'chapter89' ? style.active : ''}  `}>
                          Frontend Tooling 
                        </li>

            
                        <li onClick={() => handleClick('chapter90')} 
                        className={`${style.chapter90} ${activeChapter === 'chapter90' ? style.active : ''}  `}>
                         TypeScript
                        </li>

 <h5>Testing in JavaScript</h5>
                        <li onClick={() => handleClick('chapter91')} 
                        className={`${style.chapter91} ${activeChapter === 'chapter91' ? style.active : ''}  `}>
                           Unit Testing with Jasmine or Mocha
                        </li>

            
                        <li onClick={() => handleClick('chapter92')} 
                        className={`${style.chapter92} ${activeChapter === 'chapter92' ? style.active : ''}  `}>
                          Integration Testing
                        </li>

            
                        <li onClick={() => handleClick('chapter93')} 
                        className={`${style.chapter93} ${activeChapter === 'chapter93' ? style.active : ''}  `}>
                           Test-Driven Development Concepts
                        </li>

            
 <h5>Advanced JavaScript Concepts</h5>           
                        <li onClick={() => handleClick('chapter94')} 
                        className={`${style.chapter94} ${activeChapter === 'chapter94' ? style.active : ''}  `}>
                       Currying and Partial Application
                        </li>

            
                        <li onClick={() => handleClick('chapter95')} 
                        className={`${style.chapter95} ${activeChapter === 'chapter95' ? style.active : ''}  `}>
                        Memoization
                        </li>

            
                        <li onClick={() => handleClick('chapter96')} 
                        className={`${style.chapter96} ${activeChapter === 'chapter96' ? style.active : ''}  `}>
                          Event Loop and Concurrency Model
                        </li>

            
                        <li onClick={() => handleClick('chapter97')} 
                        className={`${style.chapter97} ${activeChapter === 'chapter97' ? style.active : ''}  `}>
                          JavaScript Engines
                        </li>

            
                        <li onClick={() => handleClick('chapter98')} 
                        className={`${style.chapter98} ${activeChapter === 'chapter98' ? style.active : ''}  `}>
                       Web Workers
                        </li>

            
                        <li onClick={() => handleClick('chapter99')} 
                        className={`${style.chapter99} ${activeChapter === 'chapter99' ? style.active : ''}  `}>
                       Proxy and Reflect
                        </li>

<h5>JavaScript Security</h5>
                        <li onClick={() => handleClick('chapter100')} 
                        className={`${style.chapter100} ${activeChapter === 'chapter100' ? style.active : ''}  `}>
                         Common JavaScript Security Issues
                        </li>

                        <li onClick={() => handleClick('chapter101')} 
                        className={`${style.chapter101} ${activeChapter === 'chapter101' ? style.active : ''}  `}>
                           Avoiding Cross-Site Scripting 
                        </li>

                        <li onClick={() => handleClick('chapter102')} 
                        className={`${style.chapter102} ${activeChapter === 'chapter102' ? style.active : ''}  `}>
                          Content Security Policy 
                        </li>

                       

            

                    </ul>
                </div>




                <div className={`${style.rightcolumn} col`}>
                    {/* Chapter Content */}


                    {selectedChapter === 'chapter1' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Introduction </h1>

    <p>
      <strong>JavaScript</strong> is a high-level, dynamic programming language primarily used for creating interactive and dynamic content on web pages. It is one of the core technologies of the World Wide Web, alongside HTML (for structure) and CSS (for styling). JavaScript allows developers to add complex features like dynamic updates, interactivity, animations, and more to websites, making it a crucial component in modern web development.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Key Characteristics of JavaScript:</h2>
    <ol>
      <li>
        <strong>Client-Side and Server-Side:</strong> JavaScript was originally designed as a client-side language (executed in the browser), but with technologies like Node.js, it can also be used on the server side.
      </li><br />
      <li>
        <strong>Interpreted Language:</strong> JavaScript is an interpreted language, meaning code is executed line by line by the browser or runtime environment, without the need for prior compilation.
      </li><br />
      <li>
        <strong>Event-Driven and Asynchronous:</strong> JavaScript handles events (e.g., user clicks) and supports asynchronous programming (e.g., using promises, async/await) for handling long-running tasks like network requests.
      </li><br />
      <li>
        <strong>Prototype-based Object-Oriented:</strong> JavaScript supports object-oriented programming, but instead of using traditional classes (as in Java or C++), it uses prototypes to define and inherit object properties and methods.
      </li><br />
      <li>
        <strong>Dynamic and Loosely Typed:</strong> JavaScript variables are loosely typed, meaning a variable can hold any type of value (e.g., a string, a number) without strict data type enforcement.
      </li>
    </ol><br />

    <h2>Use Cases:</h2>
    <ul>
      <li>
        <strong>Web Development:</strong> JavaScript is primarily used in web development for:
        <ul>
          <li>Manipulating the DOM (Document Object Model): To dynamically change HTML and CSS content, such as showing/hiding elements, or responding to user interactions.</li><br />
          <li>Form Validation: To check user input before it is sent to the server.</li><br />
          <li>Interactive Features: Creating animations, sliders, pop-ups, and much more.</li>
        </ul>
      </li><br />
      <li>
        <strong>Backend Development:</strong> Using <strong>Node.js</strong>, JavaScript can be used to create server-side applications, manage databases, and handle HTTP requests and responses.
      </li><br />
      <li>
        <strong>Mobile and Desktop Applications:</strong> JavaScript, along with frameworks like <strong>React Native</strong> (for mobile apps) and <strong>Electron</strong> (for desktop apps), allows developers to build cross-platform applications.
      </li>
    </ul><br />

    <h2>Example:</h2>
    <pre>
      <code>
        {`// A simple JavaScript code to display an alert message
alert('Hello, World!');

// Adding interactivity to a button
document.querySelector('button').addEventListener('click', function() {
  alert('Button clicked!');
});`}
      </code>
    </pre><br />

    <h2>Evolution of JavaScript:</h2>
    <p>
      JavaScript has evolved significantly over time, especially with the release of ECMAScript standards. Some key milestones include:
    </p>
    <ul>
      <li><strong>ECMAScript 5 (ES5):</strong> Introduced new array methods, stricter syntax with 'use strict', and JSON support.</li><br />
      <li><strong>ECMAScript 6 (ES6/ES2015):</strong> A major update with features like arrow functions, <code>let</code> and <code>const</code> keywords, template literals, promises, and classes.</li><br />
      <li><strong>Modern Features:</strong> Further updates introduced async/await for better asynchronous programming, modules for structuring code, and much more.</li>
    </ul><br />

    <h2>Conclusion:</h2>
    <p>
      JavaScript is a versatile, powerful language that runs on almost every web browser and server environment. It has become indispensable in modern web development due to its ability to create dynamic, interactive user experiences, and its wide usage in full-stack development with frameworks like <strong>React</strong>, <strong>Angular</strong>, <strong>Vue.js</strong>, and <strong>Node.js</strong>.
    </p>
  </div>
)}


{selectedChapter === 'chapter2' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>History and Evolution</h1>


      <p>
        JavaScript has undergone significant evolution since its inception, shaping it into one of the most widely used
        programming languages today. Here’s a look at its history and key milestones:
      </p><br />

      <h4>1. Creation and Early Days (1995)</h4>
      <p>
        JavaScript was created by <strong>Brendan Eich</strong> in just 10 days in May 1995 while working at{' '}
        <strong>Netscape Communications</strong>. It was initially called <strong>Mocha</strong>, later renamed to{' '}
        <strong>LiveScript</strong>, and finally <strong>JavaScript</strong> to leverage the popularity of Java (despite
        the two languages having little in common). Netscape intended JavaScript to be a lightweight language to add
        interactivity to web pages, complementing HTML and CSS.
      </p><br />

      <h5 style={{paddingBottom:"6px"}}>Key points from this phase:</h5>
      <ul>
        <li>Designed for <strong>client-side scripting</strong>, primarily for browser environments.</li><br />
        <li>Created to allow non-programmers (like designers) to add dynamic features to websites.</li><br />
        <li>Was embedded in Netscape Navigator 2.0.</li>
      </ul><br />

      <h4>2. Standardization and ECMAScript (1997)</h4>
      <p>
        To prevent browser-specific implementations of JavaScript, <strong>Netscape</strong> submitted the language to{' '}
        <strong>ECMA International</strong> for standardization. This led to the creation of the{' '}
        <strong>ECMAScript</strong> specification, which formally defined JavaScript’s core language and syntax.
      </p><br />

      <h5 style={{paddingBottom:"6px"}}>ECMAScript 1 (ES1) – 1997:</h5>
      <ul>
        <li>First official standard version.</li><br />
        <li>Defined basic features such as object manipulation, loops, conditionals, and basic syntax rules.</li>
      </ul><br />

      <h4>3. Early Growth: ECMAScript 3 and Browser Wars (1999)</h4>
      <p>
        During the late 1990s, the so-called <strong>Browser Wars</strong> emerged between Netscape Navigator and
        Microsoft’s Internet Explorer (IE). Microsoft developed <strong>JScript</strong>, its own implementation of
        JavaScript. This rivalry pushed JavaScript adoption forward but also led to compatibility issues as different
        browsers supported different versions of JavaScript.
      </p><br />

      <h5 style={{paddingBottom:"6px"}}>ECMAScript 3 (ES3) – 1999:</h5>
      <ul>
        <li>
          Major update that introduced important features like <strong>regular expressions</strong>, <strong>try/catch</strong>{' '}
          for error handling, and new string methods.
        </li><br />
        <li>It became the most widely implemented version of JavaScript for several years.</li>
      </ul><br />

      <h4>4. Stagnation: ECMAScript 4 and the Dark Ages (2000s)</h4>
      <p>
        After ECMAScript 3, there were attempts to release <strong>ECMAScript 4</strong>, but disagreements among major
        stakeholders led to delays. As a result, JavaScript development stagnated for almost a decade.
      </p><br />
      <p>
        However, during this period:
        <ul>
          <li>
            JavaScript became more popular due to the rise of <strong>Ajax</strong> (Asynchronous JavaScript and XML),
            which enabled dynamic loading of data without reloading web pages.
          </li><br />
          <li>
            <strong>Libraries like jQuery</strong> (2006) made JavaScript easier to work with, especially when dealing
            with browser inconsistencies.
          </li>
        </ul>
      </p><br />

      <h4>5. Revival: ECMAScript 5 (2009)</h4>
      <p>
        In 2009, after years of delay, <strong>ECMAScript 5 (ES5)</strong> was released. It brought long-awaited
        improvements, such as:
        <ul>
          <li>
            <strong>'Strict mode'</strong> for cleaner error handling.
          </li><br />
          <li>Support for <strong>JSON</strong> (JavaScript Object Notation) natively.</li><br />
          <li>
            Enhanced array methods such as <code>forEach()</code>, <code>map()</code>, <code>filter()</code>, and{' '}
            <code>reduce()</code>.
          </li><br />
          <li>Better property manipulation and function improvements.</li>
        </ul>
      </p><br />

      <h4>6. The Modern JavaScript Era: ECMAScript 6 (ES6) / ECMAScript 2015</h4>
      <p>
        <strong>ES6/ECMAScript 2015</strong>, released in 2015, was a turning point for JavaScript. It introduced a
        massive overhaul of the language, making it more developer-friendly and powerful.
      </p><br />
      <p>
       <h3 style={{paddingBottom:"6px"}}> Key features of <strong>ES6</strong> include:</h3>
        <ul>
          <li>
            <code>let</code> and <code>const</code>: Block-scoped variable declarations.
          </li><br />
          <li>Arrow functions: A more concise syntax for function expressions.</li><br />
          <li>Classes: A cleaner syntax for object-oriented programming.</li><br />
          <li>Modules: Native support for modular code (using <code>import</code> and <code>export</code>).</li><br />
          <li>Promises: Simplified handling of asynchronous operations.</li><br />
          <li>Template literals: For easier string interpolation.</li><br />
          <li>
            Destructuring assignment: For more elegant extraction of values from arrays and objects.
          </li><br />
          <li>Default parameters and spread/rest operators.</li>
        </ul>
      </p><br />

      <h4>7. Post-ES6 and Yearly Updates (ES7, ES8, ES9...)</h4>
      <p>
        After ES6, JavaScript started following an annual release cycle with smaller, incremental updates.
      </p>
      <p>
        Some notable additions in recent versions include:
        <ul>
          <li>
            <strong>ES7 (2016):</strong> <code>Array.prototype.includes()</code> method and exponentiation operator
            (<code>**</code>).
          </li><br />
          <li>
            <strong>ES8 (2017):</strong> <code>async/await</code> and <code>Object.entries()</code> and{' '}
            <code>Object.values()</code> methods.
          </li><br />
          <li>
            <strong>ES9 (2018):</strong> Rest/Spread properties for object manipulation and asynchronous iteration.
          </li>
        </ul>
      </p><br />

      <h4>8. Current Trends and the Future</h4>
      <p>
        JavaScript is now ubiquitous, running not only in web browsers but also on servers (with <strong>Node.js</strong>),
        mobile devices (with <strong>React Native</strong>, <strong>Ionic</strong>), and even desktop apps (with{' '}
        <strong>Electron</strong>). The language continues to evolve to meet the demands of modern development.
      </p><br />
      <p>
        <strong>TypeScript</strong> (a statically-typed superset of JavaScript) has gained immense popularity for
        large-scale projects.
      </p><br />
      <p>
        <strong>WebAssembly</strong> allows JavaScript to interoperate with lower-level languages like C++ and Rust,
        improving performance in areas such as gaming, graphics, and data science.
      </p><br />

      <h4>Conclusion</h4>
      <p>
        From its humble beginnings in 1995 as a simple client-side scripting language to its current status as a
        versatile, full-stack language powering modern web and server applications, JavaScript has come a long way. With
        continuous improvements and a large developer community, it remains one of the most influential and widely used
        programming languages in the world.
      </p>
    </div>
)}

{selectedChapter === 'chapter3' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Role of JavaScript in Web Development</h1>


    <p>
      <strong>JavaScript</strong> plays a crucial role in modern web development as one of the core technologies for building dynamic and interactive websites. Alongside <strong>HTML</strong> (for content structure) and <strong>CSS</strong> (for styling), JavaScript provides the behavior and functionality that makes web pages responsive, engaging, and user-friendly. Here’s an overview of JavaScript’s role in web development:
    </p><br />

    <h3>1. Client-Side Scripting</h3>
    <p>
      JavaScript is primarily used as a client-side scripting language, meaning it runs in the user’s web browser without needing communication with the server. This allows for immediate interaction with the webpage, such as:
    </p>
    <ul>
      <li><strong>Form validation</strong>: Ensuring user input is correct before submission.</li><br />
      <li><strong>DOM manipulation</strong>: Dynamically updating or changing HTML and CSS content based on user interactions.</li><br />
      <li><strong>Interactive content</strong>: Creating interactive elements like sliders, pop-ups, dropdowns, and animations.</li>
    </ul><br />

    <h3>2. Asynchronous Programming (AJAX)</h3>
    <p>
      JavaScript enables asynchronous communication between the client and server using <strong>AJAX</strong> (Asynchronous JavaScript and XML). This allows web pages to:
    </p>
    <ul>
      <li>Fetch data from a server in the background.</li><br />
      <li>Update parts of a web page without reloading the entire page (enhancing the user experience).</li>
    </ul><br />

    <h3>3. Server-Side Development (Node.js)</h3>
    <p>
      JavaScript can also be used on the server side with platforms like <strong>Node.js</strong>. In server-side development, JavaScript plays a role in:
    </p>
    <ul>
      <li>Handling HTTP requests and responses.</li><br />
      <li>Managing databases (e.g., MongoDB).</li><br />
      <li>Building RESTful APIs and real-time applications like chat apps.</li>
    </ul><br />

    <h3>4. Web APIs and Browser Interaction</h3>
    <p>
      JavaScript interacts with various <strong>Web APIs</strong> provided by browsers, enabling developers to:
    </p>
    <ul>
      <li>Access and manipulate the <strong>Document Object Model (DOM)</strong>.</li><br />
      <li>Use <strong>Geolocation APIs</strong>, <strong>Web Storage</strong>, <strong>Canvas API</strong> for graphics, and <strong>Web Workers</strong> for multi-threading.</li><br />
      <li>Handle <strong>events</strong> (clicks, form submissions, keyboard presses) for enhanced interactivity.</li>
    </ul><br />

    <h3>5. Frameworks and Libraries</h3>
    <p>
      JavaScript is the foundation for many popular frameworks and libraries that simplify web development:
    </p>
    <ul>
      <li><strong>Front-end frameworks</strong> like <strong>React</strong>, <strong>Angular</strong>, and <strong>Vue.js</strong> make building complex user interfaces easier.</li><br />
      <li><strong>Back-end frameworks</strong> like <strong>Express.js</strong> allow for building robust server-side applications.</li><br />
      <li><strong>Libraries</strong> like <strong>jQuery</strong> simplify cross-browser scripting and DOM manipulation.</li>
    </ul><br />

    <h3>6. Mobile and Desktop Applications</h3>
    <p>
      JavaScript, combined with frameworks like <strong>React Native</strong> for mobile apps and <strong>Electron</strong> for desktop apps, enables developers to create cross-platform applications with a single codebase.
    </p><br />

    <h3>7. Full-Stack Development</h3>
    <p>
      With JavaScript running on both the client-side (browser) and server-side (Node.js), developers can work as <strong>full-stack developers</strong> using a single language for the entire application, making development more streamlined and efficient.
    </p><br />

    <h3>Conclusion</h3>
    <p>
      JavaScript is essential in web development for creating dynamic, interactive, and modern web applications. It powers everything from simple form validation to complex web apps, playing a pivotal role in both client and server-side development.
    </p>
  </div>
)}



{selectedChapter === 'chapter4' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>How JavaScript Works (Browser vs. Node.js)</h1>

    
    <p>
      <strong>JavaScript</strong> is a versatile language that can run in different environments: the browser and on the server (Node.js). While the core language remains the same in both environments, the way it works and the APIs available differ between browsers and Node.js. Let’s explore how JavaScript operates in these two environments:
    </p><br />


    <h4>1. JavaScript in the Browser</h4>
    <p>
      In the browser, JavaScript primarily interacts with the <strong>Document Object Model (DOM)</strong> and the browser’s <strong>Web APIs</strong>. Here's an overview of how it works in a browser environment:
    </p>
    <ul>
      <li><strong>Execution Environment:</strong> JavaScript runs on the client-side, directly inside the browser. Each tab or window of a browser typically represents a separate JavaScript execution environment.</li><br />
      <li><strong>Event-Driven Model:</strong> JavaScript is single-threaded in the browser, using an event-driven model. Tasks like user input, network responses, or timers trigger events, which JavaScript handles asynchronously using a callback/event loop system.</li><br />
      <li style={{paddingBottom:"6px"}}><strong>Key Responsibilities:</strong></li>
      <ul>
        <li>DOM Manipulation: JavaScript can interact with and manipulate the HTML and CSS on the page through the DOM.</li><br />
        <li>Event Handling: It responds to user interactions, such as clicks, keypresses, and scrolls.</li><br />
        <li>Asynchronous Operations: JavaScript in the browser can perform asynchronous tasks like HTTP requests via <strong>AJAX</strong> or <strong>Fetch API</strong>.</li>
      </ul><br />
      <li style={{paddingBottom:"6px"}}><strong>Limitations:</strong></li>
      <ul>
        <li>Limited access to system resources and files for security reasons.</li><br />
        <li>Runs in a sandboxed environment, meaning JavaScript in one browser tab cannot interfere with another.</li>
      </ul>
    </ul><br />

    <p><strong>Example of JavaScript in the Browser:</strong></p>
    <pre>
      <code>
{`
document.querySelector('button').addEventListener('click', function() {
  alert('Button clicked!');
});
`}
      </code>
    </pre>
<br />
   

    <h4>2. JavaScript in Node.js</h4>
    <p>
      <strong>Node.js</strong> is a server-side JavaScript runtime built on Chrome's V8 engine, allowing JavaScript to run outside the browser. Here's how it differs from the browser:
    </p>
    <ul>
      <li><strong>Execution Environment:</strong> In Node.js, JavaScript runs on the server. Unlike the browser, which is focused on user interface and interactivity, Node.js is used for backend services like APIs, database handling, and file operations.</li><br />
      <li><strong>Event-Driven and Asynchronous:</strong> Like in the browser, Node.js uses an event-driven, non-blocking model, making it highly efficient for handling concurrent tasks, such as serving multiple client requests.</li><br />
      <li style={{paddingBottom:"6px"}}><strong>Key Responsibilities:</strong></li>
      <ul>
        <li>File System Operations: Node.js allows JavaScript to interact with the server’s file system.</li><br />
        <li>Handling HTTP Requests: It can handle and respond to HTTP requests using frameworks like <strong>Express.js</strong>.</li><br />
        <li>Database Interaction: Node.js communicates with databases (e.g., MongoDB, MySQL) to fetch and store data.</li><br />
        <li>Modules: Node.js uses a module system (<code>require</code>) to load different pieces of functionality, including built-in modules like <code>fs</code> (file system) and <code>http</code>.</li><br />
      </ul>
      <li><strong>No DOM or Browser APIs:</strong> Node.js doesn’t have access to browser-specific objects like <code>window</code> or the DOM.</li>
    </ul><br />

    <p><strong>Example of JavaScript in Node.js:</strong></p>
    <pre>
      <code>
{`
const http = require('http');

http.createServer((req, res) => {
  res.writeHead(200, { 'Content-Type': 'text/plain' });
  res.end('Hello, Node.js');
}).listen(3000, () => {
  console.log('Server running on port 3000');
});
`}
      </code>
    </pre><br />



    <h3>Key Differences Between Browser and Node.js</h3>
    <table>
      <thead>
        <tr>
          <th>Feature</th>
          <th>Browser</th>
          <th>Node.js</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Environment</strong></td>
          <td>Client-side</td>
          <td>Server-side</td>
        </tr>
        <tr>
          <td><strong>Primary Use</strong></td>
          <td>Interacting with web pages</td>
          <td>Building backend applications</td>
        </tr>
        <tr>
          <td><strong>APIs Available</strong></td>
          <td>DOM, Web APIs (e.g., Fetch, Local Storage)</td>
          <td>File system, HTTP, modules</td>
        </tr>
        <tr>
          <td><strong>Global Objects</strong></td>
          <td><code>window</code>, <code>document</code></td>
          <td><code>global</code>, <code>process</code>, <code>require</code></td>
        </tr>
        <tr>
          <td><strong>Security</strong></td>
          <td>Sandboxed environment</td>
          <td>Full access to system resources</td>
        </tr>
      </tbody>
    </table><br />

    <h3>Conclusion:</h3>
    <p>
      JavaScript works differently depending on the environment—whether it’s running in the browser to manipulate web pages or on the server via Node.js to handle backend tasks. While the core syntax is the same, the APIs and the scope of what JavaScript can do differ significantly between these environments.
    </p>
  </div>
)}




{selectedChapter === 'chapter5' && (
<div className={style.chaptercontent}>
<h1 className={style.heading}>  Installing and Setting Up IDE (VS Code, Sublime Text, etc.)  </h1>
      

    <p>When starting with JavaScript development, using the right Integrated Development Environment (IDE) or text editor can greatly enhance your productivity. Here's how to install and set up popular editors like <strong>Visual Studio Code (VS Code)</strong> and <strong>Sublime Text</strong> for JavaScript development.</p>

  <br />

    <h2>1. Visual Studio Code (VS Code)</h2>
    <p><strong>VS Code</strong> is one of the most popular free code editors for JavaScript development. It's lightweight yet powerful, with support for various extensions and built-in Git integration.</p><br />

    <h3>Steps to Install and Set Up:</h3>
    <ol>
      <li>
        <strong>Download and Install:</strong>
        <p>
          Go to the official <a href="https://code.visualstudio.com/" target="_blank" rel="noopener noreferrer">VS Code website</a> and download the version for your operating system (Windows, macOS, or Linux). Run the installer and follow the on-screen instructions.
        </p>
      </li><br />
      <li>
        <strong>Setting Up for JavaScript:</strong>
        <p>VS Code supports JavaScript out of the box, but you can enhance your experience by installing these extensions:</p>
        <ul>
          <li><strong>ESLint:</strong> Provides JavaScript code linting to enforce best practices and style.</li><br />
          <li><strong>Prettier:</strong> A code formatter that ensures consistent code style.</li><br />
          <li><strong>Debugger for Chrome:</strong> Useful for debugging JavaScript code directly in the Chrome browser.</li><br />
          <li><strong>JavaScript (ES6) code snippets:</strong> Provides useful snippets for modern JavaScript.</li>
        </ul>
      </li><br />
      <li>
        <strong>Running JavaScript:</strong>
        <p>You can run JavaScript files directly in VS Code by using the built-in terminal. For Node.js development, install Node.js from the <a href="https://nodejs.org/" target="_blank" rel="noopener noreferrer">official website</a> and use the terminal in VS Code:</p>
        <pre>
          <code>node filename.js</code>
        </pre>
      </li><br />
      <li>
        <strong>Customization:</strong>
        <p>You can customize VS Code themes, fonts, and shortcuts by navigating to <code>File &gt; Preferences &gt; Settings</code>.</p>
      </li>
    </ol>
<br />

    <h2>2. Sublime Text</h2>
    <p><strong>Sublime Text</strong> is another lightweight yet powerful text editor widely used for JavaScript development. It's known for its speed and simplicity.</p>

    <h3>Steps to Install and Set Up:</h3>
    <ol>
      <li>
        <strong>Download and Install:</strong>
        <p>Visit the official <a href="https://www.sublimetext.com/" target="_blank" rel="noopener noreferrer">Sublime Text website</a> and download the installer for your OS. Install it following the provided instructions.</p>
      </li><br />
      <li>
        <strong>Setting Up for JavaScript:</strong>
        <p>By default, Sublime Text supports JavaScript with basic syntax highlighting. To enhance functionality, install <strong>Package Control</strong>:</p>
        <ul>
          <li>Press <code>Ctrl + Shift + P</code> and search for "Install Package Control."</li>
          <li>After installation, use it to install useful plugins.</li>
        </ul>
      </li><br />
      <li>
        <strong>Installing JavaScript Plugins:</strong>
        <p>Open the Command Palette (<code>Ctrl + Shift + P</code>) and type <strong>Package Control: Install Package</strong>. Search and install these packages:</p>
        <ul>
          <li><strong>SublimeLinter:</strong> Provides linting for JavaScript.</li><br />
          <li><strong>JavaScriptNext:</strong> Offers improved JavaScript syntax highlighting.</li><br />
          <li><strong>Babel:</strong> For ES6+ syntax highlighting and support.</li>
        </ul>
      </li><br />
      <li>
        <strong>Running JavaScript:</strong>
        <p>Sublime Text does not have a built-in terminal. For Node.js development, you'll need to run scripts from an external terminal or install plugins like <strong>SublimeREPL</strong> to execute JavaScript within the editor.</p>
      </li>
    </ol>
<br />

    <h2>Conclusion:</h2>
    <p>Both <strong>VS Code</strong> and <strong>Sublime Text</strong> are excellent choices for JavaScript development. While VS Code offers a more integrated environment with built-in features and extensions, Sublime Text is favored for its speed and simplicity. Depending on your development needs and preferences, either can be set up easily to support efficient JavaScript coding.</p>
  </div>
)}

    


{selectedChapter === 'chapter6' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>
      Using Browser Developer Tools in JavaScript
    </h1>

      <p>
        Browser Developer Tools are an essential part of JavaScript development, offering powerful features for debugging, inspecting, and optimizing your code. Here's how to use Developer Tools effectively in browsers like Chrome, Firefox, and Edge.
      </p>

 <br />

      <h3>1. Opening Developer Tools</h3>
      <p>
        Most modern browsers come with built-in Developer Tools, which can be opened using a keyboard shortcut or through the browser's menu:
      </p>
      <ul>
        <li>
          <strong>Chrome, Edge:</strong> Right-click anywhere on the page and select "Inspect" or press <code>Ctrl + Shift + I</code> (Windows/Linux) or <code>Cmd + Option + I</code> (macOS).
        </li><br />
        <li>
          <strong>Firefox:</strong> Right-click and select "Inspect Element" or press <code>Ctrl + Shift + I</code> (Windows/Linux) or <code>Cmd + Option + I</code> (macOS).
        </li>
        </ul>
<br />

      <h3 style={{paddingBottom:"6px"}}>2. Key Features of Developer Tools</h3>

      <h4>a. Elements Panel</h4>
      <p><strong>Purpose:</strong> The Elements panel lets you inspect and modify HTML and CSS in real-time.</p>
      <ul>
        <li>View the DOM structure of the current page.</li>
        <li>Modify HTML elements or CSS styles directly to test changes instantly.</li>
        <li>Use the "Styles" pane to test new styles or change existing ones without affecting the actual source code.</li>
        <li>Highlight specific elements by hovering over them in the DOM tree.</li>
      </ul><br />

      <h4>b. Console</h4>
      <p><strong>Purpose:</strong> The Console is used for debugging JavaScript code, testing snippets, and interacting with the webpage via the browser's JavaScript runtime.</p>
      <ul>
        <li><strong>Log Output:</strong> Use <code>console.log()</code>, <code>console.warn()</code>, and <code>console.error()</code> to output messages for debugging.</li>
        <pre>
          <code>{`
            console.log("This is a log message.");
            console.warn("This is a warning message.");
            console.error("This is an error message.");
           `} </code>
        </pre>
        <li>Run JavaScript commands directly in the console for testing.</li><br />
        <li>Errors in the script will appear in the Console with stack traces and line numbers.</li><br />
        <li>View AJAX or Fetch requests and their responses directly in the Console.</li>
      </ul><br />

      <h4>c. Sources Panel</h4>
      <p><strong>Purpose:</strong> The Sources panel allows you to view, edit, and debug your JavaScript files.</p>
      <ul>
        <li>Add breakpoints by clicking on the line numbers. The script will pause at the breakpoints, allowing you to inspect the state of the variables.</li><br />
        <li>Step through your code one line at a time to examine how the execution flows.</li><br />
        <li>Add expressions to watch, and the panel will display their current values as the code executes.</li><br />
        <li>Modify JavaScript files directly within the browser using Local Overrides to test changes without affecting server-side files.</li>
      </ul><br />

      <h4>d. Network Panel</h4>
      <p><strong>Purpose:</strong> The Network panel tracks all network activity between your browser and the server.</p>
      <ul>
        <li>Track AJAX/Fetch requests and view details like status codes, headers, and response times.</li><br />
        <li>Analyze performance and identify slow-loading resources or failed requests.</li><br />
        <li>Filter requests by type (e.g., XHR for AJAX, JS for JavaScript, CSS for stylesheets) to focus on relevant requests.</li>
      </ul><br />

      <h4>e. Performance Panel</h4>
      <p><strong>Purpose:</strong> The Performance panel allows you to profile and analyze the runtime performance of your website.</p>
      <ul>
        <li>Click "Record" and interact with your page, then stop recording to see a detailed analysis of time spent rendering, scripting, and painting.</li><br />
        <li>Identify performance bottlenecks and optimize JavaScript functions to improve speed.</li>
      </ul><br />

      <h4>f. Application Panel</h4>
      <p><strong>Purpose:</strong> The Application panel is used to inspect and manage web app resources like cookies, local storage, session storage, and service workers.</p>
      <ul>
        <li>View and manipulate local storage, session storage, cookies, and indexedDB.</li><br />
        <li>Manage service workers and check if they are registered and running correctly.</li><br />
        <li>Clear cache or manage assets stored by service workers.</li>
      </ul>

  <br />

      <h3>3. Debugging JavaScript with Developer Tools</h3>
      <p>One of the most valuable uses of Developer Tools is debugging JavaScript code. Here's how to approach debugging:</p>
      <ul>
        <li><strong>Set Breakpoints:</strong> In the Sources panel, click on the line number to set a breakpoint.</li><br />
        <li><strong>Step Over/Into/Out:</strong> Use <code>F10</code> to step over, <code>F11</code> to step into, and <code>Shift + F11</code> to step out of functions.</li><br />
        <li><strong>Inspect Variables:</strong> Hover over variables to see their current values, or use the "Scope" panel to view all variables in the current scope.</li><br />
        <li><strong>Modify Code:</strong> Change variables or functions on the fly to test different outcomes during execution.</li>
      </ul>

    <br />

      <h3>Conclusion</h3>
      <p>
        Browser Developer Tools offer a wide range of features that make debugging, inspecting, and optimizing JavaScript much easier. By mastering these tools, you can significantly improve the efficiency and quality of your JavaScript development workflow.
      </p>
    </div>

)}


{selectedChapter === 'chapter7' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Including JavaScript in HTML (Internal, External, Inline Scripts)</h1>

    <p>
      When working with JavaScript, there are different ways to include it in your HTML file. Depending on your use case, you can add JavaScript internally, externally, or inline within the HTML document. Here's an overview of each method:
    </p>

<br />

    <h3>1. Internal JavaScript</h3>
    <p style={{paddingBottom:"6px"}}>
      Internal JavaScript refers to adding JavaScript code directly within the HTML file using the <code>&lt;script&gt;</code> tag. The script is placed inside the <code>&lt;head&gt;</code> or <code>&lt;body&gt;</code> sections of the HTML document.
    </p>

    <h4>Example:</h4>
    <pre>
      <code>
        {`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Internal JavaScript</title>
    <script>
        // Internal JavaScript code
        function greet() {
            alert("Hello from internal JavaScript!");
        }
    </script>
</head>
<body>
    <button onclick="greet()">Click Me</button>
</body>
</html>`}
      </code>
    </pre><br />

    <h4 style={{paddingBottom:"6px"}}>Key Points:</h4>
    <ul>
      <li><strong>When to use:</strong> When your JavaScript code is small and specific to that particular HTML page.</li><br />
      <li><strong>Advantages:</strong> No need for external file management; code is immediately available in the HTML document.</li><br />
      <li><strong>Disadvantages:</strong> It can clutter the HTML file, especially with larger scripts.</li>
    </ul>

<br />

    <h3>2. External JavaScript</h3>
    <p style={{paddingBottom:"6px"}}>
      External JavaScript refers to writing JavaScript code in a separate <code>.js</code> file and linking it to your HTML using the <code>&lt;script&gt;</code> tag with the <code>src</code> attribute. This method is generally preferred for maintaining larger codebases.
    </p>

    <h4>Example:</h4>
    <ol>
      <li>
        <strong>External JavaScript File (<code>script.js</code>):</strong>
        <pre>
          <code>
            {`// External JavaScript code
function greet() {
    alert("Hello from external JavaScript!");
}`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>HTML File:</strong>
        <pre>
          <code>
            {`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>External JavaScript</title>
    <script src="script.js"></script>
</head>
<body>
    <button onclick="greet()">Click Me</button>
</body>
</html>`}
          </code>
        </pre>
      </li>
    </ol><br />

    <h4 style={{paddingBottom:"6px"}}>Key Points:</h4>
    <ul>
      <li><strong>When to use:</strong> When your JavaScript is shared across multiple pages or grows large enough to justify separating it into its own file.</li><br />
      <li><strong>Advantages:</strong> Keeps HTML files clean and separates concerns (HTML for structure, JavaScript for functionality). Easier to maintain and debug.</li><br />
      <li><strong>Disadvantages:</strong> Requires network requests to load the external file, which might slow down page loading if not optimized.</li>
    </ul>

    <br />

    <h3>3. Inline JavaScript</h3>
    <p style={{paddingBottom:"6px"}}>
      Inline JavaScript is embedded directly within an HTML element's attribute, such as the <code>onclick</code> attribute in a button or link. This is the least recommended approach but can be useful for very small scripts or quick tests.
    </p>

    <h4>Example:</h4>
    <pre>
      <code>
        {`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Inline JavaScript</title>
</head>
<body>
    <button onclick="alert('Hello from inline JavaScript!')">Click Me</button>
</body>
</html>`}
      </code>
    </pre><br />

    <h4 style={{paddingBottom:"6px"}}>Key Points:</h4>
    <ul>
      <li><strong>When to use:</strong> When you need to quickly add simple, one-line JavaScript code to an element.</li><br />
      <li><strong>Advantages:</strong> Quick and simple for small scripts.</li><br />
      <li><strong>Disadvantages:</strong> Reduces code readability and maintainability. Mixing JavaScript with HTML makes debugging harder and is not considered a good practice.</li>
    </ul>

   <br />

    <h2>Conclusion:</h2>
    <p>
      Each method of including JavaScript in HTML serves a purpose, and your choice depends on the project requirements:
    </p>
    <ul>
      <li><strong>Internal scripts</strong> are good for small, page-specific code.</li><br />
      <li><strong>External scripts</strong> are preferred for larger projects or when the script needs to be reused across multiple pages.</li><br />
      <li><strong>Inline scripts</strong> are discouraged in larger applications but may be useful for quick tests or simple functionality.</li>
    </ul><br />
    <p>
      Understanding when and how to use these methods can improve both the efficiency and maintainability of your code.
    </p>
  </div>
)}




{selectedChapter === 'chapter8' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Variables (var, let, const)</h1>

    <h2>Variables in JavaScript (var, let, const)</h2>
    <p>
      In JavaScript, variables are used to store data values. The way you declare a variable can affect its scope, reassignability, and hoisting behavior. JavaScript provides three keywords for declaring variables: <code>var</code>, <code>let</code>, and <code>const</code>. Here's an overview of each:
    </p>

  <br />

    <h3 style={{paddingBottom:"6px"}}>1. <strong>var</strong></h3>
    <ul>
      <li><strong>Scope:</strong>
        <p>
          <code>var</code> has a function scope, which means that it is only accessible within the function where it is declared. If declared outside a function, it is globally scoped.
        </p>
      </li><br />
      <li><strong>Hoisting:</strong>
        <p>
          Variables declared with <code>var</code> are hoisted to the top of their scope. This means you can use the variable before it's declared, but it will be <code>undefined</code> until the declaration is reached in the code.
        </p>
      </li><br />
      <li><strong>Reassignability:</strong>
        <p>You can reassign a variable declared with <code>var</code> to a different value.</p>
      </li>
    </ul><br />

    <h4>Example:</h4>
    <pre>
      <code>
{`function exampleVar() {
    console.log(a); // undefined (due to hoisting)
    var a = 10;
    console.log(a); // 10
}
exampleVar();`}
      </code>
    </pre>

<br />

    <h3 style={{paddingBottom:"6px"}}>2. <strong>let</strong></h3>
    <ul>
      <li><strong>Scope:</strong>
        <p>
          <code>let</code> has a block scope, meaning it is only accessible within the nearest enclosing block (curly braces <code>{'{}'}</code>), such as within loops or if statements.
        </p>
      </li><br />
      <li><strong>Hoisting:</strong>
        <p>
          Variables declared with <code>let</code> are also hoisted, but they cannot be accessed before the declaration. Trying to do so results in a <code>ReferenceError</code>.
        </p>
      </li><br />
      <li><strong>Reassignability:</strong>
        <p>You can reassign a variable declared with <code>let</code>, allowing you to change its value within its scope.</p>
      </li>
    </ul><br />

    <h4>Example:</h4>
    <pre>
      <code>
{`function exampleLet() {
    // console.log(b); // ReferenceError: Cannot access 'b' before initialization
    let b = 20;
    console.log(b); // 20
}
exampleLet();`}
      </code>
    </pre>

<br />

    <h3 style={{paddingBottom:"6px"}}>3. <strong>const</strong></h3>
    <ul>
      <li><strong>Scope:</strong>
        <p>
          Like <code>let</code>, <code>const</code> also has a block scope. It is only accessible within the nearest enclosing block.
        </p>
      </li><br />
      <li><strong>Hoisting:</strong>
        <p>
          <code>const</code> variables are hoisted similarly to <code>let</code>, meaning they cannot be accessed before their declaration.
        </p>
      </li><br />
      <li><strong>Reassignability:</strong>
        <p>
          Variables declared with <code>const</code> must be initialized at the time of declaration and cannot be reassigned. However, if the variable is an object or array, you can still modify the contents of the object or array.
        </p>
      </li>
    </ul><br />

    <h4>Example:</h4>
    <pre>
      <code>
{`function exampleConst() {
    const c = 30;
    console.log(c); // 30
    // c = 40; // TypeError: Assignment to constant variable

    const obj = { name: 'John' };
    obj.name = 'Doe'; // This is allowed
    console.log(obj.name); // 'Doe'
}
exampleConst();`}
      </code>
    </pre>

   <br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li>Use <strong>var</strong> for function-scoped variables, keeping in mind the potential for hoisting and its global accessibility if declared outside functions.</li><br />
      <li>Use <strong>let</strong> for block-scoped variables that may need to be reassigned.</li><br />
      <li>Use <strong>const</strong> for block-scoped variables that should not be reassigned after their initial declaration.</li>
    </ul><br />

    <p>
      Choosing the right variable declaration method is essential for maintaining clean, predictable code in JavaScript.
    </p>
  </div>
)}

{selectedChapter === 'chapter9' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Data Types (Primitive and Reference Type)</h1>
    
    <p>In JavaScript, data types are categorized into two main groups: <strong>Primitive Types</strong> and <strong>Reference Types</strong>. Understanding these types is essential for effective programming, as they determine how values are stored and manipulated.</p><br />

    <h2>1. Primitive Types</h2>

    <p>Primitive types represent the most basic data types in JavaScript. They are immutable and stored directly in the variable. Here are the primitive data types:</p>

    <ul>
      <li>
        <strong>Number</strong>: Represents both integer and floating-point numbers. For example:
        <pre><code>{`let age = 30;        // Integer
let price = 29.99;  // Floating-point`}</code></pre>
      </li><br />

      <li>
        <strong>String</strong>: Represents a sequence of characters. Strings can be defined using single quotes, double quotes, or backticks (for template literals). For example:
        <pre><code>{`let name = "John";
let greeting = \`Hello, \${name}!\`;  // Template literal`}</code></pre>
      </li><br />

      <li>
        <strong>Boolean</strong>: Represents a logical entity and can have two values: <code>true</code> or <code>false</code>. For example:
        <pre><code>{`let isActive = true;`}</code></pre>
      </li><br />

      <li>
        <strong>Undefined</strong>: A variable that has been declared but has not yet been assigned a value. The default value of an uninitialized variable is <code>undefined</code>. For example:
        <pre><code>{`let x;
console.log(x); // undefined`}</code></pre>
      </li><br />

      <li>
        <strong>Null</strong>: Represents the intentional absence of any object value. It is often used to indicate that a variable should be empty. For example:
        <pre><code>{`let data = null;`}</code></pre>
      </li><br />

      <li>
        <strong>Symbol</strong>: A unique and immutable value often used as object property keys. Symbols can be created using the <code>Symbol()</code> function. For example:
        <pre><code>{`const uniqueId = Symbol("id");`}</code></pre>
      </li><br />

      <li>
        <strong>BigInt</strong>: A relatively new addition to JavaScript that can represent integers with arbitrary precision. It is created by appending <code>n</code> to the end of a number. For example:
        <pre><code>{`let largeNumber = 123456789012345678901234567890n;`}</code></pre>
      </li>
    </ul><br />

    <h2>2. Reference Types</h2>

    <p>Reference types are more complex data types that are used to store collections of values or more complex entities. Unlike primitive types, reference types are mutable, meaning the values can be changed after their creation. Here are the main reference types:</p>

    <ul>
      <li>
        <strong>Object</strong>: A collection of key-value pairs, where keys are strings (or Symbols) and values can be of any data type. Objects can represent real-world entities and are created using curly braces <code>{}</code>. For example:
        <pre><code>{`let person = {
    name: "Alice",
    age: 25,
    isStudent: true
};`}</code></pre>
      </li><br />

      <li>
        <strong>Array</strong>: A special type of object used to store ordered collections of values. Arrays are created using square brackets <code>[]</code>. For example:
        <pre><code>{`let fruits = ["apple", "banana", "cherry"];`}</code></pre>
      </li><br />

      <li>
        <strong>Function</strong>: In JavaScript, functions are first-class objects, meaning they can be treated like any other object. They can be assigned to variables, passed as arguments, and returned from other functions. For example:
        <pre><code>{`function greet() {
    return "Hello!";
}`}</code></pre>
      </li><br />

      <li>
        <strong>Date</strong>: A built-in object that represents dates and times. It provides methods for date manipulation and formatting. For example:
        <pre><code>{`let now = new Date();`}</code></pre>
      </li><br />

      <li>
        <strong>RegExp</strong>: A built-in object that provides a way to work with regular expressions, allowing for pattern matching in strings. For example:
        <pre><code>{`let regex = /abc/;`}</code></pre>
      </li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>

    <p>
      <strong>Primitive Types</strong> (Number, String, Boolean, Undefined, Null, Symbol, BigInt) are immutable and store single values directly.
      <br />
      <strong>Reference Types</strong> (Object, Array, Function, Date, RegExp) are mutable, store collections of values, and are stored by reference.
    </p><br />

    <p>Understanding the distinction between these data types is crucial for managing data effectively and writing efficient JavaScript code.</p>
  </div>
)}




{selectedChapter === 'chapter10' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>
      Operators (Arithmetic, Assignment, Comparison, Logical, Ternary)
    </h1>

    <h2>1. Arithmetic Operators</h2>
    <p>
      Arithmetic operators are used to perform mathematical calculations. Here are the common arithmetic operators in JavaScript:
    </p>
    <ul>
      <li>
        <strong>Addition (`+`)</strong>: Adds two numbers.
        <pre><code>{`let sum = 5 + 3; // 8`}</code></pre>
      </li><br />
      <li>
        <strong>Subtraction (`-`)</strong>: Subtracts the second number from the first.
        <pre><code>{`let difference = 5 - 3; // 2`}</code></pre>
      </li><br />
      <li>
        <strong>Multiplication (`*`)</strong>: Multiplies two numbers.
        <pre><code>{`let product = 5 * 3; // 15`}</code></pre>
      </li><br />
      <li>
        <strong>Division (`/`)</strong>: Divides the first number by the second.
        <pre><code>{`let quotient = 5 / 2; // 2.5`}</code></pre>
      </li><br />
      <li>
        <strong>Modulus (`%`)</strong>: Returns the remainder of a division operation.
        <pre><code>{`let remainder = 5 % 2; // 1`}</code></pre>
      </li><br />
      <li>
        <strong>Exponentiation (`**`)</strong>: Raises the first number to the power of the second.
        <pre><code>{`let power = 2 ** 3; // 8`}</code></pre>
      </li>
    </ul><br />

    <h2>2. Assignment Operators</h2>
    <p>
      Assignment operators are used to assign values to variables. Here are the common assignment operators:
    </p>
    <ul>
      <li>
        <strong>Assignment (`=`)</strong>: Assigns a value to a variable.
        <pre><code>{`let x = 10; // x is now 10`}</code></pre>
      </li><br />
      <li>
        <strong>Addition Assignment (`+=`)</strong>: Adds the right operand to the left operand and assigns the result to the left operand.
        <pre><code>{`x += 5; // x is now 15`}</code></pre>
      </li><br />
      <li>
        <strong>Subtraction Assignment (`-=`)</strong>: Subtracts the right operand from the left operand and assigns the result to the left operand.
        <pre><code>{`x -= 5; // x is now 10`}</code></pre>
      </li><br />
      <li>
        <strong>Multiplication Assignment (`*=`)</strong>: Multiplies the left operand by the right operand and assigns the result to the left operand.
        <pre><code>{`x *= 2; // x is now 20`}</code></pre>
      </li><br />
      <li>
        <strong>Division Assignment (`/=`)</strong>: Divides the left operand by the right operand and assigns the result to the left operand.
        <pre><code>{`x /= 2; // x is now 10`}</code></pre>
      </li><br />
      <li>
        <strong>Modulus Assignment (`%=`)</strong>: Takes the modulus using two operands and assigns the result to the left operand.
        <pre><code>{`x %= 3; // x is now 1`}</code></pre>
      </li>
    </ul><br />

    <h2>3. Comparison Operators</h2>
    <p>
      Comparison operators are used to compare two values and return a boolean value (`true` or `false`). Here are the common comparison operators:
    </p>
    <ul>
      <li>
        <strong>Equal (`==`)</strong>: Checks if two values are equal (type coercion is performed).
        <pre><code>{`console.log(5 == '5'); // true`}</code></pre>
      </li><br />
      <li>
        <strong>Strict Equal (`===`)</strong>: Checks if two values are equal and of the same type.
        <pre><code>{`console.log(5 === '5'); // false`}</code></pre>
      </li><br />
      <li>
        <strong>Not Equal (`!=`)</strong>: Checks if two values are not equal (type coercion is performed).
        <pre><code>{`console.log(5 != '5'); // false`}</code></pre>
      </li><br />
      <li>
        <strong>Strict Not Equal (`!==`)</strong>: Checks if two values are not equal and not of the same type.
        <pre><code>{`console.log(5 !== '5'); // true`}</code></pre>
      </li><br />
      <li>
        <strong>Greater Than {"(`>`)"}</strong>: Checks if the left operand is greater than the right operand.
        <pre><code>{`console.log(5 > 3); // true`}</code></pre>
      </li><br />
      <li>
        <strong>Less Than {"(`<`)"}</strong>: Checks if the left operand is less than the right operand.
        <pre><code>{`console.log(5 < 3); // false`}</code></pre>
      </li><br />
      <li>
        <strong>Greater Than or Equal To{"(`>=`)"}</strong>: Checks if the left operand is greater than or equal to the right operand.
        <pre><code>{`console.log(5 >= 5); // true`}</code></pre>
      </li><br />
      <li>
        <strong>Less Than or Equal To{"(`<=`)"}</strong>: Checks if the left operand is less than or equal to the right operand.
        <pre><code>{`console.log(5 <= 3); // false`}</code></pre>
      </li>
    </ul><br />

    <h2>4. Logical Operators</h2>
    <p>
      Logical operators are used to combine two or more boolean expressions. Here are the common logical operators:
    </p>
    <ul>
      <li>
        <strong>Logical AND (`&&`)</strong>: Returns `true` if both operands are true.
        <pre><code>{`console.log(true && false); // false`}</code></pre>
      </li><br />
      <li>
        <strong>Logical OR (`||`)</strong>: Returns `true` if at least one of the operands is true.
        <pre><code>{`console.log(true || false); // true`}</code></pre>
      </li><br />
      <li>
        <strong>Logical NOT (`!`)</strong>: Reverses the logical state of its operand.
        <pre><code>{`console.log(!true); // false`}</code></pre>
      </li>
    </ul><br />

    <h2>5. Ternary Operator</h2>
    <p>
      The ternary operator is a shorthand for the `if...else` statement and is used to evaluate a condition. It takes three operands:
    </p>
    <pre><code>{`condition ? expressionIfTrue : expressionIfFalse;`}</code></pre>
    <p>For example:</p>
    <pre><code>{`let age = 18;
let canVote = (age >= 18) ? "Yes" : "No"; // "Yes"`}</code></pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li> <strong>Arithmetic Operators</strong> perform mathematical calculations.</li><br />
      <li> <strong>Assignment Operators</strong> assign values to variables.</li><br />
      <li> <strong>Comparison Operators</strong> compare values and return boolean results.</li><br />
      <li> <strong>Logical Operators</strong> combine boolean expressions.</li><br />
      <li> <strong>Ternary Operator</strong> provides a shorthand way to perform conditional evaluations.</li>
    </ul><br />

    <p>
      Understanding these operators is essential for writing effective JavaScript code!
    </p>
  </div>
)}
{selectedChapter === 'chapter11' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Comments and Whitespace</h1>

    <h2>Comments </h2>

    <p style={{paddingBottom:"6px"}}>
      Comments are used to annotate code and explain its functionality without affecting the execution of the program.
      They can be useful for documentation, debugging, or leaving notes for other developers. There are two types of comments in JavaScript:
    </p>

    <h3>1. Single-line Comments</h3>
    <p>
      These comments begin with <code>//</code>. Everything following <code>//</code> on that line will be treated as a comment.
    </p>
    <pre>
      <code>{`// This is a single-line comment
let x = 5; // Assigning 5 to x`}</code>
    </pre><br />

    <h3>2. Multi-line Comments</h3>
    <p>
      These comments begin with <code>/*</code> and end with <code>*/</code>. They can span multiple lines.
    </p>
    <pre style={{paddingBottom:"6px"}}>
      <code>{`/* This is a multi-line comment
that spans multiple lines */
let y = 10;`}</code>
    </pre>

    <h4>Example of Comments:</h4>
    <pre>
      <code>{`// Function to add two numbers
function add(a, b) {
    return a + b; // Return the sum of a and b
}

/* Calling the add function
   with arguments 5 and 3 */
let result = add(5, 3);
console.log(result); // Output: 8`}</code>
    </pre><br /> 

    <h2>Whitespace</h2>

    <p style={{paddingBottom:"6px"}}>
      Whitespace refers to any space, tab, or newline character in the code. It is often used to improve the readability of the code but does not affect the execution of JavaScript. Whitespace can be found in various forms:
    </p>

    <h3>1. Spaces</h3>
    <p>Used to separate keywords, variables, and operators.</p>
    <pre>
      <code>{`let sum = a + b; // Spaces separate the variables and operators`}</code>
    </pre><br />

    <h3>2. Tabs</h3>
    <p>Often used for indentation to indicate block levels in code.</p>
    <pre>
      <code>{`function example() {
    let x = 5; // Indented with a tab
}`}</code>
    </pre><br />

    <h3>3. Newlines</h3>
    <p>Used to separate statements and create line breaks.</p>
    <pre>
      <code>{`let a = 1;
let b = 2; // Each statement is on a new line`}</code>
    </pre><br />

    <h4>Example of Whitespace:</h4>
    <pre>
      <code>{`// Function to calculate the area of a rectangle
function calculateArea(length, width) {
    return length * width; // Multiplying length and width
}

// Calculate the area with length 5 and width 3
let area = calculateArea(5, 3);
console.log(area); // Output: 15`}</code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li><strong>Comments</strong>: Used to annotate and explain code. They are ignored during execution. There are two types: single-line (<code>//</code>) and multi-line (<code>/* ... */</code>).</li><br />
      <li><strong>Whitespace</strong>: Includes spaces, tabs, and newlines. It is used to improve code readability but does not affect code execution.</li>
    </ul>

    <p>Understanding comments and whitespace is essential for writing clean, maintainable JavaScript code!</p>
  </div>
)}


{selectedChapter === 'chapter12' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Conditional Statement (if, else if, else, switch)</h1>

    <p>
      Conditional statements are used to perform different actions based on different conditions.
      They allow you to control the flow of your program by executing specific blocks of code depending on whether a condition evaluates to true or false.
    </p><br />

    <h3>1. <code>if</code> Statement</h3>
    <p style={{paddingBottom:"6px"}}>The <code>if</code> statement evaluates a condition and executes a block of code if the condition is true.</p>
    
    <strong>Syntax:</strong>
    <pre>
      <code>
{`if (condition) {
    // Code to execute if condition is true
}`}
      </code>
    </pre><br />

    <strong>Example:</strong>
    <pre>
      <code>
{`let score = 85;
if (score >= 60) {
    console.log("You passed the exam!"); // Output: You passed the exam!
}`}
      </code>
    </pre><br />

    <h3>2. <code>else if</code> Statement</h3>
    <p style={{paddingBottom:"6px"}}>The <code>else if</code> statement allows you to check multiple conditions. If the first condition is false, it checks the next condition, and so on.</p>
    
    <strong>Syntax:</strong>
    <pre>
      <code>
{`if (condition1) {
    // Code to execute if condition1 is true
} else if (condition2) {
    // Code to execute if condition2 is true
} else {
    // Code to execute if none of the conditions are true
}`}
      </code>
    </pre><br />

    <strong>Example:</strong>
    <pre>
      <code>
{`let score = 75;

if (score >= 90) {
    console.log("Grade: A");
} else if (score >= 80) {
    console.log("Grade: B"); // Output: Grade: B
} else if (score >= 70) {
    console.log("Grade: C");
} else {
    console.log("Grade: D");
}`}
      </code>
    </pre><br />

    <h3>3. <code>else</code> Statement</h3>
    <p style={{paddingBottom:"6px"}}>The <code>else</code> statement is used to execute a block of code if none of the preceding conditions in the <code>if</code> or <code>else if</code> statements are true.</p>
    
    <strong>Syntax:</strong>
    <pre>
      <code>
{`if (condition) {
    // Code to execute if condition is true
} else {
    // Code to execute if condition is false
}`}
      </code>
    </pre><br />

    <strong>Example:</strong>
    <pre>
      <code>
{`let score = 55;

if (score >= 60) {
    console.log("You passed the exam!");
} else {
    console.log("You failed the exam!"); // Output: You failed the exam!
}`}
      </code>
    </pre><br />

    <h3>4. <code>switch</code> Statement</h3>
    <p style={{paddingBottom:"6px"}}>The <code>switch</code> statement is used to evaluate an expression and execute different blocks of code based on the value of that expression. It is particularly useful when dealing with multiple possible conditions.</p>
    
    <strong>Syntax:</strong>
    <pre>
      <code>
{`switch (expression) {
    case value1:
        // Code to execute if expression === value1
        break;
    case value2:
        // Code to execute if expression === value2
        break;
    default:
        // Code to execute if none of the cases match
}`}
      </code>
    </pre><br />

    <strong>Example:</strong>
    <pre>
      <code>
{`let day = 3;
let dayName;

switch (day) {
    case 1:
        dayName = "Monday";
        break;
    case 2:
        dayName = "Tuesday";
        break;
    case 3:
        dayName = "Wednesday"; // Output: Wednesday
        break;
    default:
        dayName = "Invalid day";
}

console.log(dayName);`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li><code>if</code> Statement: Executes a block of code if the specified condition is true.</li><br />
      <li><code>else if</code> Statement: Checks additional conditions if the previous conditions are false.</li><br />
      <li><code>else</code> Statement: Executes a block of code if none of the preceding conditions are true.</li><br />
      <li><code>switch</code> Statement: Evaluates an expression and executes code based on matching cases, useful for multiple conditions.</li>
    </ul><br />

    <p>Understanding these conditional statements is crucial for controlling the flow of your JavaScript code and making decisions based on dynamic conditions!</p>
  </div>
)}




{selectedChapter === 'chapter13' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Loops (for, While, do...While, for...in, for...of)</h1>

  
    <p>
      Loops are used to execute a block of code repeatedly until a specified condition is met. They are essential for iterating over collections, performing repetitive tasks, and controlling the flow of execution in programs.
    </p><br />

    <h3>1. <code>for</code> Loop</h3>

    <p style={{paddingBottom:"6px"}}>
      The <code>for</code> loop is used when you know in advance how many times you want to execute a statement or a block of statements.
    </p>

    <strong>Syntax:</strong>
    <pre>
      <code>
        {`for (initialization; condition; increment/decrement) {
    // Code to execute on each iteration
}`}
      </code>
    </pre><br />

    <strong>Example:</strong>
    <pre>
      <code>
        {`for (let i = 0; i < 5; i++) {
    console.log(i); // Output: 0, 1, 2, 3, 4
}`}
      </code>
    </pre><br />

    <h3>2. <code>while</code> Loop</h3>

    <p style={{paddingBottom:"6px"}}>
      The <code>while</code> loop executes a block of code as long as the specified condition evaluates to true. It is useful when the number of iterations is not known in advance.
    </p>

    <strong>Syntax:</strong>
    <pre>
      <code>
        {`while (condition) {
    // Code to execute as long as condition is true
}`}
      </code>
    </pre><br />

    <strong>Example:</strong>
    <pre>
      <code>
        {`let i = 0;
while (i < 5) {
    console.log(i); // Output: 0, 1, 2, 3, 4
    i++;
}`}
      </code>
    </pre><br />

    <h3>3. <code>do...while</code> Loop</h3>

    <p style={{paddingBottom:"6px"}}>
      The <code>do...while</code> loop is similar to the <code>while</code> loop, but it guarantees that the block of code will execute at least once, even if the condition is false on the first check.
    </p>

    <strong>Syntax:</strong>
    <pre>
      <code>
        {`do {
    // Code to execute
} while (condition);`}
      </code>
    </pre><br />

    <strong>Example:</strong>
    <pre>
      <code>
        {`let i = 0;
do {
    console.log(i); // Output: 0, 1, 2, 3, 4
    i++;
} while (i < 5);`}
      </code>
    </pre><br />

    <h3>4. <code>for...in</code> Loop</h3>

    <p style={{paddingBottom:"6px"}}>
      The <code>for...in</code> loop is used to iterate over the enumerable properties of an object. It is particularly useful for accessing object properties.
    </p>

    <strong>Syntax:</strong>
    <pre>
      <code>
        {`for (let key in object) {
    // Code to execute for each property
}`}
      </code>
    </pre><br />

    <strong>Example:</strong>
    <pre>
      <code>
        {`const person = {
    name: "Alice",
    age: 30,
    city: "New York"
};

for (let key in person) {
    console.log(\`\${key}: \${person[key]}\`);
    // Output: name: Alice
    //         age: 30
    //         city: New York
}`}
      </code>
    </pre><br />

    <h3>5. <code>for...of</code> Loop</h3>

    <p style={{paddingBottom:"6px"}}>
      The <code>for...of</code> loop is used to iterate over iterable objects such as arrays, strings, and collections. It provides a simple way to access each value in an iterable.
    </p>

    <strong>Syntax:</strong>
    <pre>
      <code>
        {`for (let value of iterable) {
    // Code to execute for each value
}`}
      </code>
    </pre><br />

    <strong>Example:</strong>
    <pre>
      <code>
        {`const numbers = [10, 20, 30, 40, 50];

for (let number of numbers) {
    console.log(number); // Output: 10, 20, 30, 40, 50
}`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>

    <ul>
      <li><strong><code>for</code> Loop</strong>: Executes a block of code a specific number of times based on an initialization, condition, and increment/decrement.</li><br />
      <li><strong><code>while</code> Loop</strong>: Continues executing a block of code as long as the condition is true.</li><br />
      <li><strong><code>do...while</code> Loop</strong>: Executes a block of code at least once, then continues based on the condition.</li><br />
      <li><strong><code>for...in</code> Loop</strong>: Iterates over the enumerable properties of an object.</li><br />
      <li><strong><code>for...of</code> Loop</strong>: Iterates over iterable objects like arrays and strings.</li>
    </ul><br />

    <p>
      Understanding loops is fundamental in JavaScript for performing repetitive tasks and working with collections effectively!
    </p>
  </div>
)}


{selectedChapter === 'chapter14' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Break and Continue Statements</h1>

    <p>
      <strong>Break</strong> and <strong>continue</strong> are control flow statements that help manage the execution of loops in JavaScript. They alter the normal flow of execution within loops, enabling you to control how and when to exit or skip iterations.
    </p><br />

    <h3>1. Break Statement</h3>
    <p style={{paddingBottom:"6px"}}>
      The <strong>break</strong> statement is used to exit a loop or switch statement prematurely. When the break statement is encountered, the control flow immediately exits the current loop or switch, and execution continues with the first statement following it.
    </p>

    <h4>Syntax:</h4>
    <pre><code>break;</code></pre><br />

    <h4>Example:</h4>
    <pre><code>
{`for (let i = 0; i < 10; i++) {
    if (i === 5) {
        break; // Exit the loop when i is 5
    }
    console.log(i); // Output: 0, 1, 2, 3, 4
}`}
    </code></pre><br />
    <p>
      In this example, the loop will terminate as soon as <code>i</code> equals 5, so the output will only include the numbers 0 through 4.
    </p><br />

    <h3>2. Continue Statement</h3>
    <p style={{paddingBottom:"6px"}}>
      The <strong>continue</strong> statement is used to skip the current iteration of a loop and continue with the next iteration. When the continue statement is executed, the rest of the code inside the loop for that iteration is skipped, and the loop proceeds to the next iteration.
    </p>

    <h4>Syntax:</h4>
    <pre><code>continue;</code></pre><br />

    <h4>Example:</h4>
    <pre><code>
{`for (let i = 0; i < 10; i++) {
    if (i % 2 === 0) {
        continue; // Skip the rest of the loop for even numbers
    }
    console.log(i); // Output: 1, 3, 5, 7, 9
}`}
    </code></pre>
    <p>
      In this example, the loop will skip printing even numbers, so the output will only include the odd numbers from 0 to 9.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Summary</h3>
    <ul>
      <li><strong>Break Statement</strong>: Exits the current loop or switch statement immediately, continuing with the next statement following it.</li><br />
      <li><strong>Continue Statement</strong>: Skips the current iteration of the loop and continues with the next iteration.</li>
    </ul><br />
    <p>
      Understanding these statements is crucial for effectively managing control flow within loops in JavaScript, allowing for more flexible and efficient code execution.
    </p>
  </div>
)}

{selectedChapter === 'chapter15' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Function Declaration vs. Expression</h1>

    <p>
      In JavaScript, <strong>functions</strong> can be defined in two primary ways: <strong>function declarations</strong> and <strong>function expressions</strong>. Here’s a breakdown of the differences between them:
    </p><br />

    <h3>Function Declaration</h3>
    <p style={{paddingBottom:"6px"}}>
      A <strong>function declaration</strong> defines a function with a specified name, which can be called anywhere in the code, even before it is defined (due to hoisting).
    </p>

    <h4>Syntax:</h4>
    <pre><code>function functionName(parameters) { /* Function body */ }</code></pre><br />

    <h4>Example:</h4>
    <pre><code>
{`function greet(name) {
    return \`Hello, \${name}!\`;
}

console.log(greet('Alice')); // Output: Hello, Alice!`}
    </code></pre><br />

    <h3 style={{paddingBottom:"6px"}}>Key Characteristics:</h3>
    <ul>
      <li><strong>Hoisting</strong>: Function declarations are hoisted to the top of their containing scope, allowing them to be invoked before their definition.</li><br />
      <li><strong>Named Functions</strong>: The function has a name, making it easier to reference.</li>
    </ul><br />

    <h3>Function Expression</h3>
    <p style={{paddingBottom:"6px"}}>
      A <strong>function expression</strong> creates a function and assigns it to a variable. This expression can be either named or anonymous. Unlike function declarations, function expressions are not hoisted, so they can only be called after they are defined.
    </p>

    <h4>Syntax:</h4>
    <pre><code>const variableName = function(parameters) { /* Function body */ };</code></pre><br />

    <h4>Example:</h4>
    <pre><code>
{`const greet = function(name) {
    return \`Hello, \${name}!\`;
};

console.log(greet('Alice')); // Output: Hello, Alice!`}
    </code></pre><br />

    <h3 style={{paddingBottom:"6px"}}>Key Characteristics:</h3>
    <ul>
      <li><strong>No Hoisting</strong>: Function expressions are not hoisted, so they cannot be called before their definition.</li><br />
      <li><strong>Anonymous or Named</strong>: They can be anonymous (no name) or named (having a name).</li>
    </ul><br />

    <h3>Comparison</h3>
    <table>
      <thead>
        <tr>
          <th>Feature</th>
          <th>Function Declaration</th>
          <th>Function Expression</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Hoisting</strong></td>
          <td>Yes, can be called before definition</td>
          <td>No, must be defined before calling</td>
        </tr>
        <tr>
          <td><strong>Syntax</strong></td>
          <td><code>function name() {}</code></td>
          <td><code>const name = function() {}</code></td>
        </tr>
        <tr>
          <td><strong>Naming</strong></td>
          <td>Must have a name</td>
          <td>Can be anonymous or named</td>
        </tr>
        <tr>
          <td><strong>Scope</strong></td>
          <td>Available throughout the scope</td>
          <td>Limited to the scope where defined</td>
        </tr>
      </tbody>
    </table><br />

    <h3 style={{paddingBottom:"6px"}}>Summary</h3>
    <p>
      <strong>Function Declarations</strong> are defined with the <code>function</code> keyword and are hoisted, allowing them to be called before their definition. <strong>Function Expressions</strong> create functions as part of an expression and are not hoisted, meaning they can only be called after they are defined.
    </p>
    <p>
      Understanding the differences between function declarations and expressions is essential for effective function management in JavaScript, especially regarding scope and execution order!
    </p>
  </div>
)}



{selectedChapter === 'chapter16' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Arrow Functions</h1>

    <p>
      Arrow functions are a concise way to write function expressions in JavaScript, introduced in ES6 (ECMAScript 2015). They provide a more syntactically compact and often more readable alternative to traditional function expressions. Here’s a breakdown of their characteristics, syntax, and usage:
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Characteristics of Arrow Functions:</h3>
    <ol>
      <li><strong>Shorter Syntax</strong>: Arrow functions allow you to write functions in a more concise manner, especially for simple operations.</li><br />
      <li><strong>Implicit Return</strong>: If the function body consists of a single expression, you can omit the braces and the <code>return</code> keyword, and the expression will be returned implicitly.</li><br />
      <li><strong>Lexical <code>this</code> Binding</strong>: Arrow functions do not have their own <code>this</code> context. Instead, they inherit <code>this</code> from the parent scope at the time they are defined. This is particularly useful in scenarios where you want to preserve the <code>this</code> value from an enclosing context, such as in callbacks.</li><br />
      <li><strong>No <code>arguments</code> Object</strong>: Arrow functions do not have their own <code>arguments</code> object, which means you cannot access the <code>arguments</code> object within an arrow function.</li><br />
      <li><strong>Cannot be Used as Constructors</strong>: Arrow functions cannot be used with the <code>new</code> keyword, meaning they cannot be instantiated.</li>
    </ol><br />

    <h3>Syntax:</h3>
    <pre><code>const functionName = (parameters) {"=>"} {
    // Function body
};</code></pre><br />

    <h3 style={{paddingBottom:"6px"}}>Examples:</h3>
    <h4>1. Basic Example:</h4>
    <pre><code>{`const add = (a, b) => {
    return a + b;
};
console.log(add(2, 3)); // Output: 5`}</code></pre><br />

    <h4>2. Implicit Return:</h4>
    <pre><code>{`const multiply = (a, b) => a * b;
console.log(multiply(4, 5)); // Output: 20`}</code></pre><br />

    <h4>3. With No Parameters:</h4>
    <pre><code>{`const greet = () => 'Hello, World!';
console.log(greet()); // Output: Hello, World!`}</code></pre><br />

    <h4>4. With One Parameter (Parentheses Optional):</h4>
    <pre><code>{`const square = x => x * x;
console.log(square(6)); // Output: 36`}</code></pre><br />

    <h4>5. Lexical <code>this</code> Binding:</h4>
    <pre><code>{`function Person() {
    this.age = 0;

    setInterval(() => {
        this.age++; // \`this\` refers to the Person object
        console.log(this.age);
    }, 1000);
}

const p = new Person(); // Logs age incrementing every second`}</code></pre><br />

    <h3>Summary</h3>
    <p>
      Arrow functions offer a modern and cleaner syntax for writing functions in JavaScript. Their key features—such as implicit returns, lexical <code>this</code> binding, and concise syntax—make them particularly useful for writing callbacks and functional programming constructs. However, it's essential to be aware of their limitations, such as the lack of their own <code>this</code> and <code>arguments</code> object, to use them effectively.
    </p>
  </div>
)}




{selectedChapter === 'chapter17' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Parameters, Arguments, and Return Values</h1>

    <p>
      In JavaScript, parameters, arguments, and return values are fundamental concepts related to functions. Here's a breakdown of each:
    </p><br />

    <h3>1. Parameters</h3>
    <p style={{paddingBottom:"6px"}}>
      <strong>Parameters</strong> are the variables listed in a function's definition. They act as placeholders for the values that will be passed to the function when it is called. Parameters allow functions to receive input and operate on it.
    </p>

    <h4>Example:</h4>
    <pre><code>
{`function add(a, b) {  // a and b are parameters
    return a + b;
}`}
    </code></pre>
    <p>
      In this example, <code>a</code> and <code>b</code> are parameters of the <code>add</code> function. They will hold the values passed when the function is called.
    </p><br />

    <h3>2. Arguments</h3>
    <p style={{paddingBottom:"6px"}} >
      <strong>Arguments</strong> are the actual values that you pass to a function when you call it. The number of arguments passed to the function can differ from the number of parameters, as JavaScript allows for more arguments than parameters.
    </p>

    <h4>Example:</h4>
    <pre><code>
{`console.log(add(5, 3)); // 5 and 3 are arguments`}
    </code></pre>
    <p>
      In this case, <code>5</code> and <code>3</code> are the arguments provided to the <code>add</code> function when it is called. They correspond to the parameters <code>a</code> and <code>b</code>.
    </p><br />

    <h3>3. Return Values</h3>
    <p style={{paddingBottom:"6px"}}>
      A <strong>return value</strong> is the value that a function sends back to the caller after it has executed. The <code>return</code> statement is used to specify the value to be returned. If a function does not explicitly return a value, it returns <code>undefined</code> by default.
    </p>

    <h4>Example:</h4>
    <pre><code>
{`function multiply(x, y) {
    return x * y; // Returns the product of x and y
}

const result = multiply(4, 5); // result will be 20
console.log(result); // Output: 20`}
    </code></pre>
    <p>
      Here, the <code>multiply</code> function returns the product of <code>x</code> and <code>y</code>, which is captured in the variable <code>result</code>.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Summary</h3>
    <ul>
      <li><strong>Parameters</strong>: Placeholders in function definitions that specify what inputs the function can accept.</li><br />
      <li><strong>Arguments</strong>: The actual values passed to the function when it is called, which replace the parameters.</li><br />
      <li><strong>Return Values</strong>: The value that a function outputs after execution, which can be used or stored by the caller.</li>
    </ul><br />

    <p>
      Understanding these concepts is essential for writing effective and flexible functions in JavaScript.
    </p>
  </div>
)}






{selectedChapter === 'chapter18' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Function Scope (Local, Global, Block)</h1>

    <p>
      In JavaScript, scope refers to the accessibility of variables, objects, and functions in different parts of the code. 
      There are three main types of scope: <strong>Global</strong>, <strong>Local</strong>, and <strong>Block</strong> scope.
    </p><br />

    <h2>1. Global Scope</h2>
    <p>
      <strong>Definition</strong>: Variables declared outside of any function or block have a global scope. 
      These variables can be accessed from anywhere in the code, including inside functions.
    </p>
    <pre>
      <code>
        {`var globalVar = "I'm global!";

function showGlobal() {
    console.log(globalVar); // Accessing global variable
}

showGlobal(); // Output: I'm global!
console.log(globalVar); // Output: I'm global!`}
      </code>
    </pre><br />

    <h2>2. Local Scope</h2>
    <p>
      <strong>Definition</strong>: Variables declared within a function have a local scope. 
      They are only accessible within that function and are not available outside of it.
    </p>
    <pre>
      <code>
        {`function showLocal() {
    var localVar = "I'm local!";
    console.log(localVar); // Output: I'm local!
}

showLocal();
console.log(localVar); // Error: localVar is not defined`}
      </code>
    </pre><br />

    <h2>3. Block Scope</h2>
    <p>
      <strong>Definition</strong>: Introduced in ES6, block scope is created by using curly braces {`{}`}. 
      Variables declared with <code>let</code> and <code>const</code> inside a block (like an <code>if</code> statement or a loop) 
      are not accessible outside of that block.
    </p>
    <pre>
      <code>
        {`{
    let blockVar = "I'm block scoped!";
    console.log(blockVar); // Output: I'm block scoped!
}

console.log(blockVar); // Error: blockVar is not defined`}
      </code>
    </pre><br />

    <h2 style={{ paddingBottom: "6px" }}>Summary</h2>
    <ul>
      <li><strong>Global Scope</strong>: Accessible everywhere in the code.</li><br />
      <li><strong>Local Scope</strong>: Accessible only within the function where it is declared.</li><br />
      <li><strong>Block Scope</strong>: Accessible only within the block where it is declared, typically using <code>let</code> or <code>const</code>.</li>
    </ul><br />

    <p>
      Understanding these scopes is crucial for managing variable accessibility and avoiding naming conflicts in JavaScript.
    </p>
  </div>
)}




{selectedChapter === 'chapter19' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>IIFE (Immediately Invoked Function Expressions)</h1>
    
    <p>
      An <strong>IIFE (Immediately Invoked Function Expression)</strong> is a JavaScript function 
      that is defined and executed immediately after its creation. IIFEs are often used to create 
      a private scope, which helps avoid polluting the global namespace and allows for encapsulation 
      of variables and functions.
    </p><br />

    <h2>Syntax of IIFE</h2>
    <pre>
      <code>
        {`(function() {
            // code to be executed
          })();`}
      </code>
    </pre><br />

    <h2>Explanation:</h2>
    <ol>
      <li>
        <strong>Function Declaration</strong>: The function is defined inside parentheses 
      <code>{"`(function() { ... })`"
      }</code> . This ensures that it is treated as an expression.
      </li><br />
      <li>
        <strong>Immediate Invocation</strong>: The `()` at the end calls the function immediately 
        after it is defined.
      </li>
    </ol><br />

    <h2>Example:</h2>
    <pre>
      <code>
        {`(function() {
            var message = "Hello, IIFE!";
            console.log(message); // Output: Hello, IIFE!
          })();

          console.log(message); // Error: message is not defined`}
      </code>
    </pre><br />

    <h2 style={{ paddingBottom: "6px" }}>Benefits of Using IIFEs:</h2>
    <ol>
      <li>
        <strong>Encapsulation</strong>: Variables defined within an IIFE cannot be accessed 
        from the outside, thus preventing naming conflicts and keeping the global scope clean.
      </li><br />
      <li>
        <strong>Initialization</strong>: They can be used to initialize variables or settings 
        for an application.
      </li><br />
      <li>
        <strong>Module Pattern</strong>: IIFEs are often used in module patterns to create modules 
        that contain private and public methods.
      </li>
    </ol><br />

    <h2>Using Parameters:</h2>
    <pre>
      <code>
        {`(function(name) {
            console.log("Hello, " + name + "!");
          })("Alice"); // Output: Hello, Alice!`}
      </code>
    </pre><br />

    <p>
      In summary, IIFEs are a powerful feature in JavaScript that help manage scope and create 
      clean, modular code.
    </p>
  </div>
)}



{selectedChapter === 'chapter20' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Closures and Higher-Order Functions</h1>
    <p>
      <strong>Closures</strong> and <strong>Higher-Order Functions</strong> are two important concepts in JavaScript.
    </p><br />

    <h2>1. Closures:</h2>
    <p style={{paddingBottom:"6px"}}>
      A closure is a function that remembers and accesses variables from the outer function in which it was created, 
      even after that outer function has finished executing. This allows the function to "close over" its environment and retain access to the variables.
    </p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`function outerFunction(outerVariable) {
  return function innerFunction(innerVariable) {
    console.log(\`Outer: $\{outerVariable}\`);
    console.log(\`Inner: $\{innerVariable}\`);
  };
        }

const newFunction = outerFunction("Hello");
newFunction("World");`}
      </code>
    </pre>
    <p>
      Here, <strong>innerFunction</strong> forms a closure because it captures and remembers <code>outerVariable</code> from the <code>outerFunction</code>.
    </p><br />

    <h2>2. Higher-Order Functions:</h2>
    <p style={{paddingBottom:"6px"}} >
      A higher-order function is a function that either takes one or more functions as arguments, or returns a function as its result. 
      They are central to functional programming in JavaScript.
    </p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`function higherOrderFunction(callback) {
  return function(value) {
    return callback(value);
  };
}

function greet(name) {
  return \`Hello, $\{name}\`;
}

const greeter = higherOrderFunction(greet);
console.log(greeter("Alice")); // Outputs: Hello, Alice`}
      </code>
    </pre>
    <p>
      In this example, <code>higherOrderFunction</code> takes a function <code>callback</code> as an argument and returns a new function.
    </p>
  </div>
)}






{selectedChapter === 'chapter21' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Callbacks</h1>

    <p>
      In JavaScript, a <strong>callback</strong> is a function passed into another function as an argument, which is then 
      invoked or executed inside the outer function. Callbacks are commonly used for asynchronous operations like fetching 
      data from a server, reading files, or handling events.
    </p><br />

    <h2>How Callbacks Work:</h2>
    <p style={{paddingBottom:"6px"}}>
      When a function takes time to execute (e.g., an API request), instead of blocking the code execution, a callback is used 
      to define what should happen when the operation completes. This allows JavaScript to continue executing other code without waiting.
    </p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`function fetchData(callback) {
  console.log("Fetching data...");
  setTimeout(() => {
    const data = "Data received!";
    callback(data);
  }, 2000); // Simulating asynchronous operation with setTimeout
}

function handleData(data) {
  console.log(data);
}

fetchData(handleData);`}
      </code>
    </pre>

    <p>
      In this example, <code>handleData</code> is passed as a callback to <code>fetchData</code>. Once the data is fetched after 
      2 seconds (simulated by <code>setTimeout</code>), the callback <code>handleData</code> is invoked with the fetched data.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Common Use Cases:</h2>
    <ul>
      <li><strong>Event Handling:</strong> Callbacks are used when responding to user actions like clicks or keypresses.</li><br />
      <li><strong>Asynchronous Operations:</strong> Callbacks handle the result of async functions such as <code>setTimeout</code>, 
        <code>setInterval</code>, or AJAX requests.</li><br />
    </ul>
  </div>
)}


{selectedChapter === 'chapter22' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Arrays</h1>

    <p>
      In JavaScript, an <strong>Array</strong> is a data structure used to store multiple values in a single variable. Arrays can 
      hold different data types (numbers, strings, objects, etc.) and are ordered, meaning the values are stored in a sequence 
      and can be accessed by their index.
    </p><br />

    <h2>Creating an Array:</h2>
    <p>
      Arrays are created using square brackets <code>[]</code>, and the values (called elements) are separated by commas.
    </p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`let fruits = ['Apple', 'Banana', 'Cherry'];
console.log(fruits); // ['Apple', 'Banana', 'Cherry']`}
      </code>
    </pre><br />

    <h2>Accessing Elements:</h2>
    <p>
      Each element in an array has an index, starting from 0. You can access elements using their index.
    </p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`console.log(fruits[0]); // 'Apple'
console.log(fruits[2]); // 'Cherry'`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Common Array Methods:</h2>
    <ol>
      <li>
        <strong>push()</strong>: Adds one or more elements to the end of an array.
        <pre>
          <code>
            {`fruits.push('Orange');
console.log(fruits); // ['Apple', 'Banana', 'Cherry', 'Orange']`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>pop()</strong>: Removes the last element from an array.
        <pre>
          <code>
            {`fruits.pop();
console.log(fruits); // ['Apple', 'Banana', 'Cherry']`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>shift()</strong>: Removes the first element from an array.
        <pre>
          <code>
            {`fruits.shift();
console.log(fruits); // ['Banana', 'Cherry']`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>unshift()</strong>: Adds one or more elements to the beginning of an array.
        <pre>
          <code>
            {`fruits.unshift('Grapes');
console.log(fruits); // ['Grapes', 'Banana', 'Cherry']`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>length</strong>: Returns the number of elements in an array.
        <pre>
          <code>
            {`console.log(fruits.length); // 3`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>forEach()</strong>: Executes a provided function once for each array element.
        <pre>
          <code>
            {`fruits.forEach(fruit => console.log(fruit));`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>map()</strong>: Creates a new array with the results of calling a provided function on every element.
        <pre>
          <code>
            {`let upperFruits = fruits.map(fruit => fruit.toUpperCase());
console.log(upperFruits); // ['GRAPES', 'BANANA', 'CHERRY']`}
          </code>
        </pre>
      </li>
    </ol><br />

    <h2>Example of Array Usage:</h2>
    <pre>
      <code>
        {`let numbers = [1, 2, 3, 4, 5];
let squares = numbers.map(num => num * num);
console.log(squares); // [1, 4, 9, 16, 25]`}
      </code>
    </pre><br />

    <p>
      Arrays are one of the most versatile and widely used data structures in JavaScript, with many built-in methods to manipulate, 
      transform, and loop over them.
    </p>
  </div>
)}


{selectedChapter === 'chapter23' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Methods (push, pop, shift, unshift, map, filter, reduce)</h1>

    <p>
      In JavaScript, arrays come with a variety of methods that help manipulate, transform, and work with array data efficiently. 
      Here’s an explanation of the most commonly used array methods:
    </p><br />

    <h2>1. <strong>push()</strong></h2>
    <p>Adds one or more elements to the end of an array and returns the new length of the array.</p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`let numbers = [1, 2, 3];
numbers.push(4);
console.log(numbers); // [1, 2, 3, 4]`}
      </code>
    </pre><br />

    <h2>2. <strong>pop()</strong></h2>
    <p>Removes the last element from an array and returns that element.</p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`let fruits = ['Apple', 'Banana', 'Cherry'];
let lastFruit = fruits.pop();
console.log(lastFruit); // 'Cherry'
console.log(fruits);    // ['Apple', 'Banana']`}
      </code>
    </pre><br />

    <h2>3. <strong>shift()</strong></h2>
    <p>Removes the first element from an array and returns it, shifting all remaining elements to a lower index.</p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`let names = ['Alice', 'Bob', 'Charlie'];
let first = names.shift();
console.log(first); // 'Alice'
console.log(names); // ['Bob', 'Charlie']`}
      </code>
    </pre><br />

    <h2>4. <strong>unshift()</strong></h2>
    <p>Adds one or more elements to the beginning of an array and returns the new length of the array.</p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`let animals = ['Dog', 'Cat'];
animals.unshift('Elephant');
console.log(animals); // ['Elephant', 'Dog', 'Cat']`}
      </code>
    </pre><br />

    <h2>5. <strong>map()</strong></h2>
    <p>Creates a new array by applying a function to every element of the array. The original array remains unchanged.</p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`let numbers = [1, 2, 3, 4];
let doubled = numbers.map(num => num * 2);
console.log(doubled); // [2, 4, 6, 8]`}
      </code>
    </pre><br />

    <h2>6. <strong>filter()</strong></h2>
    <p>Creates a new array with all elements that pass the test implemented by a provided function.</p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`let numbers = [1, 2, 3, 4, 5];
let evenNumbers = numbers.filter(num => num % 2 === 0);
console.log(evenNumbers); // [2, 4]`}
      </code>
    </pre><br />

    <h2>7. <strong>reduce()</strong></h2>
    <p>Applies a function against an accumulator and each element of the array (from left to right) to reduce it to a single value.</p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`let numbers = [1, 2, 3, 4];
let sum = numbers.reduce((acc, curr) => acc + curr, 0);
console.log(sum); // 10`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary:</h2>
    <ul>
      <li><strong>push()</strong>: Adds elements to the end of the array.</li><br />
      <li><strong>pop()</strong>: Removes the last element from the array.</li><br />
      <li><strong>shift()</strong>: Removes the first element from the array.</li><br />
      <li><strong>unshift()</strong>: Adds elements to the beginning of the array.</li><br />
      <li><strong>map()</strong>: Creates a new array by applying a function to each element.</li><br />
      <li><strong>filter()</strong>: Creates a new array with elements that meet a condition.</li><br />
      <li><strong>reduce()</strong>: Reduces the array to a single value by applying a function.</li>
    </ul><br />
  </div>
)}


{selectedChapter === 'chapter24' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Iterating Over Arrays</h1>

    <p>
      In JavaScript, iterating over arrays allows you to access each element
      within an array and perform actions on them. There are several methods to
      iterate over arrays, each suitable for different use cases. Below are the
      most common methods:
    </p><br />

    <h3>1. <strong>for Loop</strong></h3>
    <p>
      The traditional <code>for</code> loop is one of the most common ways to
      iterate over an array.
    </p>

    <pre>
      <code>
        {`let fruits = ['Apple', 'Banana', 'Cherry'];
for (let i = 0; i < fruits.length; i++) {
  console.log(fruits[i]);
}
// Output: Apple, Banana, Cherry`}
      </code>
    </pre><br />

    <h3>2. <strong>forEach()</strong></h3>
    <p>
      The <code>forEach()</code> method executes a provided function once for
      each array element. It is simpler than the <code>for</code> loop but does
      not return a new array.
    </p>

    <pre>
      <code>
        {`let fruits = ['Apple', 'Banana', 'Cherry'];
fruits.forEach(fruit => {
  console.log(fruit);
});
// Output: Apple, Banana, Cherry`}
      </code>
    </pre><br />

    <h3>3. <strong>map()</strong></h3>
    <p>
      The <code>map()</code> method creates a new array by applying a function
      to each element in the array. Unlike <code>forEach()</code>, it returns a
      new array.
    </p>

    <pre>
      <code>
        {`let numbers = [1, 2, 3, 4];
let squares = numbers.map(num => num * num);
console.log(squares);
// Output: [1, 4, 9, 16]`}
      </code>
    </pre><br />

    <h3>4. <strong>for...of Loop</strong></h3>
    <p>
      The <code>for...of</code> loop iterates over the values of an iterable
      object (like arrays). It’s a modern, concise way to iterate through array
      elements.
    </p>

    <pre>
      <code>
        {`let fruits = ['Apple', 'Banana', 'Cherry'];
for (let fruit of fruits) {
  console.log(fruit);
}
// Output: Apple, Banana, Cherry`}
      </code>
    </pre><br />

    <h3>5. <strong>filter()</strong></h3>
    <p>
      Although primarily used to filter elements based on a condition,
      <code>filter()</code> can also be used for iteration when you need to
      filter and iterate at the same time.
    </p>

    <pre>
      <code>
        {`let numbers = [1, 2, 3, 4, 5];
let evenNumbers = numbers.filter(num => num % 2 === 0);
console.log(evenNumbers);
// Output: [2, 4]`}
      </code>
    </pre><br />

    <h3>6. <strong>reduce()</strong></h3>
    <p>
      The <code>reduce()</code> method applies a function against an
      accumulator and each array element to reduce it to a single value, but it
      can also be used to iterate over each element.
    </p>

    <pre>
      <code>
        {`let numbers = [1, 2, 3, 4];
let sum = numbers.reduce((accumulator, current) => accumulator + current, 0);
console.log(sum);
// Output: 10`}
      </code>
    </pre><br />

    <h3>7. <strong>while Loop</strong></h3>
    <p>
      The <code>while</code> loop executes as long as the specified condition
      is true. It can also be used to iterate over an array.
    </p>

    <pre>
      <code>
        {`let numbers = [1, 2, 3];
let i = 0;
while (i < numbers.length) {
  console.log(numbers[i]);
  i++;
}
// Output: 1, 2, 3`}
      </code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Summary:</h3>
    <ul>
      <li><strong>for loop:</strong> Traditional and flexible but requires manual control of the index.</li><br />
      <li><strong>forEach():</strong> Simplified iteration without a return value.</li><br />
      <li><strong>map():</strong> Iterates and returns a new array based on a transformation.</li><br />
      <li><strong>for...of loop:</strong> A concise, modern approach for iterating over arrays.</li><br />
      <li><strong>filter():</strong> Filters elements based on conditions while iterating.</li><br />
      <li><strong>reduce():</strong> Iterates and accumulates values into a single result.</li><br />
      <li><strong>while loop:</strong> Useful for custom iteration with conditions.</li>
    </ul><br />

  </div>
)}

{selectedChapter === 'chapter25' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Multi-dimensional Arrays</h1>

    <p>
      In JavaScript, <strong>multi-dimensional arrays</strong> are arrays of arrays. This means that each element in a multi-dimensional array can itself be an array, allowing for the creation of complex data structures. The most common type of multi-dimensional array is a <strong>two-dimensional array</strong>, which is often used to represent matrices or grids.
    </p><br />

    <h4>Creating Multi-dimensional Arrays</h4>

    <p>
      You can create multi-dimensional arrays by nesting arrays within each other. Here’s how to create a two-dimensional array:
    </p>

    <pre>
      <code>
        {`let matrix = [
          [1, 2, 3],
          [4, 5, 6],
          [7, 8, 9]
        ];

        console.log(matrix);
        // Output: [[1, 2, 3], [4, 5, 6], [7, 8, 9]]`}
      </code>
    </pre>

    <p>
      In this example, <code>matrix</code> is a two-dimensional array with three rows and three columns.
    </p><br />

    <h4>Accessing Elements</h4>

    <p>
      You can access elements in a multi-dimensional array using multiple indices. The first index accesses the row, and the second index accesses the column.
    </p>

    <pre>
      <code>
        {`console.log(matrix[0][1]); // Output: 2 (first row, second column)
        console.log(matrix[2][0]); // Output: 7 (third row, first column)`}
      </code>
    </pre><br />

    <h4>Iterating Over Multi-dimensional Arrays</h4>

    <p>
      You can use nested loops to iterate over multi-dimensional arrays:
    </p>

    <pre>
      <code>
        {`for (let i = 0; i < matrix.length; i++) {
          for (let j = 0; j < matrix[i].length; j++) {
            console.log(matrix[i][j]);
          }
        }
        // Output: 1, 2, 3, 4, 5, 6, 7, 8, 9`}
      </code>
    </pre><br />

    <h4 style={{paddingBottom:"6px"}}>Common Use Cases</h4>
    <ul>
      <li><strong>Matrices:</strong> Multi-dimensional arrays are often used to represent mathematical matrices.</li><br />
      <li><strong>Grids:</strong> They can be used for grid-based layouts, such as game boards or image pixels.</li><br />
      <li><strong>Tables:</strong> They can store tabular data, where each inner array represents a row in the table.</li>
    </ul><br />

    <h4>Example: Creating and Using a 3D Array</h4>

    <p>
      You can also create three-dimensional arrays (and higher dimensions) by adding another layer of nesting:
    </p>

    <pre>
      <code>
        {`let threeDArray = [
          [
            [1, 2],
            [3, 4]
          ],
          [
            [5, 6],
            [7, 8]
          ]
        ];

        // Accessing an element in a 3D array
        console.log(threeDArray[1][0][1]); // Output: 6 (second 2D array, first row, second column)`}
      </code>
    </pre><br /> 

    <h3 style={{paddingBottom:"6px"}}>Summary</h3>
    <ul>
      <li>Multi-dimensional arrays are arrays of arrays, allowing you to create complex data structures.</li><br />
      <li>They can represent grids, matrices, or any data that naturally fits into a multi-dimensional format.</li><br />
      <li>Accessing and iterating over elements requires using multiple indices, and they are useful in various applications, from mathematics to graphics.</li>
    </ul><br />
  </div>
)}



{selectedChapter === 'chapter26' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Objects</h1>

    <p>
      In JavaScript, <strong>objects</strong> are a fundamental data structure used to store collections of data and more complex entities. An object is a standalone entity with properties and types. Objects can be thought of as a dictionary, where you can associate values with keys.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Key Characteristics of Objects:</h2>
    <ol>
      <li>
        <strong>Key-Value Pairs</strong>: Objects consist of properties, each defined by a key (also known as a property name) and a corresponding value. The keys are strings (or Symbols), and the values can be any data type, including other objects.
      </li><br />
      <li>
        <strong>Dynamic Nature</strong>: Objects can be modified dynamically; you can add, change, or delete properties at runtime.
      </li><br />
      <li>
        <strong>Reference Type</strong>: Objects are reference types, meaning that when you assign an object to a variable, you're actually assigning a reference to that object in memory, not the object itself.
      </li>
    </ol><br />

    <h2>Creating Objects</h2>
    <p>You can create objects in several ways:</p>

    <h3>1. Object Literal Syntax:</h3>
    <pre style={{paddingBottom:"6px"}}>
      <code>
        {`let person = {
          name: 'John Doe',
          age: 30,
          isEmployed: true
        };`}
      </code>
    </pre><br />

    <h3>2. Using the `new Object()` Constructor:</h3>
    <pre>
      <code>
        {`let person = new Object();
        person.name = 'John Doe';
        person.age = 30;
        person.isEmployed = true;`}
      </code>
    </pre><br />

    <h3>3. Using a Constructor Function:</h3>
    <pre>
      <code>
        {`function Person(name, age, isEmployed) {
          this.name = name;
          this.age = age;
          this.isEmployed = isEmployed;
        }
        
        let person1 = new Person('John Doe', 30, true);`}
      </code>
    </pre><br />

    <h3>4. Using ES6 Classes:</h3>
    <pre>
      <code>
        {`class Person {
          constructor(name, age, isEmployed) {
            this.name = name;
            this.age = age;
            this.isEmployed = isEmployed;
          }
        }

        let person2 = new Person('Jane Doe', 28, false);`}
      </code>
    </pre><br />

    <h2>Accessing Object Properties</h2>
    <p style={{paddingBottom:"6px"}}>You can access object properties using two main methods:</p>

    <h3>1. Dot Notation:</h3>
    <pre>
      <code>
        {`console.log(person.name); // 'John Doe'`}
      </code>
    </pre><br />

    <h3>2. Bracket Notation:</h3>
    <pre>
      <code>
        {`console.log(person['age']); // 30`}
      </code>
    </pre><br />

    <h2 >Common Object Methods</h2>
    <p>JavaScript provides several built-in methods to manipulate objects:</p>
    
    <ul>
      <li>
        <strong>Object.keys(obj)</strong>: Returns an array of a given object's own property names.
        <pre>
          <code>
            {`console.log(Object.keys(person)); // ['name', 'age', 'isEmployed']`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Object.values(obj)</strong>: Returns an array of a given object's own property values.
        <pre>
          <code>
            {`console.log(Object.values(person)); // ['John Doe', 30, true]`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Object.entries(obj)</strong>: Returns an array of a given object's own property `[key, value]` pairs.
        <pre>
          <code>
            {`console.log(Object.entries(person)); // [['name', 'John Doe'], ['age', 30], ['isEmployed', true]]`}
          </code>
        </pre>
      </li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li>Objects are collections of key-value pairs, making them essential for representing structured data.</li><br />
      <li>They are dynamic and can be modified at runtime.</li><br />
      <li>Objects in JavaScript can be created using various methods and accessed via dot or bracket notation.</li><br />
      <li>Understanding objects is crucial for working with JavaScript, as they are foundational to many frameworks and libraries.</li>
    </ul><br />
  </div>
)}


{selectedChapter === 'chapter27' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Creating Objects (Literal and Constructor)</h1>

    <p>
      In JavaScript, objects can be created using different approaches. The two most common methods are <strong>Object Literals</strong> and <strong>Constructor Functions</strong>. Each method has its own advantages and use cases.
    </p><br />

    <h3>1. Object Literal</h3>
    <p style={{paddingBottom:"6px"}}>
      Object literals are the simplest way to create an object. You define an object by enclosing a set of key-value pairs within curly braces <code>{`{}`}</code>. This method is straightforward and ideal for creating single objects without the need for additional functionality.
    </p>

    <h4>Example:</h4>
    <pre>
      <code>
        {`let person = {
  name: 'John Doe',
  age: 30,
  isEmployed: true,
  greet: function() {
    console.log(\`Hello, my name is \${this.name}.\`);
  }
};

console.log(person.name); // Output: John Doe
person.greet();           // Output: Hello, my name is John Doe.`}
      </code>
    </pre><br />

    <h4 style={{paddingBottom:"6px"}}>Key Features:</h4>
    <ul>
      <li>You can define properties and methods directly within the object.</li><br />
      <li>It is quick and easy to create a single object.</li>
    </ul><br />

    <h3>2. Constructor Function</h3>
    <p style={{paddingBottom:"6px"}}>
      Constructor functions allow you to create multiple objects with the same structure and behavior. You define a function that initializes object properties using the <code>this</code> keyword. To create a new object, you call the constructor function with the <code>new</code> keyword.
    </p>

    <h4>Example:</h4>
    <pre>
      <code>
        {`function Person(name, age, isEmployed) {
  this.name = name;
  this.age = age;
  this.isEmployed = isEmployed;

  this.greet = function() {
    console.log(\`Hello, my name is \${this.name}.\`);
  };
}

// Creating new objects
let person1 = new Person('Alice Smith', 28, true);
let person2 = new Person('Bob Johnson', 35, false);

console.log(person1.name); // Output: Alice Smith
person1.greet();           // Output: Hello, my name is Alice Smith.

console.log(person2.name); // Output: Bob Johnson
person2.greet();           // Output: Hello, my name is Bob Johnson.`}
      </code>
    </pre><br />

    <h4 style={{paddingBottom:"6px"}}>Key Features:</h4>
    <ul>
      <li>Allows the creation of multiple instances of an object with the same properties and methods.</li><br />
      <li>Promotes code reuse and helps in organizing related functionalities.</li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li><strong>Object Literal</strong>: A quick way to create a single object with properties and methods. It’s useful for simple, one-off objects.</li><br />
      <li><strong>Constructor Function</strong>: A structured way to create multiple objects with shared properties and methods. It enhances reusability and maintainability in your code.</li>
    </ul><br />

    <p>Understanding these two methods is crucial for effective object-oriented programming in JavaScript.</p>
  </div>
)}


{selectedChapter === 'chapter28' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Accessing Properties and Methods</h1>

    <p>
      Accessing properties and methods in JavaScript is essential for working with objects, as it allows you to retrieve and manipulate data stored within them. Here's an overview:
    </p><br />

    <h2>Accessing Properties</h2>
    <p style={{paddingBottom:"6px"}}>
      JavaScript provides two primary ways to access the properties of an object: <strong>dot notation</strong> and <strong>bracket notation</strong>.
    </p>

    <h3>1. Dot Notation</h3>
    <p>
      Dot notation is the most common way to access an object's properties. You use the object name followed by a dot and the property name.
    </p>
    <p><strong>Syntax</strong>: <code>objectName.propertyName</code></p>

    <p><strong>Example</strong>:</p>
    <pre>
      <code>
        {`let person = {
    name: 'Alice',
    age: 30
};

console.log(person.name); // Output: Alice
console.log(person.age);  // Output: 30`}
      </code>
    </pre><br />

    <h3>2. Bracket Notation</h3>
    <p>
      Bracket notation allows you to access properties using a string, which can be useful if the property name is dynamic or contains special characters (like spaces).
    </p>
    <p><strong>Syntax</strong>: <code>objectName['propertyName']</code></p>

    <p><strong>Example</strong>:</p>
    <pre>
      <code>
        {`let person = {
    name: 'Alice',
    age: 30,
    'favorite color': 'blue'
};

console.log(person['name']); // Output: Alice
console.log(person['favorite color']); // Output: blue`}
      </code>
    </pre><br />

    <h2>Accessing Methods</h2>
    <p style={{paddingBottom:"6px"}}>
      Methods in JavaScript are functions defined within an object. You can access and call methods using either dot or bracket notation, similar to accessing properties.
    </p>

    <p><strong>Example</strong>:</p>
    <pre>
      <code>
        {`let person = {
    name: 'Alice',
    age: 30,
    greet: function() {
        console.log(\`Hello, my name is \${this.name}.\`);
    }
};

// Accessing and calling the method
person.greet(); // Output: Hello, my name is Alice.`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Important Points</h2>
    <ul>
      <li>
        <strong>Dynamic Access</strong>: You can use variables in bracket notation to access properties dynamically:
        <pre>
          <code>
            {`let property = 'age';
console.log(person[property]); // Output: 30`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Method Context</strong>: Inside a method, <code>this</code> refers to the object that the method belongs to. This is important for accessing other properties within the same object.
      </li><br />
      <li>
        <strong>Undefined Properties</strong>: If you try to access a property that doesn’t exist, it will return <code>undefined</code>:
        <pre>
          <code>
            {`console.log(person.address); // Output: undefined`}
          </code>
        </pre>
      </li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li>Use <strong>dot notation</strong> for straightforward access to properties and methods.</li><br />
      <li>Use <strong>bracket notation</strong> for dynamic property names or when property names contain special characters.</li><br />
      <li>Understanding how to access properties and methods is crucial for effectively manipulating objects in JavaScript, as it allows for dynamic programming and enhances code readability and maintainability.</li>
    </ul><br />
  </div>
)}
{selectedChapter === 'chapter29' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>The `this` Keyword in Objects</h1>

    <p>
      In JavaScript, the <code>this</code> keyword is a crucial concept that refers to the context in which a function is executed. In the context of objects, <code>this</code> plays a significant role in determining how properties and methods can access and manipulate the object's data. Here's a detailed explanation:
    </p><br />

    <h2>The `this` Keyword in Objects</h2>

    <ol>
      <li>
        <strong>Contextual Meaning:</strong>
        <p>
          The value of <code>this</code> is determined by how a function is called, not where it is defined. This means that <code>this</code> can refer to different objects in different contexts.
        </p>
      </li><br />

      <li>
        <strong>In Object Methods:</strong>
        <p>
          When a method is called on an object, <code>this</code> refers to the object that the method is called on.
        </p><br />
        <p>
          <strong>Example:</strong>
        </p>
        <pre>
          <code>{`
            let person = {
              name: 'Alice',
              age: 30,
              greet: function() {
                console.log(\`Hello, my name is \${this.name}.\`);
              }
            };

            person.greet(); // Output: Hello, my name is Alice.
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>In Constructor Functions:</strong>
        <p>
          When using constructor functions, <code>this</code> refers to the newly created object instance.
        </p><br />
        <p>
          <strong>Example:</strong>
        </p>
        <pre>
          <code>{`
            function Person(name, age) {
              this.name = name;
              this.age = age;
              this.greet = function() {
                console.log(\`Hello, my name is \${this.name}.\`);
              };
            }

            let person1 = new Person('Alice', 30);
            person1.greet(); // Output: Hello, my name is Alice.
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>In Arrow Functions:</strong>
        <p>
          Arrow functions do not have their own <code>this</code>. Instead, they inherit <code>this</code> from the surrounding lexical context.
        </p>
        <p>
          <strong>Example:</strong>
        </p>
        <pre>
          <code>{`
            let person = {
              name: 'Alice',
              age: 30,
              greet: () => {
                console.log(\`Hello, my name is \${this.name}.\`);
              }
            };

            person.greet(); // Output: Hello, my name is undefined.
          `}</code>
        </pre>
        <p>
          In this case, <code>this</code> does not refer to the <code>person</code> object because arrow functions capture the <code>this</code> value of the enclosing context, which is not <code>person</code>.
        </p>
      </li><br />

      <li>
        <strong>Global Context:</strong>
        <p>
          In the global context (outside of any function), <code>this</code> refers to the global object (e.g., <code>window</code> in browsers).
        </p>
        <p>
          <strong>Example:</strong>
        </p>
        <pre>
          <code>{`
            console.log(this); // In a browser, this logs the Window object.
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Event Handlers:</strong>
        <p>
          In event handlers, <code>this</code> refers to the element that fired the event.
        </p>
        <p>
          <strong>Example:</strong>
        </p>
        <pre>
          <code>{`
            let button = document.getElementById('myButton');
            button.addEventListener('click', function() {
              console.log(this); // Logs the button element.
            });
          `}</code>
        </pre>
      </li>
    </ol><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li>The <code>this</code> keyword in JavaScript objects is context-dependent, meaning its value is determined by how the function is called.</li><br />
      <li>In object methods, <code>this</code> refers to the object itself, while in constructor functions, it refers to the newly created instance.</li><br />
      <li>Arrow functions do not have their own <code>this</code> and use the <code>this</code> value from their enclosing context.</li><br />
      <li>Understanding <code>this</code> is crucial for effectively working with objects and methods in JavaScript.</li>
    </ul><br />
  </div>
)}


{selectedChapter === 'chapter30' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>ES6 Maps and Sets</h1>

    <p>
      ES6 (ECMAScript 2015) introduced two new collection types in JavaScript: <strong>Maps</strong> and <strong>Sets</strong>. These data structures provide a more powerful and flexible way to manage collections of data compared to traditional objects and arrays.
    </p><br />

    <h2>ES6 Maps</h2>

    <p style={{paddingBottom:"6px"}}>
      A <strong>Map</strong> is a collection of key-value pairs where both keys and values can be of any type (objects, primitive values, etc.). Maps remember the original insertion order of the keys, making them more predictable than objects for certain use cases.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Maps:</h3>
    <ul>
      <li><strong>Key-Value Pairs</strong>: Each entry in a Map is a key-value pair.</li><br />
      <li><strong>Order of Elements</strong>: Maps maintain the insertion order of keys.</li><br />
      <li><strong>Any Type of Keys</strong>: Keys can be of any data type (not just strings or symbols, as in objects).</li><br />
      <li><strong>Size Property</strong>: You can easily get the size of a Map using the <code>.size</code> property.</li>
    </ul><br />

    <h3>Creating a Map:</h3>
    <pre>
      <code>{`
const myMap = new Map();

// Adding key-value pairs
myMap.set('name', 'Alice');
myMap.set('age', 30);
myMap.set(1, 'One');
myMap.set({ id: 1 }, 'Object Key');

// Accessing values
console.log(myMap.get('name')); // Output: Alice
console.log(myMap.get(1));       // Output: One

// Checking if a key exists
console.log(myMap.has('age'));   // Output: true

// Getting the size of the map
console.log(myMap.size);         // Output: 4

// Iterating over a Map
myMap.forEach((value, key) => {
  console.log(\`\${key}: \${value}\`);
});
      `}</code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Common Methods for Maps:</h3>
    <ul>
      <li><code>.set(key, value)</code>: Adds a new key-value pair.</li><br />
      <li><code>.get(key)</code>: Retrieves the value associated with the key.</li><br />
      <li><code>.delete(key)</code>: Removes the key-value pair by key.</li><br />
      <li><code>.has(key)</code>: Checks if the map contains the key.</li><br />
      <li><code>.clear()</code>: Removes all key-value pairs from the map.</li>
    </ul><br />

    <h2>ES6 Sets</h2>

    <p style={{paddingBottom:"6px"}}>
      A <strong>Set</strong> is a collection of unique values. You can add any type of value to a Set, but each value must be unique (no duplicates allowed).
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Sets:</h3>
    <ul>
      <li><strong>Unique Values</strong>: Sets automatically enforce uniqueness, meaning that duplicate values are not allowed.</li><br />
      <li><strong>Order of Elements</strong>: Like Maps, Sets also maintain the insertion order of values.</li><br />
      <li><strong>Size Property</strong>: You can easily get the size of a Set using the <code>.size</code> property.</li>
    </ul><br />

    <h3>Creating a Set:</h3>
    <pre>
      <code>{`
const mySet = new Set();

// Adding values
mySet.add('Alice');
mySet.add(30);
mySet.add({ id: 1 });
mySet.add('Alice'); // Duplicate, will not be added

// Accessing values
console.log(mySet.has('Alice')); // Output: true

// Getting the size of the set
console.log(mySet.size);         // Output: 3

// Iterating over a Set
mySet.forEach(value => {
  console.log(value);
});
      `}</code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Common Methods for Sets:</h3>
    <ul>
      <li><code>.add(value)</code>: Adds a new value to the set.</li><br />
      <li><code>.has(value)</code>: Checks if the set contains the value.</li><br />
      <li><code>.delete(value)</code>: Removes the value from the set.</li><br />
      <li><code>.clear()</code>: Removes all values from the set.</li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li><strong>Maps</strong> are collections of key-value pairs where both keys and values can be of any type, maintaining the order of insertion.</li><br />
      <li><strong>Sets</strong> are collections of unique values, also maintaining the order of insertion and preventing duplicates.</li><br />
      <li>Both Maps and Sets come with useful methods to manage the collection efficiently, providing more flexibility than traditional objects and arrays.</li>
    </ul><br />

    <p>
      Using Maps and Sets can lead to cleaner, more efficient code when managing collections of data in JavaScript.
    </p>
  </div>
)}


{selectedChapter === 'chapter31' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Understanding Events (click, load, submit, etc.)</h1>

    <p>
      Understanding events in JavaScript is crucial for creating interactive web applications. Events are actions or occurrences that happen in the browser, which can be triggered by user interactions (like clicks or key presses) or by the browser itself (like loading a document). Here’s a breakdown of some common events, how they work, and how to handle them.
    </p><br />

    <h2>What Are Events?</h2>
    <p>
      In JavaScript, an event is an action that occurs in the browser, such as:
    </p>
    <ul>
      <li>A user clicks a button.</li><br />
      <li>A webpage loads.</li><br />
      <li>A user submits a form.</li><br />
      <li>A mouse moves over an element.</li>
    </ul><br />

    <p>
      JavaScript provides a way to respond to these events through event listeners, which are functions that run when a specific event occurs.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Common Types of Events</h2>
    <ol>
      <li>
        <strong>Click Event</strong>
        <p>Triggered when an element is clicked. Commonly used for buttons and links.</p>
        <pre>
          <code>{`
            const button = document.getElementById('myButton');
            button.addEventListener('click', () => {
              alert('Button was clicked!');
            });
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Load Event</strong>
        <p>Triggered when a webpage or an image is fully loaded. Useful for initializing scripts or executing code after content is available.</p>
        <pre>
          <code>{`
            window.addEventListener('load', () => {
              console.log('All resources finished loading!');
            });
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Submit Event</strong>
        <p>Triggered when a form is submitted. Useful for validating form data before sending it to the server.</p>
        <pre>
          <code>{`
            const form = document.getElementById('myForm');
            form.addEventListener('submit', (event) => {
              event.preventDefault(); // Prevents the default form submission
              console.log('Form submitted!');
            });
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Mouseover Event</strong>
        <p>Triggered when the mouse pointer moves over an element. Useful for creating hover effects.</p>
        <pre>
          <code>{`
            const element = document.getElementById('myElement');
            element.addEventListener('mouseover', () => {
              element.style.backgroundColor = 'lightblue';
            });
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Keydown Event</strong>
        <p>Triggered when a key is pressed down. Useful for handling keyboard interactions.</p>
        <pre>
          <code>{`
            document.addEventListener('keydown', (event) => {
              console.log(\`Key pressed: \${event.key}\`);
            });
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Resize Event</strong>
        <p>Triggered when the window is resized. Useful for responsive design adjustments.</p>
        <pre>
          <code>{`
            window.addEventListener('resize', () => {
              console.log('Window was resized!');
            });
          `}</code>
        </pre>
      </li>
    </ol><br />

    <h2>Event Handling</h2>
    <p>
      Event handling in JavaScript typically involves three steps:
    </p>
    <ol>
      <li><strong>Selecting the Element</strong>: Identify the HTML element you want to attach an event listener to.</li><br />
      <li><strong>Adding an Event Listener</strong>: Use the <code>addEventListener</code> method to specify the event and the function to execute when the event occurs.</li><br />
      <li><strong>Defining the Callback Function</strong>: Create the function that defines what happens when the event is triggered.</li>
    </ol><br />

    <h2>Example of Event Handling</h2>
    <p>
      Here's a comprehensive example demonstrating several events:
    </p>
    <pre>
      <code>{`
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Event Handling Example</title>
        </head>
        <body>
            <button id="myButton">Click Me</button>
            <form id="myForm">
                <input type="text" placeholder="Type something..." />
                <button type="submit">Submit</button>
            </form>
            <script>
                // Click Event
                document.getElementById('myButton').addEventListener('click', () => {
                    alert('Button clicked!');
                });

                // Submit Event
                document.getElementById('myForm').addEventListener('submit', (event) => {
                    event.preventDefault(); // Prevents the form from submitting
                    console.log('Form submitted!');
                });

                // Load Event
                window.addEventListener('load', () => {
                    console.log('Page fully loaded!');
                });
            </script>
        </body>
        </html>
      `}</code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li>Events are actions or occurrences that can be detected in the browser.</li><br />
      <li>JavaScript allows developers to listen for and respond to events using event listeners.</li><br />
      <li>Common events include click, load, submit, mouseover, keydown, and resize.</li><br />
      <li>Properly handling events is essential for creating interactive and responsive web applications.</li>
    </ul><br />

    <p>
      Understanding how to work with events will significantly enhance your ability to build dynamic and user-friendly web applications.
    </p>
  </div>
)}

{selectedChapter === 'chapter32' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Event Listeners and Event Handlers</h1>

    <p>
      Event listeners and event handlers are fundamental concepts in JavaScript that enable developers to create interactive web applications by responding to user actions and other events. Here's a detailed breakdown of both:
    </p><br />

    <h2>Event Listeners</h2>

    <p style={{paddingBottom:"6px"}} >
      An <strong>event listener</strong> is a function that waits for a specific event to occur on a target element (such as a button, form, or window). When the event is triggered, the event listener executes the associated callback function.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Event Listeners:</h3>
    <ul>
      <li><strong>Asynchronous</strong>: Event listeners operate asynchronously, meaning they wait for an event to occur without blocking the execution of other code.</li><br />
      <li><strong>Multiple Listeners</strong>: You can attach multiple event listeners to a single element, allowing it to respond to different types of events.</li><br />
      <li><strong>Dynamic Binding</strong>: Event listeners can be added or removed dynamically during the execution of a script.</li>
    </ul><br />

    <h3>Syntax:</h3>
    <p>
      The basic syntax for adding an event listener to an element is:
    </p>
    <pre>
      <code>
        {`element.addEventListener(event, callback);`}
      </code>
    </pre><br />
    <ul>
      <li><code>element</code>: The DOM element to which you want to attach the listener.</li><br />
      <li><code>event</code>: A string representing the name of the event (e.g., 'click', 'load', 'submit').</li><br />
      <li><code>callback</code>: The function that will be executed when the event occurs.</li>
    </ul><br />

    <h3>Example:</h3>
    <pre>
      <code>
        {`const button = document.getElementById('myButton');

button.addEventListener('click', () => {
  alert('Button clicked!');
});`}
      </code>
    </pre><br />

    <h2>Event Handlers</h2>

    <p style={{paddingBottom:"6px"}}>
      An <strong>event handler</strong> is a function that is called in response to a specific event. It defines the behavior that should occur when the event is triggered. Event handlers can be defined in several ways, including as inline attributes in HTML, assigned directly to an element, or added using event listeners.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Event Handlers:</h3>
    <ul>
      <li><strong>Direct Assignment</strong>: Event handlers can be directly assigned to DOM elements using properties (e.g., <code>onclick</code>, <code>onsubmit</code>).</li><br />
      <li><strong>Separation of Concerns</strong>: Using event listeners is generally preferred over inline event handlers, as it separates JavaScript from HTML, making code easier to maintain.</li><br />
      <li><strong>Access to Event Object</strong>: Event handlers can access the event object, which contains information about the event, such as the target element and event type.</li>
    </ul><br />

    <h3>Example:</h3>
    <ol>
      <li><strong>Inline Event Handler:</strong>
        <pre>
          <code>{`<button id="myButton" onclick="alert('Button clicked!')">Click Me</button>`}</code>
        </pre>
      </li><br />
      <li><strong>Assigned via Property:</strong>
        <pre>
          <code>
            {`const button = document.getElementById('myButton');
button.onclick = () => {
  alert('Button clicked!');
};`}
          </code>
        </pre>
      </li><br />
      <li><strong>Using addEventListener (recommended):</strong>
        <pre>
          <code>
            {`const button = document.getElementById('myButton');

button.addEventListener('click', () => {
  alert('Button clicked!');
});`}
          </code>
        </pre>
      </li>
    </ol><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li><strong>Event Listeners</strong> are functions that wait for specific events to occur on an element and can be attached using the <code>addEventListener</code> method.</li><br />
      <li><strong>Event Handlers</strong> are the functions that define what should happen when an event occurs and can be set directly or through listeners.</li><br />
      <li>Using event listeners is the preferred method for modern JavaScript development due to better organization, flexibility, and the ability to attach multiple listeners to a single event.</li>
    </ul><br />

    <p>
      These concepts are essential for creating dynamic and interactive user experiences on the web.
    </p>
  </div>
)}


{selectedChapter === 'chapter33' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Event Bubbling and Capturing</h1>

    <p>
      Event bubbling and capturing are two phases of event propagation in the Document Object Model (DOM) when an event occurs on an element. Understanding these concepts is essential for handling events effectively in JavaScript.
    </p><br />

    <h2>Event Bubbling</h2>

    <p style={{paddingBottom:"6px"}}>
      <strong>Event bubbling</strong> is the process in which an event starts from the target element and then propagates upwards through its ancestors in the DOM hierarchy. This means that when an event is triggered on an element, it first runs the event handlers on that element, then moves to its parent element, then to the grandparent, and so on, until it reaches the root of the DOM (usually the <code>document</code> or <code>window</code>).
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Event Bubbling:</h3>
    <ul>
      <li><strong>Default Phase:</strong> Bubbling is the default behavior for most events.</li><br />
      <li><strong>Order of Execution:</strong> Event handlers are executed in the order from the target element to the root element.</li><br />
      <li><strong>Can Be Stopped:</strong> You can stop the bubbling process using the <code>stopPropagation()</code> method on the event object.</li>
    </ul><br />

    <h3>Example of Event Bubbling:</h3>
    <pre>
      <code>
        {`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Event Bubbling Example</title>
</head>
<body>
    <div id="parent" style="padding: 20px; background: lightblue;">
        Parent Div
        <button id="child">Click Me</button>
    </div>

    <script>
        document.getElementById('parent').addEventListener('click', () => {
            alert('Parent Div Clicked!');
        });

        document.getElementById('child').addEventListener('click', () => {
            alert('Button Clicked!');
        });
    </script>
</body>
</html>`}
      </code>
    </pre>

    <p>
      In this example, if you click the button, you will first see "Button Clicked!" (the child's event) and then "Parent Div Clicked!" (the parent's event) due to bubbling.
    </p><br />

    <h2>Event Capturing</h2>

    <p style={{paddingBottom:"6px"}} >
      <strong>Event capturing</strong> (or "trickling") is the opposite of bubbling. In this phase, the event starts from the root of the DOM and travels downwards to the target element. Capturing allows you to handle the event before it reaches the target element.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Event Capturing:</h3>
    <ul>
      <li><strong>Not Default:</strong> Capturing is not the default behavior; you need to specify it when adding an event listener.</li><br />
      <li><strong>Order of Execution:</strong> Event handlers are executed in the order from the root element down to the target element.</li><br />
      <li><strong>Can Be Stopped:</strong> Similar to bubbling, you can stop the capturing phase using <code>stopPropagation()</code>.</li>
    </ul><br />

    <h3>Example of Event Capturing:</h3>
    <pre>
      <code>
        {`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Event Capturing Example</title>
</head>
<body>
    <div id="parent" style="padding: 20px; background: lightcoral;">
        Parent Div
        <button id="child">Click Me</button>
    </div>

    <script>
        document.getElementById('parent').addEventListener('click', () => {
            alert('Parent Div Clicked!');
        }, true); // true for capturing

        document.getElementById('child').addEventListener('click', () => {
            alert('Button Clicked!');
        });
    </script>
</body>
</html>`}
      </code>
    </pre>

    <p>
      In this example, if you click the button, you will first see "Parent Div Clicked!" (the parent's event during the capturing phase) and then "Button Clicked!" (the child's event).
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li><strong>Event Bubbling:</strong> The event starts from the target element and propagates up through its ancestors. It's the default behavior for events in JavaScript.</li><br />
      <li><strong>Event Capturing:</strong> The event starts from the root of the DOM and propagates down to the target element. This behavior must be explicitly defined when setting up event listeners.</li>
    </ul><br />

    <p>
      Understanding these two phases allows developers to control how events are handled and ensures they can respond to user actions effectively in their applications.
    </p>
  </div>
)}

{selectedChapter === 'chapter34' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Preventing Default Behavior</h1>

    <p>
      In JavaScript, <strong>preventing default behavior</strong> refers to stopping the default action that an event would normally trigger in the browser. This is commonly used in scenarios where you want to control what happens when an event occurs, especially with events related to form submissions, link navigation, and user interactions.
    </p><br />

    <h2>Key Concepts</h2>

    <ol>
      <li>
        <strong>Default Actions:</strong>
        <ul>
          <li>Clicking a submit button in a form triggers the form to submit.</li><br />
          <li>Clicking a link navigates to a new URL.</li><br />
          <li>Pressing the Enter key while in a text field may also submit a form.</li>
        </ul>
      </li><br />
      <li>
        <strong><code>event.preventDefault()</code>:</strong>
        <p>
          This method is used to prevent the default action of an event from occurring. When called within an event handler, it stops the event's default behavior, allowing developers to implement custom behavior instead.
        </p>
      </li>
    </ol><br />

    <h2>Usage</h2>

    <p style={{paddingBottom:"6px"}}>Here’s how you can use <code>event.preventDefault()</code> in different scenarios:</p>

    <h3>Preventing Form Submission</h3>
    <p>If you want to validate form input before submitting, you can prevent the default form submission:</p>
    <pre>
      <code>
{`const form = document.getElementById('myForm');

form.addEventListener('submit', (event) => {
  event.preventDefault(); // Prevents the default form submission
  console.log('Form submitted via JavaScript instead of default action!');
  // Add validation logic here
});`}
      </code>
    </pre><br />

    <h3>Preventing Link Navigation</h3>
    <p>To prevent a link from navigating to a new page when clicked, you can use:</p>
    <pre>
      <code>
{`const link = document.getElementById('myLink');

link.addEventListener('click', (event) => {
  event.preventDefault(); // Prevents the default navigation
  console.log('Link clicked, but no navigation occurred!');
});`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Benefits</h2>
    <ul>
      <li><strong>Control Over User Experience:</strong> By preventing default behavior, developers can implement their own logic, such as validating inputs or providing feedback to users.</li><br />
      <li><strong>Improved Functionality:</strong> It allows for enhanced user interfaces, such as AJAX form submissions, where the page doesn't need to reload, creating a smoother experience.</li>
    </ul><br />

    <h2>Summary</h2>
    <p>
      Preventing default behavior is an essential aspect of event handling in JavaScript that allows developers to intercept the standard actions associated with events. By using <code>event.preventDefault()</code>, you can create more interactive and user-friendly web applications, enabling custom behaviors that enhance the overall user experience.
    </p>
  </div>
)}
{selectedChapter === 'chapter35' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Selecting Elements (getElementById, querySelector, etc.)</h1>

    <p>
      In JavaScript, selecting elements is a fundamental part of DOM manipulation. It allows developers to interact with HTML elements dynamically, enabling them to change styles, update content, handle events, and create interactive web applications. Various methods exist for selecting elements in the DOM, each with its unique features and use cases.
    </p><br />

    <h2>1. `getElementById`</h2>
    <p style={{paddingBottom:"6px"}}>
      The <code>getElementById</code> method is used to select a single element from the DOM based on its unique <code>id</code> attribute. This method returns the first element that matches the specified <code>id</code> or <code>null</code> if no such element exists.
    </p>

    <h3>Syntax:</h3>
    <pre>
      <code>const element = document.getElementById('elementId');</code>
    </pre><br />

    <h3>Example:</h3>
    <pre>
      <code>
        {`<div id="myDiv">Hello, World!</div>
<script>
  const myDiv = document.getElementById('myDiv');
  console.log(myDiv.innerText); // Outputs: Hello, World!
</script>`}
      </code>
    </pre><br />

    <h2>2. `getElementsByClassName`</h2>
    <p style={{paddingBottom:"6px"}}>
      The <code>getElementsByClassName</code> method selects all elements with a specified class name. It returns a live <code>HTMLCollection</code> of elements, which means that the collection is automatically updated if the document changes.
    </p>

    <h3>Syntax:</h3>
    <pre>
      <code>const elements = document.getElementsByClassName('className');</code>
    </pre><br />

    <h3>Example:</h3>
    <pre>
      <code>
        {`<div class="myClass">Item 1</div>
<div class="myClass">Item 2</div>
<script>
  const items = document.getElementsByClassName('myClass');
  console.log(items.length); // Outputs: 2
</script>`}
      </code>
    </pre><br />

    <h2>3. `getElementsByTagName`</h2>
    <p style={{paddingBottom:"6px"}}>
      The <code>getElementsByTagName</code> method selects all elements with a specified tag name. Like <code>getElementsByClassName</code>, it returns a live <code>HTMLCollection</code>.
    </p>

    <h3>Syntax:</h3>
    <pre>
      <code>const elements = document.getElementsByTagName('tagName');</code>
    </pre><br />

    <h3>Example:</h3>
    <pre>
      <code>
        {`<p>Paragraph 1</p>
<p>Paragraph 2</p>
<script>
  const paragraphs = document.getElementsByTagName('p');
  console.log(paragraphs.length); // Outputs: 2
</script>`}
      </code>
    </pre><br />

    <h2>4. `querySelector`</h2>
    <p style={{paddingBottom:"6px"}}>
      The <code>querySelector</code> method selects the first element that matches a specified CSS selector. It returns the element as an object or <code>null</code> if no match is found. This method allows for more complex selections using CSS selectors.
    </p>

    <h3>Syntax:</h3>
    <pre>
      <code>const element = document.querySelector('selector');</code>
    </pre><br />

    <h3>Example:</h3>
    <pre>
      <code>
        {`<div class="container">
  <p class="myClass">Paragraph 1</p>
  <p class="myClass">Paragraph 2</p>
</div>
<script>
  const firstParagraph = document.querySelector('.myClass');
  console.log(firstParagraph.innerText); // Outputs: Paragraph 1
</script>`}
      </code>
    </pre><br />

    <h2>5. `querySelectorAll`</h2>
    <p style={{paddingBottom:"6px"}}>
      The <code>querySelectorAll</code> method selects all elements that match a specified CSS selector and returns a static <code>NodeList</code>. Unlike <code>getElementsByClassName</code> or <code>getElementsByTagName</code>, the <code>NodeList</code> returned by <code>querySelectorAll</code> does not automatically update when the document changes.
    </p>

    <h3>Syntax:</h3>
    <pre>
      <code>const elements = document.querySelectorAll('selector');</code>
    </pre><br />

    <h3>Example:</h3>
    <pre>
      <code>
        {`<div class="container">
  <p class="myClass">Paragraph 1</p>
  <p class="myClass">Paragraph 2</p>
</div>
<script>
  const paragraphs = document.querySelectorAll('.myClass');
  console.log(paragraphs.length); // Outputs: 2
</script>`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li><code>getElementById</code>: Selects a single element by its unique ID.</li><br />
      <li><code>getElementsByClassName</code>: Selects all elements with a specified class name, returning a live <code>HTMLCollection</code>.</li><br />
      <li><code>getElementsByTagName</code>: Selects all elements with a specified tag name, also returning a live <code>HTMLCollection</code>.</li><br />
      <li><code>querySelector</code>: Selects the first element that matches a CSS selector.</li><br />
      <li><code>querySelectorAll</code>: Selects all elements that match a CSS selector, returning a static <code>NodeList</code>.</li>
    </ul><br />

    <p>
      These methods are essential for DOM manipulation in JavaScript, allowing developers to create dynamic and interactive web applications.
    </p>
  </div>
)}

{selectedChapter === 'chapter36' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Modifying HTML and Text Content</h1>

    <p>
      In JavaScript, modifying HTML and text content in the Document Object Model (DOM) is a core aspect of creating dynamic web applications. This process allows developers to change the content and structure of a webpage on the fly, responding to user interactions, events, or other programmatic conditions.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Key Concepts for Modifying HTML and Text Content</h2>

    <h3>1. Inner HTML</h3>
    <p>
      The <code>innerHTML</code> property allows you to get or set the HTML content of an element. By assigning new HTML to this property, you can dynamically change the structure and content of the selected element.
    </p>
    <pre>
      <code>
        {`const element = document.getElementById('myElement');\n` +
        `element.innerHTML = '<p>This is new HTML content!</p>'; // Replaces existing content`}
      </code>
    </pre><br />

    <h3>2. Text Content</h3>
    <p>
      The <code>textContent</code> property retrieves or sets the text content of an element. Unlike <code>innerHTML</code>, <code>textContent</code> does not parse HTML; it treats the content as plain text.
    </p>
    <pre>
      <code>
        {`const element = document.getElementById('myElement');\n` +
        `element.textContent = 'This is new text content!'; // Replaces existing text`}
      </code>
    </pre><br />

    <h3>3. Creating Elements</h3>
    <p>
      You can create new elements using <code>document.createElement()</code>, and then insert them into the DOM using methods like <code>appendChild()</code>, <code>insertBefore()</code>, or <code>replaceChild()</code>.
    </p>
    <pre>
      <code>
        {`const newElement = document.createElement('div');\n` +
        `newElement.textContent = 'I am a new div!';\n` +
        `document.body.appendChild(newElement); // Adds the new div to the end of the body`}
      </code>
    </pre><br />

    <h3>4. Replacing Elements</h3>
    <p>
      To replace an existing element with a new one, you can use the <code>replaceChild()</code> method.
    </p>
    <pre>
      <code>
        {`const oldElement = document.getElementById('oldElement');\n` +
        `const newElement = document.createElement('div');\n` +
        `newElement.textContent = 'This replaces the old element.';\n` +
        `oldElement.parentNode.replaceChild(newElement, oldElement);`}
      </code>
    </pre><br />

    <h3>5. Removing Elements</h3>
    <p>
      The <code>remove()</code> method can be used to remove an element from the DOM.
    </p>
    <pre>
      <code>
        {`const element = document.getElementById('myElement');\n` +
        `element.remove(); // Removes the element from the DOM`}
      </code>
    </pre><br />

    <h3>6. Appending HTML</h3>
    <p>
      To add content to an element without replacing its existing content, you can use <code>insertAdjacentHTML()</code>.
    </p>
    <pre>
      <code>
        {`const element = document.getElementById('myElement');\n` +
        `element.insertAdjacentHTML('beforeend', '<p>Added this new paragraph!</p>');`}
      </code>
    </pre><br />

    <h2>Summary</h2>
    <p>
      Modifying HTML and text content in the DOM is vital for creating interactive web pages. Key methods and properties include:
    </p>
    <ul>
      <li><code>innerHTML</code>: Get or set the HTML content of an element.</li><br />
      <li><code>textContent</code>: Get or set the text content of an element as plain text.</li><br />
      <li><code>createElement()</code>: Create a new HTML element.</li><br />
      <li><code>appendChild()</code>: Add a new child element to the DOM.</li><br />
      <li><code>replaceChild()</code>: Replace an existing child element.</li><br />
      <li><code>remove()</code>: Remove an element from the DOM.</li><br />
      <li><code>insertAdjacentHTML()</code>: Insert HTML content at specified positions relative to an element.</li>
    </ul><br />
    <p>
      These techniques enable developers to build rich, interactive web applications that respond dynamically to user input and events.
    </p>
  </div>
)}


{selectedChapter === 'chapter37' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Changing Attributes, Classes, and Styles</h1>

    <p>
      Changing attributes, classes, and styles in JavaScript DOM manipulation is crucial for dynamically altering the presentation and behavior of HTML elements. This capability allows developers to create interactive web applications that respond to user actions and modify the user interface without reloading the page. Here’s a breakdown of how to change attributes, classes, and styles:
    </p><br />

    <h2>1. Changing Attributes</h2>

    <p style={{paddingBottom:"6px"}}>
      Attributes are properties associated with HTML elements that provide additional information. JavaScript allows you to get, set, and remove attributes using the following methods:
    </p>

    <ul>
      <li>
        <strong>Getting an Attribute</strong>: You can retrieve the value of an attribute using the <code>getAttribute()</code> method.
        <pre>
          <code>
            {`const element = document.getElementById('myElement');
const value = element.getAttribute('data-custom'); // Retrieves the value of the 'data-custom' attribute`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>Setting an Attribute</strong>: Use the <code>setAttribute()</code> method to change the value of an attribute.
        <pre>
          <code>
            {`const element = document.getElementById('myElement');
element.setAttribute('data-custom', 'newValue'); // Sets the 'data-custom' attribute to 'newValue'`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>Removing an Attribute</strong>: To remove an attribute, use the <code>removeAttribute()</code> method.
        <pre>
          <code>
            {`const element = document.getElementById('myElement');
element.removeAttribute('data-custom'); // Removes the 'data-custom' attribute`}
          </code>
        </pre>
      </li>
    </ul><br /> 

    <h2>2. Changing Classes</h2>

    <p style={{paddingBottom:"6px"}}>
      Classes are used in HTML to apply CSS styles and enable JavaScript manipulation of multiple elements. JavaScript provides methods to add, remove, and toggle classes:
    </p>

    <ul>
      <li>
        <strong>Adding a Class</strong>: You can add a class to an element using the <code>classList.add()</code> method.
        <pre>
          <code>
            {`const element = document.getElementById('myElement');
element.classList.add('new-class'); // Adds 'new-class' to the element's class list`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>Removing a Class</strong>: Use the <code>classList.remove()</code> method to remove a class.
        <pre>
          <code>
            {`const element = document.getElementById('myElement');
element.classList.remove('old-class'); // Removes 'old-class' from the element's class list`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>Toggling a Class</strong>: The <code>classList.toggle()</code> method adds a class if it doesn’t exist, or removes it if it does.
        <pre>
          <code>
            {`const element = document.getElementById('myElement');
element.classList.toggle('active'); // Toggles the 'active' class`}
          </code>
        </pre>
      </li>
    </ul><br />

    <h2>3. Changing Styles</h2>

    <p style={{paddingBottom:"6px"}}>
      JavaScript allows direct manipulation of the inline styles of elements through the <code>style</code> property. This method enables dynamic styling based on conditions or events:
    </p>

    <ul>
      <li>
        <strong>Setting Styles</strong>: You can set a specific CSS style by assigning a value to the corresponding property of the <code>style</code> object.
        <pre>
          <code>
            {`const element = document.getElementById('myElement');
element.style.color = 'red'; // Changes the text color to red
element.style.backgroundColor = 'blue'; // Changes the background color to blue`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>Removing Styles</strong>: To remove a style, set the property value to an empty string.
        <pre>
          <code>
            {`const element = document.getElementById('myElement');
element.style.color = ''; // Removes the color style, reverting to default`}
          </code>
        </pre>
      </li>
    </ul><br />

    <h2>Summary</h2>

    <p>
      Changing attributes, classes, and styles in JavaScript DOM manipulation allows developers to:
    </p>
    <ul>
      <li><strong>Attributes</strong>: Retrieve, set, or remove attributes to control element properties.</li><br />
      <li><strong>Classes</strong>: Dynamically add, remove, or toggle classes to change styles based on user interactions.</li><br />
      <li><strong>Styles</strong>: Directly manipulate inline styles for real-time visual changes on the webpage.</li>
    </ul><br />

    <p>
      These techniques enable the creation of interactive and responsive web applications that enhance user experience and engagement.
    </p>
  </div>
)}


{selectedChapter === 'chapter38' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Creating and Removing Elements</h1>
    <p>
      In JavaScript, DOM (Document Object Model) manipulation involves dynamically adding or removing elements from a webpage. This is essential for creating interactive web pages where the content can change based on user interactions or other events.
    </p><br />

    <h2>1. Creating Elements in the DOM</h2>
    <p style={{paddingBottom:"6px"}}>
      To create elements, you use the <code>document.createElement()</code> method. Once created, you can set attributes, add content, and append it to the DOM using <code>appendChild()</code> or <code>insertBefore()</code>.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Steps to Create an Element:</h3>
    <ol>
      <li><strong>Create the Element</strong>: Use <code>document.createElement()</code>.</li><br />
      <li><strong>Add Attributes</strong>: You can add attributes like <code>id</code>, <code>class</code>, etc., using methods like <code>setAttribute()</code>.</li><br />
      <li><strong>Add Content</strong>: Use <code>textContent</code> or <code>innerHTML</code> to insert content inside the element.</li><br />
      <li><strong>Append to DOM</strong>: Use <code>appendChild()</code> to insert the element into an existing part of the DOM.</li>
    </ol><br />

    <h3>Example:</h3>
    <pre>
      <code>{`
        // Step 1: Create a new <div> element
        let newDiv = document.createElement('div');

        // Step 2: Set an attribute (like a class) for styling
        newDiv.setAttribute('class', 'new-div');

        // Step 3: Add some content
        newDiv.textContent = 'This is a dynamically created div!';

        // Step 4: Append it to the body or another container element
        document.body.appendChild(newDiv);
      `}</code>
    </pre>

    <p>
      This will create a new <code>&lt;div&gt;</code> element with the class <code>new-div</code> and text content inside it, then add it to the webpage.
    </p><br />

    <h2>2. Removing Elements from the DOM</h2>
    <p style={{paddingBottom:"6px"}}>
      To remove elements, you can use <code>removeChild()</code> or <code>remove()</code>. The difference is that <code>removeChild()</code> needs a reference to the parent node, while <code>remove()</code> works directly on the element itself.
    </p>

    <h3>Example Using <code>removeChild()</code>:</h3>
    <pre>
      <code>{`
        // Find the element to be removed
        let elementToRemove = document.querySelector('.new-div');

        // Find its parent node
        let parent = elementToRemove.parentNode;

        // Remove the element from the DOM
        parent.removeChild(elementToRemove);
      `}</code>
    </pre><br />

    <h3>Example Using <code>remove()</code> (simpler and modern):</h3>
    <pre>
      <code>{`
        // Directly remove the element from the DOM
        let elementToRemove = document.querySelector('.new-div');
        elementToRemove.remove();
      `}</code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary:</h2>
    <ul>
      <li><strong>Creating an Element</strong>: Use <code>document.createElement()</code> to create it, set its attributes or content, then append it to the DOM.</li><br />
      <li><strong>Removing an Element</strong>: Use <code>removeChild()</code> if you need to reference the parent node, or <code>remove()</code> for directly removing the element.</li>
    </ul><br />

    <p>
      These methods are essential for dynamic web pages where elements can be added or removed based on user interactions or other events.
    </p>
  </div>
)}


{selectedChapter === 'chapter39' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Traversing the DOM</h1>

    <p>
      <strong>Traversing the DOM in JavaScript</strong> refers to the process of navigating through the Document Object Model (DOM) tree to access and manipulate HTML elements. The DOM represents the structure of a webpage as a tree of objects, where each node corresponds to an element or a piece of text. Understanding how to traverse the DOM is crucial for effectively manipulating elements, handling events, and dynamically updating the content of web applications.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Key Concepts of DOM Traversal</h2>

    <ol>
      <li>
        <strong>Parent, Child, and Sibling Relationships:</strong>
        <ul>
          <li>
            <strong>Parent:</strong> An element that contains other elements is known as a parent. You can access the parent of an element using the <code>parentNode</code> property.
          </li><br />
          <li>
            <strong>Child:</strong> An element contained within another element is a child. You can access an element's children using the <code>childNodes</code> or <code>children</code> property.
          </li><br />
          <li>
            <strong>Sibling:</strong> Elements that share the same parent are siblings. You can access an element's next or previous sibling using <code>nextSibling</code> and <code>previousSibling</code>.
          </li>
        </ul>
      </li><br />

      <li>
        <strong style={{paddingBottom:"6px"}}>Common DOM Traversal Properties and Methods:</strong>
        <ul>
          <li><code>document.getElementById()</code>: Selects an element by its ID.</li><br />
          <li><code>document.getElementsByClassName()</code>: Selects elements by their class name.</li><br />
          <li><code>document.getElementsByTagName()</code>: Selects elements by their tag name.</li><br />
          <li><code>querySelector()</code>: Selects the first matching element based on a CSS selector.</li><br />
          <li><code>querySelectorAll()</code>: Selects all matching elements based on a CSS selector.</li>
        </ul>
      </li><br />

      <li>
        <strong>Example of Traversing the DOM:</strong>
        <p>Here’s a simple example of how to traverse the DOM:</p>
        <pre>
          <code>{`
<div id="parent">
    <p class="child">Child 1</p>
    <p class="child">Child 2</p>
    <p class="child">Child 3</p>
</div>
          `}</code>
        </pre>
        <pre>
          <code>{`
// Access the parent element
const parent = document.getElementById('parent');

// Access the children of the parent
const children = parent.children; // Returns an HTMLCollection of child elements

// Access the first child
const firstChild = parent.firstElementChild;

// Access the last child
const lastChild = parent.lastElementChild;

// Access the next sibling of the first child
const secondChild = firstChild.nextElementSibling;

// Access the parent of the second child
const parentOfSecond = secondChild.parentNode;

console.log(firstChild.textContent); // Outputs: "Child 1"
console.log(secondChild.textContent); // Outputs: "Child 2"
console.log(parentOfSecond.id);       // Outputs: "parent"
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Using <code>forEach</code> with NodeLists:</strong>
        <p>When using methods like <code>querySelectorAll()</code>, you can iterate over the resulting NodeList using <code>forEach()</code>:</p>
        <pre>
          <code>{`const children = document.querySelectorAll('.child');
children.forEach(child => {
    console.log(child.textContent);
});`}</code>
        </pre>
      </li><br />

      <li>
        <strong>Modifying the DOM During Traversal:</strong>
        <p>You can not only access but also modify elements during traversal. For example, changing the text content or styles:</p>
        <pre>
          <code>{`children.forEach(child => {
    child.style.color = 'blue'; // Changes the text color to blue for all children
});`}</code>
        </pre>
      </li>
    </ol><br />

    <h2>Summary</h2>
    <p>
      Traversing the DOM in JavaScript is a powerful technique that enables developers to access and manipulate elements effectively. By understanding the relationships between elements and using traversal methods and properties, you can create dynamic and interactive web applications that respond to user interactions.
    </p>
  </div>
)}

{selectedChapter === 'chapter40' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>DOM Events</h1>

    <p>
      DOM Events in JavaScript are actions or occurrences that happen in the Document Object Model (DOM) tree, which can be detected and responded to by JavaScript. Events play a crucial role in making web applications interactive, allowing developers to execute specific code in response to user interactions or other occurrences.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Key Concepts of DOM Events</h2>

    <ol>
      <li>
        <strong style={{paddingBottom:"6px"}}>Event Types:</strong>
        <ul>
          <li><strong>User Interface Events:</strong> Triggered by user actions, such as clicks, key presses, and mouse movements.</li><br />
          <li><strong>Keyboard Events:</strong> Fired when the user interacts with the keyboard, such as pressing a key down or releasing it.</li><br />
          <li><strong>Mouse Events:</strong> Include actions like clicking, double-clicking, mouse movement, and scrolling.</li><br />
          <li><strong>Form Events:</strong> Triggered by interactions with form elements, such as submitting a form or changing the value of an input field.</li><br />
          <li><strong>Window Events:</strong> Related to the browser window, such as loading, resizing, or scrolling.</li>
        </ul>
      </li><br />

      <li>
        <strong style={{paddingBottom:"6px"}}>Event Handling:</strong>
        <ul>
          <li><strong>Event Listeners:</strong> Functions that respond to specific events. You can add event listeners to elements using the <code>addEventListener()</code> method.</li><br />
          <li><strong>Event Objects:</strong> When an event occurs, an event object is created containing information about the event, such as its type and the target element.</li><br />
          <li><strong>Event Propagation:</strong> Events can propagate through the DOM tree in two phases: capturing (from the root to the target) and bubbling (from the target back up to the root). You can control this behavior using the <code>stopPropagation()</code> method.</li>
        </ul>
      </li><br />

      <li>
        <strong>Example of Adding an Event Listener:</strong>
        <p>Here's a simple example demonstrating how to add a click event listener to a button:</p>

        <pre><code>{`<button id="myButton">Click Me!</button>`}</code></pre>

        <pre><code>{`const button = document.getElementById('myButton');

// Add a click event listener
button.addEventListener('click', function(event) {
    alert('Button was clicked!');
});`}</code></pre>
      </li><br />

      <li>
        <strong>Event Delegation:</strong>
        <p>Instead of adding event listeners to individual elements, you can add a single listener to a parent element and handle events for multiple child elements. This technique is called event delegation:</p>

        <pre><code>{`<ul id="myList">
    <li>Item 1</li>
    <li>Item 2</li>
    <li>Item 3</li>
</ul>`}</code></pre>

        <pre><code>{`const list = document.getElementById('myList');

// Add a click event listener to the parent
list.addEventListener('click', function(event) {
    if (event.target.tagName === 'LI') {
        alert(\`You clicked on \${event.target.textContent}\`);
    }
});`}</code></pre>
      </li><br />

      <li>
        <strong>Removing Event Listeners:</strong>
        <p>You can remove an event listener using the <code>removeEventListener()</code> method, which requires a reference to the function that was originally passed to <code>addEventListener()</code>:</p>

        <pre><code>{`function handleClick() {
    alert('Button was clicked!');
}

button.addEventListener('click', handleClick);

// Later, if needed
button.removeEventListener('click', handleClick);`}</code></pre>
      </li>
    </ol><br />

    <h2>Summary</h2>
    <p>
      DOM Events are essential for creating interactive web applications. By responding to user actions and other occurrences, developers can build dynamic user interfaces that enhance the overall user experience. Understanding how to work with events, including adding, handling, and removing event listeners, is crucial for any web developer.
    </p>
  </div>
)}


{selectedChapter === 'chapter41' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Introduction to OOP Concepts (Classes, Objects, Inheritance)</h1>

    <p>
      Object-Oriented Programming (OOP) is a programming paradigm that uses "objects" to design software. 
      Objects are instances of classes, which can encapsulate data and functionality. 
      JavaScript, being a prototype-based language, supports OOP principles and enables developers to build applications using OOP concepts effectively.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Key Concepts of OOP in JavaScript</h2>

    <h3>1. Classes</h3>
    <p>
      A class is a blueprint for creating objects. It defines properties (attributes) and methods (functions) that the objects created from the class can have. 
      In JavaScript, classes are defined using the <code>class</code> keyword. Classes can have a constructor method for initializing new objects.
    </p>
    <pre>
      <code>
{`class Animal {
    constructor(name, species) {
        this.name = name;       // Property
        this.species = species; // Property
    }

    speak() {                 // Method
        console.log(\`\${this.name} makes a noise.\`);
    }
}

const dog = new Animal('Rex', 'Dog');
dog.speak(); // Outputs: Rex makes a noise.`}
      </code>
    </pre><br />

    <h3>2. Objects</h3>
    <p>
      An object is an instance of a class and can hold data and methods. Objects can be created directly using object literals or through classes. 
      In JavaScript, objects can be dynamic, allowing you to add or modify properties and methods at runtime.
    </p>
    <pre>
      <code>
{`const cat = {
    name: 'Whiskers',
    species: 'Cat',
    speak: function() {
        console.log(\`\${this.name} purrs.\`);
    }
};

cat.speak(); // Outputs: Whiskers purrs.`}
      </code>
    </pre><br />

    <h3>3. Inheritance</h3>
    <p>
      Inheritance allows one class (child class) to inherit properties and methods from another class (parent class). This promotes code reusability and establishes a relationship between classes. 
      In JavaScript, inheritance can be achieved using the <code>extends</code> keyword, allowing the child class to inherit from the parent class.
    </p>
    <pre>
      <code>
{`class Dog extends Animal { // Dog inherits from Animal
    speak() { // Method overriding
        console.log(\`\${this.name} barks.\`);
    }
}

const dog = new Dog('Buddy', 'Dog');
dog.speak(); // Outputs: Buddy barks.`}
      </code>
    </pre><br />

    <h2>Summary</h2>
    <p>
      Understanding OOP concepts such as classes, objects, and inheritance in JavaScript is essential for writing organized and maintainable code. 
      By leveraging these principles, developers can create robust applications that are easier to understand, modify, and extend. 
      OOP also facilitates a modular approach to coding, making it easier to manage complexity in larger codebases.
    </p>
  </div>
)}


{selectedChapter === 'chapter42' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Constructors and Prototypes</h1>

    <p>
      In JavaScript, <strong>constructors</strong> and <strong>prototypes</strong> are fundamental concepts that underpin the language's approach to object-oriented programming. Here’s a detailed explanation of each:
    </p><br />

    <h2>Constructors</h2>

    <p style={{paddingBottom:"6px"}}>
      A constructor is a special function that is used to create and initialize objects. In JavaScript, functions can be defined as constructors, and when invoked with the <code>new</code> keyword, they create a new object.
    </p>

    <h3>Key Features of Constructors:</h3>
    <ul>
      <li>
        <strong>Naming Convention:</strong> Constructor functions are typically named with a capital letter to distinguish them from regular functions.
      </li><br />
      <li>
        <strong>Creating Instances:</strong> When a constructor is called with <code>new</code>, it creates a new object, sets its prototype to the constructor’s prototype, and returns the new object.
      </li>
    </ul><br />

    <h3>Example of a Constructor Function:</h3>
    <pre><code>
      {`function Person(name, age) {
          this.name = name; // Property
          this.age = age;   // Property
      }

      // Creating an instance of Person
      const john = new Person('John', 30);
      console.log(john.name); // Outputs: John
      console.log(john.age);  // Outputs: 30;`}
    </code></pre><br />

    <h2>Prototypes</h2>

    <p style={{paddingBottom:"6px"}}>
      Every JavaScript function has a <code>prototype</code> property that is used to attach properties and methods that should be shared among all instances of the object created by that constructor. This is a key aspect of JavaScript's inheritance model.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Prototypes:</h3>
    <ul>
      <li>
        <strong>Inheritance:</strong> Prototypes allow for inheritance by enabling objects to share methods and properties.
      </li><br />
      <li>
        <strong>Prototype Chain:</strong> When trying to access a property or method, JavaScript first looks at the object itself. If it doesn't find it there, it checks the object's prototype, and this continues up the prototype chain.
      </li>
    </ul><br />

    <h3>Example of Using Prototypes:</h3>
    <pre><code>
      {`// Adding a method to the Person prototype
      Person.prototype.greet = function() {
          console.log(\`Hello, my name is \${this.name}.\`);
      };

      // Creating another instance of Person
      const jane = new Person('Jane', 25);
      jane.greet(); // Outputs: Hello, my name is Jane.`}
    </code></pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li>
        <strong>Constructors:</strong> Functions that create and initialize objects, typically using the <code>new</code> keyword.
      </li><br />
      <li>
        <strong>Prototypes:</strong> A mechanism for inheritance that allows methods and properties to be shared across all instances created by a constructor.
      </li>
    </ul><br />

    <p>
      Together, constructors and prototypes allow JavaScript to achieve object-oriented programming capabilities, enabling developers to create reusable and organized code structures.
    </p>
  </div>
)}

{selectedChapter === 'chapter43' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Encapsulation and Polymorphism</h1>

    <p>
      Here’s an overview of <strong>Encapsulation</strong> and <strong>Polymorphism</strong> in JavaScript, two fundamental concepts of Object-Oriented Programming (OOP):
    </p><br />

    <h2>Encapsulation</h2>

    <p style={{paddingBottom:"6px"}}>
      <strong>Encapsulation</strong> is the practice of bundling the data (properties) and methods (functions) that operate on the data into a single unit called an object. It restricts direct access to some of the object's components and can prevent the accidental modification of data. Encapsulation helps in protecting the integrity of the data and makes it easier to maintain and modify the code.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Encapsulation:</h3>
    <ul>
      <li>
        <strong>Access Modifiers:</strong> JavaScript allows you to create private and public properties using closures or modern features like the <code>#</code> prefix for private fields in classes.
      </li><br />
      <li>
        <strong>Getter and Setter Methods:</strong> These methods can be used to read or update private properties while controlling how those properties are accessed or modified.
      </li>
    </ul><br />

    <h3>Example of Encapsulation:</h3>
    <pre><code>{`
class BankAccount {
    constructor(owner, balance) {
        this.owner = owner;
        let _balance = balance; // Private property

        // Public method to get balance
        this.getBalance = function() {
            return _balance;
        };

        // Public method to deposit money
        this.deposit = function(amount) {
            if (amount > 0) {
                _balance += amount;
            }
        };

        // Public method to withdraw money
        this.withdraw = function(amount) {
            if (amount > 0 && _balance >= amount) {
                _balance -= amount;
            }
        };
    }
}

const account = new BankAccount('Alice', 1000);
console.log(account.getBalance()); // Outputs: 1000
account.deposit(500);
console.log(account.getBalance()); // Outputs: 1500
account.withdraw(200);
console.log(account.getBalance()); // Outputs: 1300
`}</code></pre><br />

    <h2>Polymorphism</h2>

    <p style={{paddingBottom:"6px"}}>
      <strong>Polymorphism</strong> is the ability of different objects to respond to the same method call in a way that is specific to their types. In JavaScript, polymorphism is achieved through method overriding and duck typing, where the behavior of an object is determined by its methods and properties rather than its type.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features of Polymorphism:</h3>
    <ul>
      <li>
        <strong>Method Overriding:</strong> Child classes can provide a specific implementation of a method that is already defined in its parent class.
      </li><br />
      <li>
        <strong>Duck Typing:</strong> If an object implements a method that can be called, it can be used regardless of its type.
      </li>
    </ul><br />

    <h3>Example of Polymorphism:</h3>
    <pre><code>{`
class Animal {
    speak() {
        console.log('Animal makes a sound');
    }
}

class Dog extends Animal {
    speak() {
        console.log('Dog barks');
    }
}

class Cat extends Animal {
    speak() {
        console.log('Cat meows');
    }
}

function makeAnimalSpeak(animal) {
    animal.speak(); // Calls the appropriate method based on the object's type
}

const dog = new Dog();
const cat = new Cat();

makeAnimalSpeak(dog); // Outputs: Dog barks
makeAnimalSpeak(cat); // Outputs: Cat meows
`}</code></pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li>
        <strong>Encapsulation:</strong> Bundles data and methods into a single unit (object) and restricts direct access to some components, ensuring data integrity.
      </li><br />
      <li>
        <strong>Polymorphism:</strong> Allows objects of different types to be treated as objects of a common super type, enabling methods to be called based on the object's type.
      </li>
    </ul><br />

    <p>
      Understanding these concepts is crucial for writing organized and maintainable code in JavaScript and leveraging the full power of object-oriented programming.
    </p>
  </div>
)}

{selectedChapter === 'chapter44' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>ES6 Classes and Methods</h1>

    <p>
      JavaScript's ES6 (ECMAScript 2015) introduced a more intuitive way to implement Object-Oriented Programming (OOP) concepts through the use of classes. This syntax provides a clearer structure for creating objects, managing inheritance, and organizing code, making it easier for developers to adopt OOP principles in their JavaScript applications.
    </p><br />

    <h3>What are ES6 Classes?</h3>

    <p style={{paddingBottom:"6px"}}>
      Classes in JavaScript are syntactical sugar over the existing prototype-based inheritance, providing a more elegant way to create objects and handle inheritance. They encapsulate data and behavior, representing real-world entities in a structured manner.
    </p>

    <h3  style={{paddingBottom:"6px"}}>Key Features of ES6 Classes</h3>

    <ol>
      <li>
        <strong>Class Declaration:</strong> You define a class using the <code>class</code> keyword followed by the class name. Class names are typically capitalized by convention.
        <pre>
          <code>{`
class ClassName {
    // Class body
}
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Constructor Method:</strong> The <code>constructor</code> method is a special method used for initializing new objects. It is called automatically when a new instance of the class is created using the <code>new</code> keyword.
        <pre>
          <code>{`
class Person {
    constructor(name, age) {
        this.name = name; // Instance property
        this.age = age;   // Instance property
    }
}
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Methods:</strong> Methods can be defined within the class body without using the <code>function</code> keyword. These methods can operate on the instance properties.
        <pre>
          <code>{`
class Person {
    constructor(name, age) {
        this.name = name;
        this.age = age;
    }

    greet() { // Instance method
        console.log(\`Hello, my name is \${this.name} and I am \${this.age} years old.\`);
    }
}
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Inheritance:</strong> ES6 classes support inheritance, allowing one class (child class) to inherit properties and methods from another class (parent class). This is done using the <code>extends</code> keyword.
        <pre>
          <code>{`
class Employee extends Person {
    constructor(name, age, position) {
        super(name, age); // Call the constructor of the parent class
        this.position = position; // Additional property
    }

    describe() {
        console.log(\`I am \${this.name}, a \${this.position}.\`);
    }
}
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Static Methods:</strong> Static methods are defined on the class itself rather than on instances. They are useful for utility functions that are related to the class but do not require instance data.
        <pre>
          <code>{`
class MathUtil {
    static add(a, b) {
        return a + b;
    }
}

console.log(MathUtil.add(5, 3)); // Outputs: 8
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Getters and Setters:</strong> ES6 classes support getters and setters, allowing you to define methods that get or set property values in a controlled way.
        <pre>
          <code>{`
class Circle {
    constructor(radius) {
        this.radius = radius;
    }

    get area() { // Getter
        return Math.PI * this.radius * this.radius;
    }

    set diameter(diameter) { // Setter
        this.radius = diameter / 2;
    }
}

const circle = new Circle(5);
console.log(circle.area); // Outputs the area
circle.diameter = 10; // Set diameter
console.log(circle.radius); // Outputs: 5
          `}</code>
        </pre>
      </li>
    </ol><br />

    <h3 style={{paddingBottom:"6px"}}>Summary</h3>

    <ul>
      <li>
        <strong>ES6 Classes:</strong> Provide a clearer, more concise syntax for creating objects and implementing inheritance, making OOP principles more accessible in JavaScript.
      </li><br />
      <li>
        <strong>Constructor Method:</strong> Initializes instances of a class.
      </li><br />
      <li>
        <strong>Instance Methods:</strong> Defined within the class to operate on instance data.
      </li><br />
      <li>
        <strong>Inheritance:</strong> Facilitates code reuse and organization through class extension.
      </li><br />
      <li>
        <strong>Static Methods:</strong> Related to the class, not specific instances, useful for utility functions.
      </li><br />
      <li>
        <strong>Getters and Setters:</strong> Allow controlled access to object properties.
      </li>
    </ul><br />

    <p>
      Overall, ES6 classes and methods enhance the way developers implement OOP in JavaScript, leading to more maintainable, organized, and scalable code.
    </p>
  </div>
)}


{selectedChapter === 'chapter45' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Inheritance (extends and super)</h1>
    <p>
      <strong>Inheritance</strong> is one of the key principles of Object-Oriented Programming (OOP). It allows one class to inherit properties and methods from another class, facilitating code reuse and creating a hierarchical structure between classes. In JavaScript, inheritance is implemented using the <code>class</code>, <code>extends</code>, and <code>super</code> keywords.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Concepts of Inheritance:</h3>
    <ul>
      <li>
        <strong>Parent Class (Base Class):</strong> The class from which properties and methods are inherited.
      </li><br />
      <li>
        <strong>Child Class (Derived Class):</strong> The class that inherits from the parent class. It can also have its own properties and methods or override the inherited ones.
      </li>
    </ul><br />

    <h3>How to Implement Inheritance in ES6:</h3>
    <p>
      <strong>1. <code>extends</code> Keyword:</strong> The <code>extends</code> keyword is used to create a subclass (child class) that inherits from a superclass (parent class). It allows the child class to access properties and methods of the parent class.
    </p><br />
    <p>
      <strong>2. <code>super</code> Keyword:</strong> The <code>super</code> keyword is used to call the constructor or methods of the parent class within the child class. It helps avoid re-implementing functionality that already exists in the parent class.
    </p><br />

    <h3>Example of Inheritance in JavaScript:</h3>
    <pre>
      <code>
{`
class Animal {
    constructor(name) {
        this.name = name;
    }

    makeSound() {
        console.log(\`\${this.name} makes a sound.\`);
    }
}

class Dog extends Animal {
    constructor(name, breed) {
        super(name); // Calls the parent class constructor
        this.breed = breed;
    }

    makeSound() {
        console.log(\`\${this.name} barks.\`);
    }

    describe() {
        console.log(\`\${this.name} is a \${this.breed}.\`);
    }
}

const myDog = new Dog('Buddy', 'Golden Retriever');

myDog.makeSound(); // Outputs: Buddy barks.
myDog.describe(); // Outputs: Buddy is a Golden Retriever.
`}
      </code>
    </pre><br />

    <h3>Explanation:</h3>
    <p>
      <strong>1. <code>extends</code>:</strong> The <code>Dog</code> class extends the <code>Animal</code> class, inheriting its properties (<code>name</code>) and methods (<code>makeSound</code>).
    </p><br />
    <p>
      <strong>2. <code>super</code>:</strong> The <code>super(name)</code> inside the <code>Dog</code> constructor calls the parent <code>Animal</code> class's constructor, allowing the <code>name</code> property to be inherited and initialized.
    </p><br />
    <p>
      <strong>3. Method Overriding:</strong> The <code>makeSound</code> method in the <code>Dog</code> class overrides the <code>makeSound</code> method from the <code>Animal</code> class to provide a more specific behavior for the <code>Dog</code> class.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Key Features of Inheritance:</h3>
    <ul>
      <li><strong>Code Reuse:</strong> Child classes can reuse the properties and methods of parent classes, reducing code duplication.</li><br />
      <li><strong>Method Overriding:</strong> Child classes can override methods inherited from the parent class, allowing for customization of behavior.</li><br />
      <li><strong><code>super</code> for Method Calls:</strong> In addition to calling the constructor, <code>super</code> can also be used to call methods from the parent class within the child class.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Summary</h3>
    <ul>
      <li><strong><code>extends</code>:</strong> Used to create a child class that inherits from a parent class.</li><br />
      <li><strong><code>super</code>:</strong> Used to call the constructor or methods of the parent class within the child class.</li><br />
      <li><strong>Inheritance:</strong> Allows child classes to inherit properties and methods, enabling code reuse and facilitating hierarchical class structures in JavaScript.</li>
    </ul><br />

    <p>
      This approach enables developers to create scalable and organized object-oriented structures in JavaScript applications.
    </p>
  </div>
)}

{selectedChapter === 'chapter46' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Static Methods and Properties</h1>

    <p>
      In JavaScript Object-Oriented Programming (OOP), <strong>static methods</strong> and <strong>static properties</strong> are associated with a class itself, rather than instances of the class. These can be called directly on the class without creating an instance.
    </p><br />

    <h2>Static Methods</h2>
    <p style={{paddingBottom:"6px"}}>
      Static methods are functions that belong to a class but are not tied to any specific object instance. They are usually utility functions that perform tasks related to the class but do not rely on instance data.
    </p>

    <h4>How to Define Static Methods</h4>
    <pre>
      <code>{`
class MathUtil {
    static add(a, b) {
        return a + b;
    }
}

// Calling a static method directly on the class
console.log(MathUtil.add(5, 3)); // Outputs: 8
      `}</code>
    </pre>
    <p>
      In the above example, the <code>add</code> method can be called on the <code>MathUtil</code> class itself without needing to create an instance.
    </p><br />

    <h4 style={{paddingBottom:"6px"}}>Key Characteristics of Static Methods:</h4>
    <ul>
      <li>
        <strong>No Access to Instance Data:</strong> Static methods cannot access instance properties or methods. They can only interact with static properties or other static methods of the class.
      </li><br />
      <li>
        <strong>Class-Level Utility:</strong> They are commonly used for tasks that are related to the class but don't require any data from specific instances of the class.
      </li>
    </ul>

 <br />

    <h2>Static Properties</h2>
    <p style={{paddingBottom:"6px"}}>
      Static properties, like static methods, belong to the class itself and not to the instances. These properties are typically used to store values that are the same across all instances of the class.
    </p>

    <h4>How to Define Static Properties</h4>
    <pre>
      <code>{`
class Config {
    static appName = 'MyApp';
    static version = '1.0';
}

console.log(Config.appName); // Outputs: MyApp
console.log(Config.version); // Outputs: 1.0
      `}</code>
    </pre>
    <p>
      In the above example, <code>appName</code> and <code>version</code> are static properties of the <code>Config</code> class and can be accessed directly without needing an instance.
    </p><br />

    <h4 style={{paddingBottom:"6px"}}>Key Characteristics of Static Properties:</h4>
    <ul>
      <li>
        <strong>Shared Among All Instances:</strong> Static properties are shared among all instances of the class. Any change to a static property affects all instances.
      </li><br />
      <li>
        <strong>Class-Level Data:</strong> They are often used for constants or settings that are relevant to the class itself rather than to individual objects.
      </li>
    </ul>
<br />

    <h4>Example of Static Methods and Properties Together:</h4>
    <pre>
      <code>{`
class Circle {
    static pi = 3.14159; // Static property

    constructor(radius) {
        this.radius = radius; // Instance property
    }

    // Static method to calculate area
    static calculateArea(radius) {
        return Circle.pi * radius * radius;
    }

    // Instance method to calculate the circumference
    getCircumference() {
        return 2 * Circle.pi * this.radius;
    }
}

// Calling static method directly on the class
console.log(Circle.calculateArea(5)); // Outputs: 78.53975

// Creating an instance to call an instance method
const myCircle = new Circle(5);
console.log(myCircle.getCircumference()); // Outputs: 31.4159
      `}</code>
    </pre><br />

    <h4 style={{paddingBottom:"6px"}}>Explanation:</h4>
    <ul>
      <li>
        <strong>Static Property:</strong> <code>Circle.pi</code> is a static property that holds the value of π (pi).
      </li><br />
      <li>
        <strong>Static Method:</strong> <code>Circle.calculateArea</code> is a static method used to calculate the area of a circle. It can be called directly on the <code>Circle</code> class.
      </li><br />
      <li>
        <strong>Instance Method:</strong> The <code>getCircumference</code> method is an instance method and requires an instance of <code>Circle</code> to be called.
      </li>
    </ul>

   <br />

    <h4 style={{paddingBottom:"6px"}}>Summary:</h4>
    <ul>
      <li><strong>Static Methods:</strong> Defined using the <code>static</code> keyword and are called directly on the class without needing to instantiate it. They are useful for utility functions related to the class but not tied to instance-specific data.</li><br />
      <li><strong>Static Properties:</strong> Also defined with the <code>static</code> keyword, static properties store data that is associated with the class itself and shared among all instances.</li>
    </ul><br />

    <p>
      Static methods and properties in JavaScript help in organizing utility functions and class-level data, making your object-oriented code more structured and maintainable.
    </p>
  </div>
)}

{selectedChapter === 'chapter47' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Callback</h1>

    <p>
      In asynchronous JavaScript, <strong>callbacks</strong> are functions passed as arguments to other functions and are executed once an operation has been completed. They are crucial in handling asynchronous operations like making network requests, reading files, or any other task that might take time to finish.
    </p><br />

    <h2>What is a Callback?</h2>
    <p>
      A <strong>callback</strong> is simply a function that is executed after another function has finished its execution. Callbacks are used to ensure that certain code doesn’t run until an asynchronous operation completes.
    </p><br />

    <h3>Synchronous vs Asynchronous Callbacks</h3>
    <ul>
      <li>
        <strong>Synchronous Callbacks</strong>: These are executed immediately after the function is called, in the same flow of code.
      </li><br />
      <li>
        <strong>Asynchronous Callbacks</strong>: These are executed after a certain event completes, like after a file is read or after an API call returns.
      </li>
    </ul><br />

    <h2>Example of an Asynchronous Callback</h2>
    <pre>
      <code>{`
        // Simulating an asynchronous operation
        function fetchData(callback) {
          console.log("Fetching data...");
          setTimeout(() => {
              console.log("Data fetched!");
              callback(); // Call the callback once data is fetched
          }, 2000); // Simulates a 2-second delay
        }

        function processData() {
          console.log("Processing data...");
        }

        // Calling fetchData and passing processData as a callback
        fetchData(processData);
      `}</code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Explanation</h3>
    <ol>
      <li>The <code>fetchData</code> function starts by logging "Fetching data..." and then performs an asynchronous operation using <code>setTimeout</code>.</li><br />
      <li>After 2 seconds, the callback function (<code>processData</code>) is executed.</li><br />
      <li>The <code>processData</code> function is passed as a callback to <code>fetchData</code>, ensuring that data processing only happens after the data has been fetched.</li>
    </ol><br />

    <h2 style={{paddingBottom:"6px"}}>Why Use Callbacks?</h2>
    <ul>
      <li>
        <strong>Handling asynchronous tasks</strong>: Callbacks allow you to handle operations like API calls, file reading, or timers without blocking the main execution thread.
      </li><br />
      <li>
        <strong>Control flow</strong>: By using callbacks, you can control when certain pieces of code execute, especially when dealing with multiple asynchronous tasks.
      </li>
    </ul><br />

    <h3>Nested Callbacks (Callback Hell)</h3>
    <p style={{paddingBottom:"6px"}}>
      When multiple asynchronous operations depend on each other, callbacks can get deeply nested. This is known as <strong>callback hell</strong> and can lead to hard-to-read and maintain code.
    </p>

    <h4>Example of Callback Hell</h4>
    <pre>
      <code>{`
        function firstTask(callback) {
          setTimeout(() => {
              console.log("First task completed");
              callback();
          }, 1000);
        }

        function secondTask(callback) {
          setTimeout(() => {
              console.log("Second task completed");
              callback();
          }, 1000);
        }

        function thirdTask() {
          setTimeout(() => {
              console.log("Third task completed");
          }, 1000);
        }

        // Chaining multiple asynchronous tasks using callbacks
        firstTask(() => {
          secondTask(() => {
              thirdTask();
          });
        });
      `}</code>
    </pre><br />

    <p>
      This pattern can quickly become difficult to manage. To avoid callback hell, modern JavaScript offers alternatives like <strong>Promises</strong> and <strong>async/await</strong>.
    </p>
  </div>
)}

{selectedChapter === 'chapter48' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Promises (resolve, reject, then, catch)</h1>


    <p>
      In JavaScript, <strong>Promises</strong> provide a powerful way to handle asynchronous operations more effectively than traditional callbacks, reducing complexity and improving readability. A Promise represents an operation that can either complete successfully or fail, offering methods to handle the outcome.
    </p><br />

    <h2>What is a Promise?</h2>

    <p style={{paddingBottom:"6px"}}>
      A <strong>Promise</strong> is an object that represents the eventual completion (or failure) of an asynchronous operation and its resulting value. It has three states:
    </p>

    <ul>
      <li><strong>Pending</strong>: The initial state, where the promise is neither fulfilled nor rejected.</li><br />
      <li><strong>Fulfilled</strong>: The operation completed successfully, resulting in a value.</li><br />
      <li><strong>Rejected</strong>: The operation failed, resulting in a reason for the failure.</li>
    </ul><br />

    <h2>Creating a Promise</h2>

    <p style={{paddingBottom:"6px"}}>
      To create a new Promise, use the <code>Promise</code> constructor, which takes a function with two parameters: <code>resolve</code> and <code>reject</code>.
    </p>

    <pre>
      <code>{`
        const myPromise = new Promise((resolve, reject) => {'\n'}
          // Perform some asynchronous operation
          const success = true;

          if (success) {{
            resolve("Operation was successful!"); // Fulfill the promise
          }} else {{
            reject("Operation failed."); // Reject the promise
          }}
        });
      `}</code>
    </pre><br />

    <ul>
      <li><code>resolve</code>: This function is called when the asynchronous operation is successful, changing the promise's state from pending to fulfilled.</li><br />
      <li><code>reject</code>: This function is called when the operation fails, changing the promise's state to rejected.</li>
    </ul><br />

    <h2>Handling Promises with <code>then</code> and <code>catch</code></h2>

    <p style={{paddingBottom:"6px"}}>
      Once a Promise is created, its outcome can be handled using the <code>.then()</code> and <code>.catch()</code> methods.
    </p>

    <ul>
      <li><code>then</code>: This method is used to define what happens when a promise is fulfilled (successful).</li><br />
      <li><code>catch</code>: This method is used to handle any errors or rejections that occur during the promise's execution.</li>
    </ul><br />

    <h3>Example of Using <code>then</code> and <code>catch</code>:</h3>

    <pre>
      <code>{`
        myPromise
          .then((message) => {{ 
            console.log(message); // Outputs: "Operation was successful!"
          }})
          .catch((error) => {{ 
            console.error(error); // Outputs the error message if rejected
          }});
      `}</code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Key Concepts of Promises:</h2>

    <h3>1. Chaining with <code>then</code>:</h3>
    <p>You can chain multiple <code>.then()</code> calls to handle sequential asynchronous operations.</p>

    <pre>
      <code>{`
        const fetchData = new Promise((resolve) => {{
          setTimeout(() => {{
            resolve("Data fetched");
          }}, 1000);
        }});

        fetchData
          .then((data) => {{
            console.log(data); // Outputs: "Data fetched"
            return "Processing data";
          }})
          .then((message) => {{
            console.log(message); // Outputs: "Processing data"
          }});
      `}</code>
    </pre><br />

    <h3>2. Error Handling with <code>catch</code>:</h3>
    <p>If any part of the promise chain fails, the error will be caught by the <code>catch</code> block.</p>

    <pre>
      <code>{`
        const fetchData = new Promise((resolve, reject) => {{
          const success = false; // Simulating failure
          if (success) {{
            resolve("Data fetched");
          }} else {{
            reject("Failed to fetch data");
          }}
        }});

        fetchData
          .then((data) => {{
            console.log(data);
          }})
          .catch((error) => {{
            console.error(error); // Outputs: "Failed to fetch data"
          }});
      `}</code>
    </pre><br />

    <h3>3. The <code>finally</code> Method:</h3>
    <p>The <code>finally</code> method can be used to execute code after a promise has settled (either fulfilled or rejected). It is often used for cleanup actions, such as closing a loading spinner.</p>

    <pre>
      <code>{`
        fetchData
          .then((data) => {{
            console.log(data);
          }})
          .catch((error) => {{
            console.error(error);
          }})
          .finally(() => {{
            console.log("Operation complete"); // This will always execute
          }});
      `}</code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li><code>resolve</code>: Indicates a successful operation, fulfilling the promise.</li><br />
      <li><code>reject</code>: Indicates a failed operation, rejecting the promise.</li><br />
      <li><code>then</code>: Defines the action that happens when a promise is fulfilled.</li><br />
      <li><code>catch</code>: Defines what happens when a promise is rejected.</li><br />
      <li><code>finally</code>: Executes code after a promise has settled, regardless of its outcome.</li>
    </ul><br />

    <p>
      Using Promises in JavaScript helps manage asynchronous operations more effectively, enhancing code readability and error handling while avoiding issues like "callback hell."
    </p>
  </div>
)}

{selectedChapter === 'chapter49' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Async/Await</h1>

    <p><strong>Async/Await</strong> is a modern way to work with asynchronous code in JavaScript, introduced in ECMAScript 2017 (ES8). It allows developers to write asynchronous code that looks and behaves more like synchronous code, improving readability and maintainability.</p><br />

    <h3 style={{paddingBottom:"6px"}}>What is Async/Await?</h3>
    <ul>
      <li><strong>Async Function</strong>: An <code>async</code> function is declared with the <code>async</code> keyword. It always returns a promise. If the function returns a value, that value is automatically wrapped in a resolved promise. If an error is thrown, it returns a rejected promise.</li>
      <li><strong>Await Expression</strong>: The <code>await</code> expression pauses the execution of an <code>async</code> function until a promise is settled (either resolved or rejected). The <code>await</code> keyword can only be used inside an <code>async</code> function.</li>
    </ul><br />

    <h3>Syntax</h3>
    <p>Here’s the basic syntax for using <code>async</code> and <code>await</code>:</p>
    <pre>
      <code>{`
        async function myAsyncFunction() &#123;
          try &#123;
            const result = await someAsyncOperation();
            console.log(result);
          &#125; catch (error) &#123;
            console.error('Error:', error);
          &#125;
        &#125;
      `}</code>
    </pre><br />

    <h3>Example of Async/Await</h3>
    <p>Consider a function that simulates fetching data from an API:</p>
    <pre>
      <code>{`
        // Simulating an asynchronous operation
        const fetchData = () => &#123;
            return new Promise((resolve, reject) => &#123;
                setTimeout(() => &#123;
                    const success = true; // Simulate success
                    if (success) &#123;
                        resolve("Data fetched successfully!");
                    &#125; else &#123;
                        reject("Failed to fetch data.");
                    &#125;
                &#125;, 1000);
            &#125;);
        &#125;;

        // Using Async/Await
        async function fetchDataAsync() &#123;
            try &#123;
                const data = await fetchData(); // Wait for the promise to resolve
                console.log(data); // Outputs: "Data fetched successfully!"
            &#125; catch (error) &#123;
                console.error('Error:', error); // Outputs error if promise is rejected
            &#125;
        &#125;;

        // Call the async function
        fetchDataAsync();
     `} </code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Key Points</h3>
    <ol>
      <li><strong>Error Handling</strong>: Async/Await simplifies error handling using <code>try/catch</code> blocks. Errors thrown during the execution of an awaited promise can be caught in the <code>catch</code> block.</li><br />
      <li><strong>Sequential Execution</strong>: When using <code>await</code>, asynchronous operations are executed in the order they are awaited, useful for operations that depend on previous results.
        <pre>
          <code>{`
            async function sequentialFetch() &#123;
                const data1 = await fetchData();
                console.log(data1);
                
                const data2 = await fetchData(); // Wait for the first to complete
                console.log(data2);
            &#125;
          `}</code>
        </pre>
      </li><br />
      <li><strong>Concurrent Execution</strong>: To run multiple asynchronous operations concurrently, start them without awaiting immediately and await their results later:
        <pre>
          <code>{`
            async function concurrentFetch() &#123;
                const promise1 = fetchData();
                const promise2 = fetchData();
        
                const results = await Promise.all([promise1, promise2]);
                console.log(results); // Outputs an array of results
            &#125;
         `} </code>
        </pre>
      </li>
      <li><strong>Return Value</strong>: An <code>async</code> function always returns a promise. The return value is wrapped in a promise, allowing you to handle the result with <code>then/catch</code> or <code>await</code>.</li>
    </ol><br />

    <h3 style={{paddingBottom:"6px"}}>Summary</h3>
    <ul>
      <li><strong>Async/Await</strong> provides a more synchronous way to write asynchronous code, enhancing readability and reducing complexity.</li><br />
      <li>An <code>async</code> function always returns a promise, and the <code>await</code> keyword pauses execution until the promise is resolved or rejected.</li><br />
      <li>Error handling is simplified with <code>try/catch</code> blocks.</li><br />
      <li>It can be used for sequential or concurrent asynchronous operations, making it a powerful tool for modern JavaScript development.</li>
    </ul><br />

    <p>This approach makes managing asynchronous operations much more intuitive and easier to read, avoiding the pitfalls of callback hell and enhancing code maintainability.</p>
  </div>
)}

{selectedChapter === 'chapter50' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Error Handling in Asynchronous Code</h1>

    <p>
      Error handling in asynchronous JavaScript is crucial for creating robust and resilient applications. Asynchronous operations, such as those performed with Promises or async/await, can fail for various reasons, including network errors, unexpected data, or timeouts. Understanding how to properly handle these errors ensures your application can respond appropriately and maintain a good user experience.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Key Concepts of Error Handling</h3>

    <ol>
      <li>
        <strong>Callbacks and Error-First Convention</strong>:  
        In traditional asynchronous code using callbacks, the first parameter of the callback function is usually reserved for an error object (if an error occurs). This is known as the error-first callback pattern.
        <pre>
          <code>
            {`function fetchData(callback) {
    // Simulate an asynchronous operation
    setTimeout(() => {
        const error = null; // Or an error object if something goes wrong
        const data = "Fetched data";
        callback(error, data);
    }, 1000);
}

fetchData((error, data) => {
    if (error) {
        console.error("Error:", error);
        return;
    }
    console.log("Data:", data);
}`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Promises and the `catch` Method</strong>:  
        Promises provide a cleaner way to handle asynchronous operations and their errors. You can use the `.catch()` method to handle rejections in the promise chain.
        <pre>
          <code>
            {`const fetchData = () => {
    return new Promise((resolve, reject) => {
        const success = false; // Simulating failure
        if (success) {
            resolve("Data fetched successfully!");
        } else {
            reject("Failed to fetch data.");
        }
    });
};

fetchData()
    .then(data => {
        console.log(data);
    })
    .catch(error => {
        console.error("Error:", error); // Handle the error
    });`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Async/Await and `try/catch`</strong>:  
        When using async/await, errors can be handled with `try/catch` blocks, making error handling more intuitive and synchronous in style.
        <pre>
          <code>
            {`const fetchDataAsync = async () => {
    try {
        const data = await fetchData(); // Await the promise
        console.log(data);
    } catch (error) {
        console.error("Error:", error); // Handle any error that occurred
    }
};

fetchDataAsync();`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Handling Multiple Errors</strong>:  
        When dealing with multiple asynchronous operations, you can handle errors for each operation separately or use `Promise.all()` and catch any error that occurs in the array of promises.
        <pre>
          <code>
            {`const fetchData1 = () => Promise.resolve("Data 1 fetched");
const fetchData2 = () => Promise.reject("Error fetching Data 2");

Promise.all([fetchData1(), fetchData2()])
    .then(results => {
        console.log(results); // This will not execute if any promise is rejected
    })
    .catch(error => {
        console.error("One of the promises failed:", error); // Handle error from any promise
    });`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Error Propagation</strong>:  
        Errors can be propagated through promise chains. If a promise is rejected, it will skip to the nearest catch handler in the chain.
        <pre>
          <code>
            {`const fetchData = () => Promise.reject("Failed to fetch data.");

fetchData()
    .then(data => {
        console.log(data);
    })
    .catch(error => {
        console.error("Error in first promise:", error);
        throw new Error("Chained error"); // Propagate error
    })
    .catch(error => {
        console.error("Error in chain:", error); // Catch the propagated error
    });`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Global Error Handling</strong>:  
        You can set up global error handlers for unhandled promise rejections using `window.onunhandledrejection` in browsers or `process.on('unhandledRejection')` in Node.js.
        <pre>
          <code>
            {`window.onunhandledrejection = event => {
    console.error("Unhandled rejection:", event.reason);
};`}
          </code>
        </pre>
      </li>
    </ol><br />

    <h3 style={{paddingBottom:"6px"}}>Summary</h3>

    <ul>
      <li><strong>Callbacks</strong>: Use the error-first convention to handle errors in traditional asynchronous code.</li><br />
      <li><strong>Promises</strong>: Utilize `.catch()` for handling rejections.</li><br />
      <li><strong>Async/Await</strong>: Use `try/catch` blocks to handle errors intuitively.</li><br />
      <li><strong>Multiple Errors</strong>: Handle errors in concurrent operations using `Promise.all()` or separate `catch` handlers.</li><br />
      <li><strong>Error Propagation</strong>: Errors can be propagated through promise chains for centralized error handling.</li><br />
      <li><strong>Global Handling</strong>: Set up global handlers for unhandled promise rejections.</li>
    </ul><br />

    <p>
      By implementing effective error handling strategies, you can create more reliable and user-friendly asynchronous applications in JavaScript.
    </p>
  </div>
)}



{selectedChapter === 'chapter51' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Fetch API for HTTP Requests</h1>

    <p>
      The <strong>Fetch API</strong> is a modern JavaScript interface that allows you to make HTTP requests to servers and handle responses in a more powerful and flexible way than traditional methods like <code>XMLHttpRequest</code>. Introduced in ECMAScript 6, the Fetch API is built around Promises, making it suitable for asynchronous programming.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Key Features of the Fetch API</h3>
    <ul>
      <li><strong>Promise-based:</strong> The Fetch API uses Promises to handle asynchronous requests, leading to cleaner and more readable code.</li><br />
      <li><strong>Simplified Syntax:</strong> It provides a concise way to make requests and handle responses compared to older methods.</li><br />
      <li><strong>More Powerful:</strong> Supports various types of HTTP requests (GET, POST, PUT, DELETE, etc.), headers, and request bodies.</li><br />
      <li><strong>Streamable Response:</strong> Allows reading the response as a stream for handling large amounts of data efficiently.</li><br />
      <li><strong>Cross-Origin Requests:</strong> Supports cross-origin requests by default, given proper CORS configuration on the server.</li>
    </ul><br />

    <h3>Basic Syntax</h3>
    <p>
      Here’s the basic syntax for making a GET request using the Fetch API:
    </p>
    <pre>
      <code>
        {`fetch(url)
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json(); // Parse the JSON from the response
    })
    .then(data => {
        console.log(data); // Handle the data from the response
    })
    .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
    });`}
      </code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Making Different Types of HTTP Requests</h3>

    <h4>1. GET Request:</h4>
    <pre>
      <code>
        {`fetch('https://api.example.com/data')
    .then(response => response.json())
    .then(data => console.log(data))
    .catch(error => console.error('Error:', error));`}
      </code>
    </pre><br />

    <h4>2. POST Request:</h4>
    <pre>
      <code>
        {`fetch('https://api.example.com/data', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({ key: 'value' }), // Convert object to JSON string
})
    .then(response => response.json())
    .then(data => console.log(data))
    .catch(error => console.error('Error:', error));`}
      </code>
    </pre><br />

    <h4>3. PUT Request:</h4>
    <pre>
      <code>
        {`fetch('https://api.example.com/data/1', {
    method: 'PUT',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({ key: 'newValue' }),
})
    .then(response => response.json())
    .then(data => console.log(data))
    .catch(error => console.error('Error:', error));`}
      </code>
    </pre><br />

    <h4>4. DELETE Request:</h4>
    <pre>
      <code>
        {`fetch('https://api.example.com/data/1', {
    method: 'DELETE',
})
    .then(response => {
        if (response.ok) {
            console.log('Data deleted successfully');
        } else {
            throw new Error('Failed to delete data');
        }
    })
    .catch(error => console.error('Error:', error));`}
      </code>
    </pre><br />

    <h3>Handling Errors</h3>
    <p>
      The Fetch API does not reject the promise on HTTP error statuses (e.g., 404 or 500). Instead, it resolves the promise normally, allowing you to handle errors based on the response status. You can check the <code>response.ok</code> property to determine if the request was successful.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Summary</h3>
    <ul>
      <li>The <strong>Fetch API</strong> is a powerful and flexible way to make HTTP requests in asynchronous JavaScript.</li><br />
      <li>It is built around Promises, simplifying the management of asynchronous code.</li><br />
      <li>Supports various HTTP methods (GET, POST, PUT, DELETE) with a simplified syntax for handling requests and responses.</li><br />
      <li>Easily handle JSON data, check for response errors, and work with streams for large data sets.</li>
    </ul><br />

    <p>
      By leveraging the Fetch API, you can create more robust and maintainable asynchronous code for interacting with APIs and handling HTTP requests in your JavaScript applications.
    </p>
  </div>
)}

{selectedChapter === 'chapter52' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Working with APIs (GET, POST)</h1>


    <p>
      Working with APIs is a fundamental aspect of web development, enabling developers to interact with external services, retrieve data, and send data from client applications. JavaScript, particularly through the Fetch API, allows you to perform these operations asynchronously using HTTP methods such as GET and POST.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>1. Understanding HTTP Methods</h3>

    <ul>
      <li>
        <strong>GET Method</strong>: Used to request data from a specified resource. GET requests do not have a body, and the data is typically sent as URL parameters. They are idempotent, meaning multiple identical requests should have the same effect as a single request.
      </li><br />
      <li>
        <strong>POST Method</strong>: Used to send data to a server to create or update a resource. POST requests can include a body containing the data being sent to the server. Unlike GET requests, POST requests are not idempotent, as they can result in different outcomes when repeated.
      </li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>2. Making a GET Request</h3>

    <p>To fetch data from an API using the GET method, you can use the Fetch API as follows:</p>

    <pre>
      <code>
        {`fetch('https://api.example.com/data')
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json(); // Parse JSON data from the response
    })
    .then(data => {
        console.log(data); // Handle the retrieved data
    })
    .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
    });`}
      </code>
    </pre><br />

    <p style={{paddingBottom:"6px"}}>In this example:</p>
    <ul>
      <li>The <code>fetch()</code> function initiates a GET request to the specified URL.</li><br />
      <li>The first <code>.then()</code> checks if the response is successful and parses the JSON data.</li><br />
      <li>The second <code>.then()</code> handles the data retrieved from the API.</li><br />
      <li>Any errors are caught and logged in the <code>.catch()</code> block.</li>
    </ul><br />

    <h3>3. Making a POST Request</h3>

    <p>To send data to an API using the POST method, the Fetch API can be used as follows:</p>

    <pre>
      <code>
        {`fetch('https://api.example.com/data', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({ key: 'value' }) // Convert JavaScript object to JSON string
})
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to create data');
        }
        return response.json(); // Parse the JSON response
    })
    .then(data => {
        console.log('Data created:', data); // Handle the response data
    })
    .catch(error => {
        console.error('Error:', error); // Handle errors
    });`}
      </code>
    </pre><br />

    <p style={{paddingBottom:"6px"}}>In this example:</p>
    <ul>
      <li>The <code>fetch()</code> function initiates a POST request with the specified URL.</li><br />
      <li>The <code>method</code> option specifies that this is a POST request.</li><br />
      <li>The <code>headers</code> option indicates that the request body will be JSON.</li><br />
      <li>The <code>body</code> option contains the JSON string of the data being sent.</li><br />
      <li>As with GET requests, responses and errors are handled in chained <code>.then()</code> and <code>.catch()</code> blocks.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>4. Common Practices When Working with APIs</h3>

    <ul>
      <li><strong>Check Response Status</strong>: Always check the <code>response.ok</code> property to determine if the request was successful.</li><br />
      <li><strong>Error Handling</strong>: Implement error handling using <code>.catch()</code> to gracefully handle network errors or unexpected responses.</li><br />
      <li><strong>Data Parsing</strong>: Use appropriate methods (like <code>.json()</code>, <code>.text()</code>, etc.) to parse the response based on the expected data format.</li><br />
      <li><strong>Avoid CORS Issues</strong>: When making requests to different domains, ensure the server allows cross-origin requests by implementing CORS (Cross-Origin Resource Sharing).</li>
    </ul><br />

    <h3>5. Conclusion</h3>

    <p>
      Working with APIs using the Fetch API in JavaScript allows for efficient and straightforward data retrieval and submission. Mastering GET and POST requests is essential for modern web development, enabling applications to interact dynamically with back-end services and provide rich user experiences.
    </p>

    <p>
      By understanding and effectively using these methods, developers can create robust, responsive applications that seamlessly connect to various APIs.
    </p>

   <br />
    <p>
      This overview should provide a solid foundation for understanding how to work with APIs using asynchronous JavaScript code, specifically focusing on GET and POST requests. Let me know if you need any further details or examples!
    </p>
  </div>
)}


{selectedChapter === 'chapter53' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>try, catch, finally</h1>

    <p>
      In JavaScript, error handling is crucial for managing exceptions that may arise during the execution of code,
      especially in asynchronous operations. The <code>try</code>, <code>catch</code>, and <code>finally</code> 
      statements are fundamental constructs that allow developers to gracefully handle errors and ensure that certain 
      code runs regardless of whether an error occurred.
    </p><br />

    <h3>1. <code>try</code> Statement</h3>

    <p>
      The <code>try</code> block is used to wrap code that may throw an error. If an error occurs within the 
      <code>try</code> block, control is passed to the corresponding <code>catch</code> block.
    </p>

    <pre>
      <code>
        {`try {
    // Code that may throw an error
    let result = riskyOperation();
    console.log(result);
} catch (error) {
    console.error('Error occurred:', error);
}`}
      </code>
    </pre>

    <p>
      In this example, if <code>riskyOperation()</code> throws an error, the error will be caught by the 
      <code>catch</code> block, preventing the program from crashing.
    </p><br />

    <h3>2. <code>catch</code> Statement</h3>

    <p>
      The <code>catch</code> block is executed when an error occurs in the corresponding <code>try</code> block. 
      It captures the error object, allowing you to handle it appropriately, such as logging it or displaying a 
      message to the user.
    </p>

    <pre>
      <code>
        {`try {
    let data = fetchData();
    console.log(data);
} catch (error) {
    console.error('Fetch failed:', error);
}`}
      </code>
    </pre>

    <p>
      Here, if <code>fetchData()</code> fails, the error will be caught, and a relevant message will be logged.
    </p><br />

    <h3>3. <code>finally</code> Statement</h3>

    <p>
      The <code>finally</code> block is optional and will execute after the <code>try</code> and <code>catch</code> 
      blocks, regardless of whether an error occurred or not. It is often used for cleanup operations, such as 
      closing connections or releasing resources.
    </p>

    <pre>
      <code>
        {`try {
    console.log('Trying to read data...');
    let data = readData(); // May throw an error
    console.log(data);
} catch (error) {
    console.error('Error occurred:', error);
} finally {
    console.log('This will run regardless of the outcome.');
}`}
      </code>
    </pre>

    <p>
      In this example, whether <code>readData()</code> succeeds or fails, the <code>finally</code> block will execute.
    </p><br />

    <h3>4. Using <code>try/catch/finally</code> with Asynchronous Code</h3>

    <p>
      In asynchronous JavaScript, error handling can also be achieved using <code>try</code>, <code>catch</code>, and 
      <code>finally</code>, particularly when using <code>async/await</code>. Here's how it works:
    </p>

    <pre>
      <code>
        {`const fetchData = async () => {
    try {
        const response = await fetch('https://api.example.com/data');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log(data);
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        console.log('Fetch attempt completed.');
    }
};

fetchData();`}
      </code>
    </pre><br />

    <p>
      In this asynchronous example:
    </p>
    <ul>
      <li>
        The <code>try</code> block contains the asynchronous code that may throw an error (like a failed network request).
      </li><br />
      <li>
        If an error occurs during the fetch or JSON parsing, it will be caught by the <code>catch</code> block.
      </li><br />
      <li>
        The <code>finally</code> block will execute after the <code>try</code> and <code>catch</code>, regardless of the 
        outcome, indicating that the fetch attempt is complete.
      </li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>5. Summary</h3>

    <ul>
      <li><code>try</code>: Used to wrap code that may throw an error.</li><br />
      <li><code>catch</code>: Executes if an error is thrown in the <code>try</code> block, allowing for error handling.</li><br />
      <li><code>finally</code>: Executes after the <code>try</code> and <code>catch</code> blocks, regardless of whether an error occurred, useful for cleanup operations.</li>
    </ul><br />

    <p>
      These constructs provide a robust way to handle errors in both synchronous and asynchronous JavaScript, allowing for 
      more resilient and maintainable code.
    </p>
  </div>
)}

{selectedChapter === 'chapter54' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Custom Errors</h1>

    <p>
      In JavaScript, handling errors effectively is crucial for creating robust applications. While built-in error types like <code>TypeError</code> and <code>ReferenceError</code> serve well in many scenarios, custom errors can provide more context and specificity for particular situations, especially in asynchronous code.
    </p><br />

    <h3 style={
    {paddingBottom:"6px"}}>Why Use Custom Errors?</h3>
    <ul>
      <li>
        <strong>Specificity:</strong> Custom errors allow you to define error types that are specific to your application or domain logic. This specificity helps in identifying the source and nature of the error quickly.
      </li><br />
      <li>
        <strong>Enhanced Error Handling:</strong> By creating custom error classes, you can implement tailored error handling logic that is more meaningful to your application. This can simplify debugging and improve the user experience.
      </li><br />
      <li>
        <strong>Structured Error Responses:</strong> In APIs, custom errors can provide structured responses that include helpful information about what went wrong.
      </li>
    </ul><br />

    <h3>Creating Custom Errors</h3>
    <p>
      To create a custom error in JavaScript, you can extend the built-in <code>Error</code> class. Here’s a simple example:
    </p>
    <pre>
      <code>
        {`class CustomError extends Error {
    constructor(message, code) {
        super(message); // Call the parent constructor with the message
        this.name = this.constructor.name; // Set the error name to the custom error name
        this.code = code; // Add custom property to store error code
        Error.captureStackTrace(this, this.constructor); // Capture stack trace
    }
}`}
      </code>
    </pre><br />

    <h3>Using Custom Errors in Asynchronous Code</h3>
    <p>
      You can throw and catch custom errors in asynchronous functions, just like built-in errors. Here’s how to do that:
    </p>
    <pre>
      <code>
        {`const fetchData = async (url) => {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new CustomError('Failed to fetch data', 'FETCH_ERROR');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        // Handle custom errors specifically
        if (error instanceof CustomError) {
            console.error(\`Custom Error: \${error.message} (Code: \${error.code})\`);
        } else {
            console.error('An unexpected error occurred:', error);
        }
    }
};

fetchData('https://api.example.com/data');`}
      </code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Summary</h3>
    <ul>
      <li>
        <strong>Custom Errors:</strong> Allow you to create specific error types that can enhance error handling in your application.
      </li><br />
      <li>
        <strong>Creating Custom Errors:</strong> Extend the built-in <code>Error</code> class and define custom properties and methods.
      </li><br />
      <li>
        <strong>Error Handling:</strong> Use custom errors in asynchronous code to provide clearer context and structured responses.
      </li>
    </ul><br />

    <p>
      By implementing custom errors in your asynchronous JavaScript code, you can improve error handling, debugging, and overall code maintainability, leading to a better developer and user experience.
    </p>
  </div>
)}



{selectedChapter === 'chapter55' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Debugging with `console.log`, Breakpoints, and Developer Tools</h1>

    <p>
      Debugging is a vital part of the development process, especially when dealing with error handling in JavaScript.
      Understanding how to effectively use tools such as <code>console.log</code>, breakpoints, and browser developer tools can significantly enhance your ability to diagnose and resolve issues in your code. Here’s a detailed look at these techniques:
    </p><br />

    <h3>1. Using `console.log`</h3>

    <p style={{paddingBottom:"6px"}}>
      The <code>console.log</code> method is one of the simplest and most widely used debugging tools in JavaScript. 
      It allows you to print messages to the console, which can help track the flow of execution and the state of variables at various points in your code.
    </p>

    <h4>Example:</h4>
    <pre>
      <code>
        {`const fetchData = async (url) => {
          try {
              console.log(\`Fetching data from: \${url}\`); // Log the URL being fetched
              const response = await fetch(url);
              if (!response.ok) {
                  throw new Error(\`HTTP error! status: \${response.status}\`);
              }
              const data = await response.json();
              console.log('Data retrieved:', data); // Log the retrieved data
              return data;
          } catch (error) {
              console.error('Error fetching data:', error);
          }
      };

      fetchData('https://api.example.com/data');`}
      </code>
    </pre><br />

    <h4 style={{paddingBottom:"6px"}}>Advantages:</h4>
    <ul>
      <li><strong>Quick Feedback:</strong> You can add or remove <code>console.log</code> statements quickly without modifying the structure of your code.</li><br />
      <li><strong>Variable Inspection:</strong> You can print the values of variables to understand their state at different points in execution.</li><br />
      <li><strong>Flow Tracking:</strong> Helps to track which parts of your code are executing and in what order.</li>
    </ul><br />

    <h4 style={{paddingBottom:"6px"}}>Disadvantages:</h4>
    <ul>
      <li><strong>Clutter:</strong> Excessive logging can clutter the console and make it difficult to find relevant information.</li><br />
      <li><strong>Performance:</strong> While logging is generally lightweight, excessive logging can impact performance in critical code paths.</li>
    </ul><br />

    <h3>2. Using Breakpoints</h3>

    <p>
      Breakpoints allow you to pause the execution of your code at a specific line, enabling you to inspect the state of your application at that moment. This can be particularly useful for understanding complex logic or identifying the exact point where an error occurs.
    </p><br />

    <h4 style={{paddingBottom:"6px"}}>How to Use Breakpoints:</h4>
    <ol>
      <li>Open the Developer Tools in your browser (usually by pressing F12).</li><br />
      <li>Navigate to the "Sources" tab.</li><br />
      <li>Find your JavaScript file and click on the line number where you want to set a breakpoint.</li><br />
      <li>Refresh the page or trigger the code execution to hit the breakpoint.</li>
    </ol><br />

    <h4 style={{paddingBottom:"6px"}}>Advantages:</h4>
    <ul>
      <li><strong>In-depth Inspection:</strong> You can examine the values of variables, the call stack, and the state of the application at the moment execution is paused.</li><br />
      <li><strong>Step Through Code:</strong> Allows you to step through your code line-by-line, making it easier to understand the flow and catch errors.</li>
    </ul><br />

    <h4 style={{paddingBottom:"6px"}}>Disadvantages:</h4>
    <ul>
      <li><strong>Setup Time:</strong> Setting breakpoints requires more effort than simply adding <code>console.log</code> statements.</li><br />
      <li><strong>Less Suitable for Production:</strong> Breakpoints are typically used during development and are not present in production code.</li>
    </ul><br />

    <h3>3. Using Developer Tools</h3>

    <p>
      Modern browsers come equipped with powerful developer tools that provide a suite of features for debugging and profiling JavaScript code. Here’s a brief overview of some key features:
    </p>

    <ul>
      <li><strong>Console:</strong> View <code>console.log</code> outputs and errors, and run JavaScript commands in the context of the currently loaded page.</li><br />
      <li><strong>Network Tab:</strong> Monitor network requests, view responses, and analyze load times. This is particularly useful for debugging API calls.</li><br />
      <li><strong>Sources Tab:</strong> Inspect JavaScript files, set breakpoints, and step through your code as previously discussed.</li><br />
      <li><strong>Performance Tab:</strong> Profile your application to identify performance bottlenecks, including slow API calls or heavy computations.</li>
    </ul><br />

    <h4 style={{paddingBottom:"6px"}}>Advantages:</h4>
    <ul>
      <li><strong>Comprehensive Debugging:</strong> Provides a range of tools for different debugging needs, from inspecting DOM elements to profiling performance.</li><br />
      <li><strong>Interactive Environment:</strong> You can modify code and see changes in real-time without needing to refresh the page.</li>
    </ul><br />

    <h4 style={{paddingBottom:"6px"}}>Disadvantages:</h4>
    <ul>
      <li><strong>Learning Curve:</strong> The interface and functionality can be overwhelming for beginners.</li><br />
      <li><strong>Browser-Specific:</strong> Developer tools vary between browsers, which can lead to inconsistencies.</li>
    </ul><br />

    <h2>Conclusion</h2>

    <p>
      Debugging is an essential skill for JavaScript developers, especially when dealing with error handling. Using techniques like <code>console.log</code>, breakpoints, and browser developer tools can significantly enhance your ability to diagnose issues effectively.
    </p>

    <p>
      By incorporating these debugging methods into your workflow, you can improve the reliability of your code and create more robust applications. Each method has its strengths and weaknesses, so using them in combination often yields the best results in troubleshooting and resolving errors.
    </p>
  </div>
)}


{selectedChapter === 'chapter56' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Template Literals</h1>

    <p>
      Template literals are a powerful feature introduced in ECMAScript 2015 (ES6) that provide an improved way to work with strings in JavaScript. They allow for easier string interpolation, multi-line strings, and the inclusion of expressions, making string manipulation more intuitive and readable.
    </p><br />

    <h3 style={{ paddingBottom: "6px" }}>Key Features of Template Literals</h3>

    <ol>
      <li>
        <strong>Backticks:</strong> Template literals are enclosed by backticks (<code>`` ` ``</code>) instead of single quotes (<code>'</code>) or double quotes (<code>"</code>). This allows for more flexible string creation.
        <pre>
          <code>{`const greeting = \`Hello, world!\`;`}</code>
        </pre>
      </li><br />
      <li>
        <strong>String Interpolation:</strong> You can embed expressions inside template literals using the <code>{"${expression} "}</code> syntax. This allows for dynamic string creation without needing to concatenate strings manually.
        <pre>
          <code>
            {`const name = 'Alice';\nconst greeting = \`Hello, \${name}!\`;\nconsole.log(greeting); // Output: Hello, Alice!`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Multi-line Strings:</strong> Template literals can span multiple lines without the need for concatenation or escape characters. This makes it easier to create multi-line strings, such as paragraphs or formatted text.
        <pre>
          <code>{`const message = \`This is a string\nthat spans multiple lines.\`;\nconsole.log(message);`}</code>
        </pre>
      </li><br />
      <li>
        <strong>Embedded Expressions:</strong> You can include any valid JavaScript expression within the <code>{"${}"}</code> placeholder, including function calls, arithmetic operations, and more.
        <pre>
          <code>
            {`const a = 5;\nconst b = 10;\nconst result = \`The sum of \${a} and \${b} is \${a + b}.\`;\nconsole.log(result); // Output: The sum of 5 and 10 is 15.`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Tagged Templates:</strong> Template literals can also be used with a special syntax called "tagged templates," where a function can process the template literal. The function can manipulate the parts of the template before returning the final string.
        <pre>
          <code>
            {`function tag(strings, ...values) {\n    return strings.reduce((result, str, i) => {\n        return result + str + (values[i] ? values[i].toUpperCase() : '');\n    }, '');\n}\n\nconst name = 'Bob';\nconst message = tag\`Hello, \${name}! Welcome.\`;\nconsole.log(message); // Output: Hello, BOB! Welcome.`}
          </code>
        </pre>
      </li>
    </ol><br />

    <h3 style={{ paddingBottom: "6px" }}>Advantages of Template Literals</h3>
    <ul>
      <li><strong>Improved Readability:</strong> Template literals make it easier to read and understand the code, especially when working with strings that require interpolation or multiple lines.</li><br />
      <li><strong>Less Boilerplate:</strong> Eliminates the need for cumbersome string concatenation, reducing the amount of code you need to write.</li><br />
      <li><strong>Dynamic Content:</strong> Allows for easy inclusion of dynamic content within strings, making your code more flexible and powerful.</li>
    </ul><br />

    <h3>Summary</h3>
    <p>
      Template literals are a significant enhancement to string handling in JavaScript, providing developers with a more intuitive and powerful way to work with strings. By using backticks, string interpolation, and the ability to create multi-line strings, template literals improve both the readability and functionality of JavaScript code.
    </p>
  </div>
)}


{selectedChapter === 'chapter57' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Destructuring Assignment (Arrays and Objects)</h1>

    <p>
      Destructuring assignment is a syntactic feature introduced in ECMAScript 2015 (ES6) that allows unpacking values from arrays or properties from objects into distinct variables. This feature makes it easier to extract data from complex structures and enhances code readability and conciseness.
    </p><br />

    <h3>1. Destructuring Arrays</h3>
    <p>
      Destructuring arrays allows you to extract values from an array and assign them to variables in a single statement.
    </p>
    <p><strong>Example:</strong></p>
    <pre style={{paddingBottom:"6px"}}>
      <code>{`const numbers = [1, 2, 3, 4, 5];\nconst [first, second, third] = numbers;\n\nconsole.log(first); // Output: 1\nconsole.log(second); // Output: 2\nconsole.log(third); // Output: 3;`}</code>
    </pre>

    <p><strong>Skipping Items:</strong> You can skip items in the array during destructuring by leaving the corresponding variable assignment empty.</p>
    <pre>
      <code>{`const numbers = [1, 2, 3, 4, 5];\nconst [, second, , fourth] = numbers;\n\nconsole.log(second); // Output: 2\nconsole.log(fourth); // Output: 4;`}</code>
    </pre><br />

    <h3>2. Destructuring Objects</h3>
    <p>
      Destructuring objects allows you to extract properties from an object and assign them to variables. You can also rename the variables while destructuring.
    </p>
    <p><strong>Example:</strong></p>
    <pre style={{paddingBottom:"6px"}}>
      <code>{`const person = {\n    name: 'Alice',\n    age: 25,\n    location: 'Wonderland'\n};\n\nconst { name, age } = person;\n\nconsole.log(name); // Output: Alice\nconsole.log(age); // Output: 25;`}</code>
    </pre>

    <p><strong>Renaming Variables:</strong> You can rename variables during destructuring by using a colon (`:`).</p>
    <pre>
      <code>{`const person = {\n    name: 'Alice',\n    age: 25,\n    location: 'Wonderland'\n};\n\nconst { name: fullName, age: years } = person;\n\nconsole.log(fullName); // Output: Alice\nconsole.log(years); // Output: 25;`}</code>
    </pre><br />

    <p><strong>Default Values:</strong> You can set default values for variables in case the property does not exist in the object.</p>
    <pre>
      <code>{`const person = {\n    name: 'Alice'\n};\n\nconst { name, age = 30 } = person;\n\nconsole.log(name); // Output: Alice\nconsole.log(age); // Output: 30 (default value);`}</code>
    </pre><br />

    <h3>3. Nested Destructuring</h3>
    <p>You can also destructure nested objects and arrays.</p>
    <p><strong>Example:</strong></p>
    <pre>
      <code>{`const user = {\n    id: 1,\n    profile: {\n        name: 'Alice',\n        age: 25,\n        hobbies: ['reading', 'gaming']\n    }\n};\n\nconst { profile: { name, hobbies: [firstHobby] } } = user;\n\nconsole.log(name); // Output: Alice\nconsole.log(firstHobby); // Output: reading;`}</code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Advantages of Destructuring Assignment</h3>
    <ul>
      <li><strong>Improved Readability:</strong> Destructuring makes it clear which properties or array elements are being accessed, improving code readability.</li><br />
      <li><strong>Less Boilerplate Code:</strong> Reduces the need for repetitive code when extracting values from arrays or objects.</li><br />
      <li><strong>Easier to Handle Nested Structures:</strong> Allows for concise handling of nested objects and arrays, making it easier to access deeply nested values.</li>
    </ul><br />

    <h3>Summary</h3>
    <p>
      Destructuring assignment is a powerful feature in ES6 that simplifies extracting values from arrays and properties from objects. By using this feature, developers can write cleaner, more expressive code, which is easier to read and maintain. Whether working with simple data structures or complex nested ones, destructuring provides a robust solution for managing data effectively in JavaScript.
    </p>
  </div>
)}


{selectedChapter === 'chapter58' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Default Function Parameters</h1>

    <p>
      Default function parameters allow you to initialize named parameters with default values if no value or <code>undefined</code> is passed during the function call. This feature, introduced in ECMAScript 2015 (ES6), simplifies function definitions by providing default values directly in the parameter list.
    </p><br />

    <h3>Syntax</h3>
    <pre>
      <code>
{`function functionName(parameter1 = defaultValue1, parameter2 = defaultValue2) {
    // function body
}`}
      </code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Example of Default Function Parameters</h3>

    <ol>
      <li>
        <strong>Basic Example:</strong>
        <p>
          In the following example, if a user does not provide a value for the <code>greeting</code> parameter, it defaults to "Hello":
        </p>
        <pre>
          <code>
{`function greet(name, greeting = 'Hello') {
    return \`\${greeting}, \${name}!\`;
}

console.log(greet('Alice')); // Output: Hello, Alice!
console.log(greet('Bob', 'Hi')); // Output: Hi, Bob!`}
          </code>
        </pre>
      </li><br />


      <li>
        <strong>Multiple Default Parameters:</strong>
        <p>You can define multiple parameters with default values:</p>
        <pre>
          <code>
{`function createProfile(name, age = 18, country = 'USA') {
    return {
        name: name,
        age: age,
        country: country
    };
}

console.log(createProfile('Alice')); // Output: { name: 'Alice', age: 18, country: 'USA' }
console.log(createProfile('Bob', 25)); // Output: { name: 'Bob', age: 25, country: 'USA' }`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>Using Expressions as Default Values:</strong>
        <p>
          Default values can be set using expressions, including function calls or arithmetic operations:
        </p>
        <pre>
          <code>
{`function multiply(a, b = 1) {
    return a * b;
}

console.log(multiply(5)); // Output: 5 (5 * 1)
console.log(multiply(5, 2)); // Output: 10 (5 * 2)`}
          </code>
        </pre>
      </li><br />

      <li>
        <strong>Default Parameters with Previous Parameters:</strong>
        <p>
          Default parameters can reference other parameters that have already been defined:
        </p>
        <pre>
          <code>
{`function order(item, price, tax = price * 0.1) {
    return \`Item: \${item}, Price: \$\${price}, Tax: \$\${tax}\`;
}

console.log(order('Laptop', 1000)); // Output: Item: Laptop, Price: $1000, Tax: $100
console.log(order('Phone', 500, 50)); // Output: Item: Phone, Price: $500, Tax: $50`}
          </code>
        </pre>
      </li>
    </ol><br />

    <h3 style={{paddingBottom:"6px"}}>Advantages of Default Function Parameters</h3>
    <ul>
      <li><strong>Code Clarity:</strong> Default parameters reduce the need for additional logic inside the function to handle missing arguments, leading to cleaner and more understandable code.</li><br />
      <li><strong>Flexible Function Calls:</strong> They allow you to call functions with fewer arguments while still providing sensible defaults, improving usability.</li><br />
      <li><strong>Less Boilerplate:</strong> They eliminate the need for manual checks or assignments within the function body, reducing boilerplate code.</li>
    </ul><br />

    <h3>Summary</h3>
    <p>
      Default function parameters are a valuable addition to JavaScript, making functions more flexible and easier to work with. By allowing developers to specify default values directly in the function signature, ES6 enhances the expressiveness and readability of the code while also minimizing the need for additional error-checking logic within functions.
    </p>
  </div>
)}

{selectedChapter === 'chapter59' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Spread and Rest Operators</h1>

    <p>
      The Spread and Rest operators are two powerful features introduced in ECMAScript 2015 (ES6) that allow for more flexible and concise handling of arrays and objects. They are represented by the same syntax (<code>...</code>), but their use cases are different.
    </p><br />

    <h2>1. Spread Operator</h2>

    <p>
      The Spread operator allows an iterable (like an array or object) to be expanded into its individual elements. It is commonly used for:
    </p>
    <ul>
      <li><strong>Copying Arrays:</strong> Creating a shallow copy of an array.</li><br />
      <li><strong>Combining Arrays:</strong> Merging multiple arrays into one.</li><br />
      <li><strong>Function Calls:</strong> Expanding an array into individual arguments in a function call.</li><br />
      <li><strong>Object Literals:</strong> Merging object properties.</li>
    </ul><br /> 

    <h3 style={{paddingBottom:"6px"}}>Example of Spread Operator:</h3>

    <h4>Copying Arrays:</h4>
    <pre><code>
      {`const originalArray = [1, 2, 3];
const copiedArray = [...originalArray];
console.log(copiedArray); // Output: [1, 2, 3]`}
    </code></pre><br />

    <h4>Combining Arrays:</h4>
    <pre><code>
      {`const array1 = [1, 2];
const array2 = [3, 4];
const combinedArray = [...array1, ...array2];
console.log(combinedArray); // Output: [1, 2, 3, 4]`}
    </code></pre><br />

    <h4>Function Calls:</h4>
    <pre><code>
      {`function add(a, b, c) {
    return a + b + c;
}
const numbers = [1, 2, 3];
console.log(add(...numbers)); // Output: 6`}
    </code></pre><br />

    <h4>Merging Objects:</h4>
    <pre><code>
      {`const obj1 = { a: 1, b: 2 };
const obj2 = { b: 3, c: 4 };
const mergedObj = { ...obj1, ...obj2 };
console.log(mergedObj); // Output: { a: 1, b: 3, c: 4 }`}
    </code></pre><br />

    <h2>2. Rest Operator</h2>

    <p style={{paddingBottom:"6px"}}>
      The Rest operator allows you to represent an indefinite number of arguments as an array. It is used in function parameters to gather multiple arguments into a single array. This is particularly useful for functions that can take a variable number of arguments.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Example of Rest Operator:</h3>

    <h4>Function Parameters:</h4>
    <pre><code>
      {`function sum(...numbers) {
    return numbers.reduce((acc, curr) => acc + curr, 0);
}
console.log(sum(1, 2, 3)); // Output: 6
console.log(sum(5, 10, 15, 20)); // Output: 50`}
    </code></pre><br />

    <h4>Combining with Other Parameters:</h4>
    <pre><code>
      {`function displayInfo(name, ...hobbies) {
    console.log(\`Name: \${name}\`);
    console.log(\`Hobbies: \${hobbies.join(', ')}\`);
}
displayInfo('Alice', 'reading', 'gaming', 'hiking');
// Output: 
// Name: Alice
// Hobbies: reading, gaming, hiking`}
    </code></pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <p>
      <strong>Spread Operator (<code>...</code>):</strong> Expands elements of an iterable (array or object) into individual elements.
    </p>
    <p>
      <strong>Rest Operator (<code>...</code>):</strong> Gathers multiple arguments into a single array.
    </p><br />

    <p>
      These operators significantly enhance the flexibility and expressiveness of JavaScript code, making it easier to work with arrays and objects. They help reduce boilerplate code, improve readability, and simplify handling of function arguments.
    </p>
  </div>
)}



{selectedChapter === 'chapter60' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Modules (Export,Import)</h1>

    <p>
      Modules are a way to encapsulate code in JavaScript, allowing developers to create reusable pieces of code that can be easily shared and maintained. Introduced in ECMAScript 2015 (ES6), the module system enables you to divide your code into separate files, making it more organized and modular.
    </p><br />

    <h3>1. Exporting Modules</h3>
    <p style={{paddingBottom:"6px"}}>
      To make parts of your code available to other modules, you use the <code>export</code> keyword. There are two types of exports: named exports and default exports.
    </p>

    <h4>1.1 Named Exports</h4>
    <p>
      Named exports allow you to export multiple values from a module. You can export variables, functions, or classes by name.
    </p>

    <p><strong>Example of Named Exports:</strong></p>
    <pre>
      <code>
{`// math.js
export const PI = 3.14;

export function add(a, b) {
    return a + b;
}

export class Calculator {
    subtract(a, b) {
        return a - b;
    }
}`}
      </code>
    </pre><br />

    <h4>1.2 Default Exports</h4>
    <p>
      A default export is a single value or object that can be exported from a module. You can have only one default export per module.
    </p>

    <p><strong>Example of Default Export:</strong></p>
    <pre>
      <code>
{`// calculator.js
export default function multiply(a, b) {
    return a * b;
}`}
      </code>
    </pre><br />

    <h3>2. Importing Modules</h3>
    <p style={{paddingBottom:"6px"}}>
      To use the exported values from a module, you use the <code>import</code> keyword. You can import named exports or default exports.
    </p>

    <h4>2.1 Importing Named Exports</h4>
    <p>
      When importing named exports, you must use the same names as those used in the exporting module.
    </p>

    <p><strong>Example of Importing Named Exports:</strong></p>
    <pre>
      <code>
{`// main.js
import { PI, add } from './math.js';

console.log(PI); // Output: 3.14
console.log(add(2, 3)); // Output: 5`}
      </code>
    </pre><br />

    <h4>2.2 Importing Default Exports</h4>
    <p>
      When importing a default export, you can choose any name you like for the imported value.
    </p>

    <p><strong>Example of Importing Default Export:</strong></p>
    <pre>
      <code>
{`// main.js
import multiply from './calculator.js';

console.log(multiply(2, 3)); // Output: 6`}
      </code>
    </pre><br />

    <h4>2.3 Importing All Exports</h4>
    <p>
      You can import all named exports from a module as a single object using the <code>* as</code> syntax.
    </p>

    <p><strong>Example of Importing All Exports:</strong></p>
    <pre>
      <code>
{`// main.js
import * as math from './math.js';

console.log(math.PI); // Output: 3.14
console.log(math.add(2, 3)); // Output: 5`}
      </code>
    </pre><br />

    <h3>3. Dynamic Imports</h3>
    <p>
      ES6 also supports dynamic imports, which allow you to load modules asynchronously. This is useful for optimizing performance by loading only the necessary modules when needed.
    </p>

    <p><strong>Example of Dynamic Imports:</strong></p>
    <pre>
      <code>
{`// main.js
async function loadModule() {
    const { default: multiply } = await import('./calculator.js');
    console.log(multiply(2, 3)); // Output: 6
}

loadModule();`}
      </code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Advantages of Using Modules</h3>
    <ul>
      <li><strong>Encapsulation</strong>: Modules help encapsulate functionality, reducing global scope pollution and potential name conflicts.</li><br />

      <li><strong>Reusability</strong>: You can create modules for reusable functionalities that can be imported and used in various parts of your application.</li><br />
      <li><strong>Maintainability</strong>: Breaking code into smaller modules makes it easier to maintain and test individual components.</li><br />
      <li><strong>Improved Code Organization</strong>: Modules promote better organization of code, making it easier to navigate and understand the structure of a project.</li>
    </ul><br />

    <h3>Summary</h3>
    <p>
      Modules in ES6+ JavaScript provide a powerful way to structure code by allowing you to export and import functionalities between different files. This modular approach enhances code reusability, maintainability, and organization, making it a fundamental feature for modern JavaScript development.
    </p>
  </div>
)}


{selectedChapter === 'chapter61' && (
    <div className={style.chaptercontent}>
        <h1 className={style.heading}>Promises and Async/Await</h1>

        <p>
            Asynchronous programming is essential in JavaScript to handle operations that take time, such as network requests or file I/O.
            ES6 introduced <strong>Promises</strong> as a way to manage asynchronous operations, and later, the <strong>async/await</strong> syntax was introduced to simplify working with Promises.
        </p><br />

        <h3>1. Promises</h3>

        <p>
            A Promise is an object that represents the eventual completion (or failure) of an asynchronous operation and its resulting value.
            Promises can be in one of three states:
        </p>
        <ul>
            <li><strong>Pending</strong>: The initial state; neither fulfilled nor rejected.</li><br />
            <li><strong>Fulfilled</strong>: The operation completed successfully.</li><br />
            <li><strong>Rejected</strong>: The operation failed.</li>
        </ul><br />

        <h4>Creating a Promise</h4>
        <p>
            You can create a Promise using the <code>Promise</code> constructor, which takes a function (the executor) that contains the asynchronous operation.
        </p>

        <h4>Example of a Promise</h4>
        <pre>
            <code>
                {`const myPromise = new Promise((resolve, reject) => {
    const success = true; // Simulate success or failure
    if (success) {
        resolve('Operation succeeded!');
    } else {
        reject('Operation failed.');
    }
});

myPromise
    .then(result => console.log(result)) // Output: Operation succeeded!
    .catch(error => console.error(error)); // Output: Operation failed.
`}
            </code>
        </pre><br />

        <h4>Chaining Promises</h4>
        <p>
            You can chain multiple <code>then</code> calls to handle a series of asynchronous operations.
        </p>

        <h4>Example of Chaining</h4>
        <pre>
            <code>
                {`fetch('https://api.example.com/data')
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => console.log(data))
    .catch(error => console.error('Fetch error:', error));`}
            </code>
        </pre><br />

        <h3>2. Async/Await</h3>

        <p>
            The <code>async</code> and <code>await</code> keywords, introduced in ES2017 (ES8), provide a more readable and concise way to work with Promises.
            The <code>async</code> keyword is used to declare a function as asynchronous, and <code>await</code> is used to pause the execution of the function until the Promise is resolved.
        </p><br />

        <h4>Creating an Async Function</h4>
        <p>
            You can create an async function using the <code>async</code> keyword before the function declaration.
        </p>

        <h4>Example of Async Function</h4>
        <pre>
            <code>
                {`async function fetchData() {
    try {
        const response = await fetch('https://api.example.com/data');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log(data);
    } catch (error) {
        console.error('Fetch error:', error);
    }
}

fetchData();`}
            </code>
        </pre><br />

        <h3 style={{paddingBottom:"6px"}}>Advantages of Promises and Async/Await</h3>
        <ul>
            <li><strong>Simplified Syntax</strong>: <code>async/await</code> allows you to write asynchronous code that looks and behaves like synchronous code, making it easier to read and maintain.</li><br />
            <li><strong>Error Handling</strong>: Both Promises and <code>async/await</code> provide better error handling mechanisms compared to traditional callback methods.</li><br />
            <li><strong>Chaining and Composition</strong>: Promises can be chained, allowing for cleaner and more modular code when dealing with multiple asynchronous operations.</li>
        </ul><br />

        <h2>Summary</h2>
        <p>
            Promises and <code>async/await</code> are essential features of modern JavaScript that simplify handling asynchronous operations.
            They help developers write cleaner, more maintainable code by providing a structured approach to managing asynchronous tasks.
            By using Promises and <code>async/await</code>, developers can avoid callback hell and improve error handling in their applications.
        </p>
    </div>
)}

{selectedChapter === 'chapter62' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Arrow Functions</h1>

    <p>
      Arrow functions are a concise way to write function expressions in JavaScript. Introduced in ECMAScript 2015 (ES6), they provide a shorter syntax compared to traditional function expressions and come with unique characteristics regarding the <code>this</code> keyword.
    </p>
    <br />

    <h3>1. Syntax</h3>

    <p>The syntax for an arrow function is straightforward:</p>

    <pre>
      <code>{`
        const functionName = (parameters) => {
          // function body
        };
      `}</code>
    </pre>

    <p>If the function has a single parameter, parentheses can be omitted:</p>

    <pre>
      <code>{`
        const square = x => x * x; // Single parameter without parentheses
      `}</code>
    </pre>

    <p>If the function body consists of a single expression, the braces and <code>return</code> keyword can also be omitted:</p>

    <pre>
      <code>{`
        const add = (a, b) => a + b; // Implicit return
      `}</code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>2. Key Features</h3>

    <ul>
      <li>
        <strong>Lexical <code>this</code> Binding:</strong> Unlike traditional functions, arrow functions do not have their own <code>this</code> context. They inherit <code>this</code> from the enclosing scope, making them particularly useful in scenarios where you need to preserve context, such as in callbacks or methods.
        <p>Example of Lexical <code>this</code> Binding:</p>
        <pre>
          <code>{`
            function Person() {
              this.age = 0;

              setInterval(() => {
                this.age++; // \`this\` refers to the Person object
                console.log(this.age);
              }, 1000);
            }

            const person = new Person(); // Logs increasing age every second
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>No <code>arguments</code> Object:</strong> Arrow functions do not have an <code>arguments</code> object, which is an array-like object holding the arguments passed to a function. To access arguments, use rest parameters.
        <p>Example:</p>
        <pre>
          <code>{`
            const sum = (...args) => args.reduce((acc, curr) => acc + curr, 0);
            console.log(sum(1, 2, 3, 4)); // Output: 10
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Cannot Be Used as Constructors:</strong> Arrow functions cannot be used as constructors; you cannot use the <code>new</code> keyword with them. Attempting to do so will throw an error.
      </li>
    </ul><br />

    <h3>3. Use Cases</h3>

    <ul>
      <li>
        <strong>Shorter Syntax:</strong> Arrow functions provide a more concise way to write functions, making the code cleaner and easier to read, especially for simple operations.
        <p>Example:</p>
        <pre>
          <code>{`
            const double = n => n * 2;
            console.log(double(5)); // Output: 10
          `}</code>
        </pre>
      </li><br />

      <li>
        <strong>Callbacks:</strong> Arrow functions are commonly used as callback functions due to their lexical scoping of <code>this</code>.
        <p>Example:</p>
        <pre>
          <code>{`
            const array = [1, 2, 3];
            const doubled = array.map(num => num * 2);
            console.log(doubled); // Output: [2, 4, 6]
          `}</code>
        </pre>
      </li>
    </ul><br />

    <h2>Summary</h2>
    <p>
      Arrow functions are a powerful addition to JavaScript that simplify function syntax and improve code readability. Their unique handling of <code>this</code>, lack of an <code>arguments</code> object, and inability to be used as constructors make them a versatile tool in modern JavaScript development. By using arrow functions, developers can write more concise and maintainable code, especially in functional programming patterns.
    </p>

    <hr />
  </div>
)}


{selectedChapter === 'chapter63' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Symbol, Map, and Set</h1>

    <h2>1. Symbol</h2>
    <p style={{paddingBottom:"6px"}}>
      A <code>Symbol</code> is a primitive data type introduced in ES6. It is
      used to create unique identifiers that are guaranteed to be unique, even
      if they have the same description. Symbols are often used as object
      property keys to avoid property name collisions in JavaScript.
    </p>
    <h3>Usage:</h3>
    <pre>
      <code>
        {`let sym1 = Symbol('description');
let sym2 = Symbol('description');

console.log(sym1 === sym2); // false`}
      </code>
    </pre>
    <p>
      In the example above, <code>sym1</code> and <code>sym2</code> are both
      <code>Symbol</code> values but are unique, even though they have the same
      description.
    </p><br />

    <h2>2. Map</h2>
    <p style={{paddingBottom:"6px"}}>
      A <code>Map</code> is an ordered collection of key-value pairs, where keys
      can be of any data type (including objects or primitive types). Unlike
      objects, which only allow strings or symbols as keys, <code>Map</code>{' '}
      keys can be any type.
    </p>
    <h3 style={{paddingBottom:"6px"}}>Key Features:</h3>
    <ul>
      <li>Maintains insertion order of the keys.</li><br />
      <li>Has methods like <code>set()</code>, <code>get()</code>,{' '} <br />
        <code>delete()</code>, <code>has()</code>, and <code>clear()</code>.
      </li>
    </ul>
    <h3>Usage:</h3>
    <pre>
      <code>
        {`let map = new Map();

map.set('name', 'John');
map.set(1, 'one');
map.set({}, 'empty object');

console.log(map.get('name'));  // John
console.log(map.has(1));       // true
console.log(map.size);         // 3
map.delete(1);                 // removes the entry with key \`1\``}
      </code>
    </pre><br />

    <h2>3. Set</h2>
    <p style={{paddingBottom:"6px"}}>
      A <code>Set</code> is a collection of unique values. Unlike arrays, a{' '}
      <code>Set</code> ensures that no duplicate values are present. The values
      can be of any type, and it provides methods to manipulate them like{' '}
      <code>add()</code>, <code>delete()</code>, <code>has()</code>, and{' '}
      <code>clear()</code>.
    </p>
    <h3 style={{paddingBottom:"6px"}}>Key Features:</h3>
    <ul>
      <li>Ensures no duplicates.</li><br />
      <li>Maintains insertion order.</li><br />
      <li>Allows primitive types, objects, and more as values.</li>
    </ul><br />
    <h3>Usage:</h3>
    <pre>
      <code>
        {`let set = new Set();

set.add(1);
set.add(2);
set.add(2);  // No effect, as 2 is already in the set
set.add('hello');

console.log(set.has(1));  // true
console.log(set.size);    // 3
set.delete(2);            // removes 2 from the set`}
      </code>
    </pre><br />

    <p>
      These ES6+ features provide advanced mechanisms for managing unique
      identifiers (<code>Symbol</code>), structured key-value pairs (
      <code>Map</code>), and collections of unique values (<code>Set</code>).
    </p>
  </div>
)}

{selectedChapter === 'chapter64' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Understanding Modules and Their Importance</h1>

    <p>
      In JavaScript, a <strong>module</strong> is a self-contained block of code that encapsulates specific functionality 
      or data. Modules allow developers to organize and separate their code into independent, reusable parts. They are 
      isolated from the global scope, meaning variables, functions, or objects defined within a module cannot be accessed 
      directly from outside unless they are explicitly exported.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Importance of Modules in JavaScript:</h3>
    <ul>
      <li><strong>Encapsulation</strong>: Modules keep variables and functions private unless exported, reducing the risk of name conflicts with other parts of the code.</li><br />
      <li><strong>Reusability</strong>: Once a module is created, it can be reused across multiple projects or within different parts of the same application, avoiding code duplication.</li><br />
      <li><strong>Maintainability</strong>: Breaking down code into smaller, manageable modules makes it easier to update or fix bugs. Developers can focus on individual modules without affecting the rest of the application.</li><br />
      <li><strong>Separation of Concerns</strong>: By organizing code into distinct modules, each handling a specific responsibility, it becomes easier to understand, modify, and test individual parts of the application.</li><br />
      <li><strong>Dependency Management</strong>: Modules make dependencies between different parts of the code explicit, as each module must import what it needs. This makes it clear which modules rely on others.</li><br />
      <li><strong>Testability</strong>: Smaller, focused modules are easier to test independently, leading to more reliable and less error-prone applications.</li>
    </ul><br />

    <p>
      In modern JavaScript, <strong>ES6 modules</strong> are the standard. They use the <code>import</code> and 
      <code>export</code> keywords to manage module interactions, replacing older patterns like CommonJS (used in 
      Node.js) and Immediately Invoked Function Expressions (IIFEs). This module system improves both the development 
      experience and the scalability of applications.
    </p>
  </div>
)}


{selectedChapter === 'chapter65' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>export and import</h1>


    <p>
      In JavaScript, <strong>export</strong> and <strong>import</strong> are key mechanisms used to share code between files 
      in a modular structure. They are part of the ES6 module system and help manage how modules interact with each other, 
      promoting code reuse and better organization.
    </p><br />

    <h4>Export:</h4>
    <p>
      The <code>export</code> keyword is used to make functions, objects, or values available to be imported by other modules.
    </p>
    <ul>
      <li>
        <strong>Named Exports</strong>: You can export multiple values from a module by name. When importing, you must use 
        the exact names.
        <pre>
          <code>
            {`
// module.js
export const greet = () => {
  console.log('Hello');
};

export const farewell = () => {
  console.log('Goodbye');
};
            `}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Default Export</strong>: A module can have one default export, which can be any value (function, object, class, etc.). 
        The default export can be imported with any name.
        <pre>
          <code>
            {`
// module.js
const welcome = () => {
  console.log('Welcome');
};

export default welcome;
            `}
          </code>
        </pre>
      </li>
    </ul><br />

    <h4>Import:</h4>
    <p>
      The <code>import</code> keyword is used to bring in exported values from another module into the current file.
    </p>
    <ul>
      <li>
        <strong>Importing Named Exports</strong>: You import the specific values using their names inside curly braces <code>{`{}`}</code>.
        <pre>
          <code>
            {`
// main.js
import { greet, farewell } from './module.js';

greet();    // Output: Hello
farewell(); // Output: Goodbye
            `}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Importing Default Export</strong>: You can import the default export without curly braces, and assign it any name.
        <pre>
          <code>
            {`
// main.js
import welcomeFunction from './module.js';

welcomeFunction(); // Output: Welcome
            `}
          </code>
        </pre>
      </li>
    </ul><br />

    <h4 style={{paddingBottom:"6px"}}>Key Points:</h4>
    <ul>
      <li><strong>Named exports</strong> allow you to export multiple values, while <strong>default export</strong> is limited to one.</li><br />
      <li><strong>Importing</strong> is flexible: named exports require exact names, but default exports can be imported with any name.</li><br />
      <li>These mechanisms promote modularization, allowing better organization and separation of concerns in JavaScript applications.</li>
    </ul>
  </div>
)}

{selectedChapter === 'chapter66' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Default and Named Exports</h1>

    <p>
      In JavaScript, <strong>exports</strong> are used in modules to share functionality between different files. The ES6 module system provides two primary ways to export code: <strong>named exports</strong> and <strong>default exports</strong>.
    </p><br />

    <h3>1. Named Exports</h3>
    <p>
      Named exports allow you to export multiple values from a module by their names. Each value can be imported individually using the same name in another module. This type of export is useful when you want to export several related functions or variables.
    </p>

    <p><strong>Example:</strong></p>
    <pre style={{paddingBottom:"6px"}}>
      <code>
{`// math.js
export const add = (a, b) => a + b;
export const subtract = (a, b) => a - b;`}
      </code>
    </pre>

    <p><strong>Importing Named Exports:</strong></p>
    <pre>
      <code>
{`// main.js
import { add, subtract } from './math.js';

console.log(add(5, 3));      // Output: 8
console.log(subtract(5, 3)); // Output: 2;`}
      </code>
    </pre><br />

    <h3>2. Default Exports</h3>
    <p style={{paddingBottom:"6px"}}>
      A module can have one default export, which can be a function, class, object, or primitive value. The default export can be imported with any name, providing flexibility in how you use it in different files.
    </p>

    <p><strong>Example:</strong></p>
    <pre>
      <code>
{`// greeting.js
const greet = () => console.log('Hello');
export default greet;`}
      </code>
    </pre><br />

    <p><strong>Importing Default Export:</strong></p>
    <pre>
      <code>
{`// main.js
import greetFunction from './greeting.js';

greetFunction(); // Output: Hello;`}
      </code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Key Differences</h3>
    <ul>
      <li><strong>Number of Exports:</strong> Named exports allow for multiple exports from a module, while a module can have only one default export.</li><br />
      <li><strong>Import Syntax:</strong> Named exports must be imported using the exact name inside curly braces <code>{'{}'}</code>, while default exports can be imported without curly braces and can be renamed during import.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Benefits of Using Exports</h3>
    <ul>
      <li><strong>Code Organization:</strong> Helps in organizing code into separate, manageable files.</li><br />
      <li><strong>Reusability:</strong> Promotes reusability of functions and variables across different modules.</li><br />
      <li><strong>Encapsulation:</strong> Allows modules to expose only the necessary parts of their code, keeping the internal implementation hidden.</li>
    </ul><br />

    <p>
      By understanding and using default and named exports effectively, developers can create modular, maintainable, and scalable JavaScript applications.
    </p>
  </div>
)}


{selectedChapter === 'chapter67' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Modularization Best Practices</h1>
    <p >
      Modularization is a design principle in software development that encourages the separation of code into distinct modules,
      each handling a specific aspect of the functionality. This approach enhances code organization and maintainability while 
      promoting reusability and collaboration. Below are key best practices for modularization in JavaScript:
    </p><br />

    <h3>1. Use ES6 Modules</h3>
    <p>
      Utilize the ES6 module system (<code>import</code> and <code>export</code>) for better code organization. This allows you 
      to create modules that can be easily shared across different parts of your application.
    </p>
    <pre>
      <code>
        {`// module.js\nexport const myFunction = () => { /*...*/ };\n\n// main.js\nimport { myFunction } from './module.js';`}
      </code>
    </pre><br />


    <h3>2. Single Responsibility Principle</h3>
    <p>
      Each module should focus on a single responsibility or functionality. This makes the module easier to understand, test, 
      and maintain.
    </p>
    <pre>
      <code>
        {`// math.js - handles mathematical operations\nexport const add = (a, b) => a + b;\nexport const subtract = (a, b) => a - b;\n\n// logger.js - handles logging functionality\nexport const log = (message) => console.log(message);`}
      </code>
    </pre><br />

    <h3>3. Organize Files Logically</h3>
    <p>
      Group related modules together in folders and maintain a clear file structure. This organization helps in navigating 
      the codebase efficiently.
    </p>
    <pre>
      <code>
        {`/src\n  /modules\n    math.js\n    logger.js\n  /components\n    Header.js\n    Footer.js`}
      </code>
    </pre><br />

    <h3>4. Keep Modules Small</h3>
    <p>
      Aim to keep your modules small and focused. If a module becomes too large, consider splitting it into smaller sub-modules 
      to improve readability and maintainability.
    </p><br />

    <h3>5. Limit Global Scope Exposure</h3>
    <p>
      Avoid polluting the global scope by encapsulating code within modules. Export only what is necessary to be accessible 
      from outside the module.
    </p>
    <pre>
      <code>
        {`// user.js\nconst privateVariable = 'This is private';\nexport const publicVariable = 'This is public';`}
      </code>
    </pre><br />

    <h3>6. Use Clear and Descriptive Names</h3>
    <p>
      Choose meaningful names for your modules and their exported members. This enhances readability and helps other developers 
      understand the purpose of each module.
    </p>
    <pre>
      <code>
        {`// bad naming\nexport const fn1 = () => { /*...*/ };\n\n// good naming\nexport const calculateTotal = () => { /*...*/ };`}
      </code>
    </pre><br />

    <h3>7. Document Your Modules</h3>
    <p>
      Include comments and documentation for each module, describing its purpose, usage, and exported members. This practice 
      aids in onboarding new developers and maintaining the code.
    </p>
    <pre>
      <code>
        {`/**\n * Calculates the total price including tax.\n * @param {number} price - The base price.\n * @param {number} tax - The tax percentage.\n * @returns {number} - The total price including tax.\n */\nexport const calculateTotal = (price, tax) => price + (price * tax / 100);`}
      </code>
    </pre><br />

    <h3>8. Implement Testing</h3>
    <p>
      Ensure that each module is independently testable. Write unit tests for your modules to verify that they function as 
      expected. This practice improves code reliability and reduces bugs.
    </p><br />

    <h2>Conclusion</h2>
    <p>
      By following these modularization best practices in JavaScript, developers can create a more structured, maintainable, 
      and scalable codebase. This approach enhances collaboration among team members and improves the overall quality of the software.
    </p>
  </div>
)}

{selectedChapter === 'chapter68' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Work with JSON (JavaScript Object Notation)</h1>
    <p>
      Working with JSON (JavaScript Object Notation) in JavaScript involves using a lightweight data interchange format that is easy for humans to read and write and easy for machines to parse and generate. Here’s a comprehensive overview of how to work with JSON in JavaScript:
    </p><br />

    <h2>1. What is JSON?</h2>
    <ul>
      <li>
        JSON is a text-based format that represents structured data based on JavaScript object syntax.
      </li>
      <li>
        It is widely used for data exchange between a server and a web application.
      </li>
    </ul><br />

    <h2>2. Basic Structure of JSON</h2>
    <p>
      JSON data is represented in key/value pairs, where keys are strings and values can be strings, numbers, arrays, objects, booleans, or null.
    </p>
    <pre>
      <code>
        {`{
  "name": "John",
  "age": 30,
  "isStudent": false,
  "courses": ["Math", "Science"],
  "address": {
    "street": "123 Main St",
    "city": "Anytown"
  }
}`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>3. Working with JSON in JavaScript</h2>

    <h3>a. Parsing JSON</h3>
    <p>
      To convert a JSON string into a JavaScript object, you use the <code>JSON.parse()</code> method:
    </p>
    <pre>
      <code>
        {`const jsonString = '{"name": "John", "age": 30}';
const jsonObject = JSON.parse(jsonString);
console.log(jsonObject.name); // Output: John`}
      </code>
    </pre><br />

    <h3>b. Stringifying JSON</h3>
    <p>
      To convert a JavaScript object into a JSON string, you use the <code>JSON.stringify()</code> method:
    </p>
    <pre>
      <code>
        {`const obj = { name: "John", age: 30 };
const jsonString = JSON.stringify(obj);
console.log(jsonString); // Output: {"name":"John","age":30}`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>4. Common Use Cases</h2>
    <ul>
      <li><strong>Data Exchange:</strong> JSON is commonly used to send and receive data in APIs.</li><br />
      <li><strong>Configuration Files:</strong> JSON can be used to store configuration settings in a structured format.</li><br />
      <li><strong>Serialization:</strong> JSON allows for easy serialization of JavaScript objects for storage or transmission.</li>
    </ul><br />

    <h2>5. Handling JSON Errors</h2>
    <p>
      When parsing JSON, it's essential to handle potential errors, as malformed JSON will throw an error:
    </p>
    <pre>
      <code>
        {`const invalidJsonString = '{"name": "John", "age": 30'; // Missing closing brace

try {
  const data = JSON.parse(invalidJsonString);
} catch (error) {
  console.error("Invalid JSON: ", error.message);
}`}
      </code>
    </pre><br />

    <h2>6. Working with JSON in APIs</h2>
    <p>
      When working with APIs, you often need to send and receive JSON data. Here’s an example using the Fetch API:
    </p>
    <pre>
      <code>
        {`fetch('https://api.example.com/data')
  .then(response => response.json()) // Automatically parses JSON
  .then(data => console.log(data))
  .catch(error => console.error('Error:', error));`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>7. Best Practices</h2>
    <ul>
      <li>Always validate JSON data to ensure it meets expected formats.</li><br />
      <li>Use meaningful keys to make the JSON data self-descriptive.</li><br />
      <li>Keep JSON data structures simple to enhance readability and maintainability.</li>
    </ul><br />

    <h2>Conclusion</h2>
    <p>
      Working with JSON in JavaScript is straightforward and essential for modern web development, especially in client-server communication. Understanding how to parse, stringify, and handle JSON is crucial for effectively managing data in JavaScript applications.
    </p>
  </div>
)}

{selectedChapter === 'chapter69' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Parsing and Stringifying JSON</h1>

    <p style={{paddingBottom:"6px"}}>
      Parsing and stringifying JSON (JavaScript Object Notation) in JavaScript are fundamental processes that allow you to convert data between JSON format (text) and JavaScript objects. Here’s a detailed explanation of both concepts:
    </p>

    <h2>1. Parsing JSON</h2>
    <p>
      <strong>Definition:</strong> Parsing JSON involves converting a JSON string into a JavaScript object. This process allows you to work with the data in a structured way within your JavaScript code.
    </p><br />
    <p>
      <strong>Method:</strong> <code>JSON.parse()</code>
    </p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`const jsonString = '{"name": "John", "age": 30, "isStudent": false}';
const jsonObject = JSON.parse(jsonString);

console.log(jsonObject.name); // Output: John
console.log(jsonObject.age);  // Output: 30
console.log(jsonObject.isStudent); // Output: false`}
      </code>
    </pre><br />

    <h3>Handling Errors:</h3>
    <p style={{paddingBottom:"6px"}}>
      When parsing JSON, it's essential to handle errors because malformed JSON will cause <code>JSON.parse()</code> to throw a syntax error.
    </p>
    <h4>Example of Error Handling:</h4>
    <pre>
      <code>
        {`const invalidJsonString = '{"name": "John", "age": 30'; // Missing closing brace

try {
  const data = JSON.parse(invalidJsonString);
} catch (error) {
  console.error("Invalid JSON:", error.message); // Output: Invalid JSON: Unexpected end of JSON input
}`}
      </code>
    </pre><br />

    <h2>2. Stringifying JSON</h2>
    <p>
      <strong>Definition:</strong> Stringifying JSON involves converting a JavaScript object into a JSON string. This process is useful for sending data to a server or storing it in a text format.
    </p>
    <p>
      <strong>Method:</strong> <code>JSON.stringify()</code>
    </p>

    <h3>Example:</h3>
    <pre>
      <code>
        {`const obj = { name: "John", age: 30, isStudent: false };
const jsonString = JSON.stringify(obj);

console.log(jsonString); // Output: {"name":"John","age":30,"isStudent":false}`}
      </code>
    </pre><br />

    <h3>Customizing Stringification:</h3>
    <p>
      You can customize the behavior of <code>JSON.stringify()</code> using optional parameters:
    </p>
    <ul>
      <li><strong>Replacer:</strong> A function or an array that specifies which properties to include or modify in the JSON string.</li><br />
      <li><strong>Space:</strong> A number or string used to insert white space into the output JSON string for readability.</li>
    </ul><br />

    <h4>Example with Customization:</h4>
    <pre>
      <code>
        {`const obj = { name: "John", age: 30, isStudent: false };

// Using a replacer function to exclude the 'isStudent' property
const jsonString = JSON.stringify(obj, (key, value) => {
  return key === 'isStudent' ? undefined : value;
}, 2); // Indentation of 2 spaces

console.log(jsonString);
/*
Output:
{
  "name": "John",
  "age": 30
}
*/}
 `} </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>
    <ul>
      <li><strong>Parsing</strong> (<code>JSON.parse()</code>) is used to convert a JSON string into a JavaScript object, enabling easy manipulation of the data.</li><br />
      <li><strong>Stringifying</strong> (<code>JSON.stringify()</code>) converts a JavaScript object into a JSON string, making it suitable for data transmission or storage.</li><br />
      <li>Both processes are crucial for working with data in web applications, especially when interacting with APIs or local storage.</li>
    </ul>
  </div>
)}

{selectedChapter === 'chapter70' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Local Storage and Session Storage</h1>

    <p>
      Local Storage and Session Storage are part of the Web Storage API in JavaScript, allowing web applications to store data in the user's browser. They provide a way to save data in key/value pairs but differ in terms of scope, lifespan, and availability. Here’s a breakdown of both:
    </p><br />


    <h2>Local Storage</h2>
    <p style={{paddingBottom:"6px"}}>
      <strong>Definition:</strong> Local Storage allows you to store data persistently in the browser. The data saved in Local Storage has no expiration time and will remain even after the browser is closed and reopened.
    </p>
    
    <h3 style={{paddingBottom:"6px"}} >Characteristics:</h3>
    <ul>
      <li><strong>Scope:</strong> Accessible only from the same origin (protocol, hostname, and port).</li><br />
      <li><strong>Lifespan:</strong> Data persists until it is explicitly deleted, either by the user or programmatically through JavaScript.</li><br />
      <li><strong>Capacity:</strong> Generally, browsers allow around 5-10 MB of data per origin.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Methods:</h3>
    <ul>
      <li><strong>Set Item:</strong> Stores a key/value pair.</li><br />
      <li><strong>Get Item:</strong> Retrieves the value associated with a key.</li><br />
      <li><strong>Remove Item:</strong> Deletes a key/value pair.</li><br />
      <li><strong>Clear:</strong> Removes all key/value pairs.</li>
    </ul><br />

    <h3>Example:</h3>
    <pre>
      <code>
        {`// Storing data
localStorage.setItem('username', 'JohnDoe');

// Retrieving data
const username = localStorage.getItem('username');
console.log(username); // Output: JohnDoe

// Removing data
localStorage.removeItem('username');

// Clearing all data
localStorage.clear();`}
      </code>
    </pre><br />

    <h2>Session Storage</h2>
    <p style={{paddingBottom:"6px"}}>
      <strong>Definition:</strong> Session Storage allows you to store data for the duration of a page session. Data stored in Session Storage is only available for the duration of the page session, which lasts as long as the browser tab or window is open.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Characteristics:</h3>
    <ul>
      <li><strong>Scope:</strong> Accessible only from the same origin within the same tab or window. Data is not shared between different tabs or windows.</li><br />
      <li><strong>Lifespan:</strong> Data is cleared when the tab or window is closed.</li><br />
      <li><strong>Capacity:</strong> Similar to Local Storage, generally around 5-10 MB per origin.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Methods:</h3>
    <ul>
      <li><strong>Set Item:</strong> Stores a key/value pair.</li><br />
      <li><strong>Get Item:</strong> Retrieves the value associated with a key.</li><br />
      <li><strong>Remove Item:</strong> Deletes a key/value pair.</li><br />
      <li><strong>Clear:</strong> Removes all key/value pairs.</li>
    </ul><br />


    <h3>Example:</h3>
    <pre>
      <code>
        {`// Storing data
sessionStorage.setItem('sessionToken', 'abc123');

// Retrieving data
const token = sessionStorage.getItem('sessionToken');
console.log(token); // Output: abc123

// Removing data
sessionStorage.removeItem('sessionToken');

// Clearing all data
sessionStorage.clear();`}
      </code>
    </pre><br />

    <h2>Key Differences</h2>
    <table>
      <thead>
        <tr>
          <th>Feature</th>
          <th>Local Storage</th>
          <th>Session Storage</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Lifespan</td>
          <td>Persistent (until deleted)</td>
          <td>Temporary (until tab/window closed)</td>
        </tr>
        <tr>
          <td>Scope</td>
          <td>Same origin</td>
          <td>Same origin, same tab/window</td>
        </tr>
        <tr>
          <td>Data Sharing</td>
          <td>Data is shared across tabs</td>
          <td>Data is not shared across tabs</td>
        </tr>
        <tr>
          <td>Use Cases</td>
          <td>User preferences, settings, etc.</td>
          <td>Single session data, temporary state</td>
        </tr>
      </tbody>
    </table><br />

    <h2>Summary</h2>
    <p>
      Both Local Storage and Session Storage provide a way to store data in the browser, enabling web applications to maintain state and user preferences without requiring server-side storage. Understanding when to use each storage type is essential for effective web development.
    </p>
  </div>
)}


{selectedChapter === 'chapter71' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Cookies in JavaScript</h1>

    <p>
      Cookies in JavaScript are small pieces of data stored on the user's computer by the web browser while browsing a website. They are primarily used to remember information about the user, such as login status, preferences, and other data that can enhance the browsing experience. Here’s a detailed explanation of cookies in JavaScript:
    </p><br />

    <h2>1. What Are Cookies?</h2>
    <ul>
      <li>Cookies are text files created by a web server that are stored on the client-side (user's browser).</li>
      <li>Each cookie consists of a name-value pair and optional attributes, such as expiration date, domain, path, and secure flag.</li>
    </ul><br />

    <h2>2. Use Cases for Cookies</h2>
    <ul>
      <li><strong>User Authentication:</strong> Cookies can store session tokens to keep users logged in.</li>
      <li><strong>User Preferences:</strong> Websites can remember user preferences (like language or theme settings) using cookies.</li>
      <li><strong>Tracking:</strong> Cookies are often used for tracking user behavior for analytics or advertising purposes.</li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>3. Creating and Managing Cookies in JavaScript</h2>

    <h3>a. Setting a Cookie</h3>
    <p>
      You can set a cookie using the <code>document.cookie</code> property. Here's how to create a cookie:
    </p>
    <pre>
      <code>
        {`document.cookie = "username=JohnDoe; expires=Fri, 31 Dec 2024 23:59:59 GMT; path=/";`}
      </code>
    </pre>
    <p>
      <strong>Format:</strong> <code>"key=value; expires=date; path=path; domain=domain; secure"</code>
    </p>
    <h4>Example Attributes:</h4>
    <ul>
      <li><code>expires</code>: Sets an expiration date for the cookie. If not set, the cookie will expire when the browser is closed.</li>
      <li><code>path</code>: Specifies the URL path the cookie is valid for. If set to <code>/</code>, the cookie is accessible from all pages on the domain.</li>
      <li><code>secure</code>: If set, the cookie will only be sent over secure HTTPS connections.</li>
    </ul><br />

    <h3>b. Retrieving a Cookie</h3>
    <p>
      To retrieve a cookie, you can read the <code>document.cookie</code> property, which returns a string of all cookies for the current document:
    </p>
    <pre>
      <code>
        {`const cookies = document.cookie;\nconsole.log(cookies); // Output: username=JohnDoe; otherCookie=value`}
      </code>
    </pre><br />
    <p>
      To get the value of a specific cookie, you can create a function:
    </p>
    <pre>
      <code>
        {`function getCookie(name) {\n  const value = \`;\${document.cookie}\`;\n  const parts = value.split(\`; \${name}=\`);\n  if (parts.length === 2) return parts.pop().split(';').shift();\n}\n\nconst username = getCookie('username');\nconsole.log(username); // Output: JohnDoe`}
      </code>
    </pre><br />

    <h3>c. Deleting a Cookie</h3>
    <p>
      To delete a cookie, you set its expiration date to a time in the past:
    </p>
    <pre>
      <code>
        {`document.cookie = "username=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>4. Limitations of Cookies</h2>
    <ul>
      <li><strong>Size Limit:</strong> Each cookie can hold only about 4KB of data.</li><br />
      <li><strong>Number of Cookies:</strong> Browsers limit the number of cookies stored per domain (usually around 20–50).</li><br />

      <li><strong>Privacy Concerns:</strong> Cookies can be used for tracking users across websites, leading to privacy concerns.</li>
    </ul><br />

    <h2>5. Summary</h2>
    <p>
      Cookies in JavaScript are useful for storing small amounts of data related to user sessions, preferences, and tracking information. While they offer many advantages for enhancing user experience, it’s essential to be mindful of privacy and security when using cookies in web applications. Understanding how to create, retrieve, and delete cookies is vital for effective client-side data management.
    </p>
  </div>
)}

{selectedChapter === 'chapter72' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Introduction to Web APIs</h1>

    <p>
      Web APIs (Application Programming Interfaces) are sets of protocols and tools that allow developers to interact with web services and resources. They enable JavaScript applications to communicate with external systems, retrieve data, and perform various operations over the web. Web APIs play a crucial role in modern web development, allowing for the integration of third-party services, dynamic content retrieval, and enhanced user experiences.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Key Concepts</h2>

    <ol>
      <li>
        <strong>Definition</strong>: 
        <p>
          Web APIs provide endpoints through which applications can send and receive data over HTTP (Hypertext Transfer Protocol). They expose functionality that can be utilized by client-side applications, such as web browsers.
        </p>
      </li><br />
      <li>
        <strong style={{paddingBottom:"6px"}}>Types of Web APIs</strong>: 
        <ul>
          <li>
            <strong>REST APIs</strong>: Representational State Transfer APIs use standard HTTP methods (GET, POST, PUT, DELETE) and are stateless. They are widely used for CRUD (Create, Read, Update, Delete) operations.
          </li><br />
          <li>
            <strong>SOAP APIs</strong>: Simple Object Access Protocol APIs are based on XML and provide a more rigid structure for messaging compared to REST.
          </li><br />
          <li>
            <strong>GraphQL APIs</strong>: A query language for APIs that allows clients to request exactly the data they need, offering more flexibility than traditional REST APIs.
          </li>
        </ul>
      </li><br />
      <li>
        <strong style={{paddingBottom:"6px"}}>Use Cases</strong>: 
        <ul>
          <li><strong>Data Retrieval</strong>: Fetching data from external services (e.g., weather data, user profiles, etc.).</li><br />
          <li><strong>User Authentication</strong>: Interacting with authentication services (e.g., OAuth) to manage user sessions.</li><br />
          <li><strong>Social Media Integration</strong>: Accessing social media platforms to post updates or retrieve user feeds.</li><br />
          <li><strong>Payment Processing</strong>: Integrating with payment gateways to handle transactions.</li>
        </ul>
      </li><br />
      <li>
        <strong>Using Web APIs in JavaScript</strong>: 
        <p>
          JavaScript provides several methods for making API requests, such as the <code>fetch</code> API and <code>XMLHttpRequest</code>. The <code>fetch</code> API is the modern way to perform HTTP requests and supports promises, making it easier to handle asynchronous operations.
        </p>
        <pre>
          <code>{`
            // Example of fetching data from a REST API
            fetch('https://api.example.com/data')
              .then(response => {
                if (!response.ok) {
                  throw new Error('Network response was not ok');
                }
                return response.json();
              })
              .then(data => console.log(data))
              .catch(error => console.error('There has been a problem with your fetch operation:', error));
 `} </code>
        </pre>
      </li><br />
      <li>
        <strong>Security Considerations</strong>: 
        <p>
          Web APIs may expose sensitive data, so proper authentication and authorization mechanisms should be in place. It's essential to use HTTPS to encrypt data during transmission.
        </p>
      </li>
    </ol><br />

    <h2>Summary</h2>
    <p>
      Web APIs are fundamental in enabling communication between web applications and external services. They allow developers to build feature-rich applications by integrating various functionalities seamlessly. Understanding how to work with Web APIs is a crucial skill for modern JavaScript developers.
    </p>
  </div>
)}


{selectedChapter === 'chapter73' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Fetch API for AJAX Calls</h1>

    <p>
      The Fetch API is a modern interface in JavaScript that allows you to make network requests to servers. 
      It provides a more powerful and flexible way to perform AJAX (Asynchronous JavaScript and XML) calls compared 
      to the older <code>XMLHttpRequest</code> object. The Fetch API uses Promises, which makes it easier to work 
      with asynchronous operations and handle responses effectively.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Key Features of Fetch API:</h2>
    <ol>
      <li>
        <strong>Promise-Based</strong>: The Fetch API returns a Promise that resolves to the Response object 
        representing the response to the request. This allows for cleaner and more readable asynchronous code using 
        <code>.then()</code> and <code>.catch()</code> for handling success and errors.
      </li><br />
      <li>
        <strong>Simpler Syntax</strong>: The Fetch API has a cleaner syntax compared to <code>XMLHttpRequest</code>, 
        making it easier to read and write.
      </li><br />
      <li>
        <strong>Better Error Handling</strong>: Fetch does not reject the Promise on HTTP error statuses (like 
        404 or 500). Instead, you need to check the <code>response.ok</code> property to determine if the request 
        was successful.
      </li><br />
      <li>
        <strong>Support for Various Data Formats</strong>: Fetch can handle different types of data (like JSON, 
        text, form data, etc.) and provides methods for parsing them easily.
      </li><br />
      <li>
        <strong>Customizable Requests</strong>: You can easily set various options like HTTP method (GET, POST, etc.), 
        headers, and body content in the request.
      </li>
    </ol><br />

    <h2>Example of Using the Fetch API:</h2>
    <p>
      Here’s a basic example of making a GET request to fetch data from an API:
    </p>
    <pre>
      <code>
        {`// Example of fetching data from a public API
fetch('https://api.example.com/data')
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Parse the JSON data
  })
  .then(data => {
    console.log(data); // Handle the fetched data
  })
  .catch(error => {
    console.error('There has been a problem with your fetch operation:', error);
  });`}
      </code>
    </pre><br />

    <h2>Example of a POST Request:</h2>
    <p>
      Here’s how to send data using a POST request:
    </p>
    <pre>
      <code>
        {`const data = {
  name: 'John Doe',
  age: 30
};

fetch('https://api.example.com/users', {
  method: 'POST', // Specify the request method
  headers: {
    'Content-Type': 'application/json' // Set the content type
  },
  body: JSON.stringify(data) // Convert the data to JSON format
})
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Parse the response data
  })
  .then(data => {
    console.log('User created:', data); // Handle the response data
  })
  .catch(error => {
    console.error('There has been a problem with your fetch operation:', error);
  });`}
      </code>
    </pre><br />

    <h2>Summary:</h2>
    <p>
      The Fetch API is a powerful and flexible way to handle network requests in JavaScript, enabling developers 
      to create dynamic and responsive web applications. Its promise-based design, improved syntax, and better 
      handling of various data formats make it a preferred choice for making AJAX calls in modern web development.
    </p>
  </div>
)}

{selectedChapter === 'chapter74' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Working with APIs (Reading Files in JavaScript)</h1>

    <p>
      Working with APIs (Application Programming Interfaces) in JavaScript often involves interacting with external services to read, manipulate, and store data. One common use case is reading files, which can be done through various APIs available in the browser or Node.js. Here's a breakdown of how to work with APIs for reading files in JavaScript.
    </p><br />

    <h2>1. FileReader API (Browser)</h2>
    <p style={{paddingBottom:"6px"}}>
      The <strong>FileReader API</strong> allows web applications to asynchronously read the contents of files stored on the user's computer. This API is typically used in conjunction with <code>&lt;input type="file"&gt;</code> elements to allow users to upload files.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features:</h3>
    <ul>
      <li><strong>Read Files:</strong> Supports reading text files, images, and other binary data.</li><br />
      <li><strong>Event Handling:</strong> Uses events to provide feedback on the reading process (e.g., when the read operation is complete).</li>
    </ul><br />

    <h3>Example of Using FileReader:</h3>
    <code>
      {`<input type="file" id="fileInput" />
<div id="fileContent"></div>

<script>
  document.getElementById('fileInput').addEventListener('change', function(event) {
    const file = event.target.files[0]; // Get the first file
    if (file) {
      const reader = new FileReader();

      reader.onload = function(e) {
        const content = e.target.result; // Get the file content
        document.getElementById('fileContent').innerText = content; // Display content
      };

      reader.readAsText(file); // Read the file as text
    }
  });
</script>`}
    </code><br /><br />

    <h2>2. Fetch API (Reading Files from Server)</h2>
    <p style={{paddingBottom:"6px"}}>
      The <strong>Fetch API</strong> allows you to make network requests to retrieve files from a server. You can fetch text files, JSON files, images, and more.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features:</h3>
    <ul>
      <li><strong>Promise-Based:</strong> Returns a Promise that resolves to the Response object.</li><br />
      <li><strong>Supports Various Formats:</strong> Can handle different types of file responses.</li>
    </ul><br />

    <h3>Example of Fetching a Text File:</h3>
    <code>
      {`fetch('https://example.com/file.txt')
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.text(); // Read the response as text
  })
  .then(data => {
    console.log(data); // Process the file content
  })
  .catch(error => {
    console.error('Error fetching the file:', error);
  });`}
    </code><br /><br />

    <h2>3. Node.js File System (fs) Module</h2>
    <p style={{paddingBottom:"6px"}}>
      In a Node.js environment, you can use the built-in <strong>fs</strong> (file system) module to read files from the server’s file system.
    </p>

    <h3 style={{paddingBottom:"6px"}}>Key Features:</h3>
    <ul>
      <li><strong>Synchronous and Asynchronous Methods:</strong> Allows for both blocking and non-blocking file reads.</li><br />

      <li><strong>Supports Various File Formats:</strong> Can read text files, JSON files, and binary files.</li>
    </ul><br />

    <h3>Example of Reading a File in Node.js:</h3>
    <code>
      {`const fs = require('fs');

// Asynchronous read
fs.readFile('example.txt', 'utf8', (err, data) => {
  if (err) {
    console.error('Error reading the file:', err);
    return;
  }
  console.log(data); // Output the file content
});

// Synchronous read
try {
  const data = fs.readFileSync('example.txt', 'utf8');
  console.log(data);
} catch (err) {
  console.error('Error reading the file:', err);
}`}
    </code><br /><br />

    <h2>4. Summary</h2>
    <p>
      Working with APIs to read files in JavaScript is essential for building interactive web applications. Whether using the FileReader API for local file uploads in the browser, the Fetch API to retrieve files from a server, or the <strong>fs</strong> module in Node.js for server-side file operations, understanding these tools enables developers to effectively manage and manipulate data within their applications.
    </p>
  </div>
)}


{selectedChapter === 'chapter75' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Geolocation API</h1>

    <p style={{paddingBottom:"6px"}}>
      The <strong>Geolocation API</strong> in JavaScript is a powerful interface that allows web applications to access the geographical location of a user's device. It provides a standardized way to obtain location information, which can be useful for a variety of applications, such as mapping, location-based services, and personalized user experiences.
    </p>

    <h2 style={{paddingBottom:"6px"}}>Key Features of the Geolocation API:</h2>
    <ol>
      <li><strong>Access to User Location:</strong> The Geolocation API allows developers to request the current location of the user. This can include latitude, longitude, altitude, accuracy, and more.</li><br />
      <li><strong>Permission Handling:</strong> Accessing the user's location requires permission. The browser prompts the user to allow or deny access to their location data.</li><br />
      <li><strong>Real-Time Location Tracking:</strong> The API supports continuous location tracking, allowing developers to receive updates on the user's location over time.</li><br />
      <li><strong>Error Handling:</strong> The API provides ways to handle errors, such as when the user denies permission or when the location cannot be determined.</li>
    </ol><br />

    <h2>Using the Geolocation API:</h2>
    <p>Here’s a basic example of how to use the Geolocation API to get the user's current location:</p>

    <pre>
      <code>
        {`
if ('geolocation' in navigator) {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude } = position.coords;
      console.log(\`Latitude: \${latitude}, Longitude: \${longitude}\`);
    },
    (error) => {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.error('User denied the request for Geolocation.');
          break;
        case error.POSITION_UNAVAILABLE:
          console.error('Location information is unavailable.');
          break;
        case error.TIMEOUT:
          console.error('The request to get user location timed out.');
          break;
        case error.UNKNOWN_ERROR:
          console.error('An unknown error occurred.');
          break;
      }
    }
  );
} else {
  console.error('Geolocation is not supported by this browser.');
}
        `}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Explanation of the Example:</h2>
    <ul>
      <li><strong>Check for Geolocation Support:</strong> Before using the API, it's essential to check if the browser supports it.</li><br />
      <li><strong>Get Current Position:</strong> The <code>getCurrentPosition()</code> method requests the current location.</li><br />
      <li><strong>Success Callback:</strong> If the request is successful, the callback receives a <code>position</code> object containing the user's coordinates.</li><br />
      <li><strong>Error Callback:</strong> If there's an error, it will handle different cases such as permission denial or unavailability of location information.</li>
    </ul><br />

    <h2>Summary:</h2>
    <p>
      The Geolocation API provides an easy way to access a user's geographical location, enabling developers to create dynamic and location-aware web applications. By leveraging this API, applications can offer personalized services and enhance user experiences based on their current location. However, it's important to handle permissions and errors gracefully to ensure a seamless user experience.
    </p>
  </div>
)}


{selectedChapter === 'chapter76' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>File API (Reading File in JavaScript)</h1>

    <p style={{paddingBottom:"6px"}}>
      The <strong>File API</strong> in JavaScript provides a way to interact with files on the user's computer. This API is particularly useful for reading, manipulating, and uploading files in web applications. It allows developers to create rich user experiences that involve file handling, such as file uploads, previews, and file type validation.
    </p>

    <h2 style={{paddingBottom:"6px"}}>Key Features of the File API:</h2>
    <ol>
      <li>
        <strong>File Objects:</strong> The File API introduces the <code>File</code> and <code>FileList</code> objects, which represent files selected by the user through input elements or drag-and-drop actions. These objects contain metadata about the files, such as name, size, and type.
      </li><br />
      <li>
        <strong>FileReader API:</strong> This is a key component of the File API that allows web applications to read the contents of files asynchronously. It supports reading text, binary data, and images.
      </li><br />
      <li>
        <strong>Blob Interface:</strong> The File API uses the <code>Blob</code> interface, which represents immutable raw binary data. Blobs can be created from file objects or can be constructed from strings or other data types.
      </li><br />
      <li>
        <strong>Drag-and-Drop Support:</strong> The File API facilitates drag-and-drop file uploads, making it easier for users to add files to web applications.
      </li>
    </ol><br />

    <h2 style={{paddingBottom:"6px"}}>Using the File API:</h2>

    <h3>1. Reading Files with FileReader:</h3>
    <p>
      The <code>FileReader</code> object provides methods to read the contents of files. Here's an example of how to use it:
    </p>

    <pre>
      <code>
        {`
<input type="file" id="fileInput" />
<div id="fileContent"></div>

<script>
  document.getElementById('fileInput').addEventListener('change', function(event) {
    const file = event.target.files[0]; // Get the first file selected by the user
    if (file) {
      const reader = new FileReader();

      // Event listener for when the read operation is complete
      reader.onload = function(e) {
        const content = e.target.result; // Get the file content
        document.getElementById('fileContent').innerText = content; // Display the content
      };

      reader.onerror = function() {
        console.error('Error reading file');
      };

      reader.readAsText(file); // Read the file as text
    } else {
      console.warn('No file selected.');
    }
  });
</script>
        `}
      </code>
    </pre><br />

    <h3>2. Accessing File Metadata:</h3>
    <p>You can access file metadata using the File object:</p>

    <pre>
      <code>
        {`
const file = event.target.files[0]; // Assuming a file input is used
if (file) {
  console.log('File Name:', file.name); // Name of the file
  console.log('File Size:', file.size); // Size of the file in bytes
  console.log('File Type:', file.type); // MIME type of the file
} else {
  console.warn('No file selected.');
}
        `}
      </code>
    </pre><br />

    <h2>Summary:</h2>
    <p>
      The File API is essential for web applications that require file manipulation and uploads. It enhances user interactions by allowing the reading of files directly from the user's device without needing to upload them to the server first. This capability is particularly useful for applications that involve image uploads, document processing, or any functionality that depends on user files. Understanding the File API is crucial for modern web development, enabling developers to create more interactive and user-friendly applications.
    </p>
  </div>
)}



{selectedChapter === 'chapter77' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>JavaScript Error Types (Syntax, Reference, Type, etc.)</h1>

    <p>
      JavaScript errors are problems that occur when the JavaScript code cannot be executed correctly. These errors can be broadly categorized into several types, each indicating a different kind of issue. Here’s an overview of the main JavaScript error types:
    </p>

    <h2>1. Syntax Errors</h2>
    <p>
      <strong>Definition:</strong> Syntax errors occur when the JavaScript code is not written correctly according to the language's grammar rules. These errors are usually detected at the time of parsing the code before execution.
    </p>
    <p>
      <strong>Example:</strong>
    </p>
    <pre>
      <code>{`
        {/* Missing closing bracket */}
        function greet(name) {
          console.log("Hello, " + name); // SyntaxError: Unexpected token
        }
`}</code>
    </pre><br />

    <h2>2. Reference Errors</h2>
    <p>
      <strong>Definition:</strong> Reference errors happen when the code attempts to access a variable that has not been declared. This indicates that the variable is out of scope or doesn't exist in the current context.
    </p>
    <p>
      <strong>Example:</strong>
    </p>
    <pre>
      <code>{`
        console.log(x); // ReferenceError: x is not defined
      `}</code>
    </pre><br />

    <h2>3. Type Errors</h2>
    <p style={{paddingBottom:"6px"}}>
      <strong>Definition:</strong> Type errors occur when an operation is performed on a value of an incorrect type. This can happen, for example, when trying to call a non-function as a function or accessing properties of <code>undefined</code> or <code>null</code>.
    </p>
    <p>
      <strong>Example:</strong>
    </p>
    <pre>
      <code>{`
        let number = 5;
        number.toUpperCase(); // TypeError: number.toUpperCase is not a function
`}</code>
    </pre><br />

    <h2>4. Range Errors</h2>
    <p>
      <strong>Definition:</strong> Range errors are thrown when a value is not in the set or range of allowed values. This typically occurs with numeric operations, such as when trying to create an array with an invalid length.
    </p>
    <p>
      <strong>Example:</strong>
    </p>
    <pre>
      <code>{`
        let arr = new Array(-1); // RangeError: Invalid array length
      `}</code>
    </pre><br />

    <h2>5. Eval Errors</h2>
    <p>
      <strong>Definition:</strong> Eval errors are related to the use of the <code>eval()</code> function, which executes a string of JavaScript code. In modern JavaScript, this type of error is rare and not commonly encountered.
    </p>
    <p>
      <strong>Example:</strong>
    </p>
    <pre>
      <code>
        {/* Although eval errors are not common, using eval incorrectly may lead to unexpected results. */}
      </code>
    </pre><br />

    <h2>6. URI Errors</h2>
    <p>
      <strong>Definition:</strong> URI errors are thrown when the <code>decodeURIComponent()</code> or <code>encodeURIComponent()</code> functions are used improperly, such as when an invalid URI is provided.
    </p>
    <p>
      <strong>Example:</strong>
    </p>
    <pre>
      <code>{`
        decodeURIComponent('%'); // URIError: URI malformed
      `}</code>
    </pre><br />

    <h2>Summary</h2>
    <p>
      Understanding these error types is crucial for debugging and developing robust JavaScript applications. Each error type provides specific insights into what went wrong, allowing developers to identify and fix issues effectively. By handling errors appropriately using <code>try...catch</code> blocks and other error-handling techniques, developers can improve user experience and maintain application stability.
    </p>
  </div>
)}

{selectedChapter === 'chapter78' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>try/catch Blocks</h1>

    <p >
      The <code>try...catch</code> blocks in JavaScript are essential constructs for handling errors and exceptions that may occur during the execution of code. They allow developers to manage runtime errors gracefully, providing a way to respond to errors without terminating the program unexpectedly. Here’s a detailed definition and explanation of how <code>try...catch</code> works in error handling:
    </p><br />

    <h2>Definition of <code>try...catch</code> Blocks</h2>

    <p>
      The <code>try...catch</code> statement consists of two main blocks:
    </p>
    <ol>
      <li>
        <strong>try Block</strong>: This block contains the code that might throw an error. The JavaScript engine will attempt to execute all the statements within this block.
      </li><br />
      <li>
        <strong>catch Block</strong>: If an error occurs in the <code>try</code> block, control is transferred to the <code>catch</code> block. This block contains code that handles the error. The error object can be referenced within this block to understand what went wrong.
      </li>
    </ol><br />

    <h2>Syntax</h2>

    <pre>
      <code>
        {`try {
    // Code that may throw an error
    riskyFunction();
} catch (error) {
    // Code to handle the error
    console.error('An error occurred:', error.message);
}`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Key Features</h2>

    <ul>
      <li>
        <strong>Error Handling</strong>: The primary purpose of <code>try...catch</code> is to handle runtime errors without crashing the program. This allows the application to continue running or provide meaningful feedback to the user.
      </li><br />
      <li>
        <strong>Error Object</strong>: The <code>catch</code> block receives an error object (often named <code>error</code>, but can be any identifier), which contains information about the error that occurred, such as its message and stack trace.
      </li><br />
      <li>
        <strong>Optional <code>finally</code> Block</strong>: You can also include an optional <code>finally</code> block that executes after the <code>try</code> and <code>catch</code> blocks, regardless of whether an error occurred. This is useful for cleaning up resources or executing code that must run in all cases.
      </li>
    </ul><br />

    <pre>
      <code>
        {`try {
    // Code that may throw an error
} catch (error) {
    // Error handling code
} finally {
    // Code that will run regardless of an error
}`}
      </code>
    </pre><br />

    <h2>Example</h2>

    <pre>
      <code>
        {`function parseJSON(jsonString) {
    try {
        const result = JSON.parse(jsonString);
        console.log('Parsed JSON:', result);
    } catch (error) {
        console.error('Invalid JSON string:', error.message);
    }
}

parseJSON('{"name": "John"}'); // Valid JSON
parseJSON('Invalid JSON'); // Invalid JSON`}
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Summary</h2>

    <ul>
      <li>
        <strong>Robustness</strong>: <code>try...catch</code> blocks enhance the robustness of JavaScript applications by allowing developers to anticipate and handle potential errors proactively.
      </li><br />
      <li>
        <strong>User Experience</strong>: By handling errors gracefully, developers can improve user experience by providing informative error messages and preventing abrupt application failures.
      </li><br />
      <li>
        <strong>Best Practices</strong>: It's generally good practice to use <code>try...catch</code> blocks for code that is prone to errors, especially when dealing with user input, network requests, or other unpredictable operations.
      </li>
    </ul>
  </div>
)}



{selectedChapter === 'chapter79' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Using throw for Custom Errors</h1>

    <p>
      In JavaScript, using <code>throw</code> allows developers to create custom errors that can provide more context and specificity when handling exceptions. This is particularly useful when you want to enforce certain conditions in your code or to signal that something unexpected has occurred.
    </p><br />

    <h2>Definition of <code>throw</code></h2>

    <p>
      The <code>throw</code> statement is used to generate a custom error. When a <code>throw</code> statement is executed, it immediately stops the execution of the current function and transfers control to the nearest <code>catch</code> block (if one exists). This allows developers to create their own error messages and error types, making it easier to debug issues and understand what went wrong in the code.
    </p><br />

    <h2>Syntax</h2>

    <pre>
      <code>
        throw expression;
      </code>
    </pre>
    <p>
      Where <code>expression</code> can be any valid JavaScript expression, including an error object.
    </p><br />

    <h2>Example of Using <code>throw</code></h2>

    <p>Here’s an example that demonstrates how to use <code>throw</code> to create custom errors:</p>

    <pre>
      <code>{`
        function validateAge(age) &#123;
          if (age &lt; 0) &#123;
            throw new Error("Age cannot be negative."); // Throw a custom error
          &#125; else if (age &lt; 18) &#123;
            throw new Error("You must be at least 18 years old."); // Another custom error
          &#125;
          return "Age is valid.";
        &#125;

        try &#123;
          console.log(validateAge(-5)); // This will throw an error
        &#125; catch (error) &#123;
          console.error("Error:", error.message); // Handle the error
        &#125;

        try &#123;
          console.log(validateAge(15)); // This will also throw an error
        &#125; catch (error) &#123;
          console.error("Error:", error.message); // Handle the error
        &#125;

        console.log(validateAge(20)); // This will return "Age is valid."
       `} </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>Key Features</h2>

    <ol>
      <li>
        <strong>Custom Error Messages:</strong> By throwing an error with a specific message, developers can provide clear and actionable feedback about what went wrong.
      </li><br />
      <li>
        <strong>Error Types:</strong> You can create instances of built-in error types like <code>TypeError</code>, <code>RangeError</code>, or your custom error types by extending the <code>Error</code> class. This helps categorize errors more effectively.
        <pre>
          <code>{`
            class CustomError extends Error &#123;
              constructor(message) &#123;
                super(message);
                this.name = "CustomError"; // Custom name for the error
              &#125;
            &#125;

            throw new CustomError("This is a custom error."); // Throwing a custom error
          `}</code>
        </pre>
      </li><br />
      <li>
        <strong>Control Flow Management:</strong> The <code>throw</code> statement provides a mechanism for managing control flow in your application. By throwing errors, you can prevent further execution of code that depends on valid conditions.
      </li>
    </ol><br />

    <h2>Summary</h2>

    <p>
      Using <code>throw</code> for custom errors in JavaScript enhances error handling by allowing developers to create meaningful and descriptive error messages tailored to their application logic. This practice improves code robustness, enhances debugging capabilities, and contributes to a better user experience by providing informative feedback when errors occur. By integrating custom error handling, developers can write more resilient and maintainable code.
    </p>
  </div>
)}



{selectedChapter === 'chapter80' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Debugging Techniques and Tools</h1>

    <p>
      Debugging is a crucial part of the development process, allowing developers to identify and fix issues in their code. JavaScript provides several techniques and tools to facilitate effective debugging. Here's an overview:
    </p><br />

    <h3>1. Console Logging</h3>
    <p>
      <strong>Technique:</strong> Using <code>console.log()</code>, <code>console.warn()</code>, and <code>console.error()</code> allows developers to output messages to the console. This is a simple yet powerful way to track the flow of execution and check the values of variables.
    </p>
    <pre>
      <code>{`
        function calculateSum(a, b) &#123;
          console.log('Adding:', a, b); // Log inputs
          return a + b;
        &#125;

        console.log(calculateSum(5, 10)); // Output: 15
      `}</code>
    </pre><br />

    <h3>2. Browser Developer Tools</h3>
    <p>
      Most modern browsers come with built-in developer tools that provide a suite of debugging features:
    </p>
    <ul>
      <li><strong>Console:</strong> View logged messages, errors, and warnings.</li><br />
      <li><strong>Debugger:</strong> Set breakpoints in your code, step through execution line by line, and inspect variable values.</li><br />
      <li><strong>Network Tab:</strong> Monitor network requests and responses, useful for debugging AJAX calls.</li><br />
      <li><strong>Elements Tab:</strong> Inspect and modify the HTML and CSS of the page in real-time.</li>
    </ul>
    <p>
      <strong>How to Access:</strong> Right-click on a webpage and select "Inspect" or press <code>F12</code>.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>3. Breakpoints</h3>
    <p>
      <strong>Technique:</strong> Breakpoints allow developers to pause code execution at a specific line. This enables inspection of variable states and control flow.
    </p>
    <p>
      <strong>Conditional Breakpoints:</strong> Set breakpoints that only activate under certain conditions, reducing interruptions during debugging.
    </p><br />

    <h3>4. Step Over, Step Into, Step Out</h3>
    <p>
      These are essential debugging controls:
    </p>
    <ul>
      <li><strong>Step Over:</strong> Execute the next line of code without stepping into functions.</li><br />
      <li><strong>Step Into:</strong> Enter the function being called and continue debugging inside it.</li><br />
      <li><strong>Step Out:</strong> Complete the current function and return to the caller.</li>
    </ul><br />

    <h3>5. Error Stack Traces</h3>
    <p>
      When an error occurs, JavaScript provides a stack trace that shows the sequence of function calls leading to the error. Analyzing the stack trace can help identify where the problem originated.
    </p>
    <pre>
      <code>{`
        function a() &#123; b(); &#125;
        function b() &#123; c(); &#125;
        function c() &#123; throw new Error("Something went wrong"); &#125;

        a(); // Will log the error stack trace
      `}</code>
    </pre><br />

    <h3>6. Unit Testing and Test Suites</h3>
    <p>
      Using frameworks like Jest, Mocha, or Jasmine allows developers to write tests for their code. Running these tests can help catch bugs early in the development process.
    </p>
    <pre>
      <code>{`
        // Using Jest
        test('adds 1 + 2 to equal 3', () => &#123;
          expect(calculateSum(1, 2)).toBe(3);
        &#125;);
      `}</code>
    </pre><br />

    <h3>7. Linting Tools</h3>
    <p>
      Tools like ESLint and JSHint analyze your code for potential errors and code style issues before runtime. Integrating these tools into your development workflow can catch common mistakes early.
    </p><br />

    <h3>8. Version Control</h3>
    <p>
      Using version control systems like Git allows developers to track changes and revert to previous versions if a new change introduces bugs. It also facilitates collaboration, making it easier to identify when an error was introduced.
    </p><br />

    <h2>Summary</h2>
    <p>
      Effective debugging in JavaScript involves a combination of techniques and tools. By leveraging console logging, browser developer tools, breakpoints, and testing frameworks, developers can quickly identify and resolve issues in their code. Incorporating linting tools and version control further enhances the debugging process, leading to more robust and maintainable JavaScript applications.
    </p>
  </div>
)}



{selectedChapter === 'chapter81' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Clean Code Practices</h1>

    <p>
      Clean code practices in JavaScript focus on writing code that is easy to read, understand, maintain, and extend. These practices help ensure that codebases remain manageable over time, facilitating collaboration among developers and reducing the likelihood of introducing bugs. Here’s an overview of clean code practices in JavaScript:
    </p><br />

    <h2>Definition of Clean Code Practices</h2>
    <p>
      <strong>Clean Code</strong>: Clean code refers to code that is well-organized, straightforward, and free of unnecessary complexity. It adheres to principles that promote clarity and simplicity, making it easier for developers to understand and modify the code without extensive effort.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Key Practices for Clean Code in JavaScript</h2>

    <ol>
      <li>
        <strong>Meaningful Naming:</strong>
        <p>
          Use descriptive and unambiguous names for variables, functions, classes, and modules. Names should convey the purpose and intention of the code.
        </p>
        <pre><code>{`// Bad Naming
const x = 10;

// Good Naming
const maxUserCount = 10;`}</code></pre>
      </li><br />

      <li>
        <strong>Consistent Formatting:</strong>
        <p>
          Maintain consistent indentation, spacing, and use of braces. This enhances readability and helps others follow the structure of the code. Use tools like Prettier or ESLint for automatic formatting.
        </p>
      </li><br />

      <li>
        <strong>Functions Should Do One Thing:</strong>
        <p>
          Each function should have a single responsibility or purpose. This makes functions easier to understand, test, and reuse.
        </p>
        <pre><code>{`// Bad Example
function processData(data) {
    // Process data
    // Format data
    // Save data
}

// Good Example
function processData(data) {
    return formatData(data);
}

function saveData(data) {
    // Save data logic
}`}</code></pre>
      </li><br />

      <li>
        <strong>Avoid Magic Numbers:</strong>
        <p>
          Replace magic numbers (literal values) with named constants to improve clarity and maintainability.
        </p>
        <pre><code>{`// Bad Example
const price = 100 * 1.05; // What does 1.05 mean?

// Good Example
const taxRate = 0.05;
const price = 100 * (1 + taxRate);`}</code></pre>
      </li><br />

      <li>
        <strong>Use Comments Judiciously:</strong>
        <p>
          Write comments that explain why certain decisions were made, but avoid redundant comments that state the obvious. Well-written code should be self-explanatory.
        </p>
        <pre><code>{`// Bad Comment
const total = price + tax; // Adding price and tax

// Good Comment
// Calculate total cost including tax
const total = price + tax;`}</code></pre>
      </li><br />

      <li>
        <strong>Error Handling:</strong>
        <p>
          Implement robust error handling using <code>try...catch</code> blocks to manage exceptions gracefully, rather than allowing the program to crash.
        </p>
        <pre><code>{`try {
    const result = riskyOperation();
} catch (error) {
    console.error('An error occurred:', error);
}`}</code></pre>
      </li><br />

      <li>
        <strong>Use ES6+ Features:</strong>
        <p>
          Take advantage of modern JavaScript features like arrow functions, template literals, destructuring, and modules to write cleaner and more concise code.
        </p>
        <pre><code>{`// Using ES5
var sum = function(a, b) {
    return a + b;
};

// Using ES6+
const sum = (a, b) => a + b;`}</code></pre>
      </li><br />

      <li>
        <strong>Keep It DRY (Don't Repeat Yourself):</strong>
        <p>
          Avoid code duplication by creating reusable functions or modules. This reduces maintenance overhead and potential errors.
        </p>
        <pre><code>{`// Bad Example: Duplication
function calculateAreaOfRectangle(length, width) {
    return length * width;
}

function calculateAreaOfSquare(side) {
    return side * side; // Duplicate logic
}

// Good Example: Reusable Function
function calculateArea(length, width) {
    return length * width;
}

function calculateAreaOfSquare(side) {
    return calculateArea(side, side);
}`}</code></pre>
      </li><br />

      <li>
        <strong>Test-Driven Development (TDD):</strong>
        <p>
          Write tests before implementing features. This practice encourages writing simpler code and ensures that each piece of functionality works as intended. Use testing frameworks like Jest or Mocha to write unit tests.
        </p>
      </li>
    </ol><br />

    <h2>Summary</h2>
    <p>
      Adopting clean code practices in JavaScript leads to better code quality, easier maintenance, and improved collaboration among team members. By focusing on meaningful naming, consistent formatting, modular functions, effective error handling, and leveraging modern JavaScript features, developers can create robust applications that are easier to understand and modify over time. Clean code not only enhances the developer experience but also results in better software quality and user satisfaction.
    </p>
  </div>
)}



{selectedChapter === 'chapter82' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Code Optimization</h1>

    <p><strong>Code Optimization</strong> in JavaScript refers to the practice of improving the efficiency and performance of code by making it run faster, use fewer resources, or achieve better scalability. Optimized code not only enhances user experience but also reduces computational costs, especially for large-scale applications. Here’s a breakdown of best practices for code optimization in JavaScript:</p><br />

    <h3 style={{paddingBottom:"6px"}}>Key Concepts of Code Optimization</h3>
    <ul>
      <li>
        <strong>Performance Efficiency:</strong>
        Improving the speed of execution and responsiveness of the code, particularly in time-critical applications like web pages or large data processing.
      </li><br />
      <li>
        <strong>Memory Efficiency:</strong>
        Minimizing the memory footprint to ensure that the code doesn’t consume excessive resources, especially in environments with limited memory, such as mobile devices.
      </li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Best Practices for Code Optimization in JavaScript</h3>

    <ol>
      <li>
        <strong>Minimize DOM Access:</strong> Accessing the DOM is relatively slow, so minimize interactions with it. Cache DOM references rather than querying them repeatedly.
        <pre>
{`
  // Bad Example
  for (let i = 0; i < items.length; i++) {
      document.getElementById('element').innerHTML += items[i];
  }

  // Good Example
  const element = document.getElementById('element');
  let content = '';
  for (let i = 0; i < items.length; i++) {
      content += items[i];
  }
  element.innerHTML = content;
`}
        </pre>
      </li><br />


      <li>
        <strong>Use Efficient Loops:</strong> Optimize loop performance by using appropriate loops (`for`, `while`, `forEach`). Cache the length of arrays when using a `for` loop.
        <pre>
{`
  // Bad Example
  for (let i = 0; i < array.length; i++) {
      process(array[i]);
  }

  // Good Example
  for (let i = 0, len = array.length; i < len; i++) {
      process(array[i]);
  }
`}
        </pre>
      </li><br />

      <li>
        <strong>Avoid Unnecessary Computation:</strong> Cache results and reuse them when needed to avoid redundant or expensive calculations.
        <pre>
{`
  // Bad Example
  let area = calculateArea();
  if (condition) {
      area = calculateArea(); // Recomputed unnecessarily
  }

  // Good Example
  let area = calculateArea();
  if (condition) {
      // Reuse the cached result
  }
`}
        </pre>
      </li><br />

      <li>
        <strong>Optimize Function Calls:</strong> Avoid creating functions within loops to reduce memory usage. Use closures carefully to avoid memory leaks.
        <pre>
{`
  // Bad Example
  for (let i = 0; i < data.length; i++) {
      (function() {
          console.log(data[i]);
      })();
  }

  // Good Example
  function logItem(item) {
      console.log(item);
  }
  for (let i = 0; i < data.length; i++) {
      logItem(data[i]);
  }
`}
        </pre>
      </li><br />

      <li>
        <strong>Use Throttling and Debouncing:</strong> Reduce the frequency of event-driven function execution using throttling or debouncing techniques.
        <pre>
{`
  // Debouncing Example
  function debounce(func, delay) {
      let timeout;
      return function() {
          const context = this, args = arguments;
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(context, args), delay);
      };
  }

  window.addEventListener('resize', debounce(() => {
      console.log('Resized');
  }, 500));
`}
        </pre>
      </li><br />

      <li>
        <strong>Lazy Loading Resources:</strong> Load resources like images, scripts, and components only when needed to improve page load times.
        <pre>
{`
  // Lazy loading images
  <img src="low-res.jpg" data-src="high-res.jpg" class="lazy-load" />

  // JavaScript to load high-res image only when in view
  const lazyImages = document.querySelectorAll('img.lazy-load');
  lazyImages.forEach(img => {
      if (img.getBoundingClientRect().top < window.innerHeight) {
          img.src = img.getAttribute('data-src');
      }
  });
`}
        </pre>
      </li><br />

      <li>
        <strong>Reduce HTTP Requests:</strong> Combine CSS and JavaScript files to reduce the number of HTTP requests. Use bundling and minification for file size reduction.
      </li><br />

      <li>
        <strong>Defer and Async Loading for Scripts:</strong> Use `async` or `defer` attributes on non-critical scripts to prevent blocking the rendering of the page.
        <pre>
{`
  <script src="script.js" async></script>
  <script src="important.js" defer></script>
`}
        </pre>
      </li><br />

      <li>
        <strong>Avoid Memory Leaks:</strong> Use proper memory management techniques such as nullifying unused variables and using weak references when necessary.
        <pre>
{`
  // Nullifying unused variables
  let obj = { key: "value" };
  obj = null;
`}
        </pre>
      </li><br />

      <li>
        <strong>Optimize CSS and JavaScript Animations:</strong> Use hardware-accelerated properties like `transform` and `opacity` for smoother animations.
      </li>
    </ol><br />

    <h3>Summary</h3>
    <p>Optimizing JavaScript code is crucial for fast, efficient, and scalable applications. By following best practices—minimizing DOM access, reducing redundant computations, using efficient loops, lazy loading, and preventing memory leaks—you can significantly improve performance and maintainability.</p>
  </div>
)}


{selectedChapter === 'chapter83' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Avoiding Common Mistakes</h1>
    <p>
      JavaScript is a powerful and flexible language, but its dynamic nature can lead to common pitfalls that developers need to avoid. Following best practices ensures code reliability, readability, and performance. Here’s a guide to avoiding common mistakes in JavaScript:
    </p><br />

    <h3>1. Declaring Variables Properly</h3>
    <p><strong>Problem:</strong> Failing to declare variables properly can lead to accidental global variables, which may cause unexpected behavior.</p>
    <p><strong>Best Practice:</strong> Always use <code>let</code>, <code>const</code>, or <code>var</code> to declare variables. Prefer <code>const</code> for values that do not change and <code>let</code> for values that do.</p>
    
    <pre>
      <code>
        {`// Bad Example
function example() {
  value = 10; // Global variable
}

// Good Example
function example() {
  let value = 10; // Local variable
}`}
      </code>
    </pre><br />

    <h3>2. Avoiding Type Coercion Confusion</h3>
    <p><strong>Problem:</strong> JavaScript’s type coercion can lead to unexpected results, especially when using <code>==</code> for comparisons.</p>
    <p><strong>Best Practice:</strong> Use <code>===</code> and <code>!==</code> to avoid automatic type conversions, which can be unpredictable.</p>

    <pre>
      <code>
        {`// Bad Example
console.log(0 == ''); // true

// Good Example
console.log(0 === ''); // false`}
      </code>
    </pre><br />

    <h3>3. Understanding <code>this</code> Context</h3>
    <p><strong>Problem:</strong> The value of <code>this</code> changes depending on how a function is called, leading to confusion.</p>
    <p><strong>Best Practice:</strong> Use arrow functions for callbacks and event handlers where you want <code>this</code> to inherit from the surrounding scope.</p>

    <pre>
      <code>
        {`// Bad Example
function Person(name) {
  this.name = name;
  setTimeout(function() {
    console.log(this.name); // undefined
  }, 1000);
}

// Good Example
function Person(name) {
  this.name = name;
  setTimeout(() => {
    console.log(this.name); // Correctly refers to the Person instance
  }, 1000);
}`}
      </code>
    </pre><br />

    <h3>4. Avoiding Mutable Data Structures</h3>
    <p><strong>Problem:</strong> Directly modifying arrays or objects can lead to bugs and side effects, especially in complex applications.</p>
    <p><strong>Best Practice:</strong> Use immutable methods (e.g., <code>map</code>, <code>filter</code>, <code>reduce</code>) or libraries like Immutable.js to avoid unexpected mutations.</p>

    <pre>
      <code>
        {`// Bad Example (mutating original array)
const arr = [1, 2, 3];
arr.push(4); // Modifies the original array

// Good Example (non-mutating)
const newArr = [...arr, 4]; // Creates a new array`}
      </code>
    </pre>

    {/* Repeat for all the other sections in similar fashion */}

  </div>
)}


{selectedChapter === 'chapter84' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Memory Management</h1>

    <section>
      <p>
        Effective memory management is crucial for developing performant, efficient, and scalable JavaScript applications,
        especially in resource-constrained environments like mobile or large-scale web apps. JavaScript's memory management is
        handled by the garbage collector, which automatically deallocates memory that is no longer used. However, developers must
        still be mindful of potential memory leaks and inefficient use of memory.
      </p>
      <p>Here’s a breakdown of best practices for memory management in JavaScript:</p>

  <br />

      <h4>1. Avoiding Global Variables</h4>
      <p>
        <strong>Problem:</strong> Global variables persist throughout the entire lifecycle of the application, leading to
        unnecessary memory usage.
      </p>
      <p>
        <strong>Best Practice:</strong> Limit the use of global variables. Encapsulate variables within functions, modules, or
        blocks using <code>let</code>, <code>const</code>, or closures.
      </p>

      <pre>
        <code>{`// Bad Example
var globalVar = 'I am global'; // Persists in memory for the entire app life

// Good Example
function myFunc() {
    let localVar = 'I am local'; // Released once the function scope ends
}
`}</code>
      </pre><br />

      <h4>2. Nullifying Unused Variables</h4>
      <p>
        <strong>Problem:</strong> Retaining references to large objects or data structures that are no longer needed can cause
        memory leaks.
      </p>
      <p>
        <strong>Best Practice:</strong> Set variables to <code>null</code> when the data is no longer needed, allowing the garbage
        collector to reclaim that memory.
      </p>

      <pre>
        <code>{`// Bad Example
let largeArray = new Array(1000000);
// The array remains in memory

// Good Example
largeArray = null; // Free up memory when no longer needed
`}</code>
      </pre><br />

      <h4>3. Use Closures Cautiously</h4>
      <p>
        <strong>Problem:</strong> Closures can retain variables in memory, even when the function has finished execution, potentially causing memory leaks.
      </p>
      <p>
        <strong>Best Practice:</strong> Be mindful when using closures, especially when holding references to large objects. Avoid creating unnecessary closures inside loops or long-running functions.
      </p>

      <pre>
        <code>{`// Bad Example (closure retaining unnecessary data)
function createFunction() {
    const largeData = new Array(1000000); // Large data retained in closure
    return function() {
        console.log(largeData);
    };
}

// Good Example
function createFunction() {
    const processedData = processLargeData(); // Process large data and discard
    return function() {
        console.log(processedData);
    };
}
`}</code>
      </pre><br />

      <h4>4. Remove Event Listeners</h4>
      <p>
        <strong>Problem:</strong> Not removing event listeners after they are no longer needed can prevent the garbage collector from releasing the memory used by the associated elements.
      </p>
      <p>
        <strong>Best Practice:</strong> Always remove event listeners when the event or element is no longer necessary. This helps prevent memory leaks.
      </p>

      <pre>
        <code>{`// Bad Example
element.addEventListener('click', handleClick);

// Good Example
element.addEventListener('click', handleClick);
element.removeEventListener('click', handleClick); // Proper cleanup
`}</code>
      </pre><br />

      <h4>5. Use WeakMap and WeakSet for Dynamic References</h4>
      <p>
        <strong>Problem:</strong> Storing dynamic or temporary references in regular objects can prevent garbage collection, leading to memory leaks.
      </p>
      <p>
        <strong>Best Practice:</strong> Use <code>WeakMap</code> or <code>WeakSet</code> when you need to reference objects that should be garbage collected if no other references exist.
      </p>

      <pre>
        <code>{`// Using WeakMap for dynamic object references
const weakMap = new WeakMap();
let obj = { key: 'value' };
weakMap.set(obj, 'some data');

// The object and associated data can be garbage collected when obj is dereferenced
obj = null; // Memory is freed when object is no longer needed
`}</code>
      </pre><br />

      <h4>6. Avoid Long-lived Timers and Intervals</h4>
      <p>
        <strong>Problem:</strong> Timers (<code>setTimeout</code>, <code>setInterval</code>) that are not cleared can hold references to objects, preventing memory from being freed.
      </p>
      <p>
        <strong>Best Practice:</strong> Always clear timers or intervals when they are no longer needed using <code>clearTimeout</code> or <code>clearInterval</code>.
      </p>

      <pre>
        <code>{`// Bad Example
setInterval(function() {
    console.log('Still running...');
}, 1000); // Continues to run indefinitely

// Good Example
const intervalId = setInterval(function() {
    console.log('Still running...');
}, 1000);

clearInterval(intervalId); // Clean up the interval when no longer needed
`}</code>
      </pre><br />

      <h4>7. Avoid Large DOM Manipulations</h4>
      <p>
        <strong>Problem:</strong> Large DOM trees or frequent DOM manipulations can increase memory usage and slow down performance.
      </p>
      <p>
        <strong>Best Practice:</strong> Minimize direct DOM manipulation by using virtual DOM frameworks (like React or Vue), or batch DOM updates to reduce memory footprint and improve performance.
      </p>

      <pre>
        <code>{`// Bad Example
for (let i = 0; i < 1000; i++) {
    const div = document.createElement('div');
    document.body.appendChild(div);
}

// Good Example
const fragment = document.createDocumentFragment();
for (let i = 0; i < 1000; i++) {
    const div = document.createElement('div');
    fragment.appendChild(div);
}
document.body.appendChild(fragment); // Batch DOM update
`}</code>
      </pre><br />

      <h4>8. Use Garbage Collection Tools for Debugging</h4>
      <p>
        <strong>Problem:</strong> It's difficult to track memory issues and leaks manually.
      </p>
      <p>
        <strong>Best Practice:</strong> Use browser developer tools to track memory usage, take heap snapshots, and identify memory leaks. Tools like Chrome's Memory tab can help you find which objects are persisting longer than expected.
      </p>

   <br />

      <h3>Summary</h3>
      <p>
        Efficient memory management in JavaScript is vital for ensuring that your application performs well and scales smoothly. By following best practices—like minimizing global variables, nullifying unused references, using weak references, and removing event listeners—you can reduce memory leaks and improve the overall efficiency of your code. Additionally, leverage developer tools to monitor memory usage during development and debugging.
      </p>
    </section>
  </div>
)}

{selectedChapter === 'chapter85' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Integrating JavaScript Projects with Git/GitHub</h1>
   

      <p>
        Version control is a critical part of modern software development, allowing teams and individuals to manage changes to their codebase, collaborate efficiently, and maintain the history of their projects. Git is a distributed version control system that helps developers track changes, while GitHub is a popular platform for hosting Git repositories, enabling collaboration and project management.
      </p>

      <p>
        When working with JavaScript projects, integrating Git and GitHub enhances both individual productivity and team collaboration. Here’s a detailed breakdown of the process and best practices for integrating JavaScript projects with Git/GitHub under the context of version control and collaboration:
      </p>

  <br />

      <h3>1. Setting Up a Git Repository for a JavaScript Project</h3>
      <p style={{paddingBottom:"6px"}}>Before integrating with GitHub, you need to initialize Git locally within your JavaScript project directory.</p>

      <h4>Steps:</h4>
      <ol>
        <li>Open your terminal or command prompt and navigate to your project folder.</li><br />
        <li>Run the following command to initialize a Git repository:</li><br />
        <pre><code>git init</code></pre>
        <li>Add your project files to the staging area with:</li><br />
        <pre><code>git add .</code></pre>
        <li>Commit the changes:</li><br />
        <pre><code>git commit -m "Initial commit"</code></pre>
      </ol><br />
      <p>This creates a local Git repository where changes to your JavaScript project can be tracked.</p>

    <br />

      <h3>2. Pushing the JavaScript Project to GitHub</h3>
      <p>Once the local repository is set up, you can push your project to a remote repository on GitHub.</p>

      <h4>Steps:</h4>
      <ol>
        <li>Create a new repository on GitHub by going to your GitHub account and clicking on "New repository."</li><br />
        <li>Copy the remote repository URL (either HTTPS or SSH).</li><br />
        <li>Link your local Git repository to GitHub:</li><br />
        <pre><code>git remote add origin &lt;repository-URL&gt;</code></pre>
        <li>Push your local repository to GitHub:</li><br />
        <pre><code>git push -u origin master</code></pre>
      </ol>
      <p>Now, your JavaScript project is available on GitHub, and you can share it with collaborators or access it from different machines.</p>

 <br />

      <h3>3. Committing Changes and Collaboration</h3>
      <p>To track changes effectively, you should follow Git best practices when committing code:</p>

      <ul>
        <li><strong>Make Atomic Commits:</strong> Ensure each commit represents a single logical change.</li><br />
        <li><strong>Write Descriptive Commit Messages:</strong> Each commit message should clearly describe what was changed and why.</li>
      </ul><br />

      <p><strong>Example:</strong></p>
      <pre><code>git commit -m "Add user authentication feature"</code></pre><br />

      <h4>Collaboration:</h4>
      <ul>
        <li>Use <strong>branches</strong> to work on new features or bug fixes independently without affecting the main codebase:</li><br />
        <pre><code>git checkout -b new-feature</code></pre><br />
        <li>Merge branches back into the main branch after reviewing and testing:</li><br />
        <pre><code>git checkout master && git merge new-feature</code></pre>
      </ul>
<br />

      <h3>4. Collaboration with Pull Requests (PRs) and Code Reviews</h3>
      <p>GitHub provides tools for collaborating on JavaScript projects through <strong>pull requests</strong> (PRs) and <strong>code reviews</strong>:</p>

      <ul>
        <li><strong>Pull Requests:</strong> Allow developers to propose changes from one branch to another.</li><br />
        <li><strong>Code Reviews:</strong> Team members can provide feedback, request changes, or approve changes before integration.</li>
      </ul>

   <br />

      <h3>5. Handling Merge Conflicts</h3>
      <p style={{paddingBottom:"6px"}}>When working with multiple collaborators, merge conflicts can occur. Git allows you to handle these conflicts manually.</p>

      <h4>Steps to Resolve Conflicts:</h4>
      <ol>
        <li>Pull the latest changes from the remote repository:</li>
        <pre><code>git pull origin master</code></pre><br />
        <li>Git will highlight the conflicting sections in the affected files. Manually edit and resolve the conflicts.</li><br />
        <li>Add the updated files and commit the merge:</li><br />
        <pre><code>git add . && git commit -m "Resolved merge conflicts"</code></pre>
      </ol>

    <br />

      <h3>6. Tracking Changes with Git Log and Blame</h3>
      <ul>
        <li>Use <code>git log</code> to view the history of changes:</li>
        <pre><code>git log</code></pre>
        <li>Use <code>git blame &lt;filename&gt;</code> to track who made changes to specific lines of code.</li>
      </ul>

  <br />

      <h3>7. Using GitHub Issues for Project Management</h3>
      <p>GitHub provides an issue-tracking system for managing tasks, bugs, and feature requests:</p>

      <ul>
        <li><strong>Create Issues:</strong> Document bugs, tasks, or features.</li><br />
        <li><strong>Assign Issues:</strong> Assign them to team members for resolution.</li><br />
        <li><strong>Link Pull Requests:</strong> Link pull requests to specific issues for tracking purposes.</li>
      </ul>

    <br />

      <h3>8. Continuous Integration with GitHub Actions</h3>
      <p>GitHub offers <strong>GitHub Actions</strong>, a CI/CD tool that automates testing, building, and deploying your JavaScript applications. Set up workflows to run automated tests on every pull request or push.</p>

    <br />

      <h3>Summary</h3>
      <p>
        Integrating JavaScript projects with Git and GitHub under version control and collaboration improves development efficiency and enables seamless teamwork. By following best practices—such as proper commit messages, branch management, pull requests, and issue tracking—developers can manage their projects effectively. Tools like GitHub Actions further enhance this integration, ensuring smooth testing and deployment processes.
      </p>
      <p>
        By mastering Git and GitHub, you not only improve code management but also foster better collaboration and maintainability in your JavaScript projects.
      </p>
    </div>

)}

{selectedChapter === 'chapter86' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Best Practices for Code Versioning</h1>


    <p>
      Effective version control is essential for successful collaboration in software development, especially in JavaScript projects. Adopting best practices for code versioning helps maintain code integrity, streamline workflows, and improve team collaboration. Here are some key best practices:
    </p><br />

    <ol>
      <li>
        <strong style={{paddingBottom:"6px"}}>Use a Consistent Branching Strategy:</strong>
        <ul>
          <li>
            <strong>Branching Model:</strong> Adopt a clear branching strategy, such as Git Flow or GitHub Flow. This provides structure to your development process and clarifies the purpose of each branch (e.g., feature branches, bug fix branches, release branches).
          </li><br />
          <li>
            <strong>Keep the Main Branch Stable:</strong> Ensure that the main branch (often <code>master</code> or <code>main</code>) is always in a deployable state. Use separate branches for ongoing development to avoid introducing unstable code into the main branch.
          </li>
        </ul>
      </li><br />

      <li>
        <strong style={{paddingBottom:"6px"}}>Commit Often and Early:</strong>
        <ul>
          <li>
            Make small, frequent commits that capture logical units of work. This not only makes it easier to track changes but also helps in pinpointing issues when they arise.
          </li><br />
          <li>
            Each commit should encapsulate a single change, such as a bug fix or a new feature, to maintain clarity in your project’s history.
          </li>
        </ul>
      </li><br />

      <li>
        <strong style={{paddingBottom:"6px"}}>Write Descriptive Commit Messages:</strong>
        <ul>
          <li>
            Use clear and meaningful commit messages that explain the changes made. A good commit message should describe what changed and why it was necessary.
          </li><br />
          <li>
            Format your commit messages consistently, starting with a short summary followed by a more detailed explanation if necessary.
          </li><br />
          <li>
            <strong>Example:</strong>
            <pre>
              <code>
                Add user authentication

                - Implement login functionality using OAuth
                - Add error handling for invalid credentials
              </code>
            </pre>
          </li>
        </ul>
      </li><br />

      <li>
        <strong>Use Tags for Releases:</strong>
        <ul>
          <li>
            Utilize Git tags to mark specific points in your repository’s history as important, such as release versions. This allows for easy reference and retrieval of stable versions of your project.
          </li><br />
          <li>
            <strong>Example:</strong>
            <pre>
              <code>
                git tag -a v1.0 -m "Release version 1.0"
              </code>
            </pre>
          </li>
        </ul>
      </li><br />

      <li>
        <strong style={{paddingBottom:"6px"}}>Implement Code Reviews:</strong>
        <ul>
          <li>
            Establish a process for code reviews through pull requests (PRs). Code reviews help ensure code quality, promote knowledge sharing, and catch potential issues early.
          </li><br />
          <li>
            Encourage constructive feedback, and foster an environment where team members can discuss and improve each other’s code.
          </li>
        </ul>
      </li><br />

      <li>
        <strong style={{paddingBottom:"6px"}}>Manage Merge Conflicts Proactively:</strong>
        <ul>
          <li>
            Communicate with team members about ongoing changes to minimize the risk of merge conflicts. Regularly pull changes from the main branch into your feature branches to stay updated.
          </li><br />
          <li>
            When conflicts occur, resolve them carefully, ensuring that the resulting code works correctly.
          </li>
        </ul>
      </li><br />

      <li>
        <strong style={{paddingBottom:"6px"}}>Use .gitignore Files:</strong>
        <ul>
          <li>
            Include a <code>.gitignore</code> file in your project to specify files and directories that should not be tracked by Git (e.g., node_modules, build artifacts, sensitive information).
          </li><br />
          <li>
            This keeps your repository clean and avoids accidental inclusion of unnecessary files.
          </li>
        </ul>
      </li><br />

      <li>
        <strong style={{paddingBottom:"6px"}}>Document Your Version Control Process:</strong>
        <ul>
          <li>
            Create documentation outlining your version control practices and workflows. This helps onboard new team members and ensures that everyone follows the same procedures.
          </li><br />
          <li>
            Regularly review and update the documentation to reflect any changes in your practices.
          </li>
        </ul>
      </li><br />

      <li>
        <strong  style={{paddingBottom:"6px"}}>Utilize CI/CD Tools:</strong>
        <ul>
          <li>
            Integrate Continuous Integration and Continuous Deployment (CI/CD) tools to automate testing and deployment processes. This helps catch issues early and ensures that changes are tested before being merged into the main branch.
          </li>
        </ul>
      </li><br />

      <li>
        <strong style={{paddingBottom:"6px"}}>Regularly Backup Your Repositories:</strong>
        <ul>
          <li>
            Make sure to regularly back up your repositories, especially if they contain critical project data. Use remote hosting services like GitHub, GitLab, or Bitbucket to ensure that your code is safe and accessible.
          </li>
        </ul>
      </li>
    </ol><br />

    <p>
      By following these best practices for code versioning, JavaScript developers can enhance collaboration, improve code quality, and streamline their development processes, ultimately leading to more successful projects.
    </p>
  </div>
)}



{selectedChapter === 'chapter87' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Single Page Application (SPA)</h1>
    <p>
      A <strong>Single Page Application (SPA)</strong> is a modern web development architecture that enhances user experience by loading a single HTML page and dynamically updating the content as the user interacts with the application. Instead of loading new pages from the server for each interaction, SPAs use AJAX (Asynchronous JavaScript and XML) or Fetch API calls to retrieve data from the server, updating the current page without a full reload. This approach results in a smoother and faster experience for users.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Key Features of SPAs:</h3>
    <ul>
      <li>
        <strong>Dynamic Loading of Content:</strong> SPAs load the necessary resources (HTML, CSS, JavaScript) only once and dynamically fetch additional content as needed, allowing for seamless transitions between different views or sections of the application.
      </li><br />
      <li>
        <strong>Enhanced User Experience:</strong> By eliminating the need for full page reloads, SPAs provide a more responsive and fluid interface, making applications feel faster and more interactive. Users can navigate through the app without interruptions.
      </li><br />
      <li>
        <strong>Client-Side Routing:</strong> SPAs often utilize client-side routing libraries (like React Router or Vue Router) to manage the application’s navigation and state. This allows users to share URLs that reflect the current view or state of the application.
      </li><br />
      <li>
        <strong>State Management:</strong> SPAs manage the application state on the client side, often using state management libraries (such as Redux or Vuex). This centralizes the state of the application, making it easier to manage and share data across components.
      </li><br />
      <li>
        <strong>Reduced Server Load:</strong> Since SPAs only request data from the server and not entire HTML pages, they can reduce server load and bandwidth usage, making them efficient in terms of resource consumption.
      </li>
    </ul><br /> 

    <h3 style={{paddingBottom:"6px"}}>Advantages of SPAs:</h3>
    <ul>
      <li><strong>Improved Performance:</strong> Faster load times due to reduced data transfer and no full page reloads.</li><br />
      <li><strong>Better User Engagement:</strong> A more app-like experience keeps users engaged and encourages them to spend more time in the application.</li><br />
      <li><strong>Easier Development and Maintenance:</strong> With a clear separation between the frontend and backend, developers can work independently on the client-side code and the server-side API.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Disadvantages of SPAs:</h3>
    <ul>
      <li><strong>Initial Load Time:</strong> The initial loading of an SPA can be slower than traditional multi-page applications since all the necessary resources must be loaded at once.</li><br />
      <li><strong>SEO Challenges:</strong> SPAs may face challenges with search engine optimization (SEO) since content is often loaded dynamically and may not be easily indexed by search engines. However, techniques like server-side rendering (SSR) or pre-rendering can mitigate this issue.</li><br />
      <li><strong>JavaScript Dependency:</strong> SPAs heavily rely on JavaScript for functionality. If a user's browser has JavaScript disabled or if there are errors in the code, the application may not function properly.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Popular Frameworks and Libraries for SPAs:</h3>
    <ul>
      <li><strong>React:</strong> A JavaScript library for building user interfaces that enables the creation of SPAs through its component-based architecture.</li><br />
      <li><strong>Angular:</strong> A full-fledged framework that provides built-in support for routing, state management, and HTTP requests, making it suitable for SPAs.</li><br />
      <li><strong>Vue.js:</strong> A progressive framework that allows developers to build SPAs with ease, offering a flexible and approachable ecosystem.</li>
    </ul><br />

    <h3>Conclusion</h3>
    <p>
      Single Page Applications (SPAs) are a powerful approach in modern web development, enabling developers to create fast, responsive, and engaging user experiences. By leveraging JavaScript and frameworks designed for SPAs, developers can build applications that meet the demands of today's users while addressing the challenges that come with this architecture.
    </p>
  </div>
)}


{selectedChapter === 'chapter88' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>JavaScript Frameworks and Libraries Overview (React, Angular, Vue)</h1>

    <p>
      JavaScript frameworks and libraries have become essential tools in modern web development,
      enabling developers to build interactive, responsive, and efficient applications. Each framework 
      and library offers unique features and advantages, catering to different development needs and 
      preferences. Here’s an overview of three of the most popular ones: React, Angular, and Vue.js.
    </p><br />

    <h3>1. React</h3>

    <p style={{paddingBottom:"6px"}}><strong>Overview:</strong> Developed by Facebook, React is a JavaScript library for building user interfaces,
      particularly for single-page applications (SPAs). It allows developers to create reusable UI components,
      which can manage their state and lifecycle.</p>

    <h4 style={{paddingBottom:"6px"}}>Key Features:</h4>
    <ul>
      <li><strong>Component-Based Architecture:</strong> React promotes the development of encapsulated components
        that manage their state, making it easier to build and maintain complex user interfaces.</li><br />
      <li><strong>Virtual DOM:</strong> React uses a virtual representation of the DOM to improve performance 
        by minimizing direct DOM manipulations. It updates only the parts of the UI that change, resulting 
        in a smoother user experience.</li><br />
      <li><strong>Declarative Syntax:</strong> React's declarative approach allows developers to describe what 
        the UI should look like at any given point in time, making code easier to read and debug.</li>
    </ul>

    <p><strong>Ecosystem:</strong> React has a rich ecosystem, including tools like React Router for routing 
      and Redux for state management, which enhance its capabilities for building complex applications.</p><br />

    <h3>2. Angular</h3>

    <p style={{paddingBottom:"6px"}}><strong>Overview:</strong> Angular is a comprehensive front-end framework developed by Google for 
      building dynamic web applications. It is a complete solution that provides tools and features to develop robust applications.</p>

    <h4 style={{paddingBottom:"6px"}}>Key Features:</h4>
    <ul>
      <li><strong>Two-Way Data Binding:</strong> Angular’s two-way data binding synchronizes data between the 
        model and the view, allowing for automatic updates when either changes. This simplifies the development process.</li><br />
      <li><strong>Dependency Injection:</strong> Angular’s dependency injection system helps manage service 
        dependencies efficiently, promoting modular and testable code.</li><br />
      <li><strong>TypeScript:</strong> Angular is built with TypeScript, providing static typing and other 
        advanced features that improve code quality and maintainability.</li>
    </ul>

    <p><strong>Ecosystem:</strong> Angular comes with built-in features such as routing, forms management, 
      and HTTP client modules, making it a robust choice for enterprise-level applications.</p><br />

    <h3>3. Vue.js</h3>

    <p style={{paddingBottom:"6px"}}><strong>Overview:</strong> Vue.js is a progressive JavaScript framework for building user interfaces. 
      It is designed to be incrementally adoptable, allowing developers to integrate it into existing projects easily.</p>

    <h4 style={{paddingBottom:"6px"}}>Key Features:</h4>
    <ul>
      <li><strong>Reactive Data Binding:</strong> Vue's reactivity system ensures that changes to the model 
        are automatically reflected in the view, simplifying the development of interactive applications.</li><br />
      <li><strong>Single-File Components:</strong> Vue encourages the use of single-file components (SFCs), 
        which bundle HTML, CSS, and JavaScript into a single file, promoting modularity and easier maintenance.</li><br />
      <li><strong>Flexibility:</strong> Vue can be used for both small projects and large-scale applications, 
        making it a versatile choice for developers with varying needs.</li>
    </ul>

    <p><strong>Ecosystem:</strong> Vue has a growing ecosystem, including Vue Router for navigation and 
      Vuex for state management, which enhance its functionality for complex applications.</p><br />

    <h2>Conclusion</h2>

    <p>
      Choosing the right JavaScript framework or library depends on the specific needs of a project, 
      team preferences, and application requirements.
    </p>

    <ul>
      <li><strong>React:</strong> Ideal for developers looking for flexibility and a component-based architecture.</li><br />
      <li><strong>Angular:</strong> Suited for larger, more complex applications requiring a full-featured framework.</li><br />
      <li><strong>Vue.js:</strong> Offers a balance of ease of use and power, making it accessible for beginners while still robust for advanced users.</li>
    </ul><br />

    <p>
      By leveraging these frameworks and libraries, developers can create modern, interactive web 
      applications that meet today’s user expectations.
    </p>

 \
  </div>
)}


{selectedChapter === 'chapter89' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Frontend Tooling (Webpack, Babel)</h1>

   

    <p >
      Frontend tooling has become a cornerstone of modern web development, enabling developers to build, bundle, and optimize applications efficiently. Two of the most essential tools in this ecosystem are <strong>Webpack</strong> and <strong>Babel</strong>.
    </p><br />

    <h3>1. Webpack</h3>

    <p style={{paddingBottom:"6px"}}><strong>Overview:</strong> Webpack is a powerful module bundler for JavaScript applications. It takes modules with dependencies and generates static assets representing those modules. By bundling resources, Webpack allows developers to manage complex application structures and optimize the delivery of assets.</p>

    <h4>Key Features:</h4>
    <ul>
      <li><strong>Module Bundling:</strong> Webpack treats every file (JavaScript, CSS, images, etc.) as a module, allowing developers to import and export dependencies seamlessly. This reduces the number of HTTP requests, improving load times.</li><br />
      <li><strong>Code Splitting:</strong> Webpack enables code splitting, allowing developers to split their code into smaller chunks that can be loaded on demand. This results in faster initial load times and improved performance.</li><br />
      <li><strong>Loaders:</strong> Loaders allow Webpack to preprocess files before bundling. For example, you can use loaders to transpile ES6/ES7 code to ES5, convert Sass to CSS, or load images. This extensibility makes Webpack highly configurable for various project needs.</li><br />
      <li><strong>Plugins:</strong> Webpack’s plugin system provides additional functionality, such as minification, optimization, and asset management. Popular plugins include <code>HtmlWebpackPlugin</code> for generating HTML files and <code>MiniCssExtractPlugin</code> for extracting CSS into separate files.</li>
    </ul>

    <p><strong>Use Cases:</strong> Webpack is ideal for complex applications with multiple assets and dependencies, particularly Single Page Applications (SPAs) where performance and load times are critical.</p><br />

    <h3>2. Babel</h3>

    <p style={{paddingBottom:"6px"}}><strong>Overview:</strong> Babel is a JavaScript compiler that allows developers to use the latest JavaScript features without worrying about browser compatibility. It converts modern JavaScript (ES6+) code into a version that can run in older browsers.</p>

    <h4 style={{paddingBottom:"6px"}}>Key Features:</h4>
    <ul>
      <li><strong>Transpilation:</strong> Babel transforms modern JavaScript syntax into backward-compatible versions. For instance, it can convert arrow functions, template literals, and classes into ES5, ensuring broader browser support.</li><br />
      <li><strong>Polyfills:</strong> Babel can automatically include polyfills for new JavaScript features that are not natively supported in certain environments, such as Promises or <code>Array.prototype.includes</code>.</li><br />
      <li><strong>Plugins and Presets:</strong> Babel's functionality can be extended through plugins and presets, which define specific transformations. Popular presets include <code>@babel/preset-env</code> for targeting specific browser environments and <code>@babel/preset-react</code> for compiling React JSX syntax.</li>
    </ul>

    <p><strong>Use Cases:</strong> Babel is essential for projects that require the use of modern JavaScript features while maintaining compatibility with a wide range of browsers. It is often used in conjunction with build tools like Webpack for seamless integration.</p><br />

    <h2>Conclusion</h2>

    <p>
      In modern web development, <strong>Webpack</strong> and <strong>Babel</strong> play crucial roles in streamlining the development process and ensuring that applications are optimized for performance and compatibility. Webpack’s robust bundling capabilities, combined with Babel’s ability to transpile modern JavaScript, empower developers to create efficient and cutting-edge web applications.
    </p>

    <p>
      This overview provides a concise yet comprehensive understanding of Webpack and Babel, highlighting their significance and functionality within modern JavaScript development.
    </p>
  </div>
)}


{selectedChapter === 'chapter90' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>TypeScript</h1>

    <p>
      <strong>TypeScript</strong> is a superset of JavaScript that adds static typing to the language. Developed and maintained by Microsoft, TypeScript was designed to enhance the development experience by providing features that improve code quality, maintainability, and collaboration among developers. It compiles down to plain JavaScript, ensuring compatibility with any browser or JavaScript engine.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Key Features of TypeScript:</h3>

    <ol>
      <li>
        <strong>Static Typing:</strong>
        <p>
          TypeScript introduces optional static typing, allowing developers to define data types for variables, function parameters, and return values. This helps catch errors at compile time rather than at runtime, reducing the likelihood of bugs and enhancing code reliability.
        </p>
      </li><br />
      <li>
        <strong>Enhanced IDE Support:</strong>
        <p>
          TypeScript offers improved autocompletion, navigation, and refactoring capabilities in IDEs and text editors. This results in a more productive development experience, as developers can leverage better tooling to understand code structure and behavior.
        </p>
      </li><br />
      <li>
        <strong>Interfaces and Type Aliases:</strong>
        <p>
          TypeScript allows the creation of interfaces and type aliases, enabling developers to define custom types that can represent complex data structures. This promotes better organization of code and clearer communication of expected data shapes.
        </p>
      </li><br />
      <li>
        <strong>Modern JavaScript Features:</strong>
        <p>
          TypeScript supports the latest JavaScript features (like async/await, destructuring, and spread operators) and provides backward compatibility. Developers can use new features without worrying about browser support, as TypeScript compiles them down to older JavaScript versions.
        </p>
      </li><br />
      <li>
        <strong>Namespace and Module Support:</strong>
        <p>
          TypeScript provides robust support for modules and namespaces, making it easier to organize and structure large codebases. This modular approach enhances code reusability and maintainability.
        </p>
      </li><br />
      <li>
        <strong>Type Inference:</strong>
        <p>
          TypeScript can automatically infer types based on the values assigned to variables. This reduces the need for explicit type annotations while still maintaining the benefits of static typing.
        </p>
      </li>
    </ol><br />

    <h3 style={{paddingBottom:"6px"}}>Advantages of Using TypeScript:</h3>
    <ul>
      <li>
        <strong>Early Error Detection:</strong> By catching type-related errors at compile time, TypeScript reduces runtime errors and improves overall code quality.
      </li><br />
      <li>
        <strong>Better Documentation:</strong> The type system serves as a form of documentation, making it easier for developers to understand how to use functions and APIs.
      </li><br />
      <li>
        <strong>Improved Code Refactoring:</strong> TypeScript's static type system facilitates safer and more straightforward refactoring, as developers can identify affected parts of the codebase when making changes.
      </li><br />
      <li>
        <strong>Large Community and Ecosystem:</strong> TypeScript has gained significant adoption and has a large community. Many popular frameworks, such as Angular and React, provide official TypeScript support.
      </li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Use Cases for TypeScript:</h3>
    <ul>
      <li><strong>Large Codebases:</strong> TypeScript is especially beneficial for large projects where maintaining code quality and structure is crucial.</li><br />
      <li><strong>Collaborative Development:</strong> In teams with multiple developers, TypeScript helps enforce consistent coding standards and improves communication through clear type definitions.</li><br />
      <li><strong>Framework Development:</strong> Many modern JavaScript frameworks support TypeScript, making it easier to develop robust applications with strong typing.</li>
    </ul><br />

    <h2>Conclusion</h2>
    <p>
      TypeScript is a powerful tool in modern web development that enhances JavaScript by providing static typing and improved tooling. By integrating TypeScript into their workflows, developers can create more reliable, maintainable, and scalable applications, meeting the demands of today’s complex software environments. As the popularity of TypeScript continues to grow, it is becoming an essential skill for web developers aiming to improve their development practices.
    </p>
  </div>
)}

{selectedChapter === 'chapter91' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Unit Testing with Jasmine or Mocha</h1>

   

    <p >
      <strong>Unit testing</strong> is a software testing technique that involves testing individual components or functions of a program in isolation from the rest of the application. The primary goal of unit testing is to validate that each unit of the software performs as expected. In JavaScript development, unit testing is crucial for ensuring code quality, facilitating refactoring, and enabling developers to catch bugs early in the development process.
    </p>

    <p>
      Two of the most popular testing frameworks in the JavaScript ecosystem are <strong>Jasmine</strong> and <strong>Mocha</strong>. Both provide tools and functionalities to write and execute unit tests effectively.
    </p><br />

    <h3>1. Jasmine</h3>

    <p style={{paddingBottom:"6px"}}>
      <strong>Overview</strong>: Jasmine is a behavior-driven development (BDD) testing framework for JavaScript. It provides a simple syntax for writing tests and focuses on making the tests readable and easy to understand.
    </p>

    <h4 style={{paddingBottom:"6px"}}>Key Features:</h4>
    <ul>
      <li><strong>Descriptive Syntax</strong>: Jasmine uses a natural language syntax that makes tests easy to read and understand. Developers can write specifications using <code>describe</code> and <code>it</code> blocks to outline what is being tested and the expected behavior.</li><br />
      <li><strong>No Dependencies</strong>: Jasmine does not require a DOM, which makes it suitable for testing JavaScript code in various environments, including Node.js and browsers.</li><br />
      <li><strong>Matchers</strong>: Jasmine provides a rich set of matchers (like <code>toBe</code>, <code>toEqual</code>, <code>toContain</code>, etc.) to make assertions in tests clear and expressive.</li><br />
      <li><strong>Spies</strong>: Jasmine has built-in support for creating spies, allowing developers to track function calls, arguments, and returned values, making it easier to test interactions between components.</li>
    </ul><br />

    <p>
      <strong>Use Cases</strong>: Jasmine is ideal for developers looking for a straightforward, BDD-style framework to write and manage unit tests, especially for projects that require easy-to-read specifications.
    </p><br />

    <h3>2. Mocha</h3>

    <p>
      <strong>Overview</strong>: Mocha is a flexible and feature-rich JavaScript testing framework that supports both BDD and TDD (test-driven development) styles. It is widely used for unit testing in Node.js and browser applications.
    </p>

    <h4 style={{paddingBottom:"6px"}}>Key Features:</h4>
    <ul>
      <li><strong>Flexible Structure</strong>: Mocha allows developers to structure tests in various ways, supporting different testing styles (BDD, TDD, etc.) using <code>describe</code>, <code>context</code>, <code>it</code>, and <code>test</code> functions.</li><br />
      <li><strong>Asynchronous Testing</strong>: Mocha provides built-in support for asynchronous tests, enabling developers to handle callbacks and promises effectively.</li><br />
      <li><strong>Reporting</strong>: Mocha offers various reporting formats to provide insights into test results, making it easy to integrate with CI/CD pipelines.</li><br />
      <li><strong>Integration with Other Libraries</strong>: Mocha can be easily integrated with other assertion libraries (like Chai) and mocking libraries, enhancing its functionality and allowing developers to choose their preferred tools.</li>
    </ul><br />

    <p>
      <strong>Use Cases</strong>: Mocha is suitable for projects of any size, especially when developers need flexibility in structuring tests or when working in environments that require asynchronous testing.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Advantages of Unit Testing with Jasmine and Mocha</h3>
    <ul>
      <li><strong>Early Bug Detection</strong>: Unit tests help identify bugs and issues at an early stage of development, reducing the cost and effort required for debugging later.</li><br />
      <li><strong>Improved Code Quality</strong>: Writing tests encourages developers to write cleaner, more modular code, leading to better software design.</li><br />
      <li><strong>Simplified Refactoring</strong>: With a solid suite of unit tests, developers can refactor code with confidence, knowing that tests will catch any regressions.</li><br />
      <li><strong>Documentation</strong>: Well-written tests serve as documentation for how a function or component is expected to behave, making it easier for other developers to understand the code.</li>
    </ul><br />

    <h3>Conclusion</h3>

    <p>
      Unit testing is an essential practice in modern JavaScript development that helps ensure the reliability and quality of code. Frameworks like <strong>Jasmine</strong> and <strong>Mocha</strong> provide developers with the tools they need to write effective unit tests, facilitating better software design and reducing the likelihood of bugs. By incorporating unit testing into their workflows, developers can enhance their productivity and deliver higher-quality applications.
    </p>
  </div>
)}



{selectedChapter === 'chapter92' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Integration Testing</h1>

    <p>
      <strong>Integration testing</strong> is a critical phase in the software testing lifecycle that focuses on verifying the interaction between different modules or components of an application. Unlike unit testing, which tests individual units of code in isolation, integration testing evaluates how various parts of a system work together as a cohesive whole. In JavaScript development, integration testing ensures that multiple components, APIs, and services function correctly when integrated.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Key Objectives of Integration Testing:</h3>
    <ol>
      <li>
        <strong>Detecting Interface Issues:</strong> Integration testing aims to identify problems that may arise at the boundaries between integrated components, such as mismatched data types, incorrect data formats, or communication failures.
      </li><br />
      <li>
        <strong>Validating Data Flow:</strong> It checks whether data flows correctly between different modules and that each module processes the data as expected.
      </li><br />
      <li>
        <strong>Testing Dependencies:</strong> Integration testing ensures that external dependencies (like databases, APIs, or third-party libraries) work as intended when called by the components of the application.
      </li><br />
      <li>
        <strong>End-to-End Scenarios:</strong> Integration tests often simulate real-world use cases by running multiple components together, providing insights into how the system behaves in a production-like environment.
      </li>
    </ol><br />

    <h3 style={{paddingBottom:"6px"}}>Common Approaches to Integration Testing:</h3>
    <ul>
      <li>
        <strong>Big Bang Integration Testing:</strong> All components are integrated at once, and the entire system is tested together. While this approach can be quick to set up, it often makes it challenging to isolate issues since multiple components are tested simultaneously.
      </li><br />
      <li>
        <strong>Incremental Integration Testing:</strong> Components are integrated and tested one at a time or in small groups. This approach can be either top-down (starting from the top-level modules and integrating downwards) or bottom-up (starting from the lower-level modules and integrating upwards). Incremental testing makes it easier to identify the source of errors.
      </li><br />
      <li>
        <strong>Contract Testing:</strong> This method focuses on the interactions between services or APIs. By defining contracts that specify the expected behavior of services, developers can ensure that different components adhere to these contracts during integration testing.
      </li>
    </ul><br />

    <h3>Tools for Integration Testing in JavaScript:</h3>
    <ul>
      <li>
        <strong>Jest:</strong> A widely used testing framework that supports integration testing alongside unit testing. Jest provides features like snapshot testing and built-in mocking, making it suitable for testing React applications and other JavaScript frameworks.
      </li><br />
      <li>
        <strong>Mocha:</strong> A flexible testing framework that can be used for integration tests. Mocha supports various assertion libraries and can handle asynchronous testing, making it versatile for different testing scenarios.
      </li><br />
      <li>
        <strong>Supertest:</strong> A library for testing HTTP servers in Node.js. Supertest works well with Mocha and Jest to perform integration tests on REST APIs, ensuring that endpoints function correctly when called with valid and invalid requests.
      </li><br />
      <li>
        <strong>Cypress:</strong> Primarily an end-to-end testing tool, Cypress can also be used for integration testing. It provides a user-friendly interface and allows developers to write tests that simulate user interactions with the application.
      </li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Advantages of Integration Testing:</h3>
    <ul>
      <li>
        <strong>Early Detection of Issues:</strong> Integration testing helps identify problems early in the development process, reducing the likelihood of bugs in production.
      </li><br />
      <li>
        <strong>Improved Reliability:</strong> By testing how components interact, integration testing enhances the reliability and stability of the application as a whole.
      </li><br />
      <li>
        <strong>Documentation of Interfaces:</strong> Integration tests serve as documentation for the interactions between components, helping developers understand how different parts of the system work together.
      </li><br />
      <li>
        <strong>Facilitates Refactoring:</strong> With a solid suite of integration tests, developers can refactor components with confidence, knowing that they will be alerted to any issues arising from changes in module interactions.
      </li>
    </ul><br />

    <h2>Conclusion</h2>
    <p>
      Integration testing is an essential practice in modern JavaScript development that ensures the seamless interaction between various components of an application. By validating that integrated modules function correctly together, developers can enhance the quality and reliability of their software. Utilizing frameworks and tools tailored for integration testing allows teams to build robust applications that meet user expectations and withstand real-world usage scenarios.
    </p>
  </div>
)}


{selectedChapter === 'chapter93' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Test-Driven Development (TDD) Concepts</h1>


    <p>
      <strong>Test-Driven Development (TDD)</strong> is a software development approach that emphasizes writing tests before the actual code. It revolves around a repetitive cycle of writing a failing test, implementing the minimum code necessary to pass the test, and then refactoring the code for optimization and readability. This methodology is particularly beneficial in modern JavaScript development, where maintaining code quality and ensuring functionality is crucial.
    </p><br />

    <h3>The TDD Cycle</h3>

    <ol>
      <li>
        <strong>Write a Failing Test</strong>: Begin by writing a test that defines a function or feature that is expected to behave in a certain way. This test should initially fail because the functionality has not yet been implemented.
      </li><br />
      <li>
        <strong>Write the Minimum Code to Pass the Test</strong>: Implement the simplest solution that allows the test to pass. This encourages developers to focus on what is necessary to meet the requirements without overcomplicating the solution.
      </li><br />
      <li>
        <strong>Run the Tests</strong>: Execute the tests to confirm that the new test passes and that previously passing tests still work as expected.
      </li><br />
      <li>
        <strong>Refactor the Code</strong>: After achieving a passing test, refactor the code to improve its structure and readability while ensuring that functionality remains intact. This step is crucial for maintaining clean and maintainable code.
      </li><br />
      <li>
        <strong>Repeat</strong>: Continue this cycle by adding more tests for additional features or edge cases, thereby incrementally building the application.
      </li>
    </ol><br />

    <h3 style={{paddingBottom:"6px"}}>Key Benefits of TDD</h3>

    <ul>
      <li><strong>Improved Code Quality</strong>: Writing tests first encourages developers to think through the design and requirements of their code, leading to cleaner, more organized implementations.</li><br />
      <li><strong>Early Bug Detection</strong>: TDD facilitates early identification of bugs by ensuring that tests are written for all new features, which reduces the likelihood of issues in production.</li><br />
      <li><strong>Enhanced Confidence</strong>: With a robust suite of tests, developers can refactor code with confidence, knowing that any regressions will be caught by existing tests.</li><br />
      <li><strong>Better Documentation</strong>: The tests serve as living documentation, clearly outlining the intended behavior of code and helping other developers understand how different components interact.</li>
    </ul><br />

    <h3>TDD in JavaScript Development</h3>

    <p>
      In the context of JavaScript, TDD can be implemented using various testing frameworks and tools. Some popular choices include:
    </p>
    
    <ul>
      <li><strong>Jest</strong>: A comprehensive testing framework that supports TDD and provides features like mocking, snapshot testing, and built-in assertions.</li><br />
      <li><strong>Mocha</strong>: A flexible testing framework that supports both BDD and TDD styles, making it suitable for various testing approaches.</li><br />
      <li><strong>Chai</strong>: An assertion library that can be used alongside Mocha to provide a rich set of assertions for more expressive tests.</li><br />
      <li><strong>Supertest</strong>: Useful for testing HTTP servers and APIs, allowing developers to ensure their endpoints behave as expected.</li>
    </ul><br />

    <h3>TDD Workflow Example</h3>

    <p>Here’s a simple example illustrating the TDD workflow in a JavaScript context:</p>

    <ol>
      <li>
        <strong>Write a Failing Test</strong>:
        <pre>
          <code>{`
          test('adds 1 + 2 to equal 3', () => {
              expect(add(1, 2)).toBe(3);
          });
`}</code>
        </pre>
      </li><br />
      <li>
        <strong>Write the Minimum Code</strong>:
        <pre>
          <code>{`
          function add(a, b) {
              return a + b; // Minimum code to pass the test
          }
           `} </code>
        </pre>
      </li><br />
      <li>
        <strong>Run the Tests</strong>: All tests pass, confirming the function works as intended.
      </li><br />
      <li>
        <strong>Refactor if Necessary</strong>: Optimize the <code>add</code> function if needed (in this case, it might already be optimal).
      </li><br />
      <li>
        <strong>Add More Tests</strong>: Write additional tests for edge cases or new features, repeating the cycle.
      </li>
    </ol><br />

    <h3>Conclusion</h3>

    <p>
      Test-Driven Development is a powerful methodology that fosters high-quality, maintainable code in JavaScript applications. By adhering to the TDD principles, developers can create robust software that meets requirements and is resilient to change. As the development landscape evolves, TDD remains a crucial practice for modern web development, empowering teams to deliver reliable applications.
    </p>


  </div>
)}



{selectedChapter === 'chapter94' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Currying and Partial Application</h1>


    <p>
      <strong>Currying</strong> and <strong>partial application</strong> are advanced techniques in functional programming that enable more flexible function invocation and code reuse. They are particularly useful in JavaScript, where functions are first-class citizens.
    </p><br />


    <h3>Currying</h3>

    <p>
      <strong>Currying</strong> is a technique where a function is transformed into a sequence of functions, each taking a single argument. Instead of accepting multiple arguments at once, a curried function takes one argument and returns another function that takes the next argument, and so on, until all arguments have been provided.
    </p>

    <h4>Example of Currying:</h4>

    <pre>
      <code>
        {`function curry(fn) {
    return function curried(...args) {
        if (args.length >= fn.length) {
            return fn(...args); // If enough arguments, call the original function
        }
        return function(...args2) {
            return curried(...args, ...args2); // Return a new function that collects more arguments
        };
    };
}

// Usage
function multiply(a, b) {
    return a * b;
}

const curriedMultiply = curry(multiply);

console.log(curriedMultiply(2)(3)); // Output: 6
console.log(curriedMultiply(2, 3)); // Output: 6`}
      </code>
    </pre>

    <p>
      In the example above, <code>curry</code> takes a function <code>fn</code> and returns a new function <code>curried</code>. The <code>curried</code> function checks if the number of arguments collected is sufficient to invoke <code>fn</code>. If so, it calls <code>fn</code> with the collected arguments. Otherwise, it returns a new function to collect more arguments.
    </p><br />

    <h3>Partial Application</h3>

    <p style={{paddingBottom:"6px"}}>
      <strong>Partial application</strong> is a similar concept but slightly different. It refers to the process of fixing a number of arguments to a function, producing another function of lesser arity (number of arguments). This means you can create a new function by pre-filling some arguments of an existing function, allowing you to call it later with the remaining arguments.
    </p>

    <h4>Example of Partial Application:</h4>

    <pre>
      <code>
        {`function partial(fn, ...fixedArgs) {
    return function(...args) {
        return fn(...fixedArgs, ...args);
    };
}

// Usage
function greet(greeting, name) {
    return \`\${greeting}, \${name}!\`;
}

const greetHello = partial(greet, "Hello");

console.log(greetHello("Alice")); // Output: "Hello, Alice!"
console.log(greetHello("Bob"));   // Output: "Hello, Bob!"`}
      </code>
    </pre>

    <p>
      In this example, <code>partial</code> takes a function <code>fn</code> and some fixed arguments. It returns a new function that can be called later with additional arguments, which will be combined with the fixed arguments when calling <code>fn</code>.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>Key Differences</h3>
    <ul>
      <li>
        <strong>Currying</strong> transforms a function with multiple arguments into a chain of functions that each take one argument, while <strong>partial application</strong> allows you to fix a certain number of arguments and return a new function that takes the remaining arguments.
      </li><br />
      <li>
        Currying is about creating a series of unary functions (functions taking one argument), whereas partial application allows for multiple arguments to be pre-filled.
      </li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Benefits of Currying and Partial Application</h3>
    <ol>
      <li><strong>Improved Code Reusability:</strong> Both techniques allow developers to create more flexible and reusable functions.</li><br />
      <li><strong>Simplified Function Calls:</strong> They can simplify complex function calls by breaking them down into smaller, more manageable functions.</li><br />
      <li><strong>Enhanced Readability:</strong> By using descriptive names for curried or partially applied functions, code can become clearer and more self-explanatory.</li><br />
      <li><strong>Facilitates Functional Composition:</strong> Currying and partial application work well with other functional programming techniques, such as function composition.</li>
    </ol><br />

    <p>
      In summary, currying and partial application are powerful tools in JavaScript that promote functional programming principles, enabling developers to write cleaner and more maintainable code.
    </p>
  </div>
)}


{selectedChapter === 'chapter95' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Memoization</h1>

    <p>
      <strong>Memoization</strong> is an optimization technique used primarily in computing to speed up the execution of functions by caching the results of expensive function calls and returning the cached result when the same inputs occur again. This technique is particularly useful in situations where a function is called repeatedly with the same arguments, making it a popular choice in performance-sensitive applications.
    </p><br />

    <h3 style={{paddingBottom:"6px"}}>How Memoization Works</h3>
    <ol>
      <li>The function checks if the result for the given input already exists in its cache.</li><br />
      <li>If it exists, the cached result is returned immediately.</li><br />
      <li>If not, the function executes the original function with the provided arguments, stores the result in the cache, and then returns the result.</li>
    </ol><br />

    <h3>Example of Memoization</h3>
    <pre>
      <code>
{`function memoize(fn) {
    const cache = new Map();

    return function(...args) {
        const key = JSON.stringify(args); // Create a cache key from the arguments

        if (cache.has(key)) {
            console.log('Fetching from cache:', key);
            return cache.get(key); // Return cached result if it exists
        }

        console.log('Calculating result for:', key);
        const result = fn(...args); // Call the original function
        cache.set(key, result); // Store the result in cache
        return result;
    };
}

// Example usage
function fibonacci(n) {
    if (n <= 1) return n;
    return fibonacci(n - 1) + fibonacci(n - 2);
}

const memoizedFibonacci = memoize(fibonacci);

console.log(memoizedFibonacci(10)); // Calculating result for: [10]
console.log(memoizedFibonacci(10)); // Fetching from cache: [10]
console.log(memoizedFibonacci(5));  // Calculating result for: [5]`}
      </code>
    </pre><br />

    <h3 style={{paddingBottom:"6px"}}>Explanation of the Example</h3>
    <ul>
      <li><strong>`memoize(fn)`</strong>: This function takes a function <code>fn</code> as an argument and returns a new function that wraps the original function with caching logic.</li><br />
      <li><strong>Cache Structure</strong>: A <code>Map</code> is used to store previously computed results, where the keys are serialized arguments.</li><br />
      <li><strong>Check Cache</strong>: Before executing the function, it checks if the result for the given input exists in the cache.</li><br />
      <li><strong>Store Result</strong>: If the function is called with new arguments, it computes the result, stores it in the cache, and returns it.</li>
    </ul><br />

    <h3 style={{paddingBottom:"6px"}}>Benefits of Memoization</h3>
    <ol>
      <li><strong>Performance Improvement</strong>: By avoiding redundant calculations, memoization can significantly reduce the time complexity of functions that have repeated calls with the same arguments.</li><br />
      <li><strong>Resource Optimization</strong>: It helps optimize resource usage by preventing unnecessary computations, which is particularly useful in recursive functions or functions that perform expensive operations.</li><br />
      <li><strong>Simplified Logic</strong>: Memoization can help simplify the logic in applications that rely on repetitive calculations, making the code easier to understand.</li>
    </ol><br />

    <h3 style={{paddingBottom:"6px"}}>Key Considerations</h3>
    <ul>
      <li><strong>Memory Consumption</strong>: Memoization increases memory usage due to the storage of cached results. This trade-off is important to consider, especially in long-running applications.</li><br />
      <li><strong>Cache Invalidation</strong>: The cache may grow indefinitely if not managed properly. In some scenarios, it may be necessary to implement a strategy for cache invalidation or eviction.</li><br />
      <li><strong>Non-primitive Arguments</strong>: The example above uses JSON serialization for caching, which works for primitive values. Handling non-primitive values (like objects) may require additional considerations.</li>
    </ul><br />

    <p>
      In summary, memoization is a powerful optimization technique in JavaScript that can lead to significant performance improvements, especially in scenarios involving repetitive calculations or recursive functions. It is widely used in various applications, particularly in areas like algorithm optimization, React component rendering, and dynamic programming.
    </p>
  </div>
)}


{selectedChapter === 'chapter96' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Event Loop and Concurrency Model</h1>

    <p>
      In JavaScript, understanding the <strong>event loop</strong> and the <strong>concurrency model</strong> is crucial for writing efficient and non-blocking code. These concepts are foundational for managing asynchronous operations, especially in web development.
    </p><br />

    <h3>Event Loop</h3>

    <p style={{paddingBottom:"6px"}}>
      The <strong>event loop</strong> is a fundamental mechanism that allows JavaScript to perform non-blocking I/O operations despite being single-threaded. It continuously checks for messages in the message queue and processes them, allowing the execution of code, collecting and processing events, and executing queued sub-tasks.
    </p>

    <h4 style={{paddingBottom:"6px"}}>How the Event Loop Works</h4>
    <ol>
      <li>
        <strong>Call Stack</strong>: JavaScript uses a call stack to manage function execution. When a function is invoked, it gets pushed onto the stack. Once the function completes, it is popped off the stack.
      </li><br />
      <li>
        <strong>Web APIs</strong>: When asynchronous operations like timers, HTTP requests, or DOM events are initiated, they are handled by the browser's Web APIs (or Node.js APIs). Once the operation completes, the callback function is queued in the message queue.
      </li><br />
      <li>
        <strong>Message Queue</strong>: The event loop constantly checks the call stack. If the stack is empty, it dequeues the first function from the message queue and pushes it onto the stack for execution.
      </li><br />
      <li>
        <strong>Execution Order</strong>: The event loop ensures that all synchronous code runs first. Only when the call stack is empty will it process asynchronous callbacks.
      </li>
    </ol><br />

    <h4>Example of Event Loop in Action</h4>
    <pre style={{paddingBottom:"6px"}}>
      <code>
{`console.log("Start"); // Synchronous operation

setTimeout(() => {
  console.log("Timeout callback"); // Asynchronous operation
}, 0);

Promise.resolve().then(() => {
  console.log("Promise callback"); // Asynchronous operation
});

console.log("End"); // Synchronous operation`}
      </code>
    </pre>

    <h5>Output:</h5>
    <pre>
      <code>
{`Start
End
Promise callback
Timeout callback`}
      </code>
    </pre>

    <p>
      In this example:
      <ul>
        <li><strong>"Start"</strong> and <strong>"End"</strong> are logged first because they are synchronous.</li><br />
        <li>The promise callback is logged before the timeout callback because it has a higher priority in the event loop.</li>
      </ul>
    </p><br />

    <h3>Concurrency Model</h3>

    <p style={{paddingBottom:"6px"}}>
      The <strong>concurrency model</strong> in JavaScript refers to how JavaScript handles multiple operations at once. Although JavaScript is single-threaded, it can handle concurrency through its event-driven nature and non-blocking I/O.
    </p>

    <h4 style={{paddingBottom:"6px"}}>Key Aspects of the Concurrency Model</h4>
    <ol>
      <li>
        <strong>Single Threaded</strong>: JavaScript executes code on a single thread, meaning it can only do one thing at a time. This design prevents issues like race conditions that are common in multi-threaded environments.
      </li><br />
      <li>
        <strong>Non-blocking I/O</strong>: By leveraging the event loop and callback functions, JavaScript can handle I/O operations without blocking the main thread. This allows other code to execute while waiting for an I/O operation to complete.
      </li><br />
      <li>
        <strong>Asynchronous Programming</strong>: JavaScript encourages asynchronous programming through callbacks, promises, and async/await syntax. This approach allows developers to write code that can handle long-running operations efficiently without freezing the user interface.
      </li>
    </ol><br />

    <h4>Example of Concurrency Model in Action</h4>
    <pre style={{paddingBottom:"6px"}}>
      <code>
{`console.log("Task 1");

setTimeout(() => {
  console.log("Task 2"); // Asynchronous operation
}, 1000);

console.log("Task 3");

// Task 1 and Task 3 will log immediately
// Task 2 will log after 1 second`}
      </code>
    </pre>

    <h5>Output:</h5>
    <pre>
      <code>
{`Task 1
Task 3
Task 2`}
      </code>
    </pre>

    <p>
      In this example:
      <ul>
        <li><strong>"Task 1"</strong> and <strong>"Task 3"</strong> are logged immediately.</li><br />
        <li><strong>"Task 2"</strong> is scheduled to run after 1 second but does not block the execution of <strong>"Task 3."</strong></li>
      </ul>
    </p><br />

    <h3>Conclusion</h3>

    <p>
      The event loop and concurrency model are essential to understanding how JavaScript handles asynchronous operations. They enable developers to write non-blocking code that can efficiently manage multiple tasks, leading to responsive applications. By leveraging these concepts, you can create applications that perform well even under heavy workloads.
    </p>
  </div>
)}


{selectedChapter === 'chapter97' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>JavaScript Engines (V8, SpiderMonkey)</h1>


    <p>
      JavaScript engines are critical components that interpret and execute JavaScript code. Each engine is designed to optimize performance, manage memory, and provide features specific to the runtime environment. Two of the most prominent JavaScript engines are <strong>V8</strong> and <strong>SpiderMonkey</strong>.
    </p><br />

    <h3>V8</h3>
    <p style={{paddingBottom:"6px"}}>
      <strong>Overview:</strong> Developed by Google, V8 is the JavaScript engine used in the Google Chrome browser and Node.js. It is designed for high performance and executes JavaScript code directly in the browser.
    </p>
    <h4 style={{paddingBottom:"6px"}}>Key Features:</h4>
    <ul>
      <li><strong>Just-In-Time (JIT) Compilation:</strong> V8 compiles JavaScript to native machine code at runtime, allowing for faster execution compared to interpreting code line by line.</li><br />
      <li><strong>Garbage Collection:</strong> V8 includes an efficient garbage collector that automatically manages memory, reclaiming unused memory to prevent leaks.</li><br />
      <li><strong>Optimizations:</strong> The engine employs several optimization techniques, such as inline caching and hidden classes, to speed up frequently executed code paths.</li><br />
      <li><strong>ECMAScript Compliance:</strong> V8 implements the ECMAScript specification, ensuring compatibility with modern JavaScript features.</li>
    </ul><br />
    <p>
      <strong>Use Cases:</strong> Beyond web browsers, V8 is used in various applications, including server-side environments (like Node.js), embedded systems, and desktop applications through frameworks like Electron.
    </p><br />

    <h3>SpiderMonkey</h3>
    <p style={{paddingBottom:"6px"}}>
      <strong>Overview:</strong> SpiderMonkey is the JavaScript engine developed by Mozilla for use in Firefox and other projects. It is the first JavaScript engine ever created and continues to evolve with modern JavaScript standards.
    </p>
    <h4 style={{paddingBottom:"6px"}}>Key Features:</h4>
    <ul>
      <li><strong>Just-In-Time (JIT) Compilation:</strong> Similar to V8, SpiderMonkey uses JIT compilation to convert JavaScript code into optimized machine code for improved execution speed.</li><br />
      <li><strong>Garbage Collection:</strong> It also features a garbage collector that effectively manages memory, preventing leaks and optimizing performance.</li><br />
      <li><strong>Support for New JavaScript Features:</strong> SpiderMonkey frequently updates to support the latest ECMAScript standards, including features like async/await, generators, and more.</li><br />
      <li><strong>Debugging and Profiling:</strong> SpiderMonkey offers extensive debugging and profiling tools, making it a favorite for developers who need to analyze performance and optimize code.</li>
    </ul><br />
    <p>
      <strong>Use Cases:</strong> In addition to being used in Firefox, SpiderMonkey is utilized in various Mozilla projects and is sometimes embedded in other applications requiring JavaScript support.
    </p><br />

    <h2>Conclusion</h2>
    <p>
      Both V8 and SpiderMonkey are powerful JavaScript engines that significantly enhance the performance and efficiency of executing JavaScript code in web browsers and server environments. Their advanced features, including JIT compilation and garbage collection, ensure that developers can create high-performance applications that leverage the full potential of modern JavaScript. Understanding these engines is crucial for optimizing code and leveraging the latest features of the language.
    </p>
  </div>
)}


{selectedChapter === 'chapter98' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Web Workers</h1>

    <p>
      Web Workers allow you to run scripts in the background, separate from the main execution thread of a web application. This enables you to perform tasks without interrupting the user interface.
    </p><br />

    <h2>Worker Script (worker.js)</h2>

    <pre>
      {`// Listen for messages from the main script
onmessage = function(event) {
    console.log('Message from main thread:', event.data);
    
    // Perform some computation or task
    const result = computeExpensiveOperation(event.data);
    
    // Send the result back to the main thread
    postMessage(\`Worker completed task: \${result}\`);
};

// Example function to simulate an expensive operation
function computeExpensiveOperation(input) {
    // Simulating a heavy computation (e.g., calculating Fibonacci)
    let num = parseInt(input);
    let a = 0, b = 1, temp;
    
    for (let i = 0; i < num; i++) {
        temp = a;
        a = b;
        b = temp + b;
    }
    
    return a; // Returns the nth Fibonacci number
}`}
    </pre>

    <p>
      In this example, the worker listens for messages from the main thread. When it receives a message, it processes the input using the <code>computeExpensiveOperation</code> function, which simulates a heavy computation (like calculating Fibonacci numbers). The result is then sent back to the main thread using <code>postMessage</code>.
    </p>
  </div>
)}






{selectedChapter === 'chapter99' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Proxy and Reflect</h1>
          <p>
            In JavaScript, <strong>Proxy</strong> and <strong>Reflect</strong> are powerful features that enable developers to create objects with custom behaviors for fundamental operations such as property lookup, assignment, enumeration, and function invocation. These features are useful for creating abstractions, modifying object behaviors, and implementing advanced design patterns.
          </p><br />


          <h4>Proxy</h4>
          <p style={{paddingBottom:"6px"}}>
            A <strong>Proxy</strong> object wraps another object or function and allows you to intercept and redefine fundamental operations for that object. This can be useful for various purposes, such as data validation, property access control, and more.
          </p>

          <h5 style={{paddingBottom:"6px"}}>Key Features of Proxy:</h5>
          <ul>
            <li><strong>Interception</strong>: Proxies can intercept operations like property access, assignment, deletion, and function calls.</li><br />
            <li><strong>Customization</strong>: You can define custom behavior for these operations using handler methods.</li>
          </ul><br />

          <h5>Basic Syntax:</h5>
          <pre>
            <code>
              {`const proxy = new Proxy(target, handler);`}
            </code>
          </pre>
          <ul>
            <li><strong>target</strong>: The object to wrap.</li><br />
            <li><strong>handler</strong>: An object that defines which operations will be intercepted and how to redefine them.</li>
          </ul><br />

          <h5>Example of Using Proxy:</h5>
          <pre>
            <code>
              {`const target = {
  message: "Hello, world!"
};

const handler = {
  get(target, property, receiver) {
    if (property in target) {
      return \`Proxy says: \${target[property]}\`;
    } else {
      return \`Property "\${property}" does not exist.\`;
    }
  }
};

const proxy = new Proxy(target, handler);

console.log(proxy.message); // Proxy says: Hello, world!
console.log(proxy.nonExistentProperty); // Property "nonExistentProperty" does not exist.`}
            </code>
          </pre><br />

          <h4>Reflect</h4>
          <p style={{paddingBottom:"6px"}}>
            The <strong>Reflect</strong> API provides methods for interceptable JavaScript operations. It is a built-in object that provides a way to manipulate objects and functions without having to directly use a proxy. Reflect methods can be used to perform the same operations as those defined in a handler object of a Proxy.
          </p>

          <h5 style={{paddingBottom:"6px"}}>Key Features of Reflect:</h5>
          <ul>
            <li>Provides methods for the same operations that can be intercepted by proxies.</li><br />
            <li>Helps maintain the default behavior of operations while allowing customization.</li>
          </ul><br />

          <h5>Basic Syntax:</h5>
          <pre>
            <code>
              {`Reflect.methodName(target, property[, value]);`}
            </code>
          </pre><br />

          <h5>Example of Using Reflect with Proxy:</h5>
          <pre>
            <code>
              {`const target = {
  name: "Alice"
};

const handler = {
  get(target, property, receiver) {
    // Using Reflect to get the property value from the target
    return Reflect.get(target, property, receiver);
  },
  set(target, property, value) {
    // Custom behavior on setting a property
    console.log(\`Setting \${property} to \${value}\`);
    // Using Reflect to set the property value
    return Reflect.set(target, property, value);
  }
};

const proxy = new Proxy(target, handler);

// Accessing property
console.log(proxy.name); // Alice

// Setting property
proxy.name = "Bob"; // Setting name to Bob
console.log(proxy.name); // Bob`}
            </code>
          </pre><br />

          <h3>Conclusion</h3>
          <p>
            <strong>Proxy</strong> and <strong>Reflect</strong> are powerful tools in JavaScript that allow developers to create more dynamic and flexible objects. They provide the ability to intercept and redefine fundamental operations on objects, making it easier to implement design patterns like validation, logging, and access control. By using these features, you can enhance the functionality and maintainability of your JavaScript applications.
          </p>
     
  </div>
)}





{selectedChapter === 'chapter100' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Common JavaScript Security Issues</h1>

    <p>
      JavaScript security is a critical aspect of web development, as it involves protecting applications from various vulnerabilities that can lead to unauthorized access, data theft, or malicious actions. Below are some common JavaScript security issues, their definitions, and examples of code that illustrate these vulnerabilities and how to mitigate them.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>1. Cross-Site Scripting (XSS)</h2>
    <p>
      <strong>Definition</strong>: XSS is a vulnerability that allows attackers to inject malicious scripts into web pages viewed by other users. This can lead to data theft, session hijacking, or spreading malware.
    </p>
    <pre style={{paddingBottom:"6px"}}>
      <code>{`// Vulnerable Code
const userInput = '<script>alert("XSS Attack!");</script>';
document.body.innerHTML = userInput; // Directly inserting user input into the DOM`}</code>
    </pre>
    <p>
      <strong>Mitigation</strong>: To prevent XSS, always sanitize user inputs. Use libraries like DOMPurify to clean HTML:
    </p>
    <pre>
      <code>{`import DOMPurify from 'dompurify';

// Safe Code
const userInput = '<script>alert("XSS Attack!");</script>';
const safeInput = DOMPurify.sanitize(userInput);
document.body.innerHTML = safeInput; // Safe insertion`}</code>
    </pre><br />

    <h2>2. Cross-Site Request Forgery (CSRF)</h2>
    <p>
      <strong>Definition</strong>: CSRF is an attack that tricks a user into performing actions on a web application in which they are authenticated. This can lead to unauthorized actions being executed on behalf of the user.
    </p>
    <pre style={{paddingBottom:"6px"}}>
      <code>{`<!-- Malicious website sends a request to a target site -->
<form action="https://target-site.com/transfer" method="POST">
    <input type="hidden" name="amount" value="1000" />
    <input type="submit" value="Transfer" />
</form>`}</code>
    </pre>
    <p>
      <strong>Mitigation</strong>: To prevent CSRF, use anti-CSRF tokens. Here's how to implement it:
    </p>
    <pre>
      <code>{`// Server-side: Generate and validate CSRF tokens
app.post('/submit', (req, res) => {
  const token = req.body.token;
  if (token !== req.session.csrfToken) {
    return res.status(403).send('Forbidden');
  }
  // Proceed with the request
});

// Client-side: Include the CSRF token in your requests
const csrfToken = getCsrfToken(); // Function to get the token from cookies or hidden input
fetch('/submit', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ token: csrfToken }),
});`}</code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>3. Insecure Direct Object References (IDOR)</h2>
    <p>
      <strong>Definition</strong>: IDOR occurs when an application exposes a reference to an internal object, allowing attackers to access unauthorized data by manipulating the reference.
    </p>
    <pre style={{paddingBottom:"6px"}}>
      <code>{`// Vulnerable Code
app.get('/user/:id', (req, res) => {
  const userId = req.params.id;
  const user = database.getUserById(userId); // No authorization check
  res.json(user);
});`}</code>
    </pre>
    <p>
      <strong>Mitigation</strong>: Always implement access controls:
    </p>
    <pre>
      <code>{`app.get('/user/:id', (req, res) => {
  const userId = req.params.id;
  if (req.user.id !== userId) { // Check if the user is authorized
    return res.status(403).send('Forbidden');
  }
  const user = database.getUserById(userId);
  res.json(user);
});`}</code>
    </pre><br />

    <h2>4. SQL Injection</h2>
    <p>
      <strong>Definition</strong>: SQL Injection is a code injection technique that attackers use to insert malicious SQL statements into input fields, allowing them to manipulate the database.
    </p>
    <pre style={{paddingBottom:"6px"}}>
      <code>{`// Vulnerable Code
const userId = req.body.userId;
const query = \`SELECT * FROM users WHERE id = \${userId}\`; // Unsafe concatenation
database.query(query);`}</code>
    </pre>
    <p>
      <strong>Mitigation</strong>: Use parameterized queries to prevent SQL injection:
    </p>
    <pre>
      <code>{`const userId = req.body.userId;
const query = 'SELECT * FROM users WHERE id = ?';
database.query(query, [userId]); // Safely parameterized`}</code>
    </pre><br />

    <h2>5. Sensitive Data Exposure</h2>
    <p>
      <strong>Definition</strong>: Sensitive data exposure occurs when applications do not adequately protect sensitive information, such as passwords or personal data, leading to unauthorized access.
    </p>
    <pre style={{paddingBottom:"6px"}}>
      <code>{`// Vulnerable Code
const password = req.body.password;
database.saveUser({ username: req.body.username, password: password }); // Storing plain text password`}</code>
    </pre>
    <p>
      <strong>Mitigation</strong>: Always hash passwords before storing them:
    </p>
    <pre>
      <code>{`const bcrypt = require('bcrypt');

// Safe Code
const hashedPassword = await bcrypt.hash(req.body.password, 10);
database.saveUser({ username: req.body.username, password: hashedPassword });`}</code>
    </pre><br />

    <h2>Summary</h2>
    <p>
      By understanding these common JavaScript security issues and implementing proper mitigations, developers can significantly enhance the security of their applications. Always validate and sanitize user inputs, implement authentication and authorization checks, and protect sensitive data to create a more secure web environment.
    </p>
  </div>
)}


{selectedChapter === 'chapter101' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Avoiding Cross-Site Scripting (XSS)</h1>
    <p>
      <strong>Cross-Site Scripting (XSS)</strong> is a vulnerability that allows attackers to inject malicious scripts into web pages viewed by other users. This can lead to a range of issues, including data theft, session hijacking, and defacement of websites. XSS attacks typically exploit the trust that users have in a particular site.
    </p><br />

    <h2 style={{paddingBottom:"6px"}}>Types of XSS</h2>
    <ol>
      <li><strong>Stored XSS</strong>: Malicious scripts are stored on the server (e.g., in a database) and served to users when they access the affected page.</li><br />
      <li><strong>Reflected XSS</strong>: The malicious script is reflected off a web server, usually via a URL. This is often delivered through phishing emails.</li><br />
      <li><strong>DOM-based XSS</strong>: The vulnerability exists in the client-side script rather than the server-side code. This occurs when the client-side JavaScript modifies the DOM without proper validation.</li>
    </ol><br />

    <h2>Vulnerable Code Example</h2>
    <p>
      Here’s an example of a simple web application that is vulnerable to XSS due to direct insertion of user input into the DOM:
    </p>
    <pre>
      <code>
        {`// Vulnerable Code
const userInput = '<script>alert("XSS Attack!");</script>';
document.body.innerHTML = userInput; // Directly inserting user input into the DOM`}
      </code>
    </pre>
    <p>
      In this example, if <code>userInput</code> is derived from an untrusted source, an attacker could potentially execute malicious JavaScript.
    </p><br />

    <h2>Mitigation Strategies</h2>
    <p>To avoid XSS vulnerabilities, developers can implement the following strategies:</p>
    <ol>
      <li>
        <strong>Sanitize User Input</strong>: Always sanitize user input to remove any harmful code. Libraries like <a href="https://github.com/cure53/DOMPurify">DOMPurify</a> can be used to clean HTML.
        <pre>
          <code>
            {`// Example Using DOMPurify
import DOMPurify from 'dompurify';

const userInput = '<script>alert("XSS Attack!");</script>';
const safeInput = DOMPurify.sanitize(userInput);
document.body.innerHTML = safeInput; // Safe insertion`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Use Text Content Instead of InnerHTML</strong>: When inserting user-generated content, prefer using <code>textContent</code> over <code>innerHTML</code> to ensure that any HTML tags are escaped.
        <pre>
          <code>
            {`// Safe Code Example
const userInput = '<script>alert("XSS Attack!");</script>';
const safeElement = document.createElement('div');
safeElement.textContent = userInput; // Escapes HTML tags
document.body.appendChild(safeElement); // Safe insertion`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Content Security Policy (CSP)</strong>: Implement a Content Security Policy to restrict the sources from which scripts can be loaded. This can help mitigate XSS attacks by preventing the execution of malicious scripts.
        <pre>
          <code>
            {`// CSP Example (added in the HTTP headers)
Content-Security-Policy: default-src 'self'; script-src 'self';`}
          </code>
        </pre>
      </li><br />
      <li>
        <strong>Validate and Encode Data</strong>: Validate and encode data both on the client and server sides. Always assume that input data can be malicious.
      </li><br />
      <li>
        <strong>Use Frameworks with Built-in XSS Protection</strong>: Use modern frameworks (like React, Angular, or Vue) that automatically escape user inputs to prevent XSS vulnerabilities.
      </li>
    </ol><br />

    <h2>Summary</h2>
    <p>
      Cross-Site Scripting (XSS) is a serious security risk in web applications. By understanding the types of XSS and implementing proper security measures, such as input sanitization, using safe DOM manipulation methods, applying CSP, and leveraging secure frameworks, developers can protect their applications from XSS attacks effectively.
    </p>
  </div>
)}


{selectedChapter === 'chapter102' && (
  <div className={style.chaptercontent}>
    <h1 className={style.heading}>Content Security Policy (CSP)</h1>
    <p>
      In JavaScript security, <strong>Content Security Policy (CSP)</strong> is an important defense mechanism that helps mitigate a range of attacks like cross-site scripting (XSS), clickjacking, and data injection. CSP allows web developers to define which sources of content are trusted and can be loaded by the browser. Here's an overview:
    </p><br />

    <h2>1. What is Content Security Policy (CSP)?</h2>
    <p>
      CSP is a browser feature that prevents a variety of attacks by controlling the sources from which resources like scripts, images, and stylesheets can be loaded. It works by specifying allowed sources for various types of content in the HTTP headers.
    </p><br />

    <h2>2. How Does CSP Work?</h2>
    <p>
      CSP is enforced through an HTTP response header (<code>Content-Security-Policy</code>). It provides a set of directives that inform the browser about what is permitted to run on the page. For example:
    </p>
    <ul>
      <li><code>default-src 'self';</code> allows content to load only from the site's own domain.</li><br />
      <li><code>script-src 'self' https://apis.google.com;</code> permits scripts from the site's domain and Google's API service.</li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>3. Benefits of CSP:</h2>
    <ul>
      <li><strong>Mitigates XSS Attacks:</strong> By disallowing inline JavaScript (<code>'unsafe-inline'</code>), CSP prevents attackers from injecting and executing malicious scripts.</li><br />
      <li><strong>Prevents Data Theft:</strong> CSP can prevent data leaks by blocking unauthorized external scripts that may steal sensitive information.</li><br />
      <li><strong>Stops Code Injection:</strong> By restricting the origin of executable code, it minimizes the risk of code injection attacks.</li>
    </ul><br />

    <h2 style={{paddingBottom:"6px"}}>4. CSP Directives:</h2>
    <ul>
      <li><code>default-src</code>: The default policy for loading resources like JavaScript, images, CSS, etc.</li><br />
      <li><code>script-src</code>: Controls the sources from which JavaScript files can be executed.</li><br />
      <li><code>style-src</code>: Restricts where CSS files can be loaded from.</li><br />
      <li><code>img-src</code>: Defines allowed sources for images.</li><br />
      <li><code>connect-src</code>: Limits the sources for AJAX, WebSockets, and EventSource connections.</li>
    </ul><br />

    <h2>5. Reporting Violations:</h2>
    <p>
      CSP can also include a <code>report-uri</code> or <code>report-to</code> directive to send violation reports to a specified endpoint when a violation of the policy occurs.
    </p><br />

    <h2>6. Example CSP Header:</h2>
    <pre>
      <code>
        Content-Security-Policy: default-src 'self'; script-src 'self' https://apis.google.com; style-src 'self' 'unsafe-inline';
      </code>
    </pre><br />

    <h2 style={{paddingBottom:"6px"}}>7. Common Pitfalls:</h2>
    <ul>
      <li><strong>Blocking Required Content:</strong> If CSP is too strict, it may block necessary content like third-party scripts or styles.</li><br />
      <li><strong>Inline Scripts and Styles:</strong> Using inline JavaScript and CSS can break under strict CSP rules unless exceptions (<code>'unsafe-inline'</code>) are made, which can reintroduce vulnerabilities.</li>
    </ul><br />

    <p>
      This approach greatly enhances security in modern web applications by controlling what external resources can be loaded and executed on a page, making it a key concept in JavaScript security.
    </p>
  </div>
)}







                </div>
            </div>
        </div>

    );

}


export default JavaScriptdata;


